<!--创建/编辑活动-->
<script>
import axios from "axios";
import { mapActions, mapState } from "vuex";
import { generateUUID } from "@/utils/uuid.js";
import appConfig from "@/app.config";
import CustomDialogHeader from "@/components/CustomDialogHeader.vue";
import {
  getCreateList,
  getVideoPathToken,
  getVideoPathUrl,
  isFollowWechat,
  updateActivitySignList,
  getActivityCode,
  getUserUrl,
  getBackgroundMusicList,
} from "@/utils/api/activity";
import {
  activityDetail,
  clockPresetsAdd,
  clockPresetsDel,
  clockPresetsDetail,
  clockPresetsList,
  clockPresetsUpdate,
  getCoverimgTemplate,
  getProjectManageAdmin,
  getSignList,
  isUpdateSignList,
  updateActivity,
  updateSignList,
} from "@/utils/api/build";
import { imageUrl } from "@/utils/config/commonUrl.js";
import serverConfig from "@/utils/config/index.js";
import router from "../../../router";
import Layout from "../../layouts/main";
import NoticeConfigDialog from "./component/NoticeConfigDialog.vue";
const gzhQrcodeImg = require("@/assets/images/gzh_qrcode.jpg");
const GZH_DIALOG_LIMIT_KEY = "jl_create_activity_gzh_dialog_show_times";
const GZH_DIALOG_MAX_SHOW = 2;

var dayjs = require("dayjs");

import systemPictures from "@/components/systemPictures/systemPictures.vue";
import copyrightConfig from "@/utils/config/changeCopyright.js";
import PosPermissionSelector from "./component/PosPermissionSelector.vue";
import WaterMarkSwitch from "./component/WaterMarkSwitch.vue";
import UploadSourceSelector from "./component/UploadSourceSelector.vue";
import siginFile from "./component/siginFile/index.vue";
import SetLogicDialog from "./component/SetLogicDialog.vue";
import AppointmentTimeDialog from "./component/AppointmentTimeDialog.vue";
import {
  createAppointmentOption,
  validateAppointmentField,
  getAppointmentOptionSummary,
  resetAppointmentTimeSlotCounts,
} from "@/utils/appointmentField.js";
import PayImagePicker from "./component/PayImagePicker.vue";
import UploadVideoCom from "./component/UploadVideoCom.vue";

// 阿里云 VOD 转码模板组 ID(按会员身份区分)
//   会员:5cdfb9c9d795d5ee4402954e9b177fab
//   普通:ead7ee89c65f42d19017e24237eec138
const VOD_TEMPLATE_GROUP_VIP = "5cdfb9c9d795d5ee4402954e9b177fab";
const VOD_TEMPLATE_GROUP_NORMAL = "ead7ee89c65f42d19017e24237eec138";
/**
 * 校验上传文件
 * @param {FileList|Array} files - 文件列表
 * @returns {Object} - { valid: boolean, message: string, fileType: string }
 */
function validateUploadFiles(files) {
  // 文件类型定义
  const FILE_TYPES = {
    word: [
      "application/msword",
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
    ],
    pdf: ["application/pdf"],
    image: ["image/jpeg", "image/png", "image/jpg", "image/webp", "image/bmp"],
  };

  // 扩展名备用检测
  const FILE_EXTENSIONS = {
    word: [".doc", ".docx"],
    pdf: [".pdf"],
    image: [".jpg", ".jpeg", ".png", ".webp", ".bmp"],
  };

  // 类型名称映射（用于提示信息）
  const TYPE_NAMES = {
    word: "Word",
    pdf: "PDF",
    image: "图片",
  };

  // 获取文件类型
  function getFileType(file) {
    const mimeType = file.type.toLowerCase();
    const fileName = file.name.toLowerCase();
    const extension = "." + fileName.split(".").pop();

    if (
      FILE_TYPES.word.includes(mimeType) ||
      FILE_EXTENSIONS.word.includes(extension)
    ) {
      return "word";
    }
    if (
      FILE_TYPES.pdf.includes(mimeType) ||
      FILE_EXTENSIONS.pdf.includes(extension)
    ) {
      return "pdf";
    }
    if (
      FILE_TYPES.image.includes(mimeType) ||
      FILE_EXTENSIONS.image.includes(extension)
    ) {
      return "image";
    }
    return "unknown";
  }

  // 统计各类型文件数量
  const fileCount = { word: 0, pdf: 0, image: 0, unknown: 0 };

  Array.from(files).forEach((file) => {
    const type = getFileType(file);
    fileCount[type]++;
  });

  // ========== 校验规则 ==========

  // 1. 检查是否有不支持的文件类型
  if (fileCount.unknown > 0) {
    return {
      valid: false,
      message: "包含不支持的文件类型，仅支持 Word、PDF 或图片",
      fileType: null,
    };
  }

  // 2. 收集存在的文件类型
  const existingTypes = ["word", "pdf", "image"].filter(
    (type) => fileCount[type] > 0,
  );

  // 3. 不允许混合上传
  if (existingTypes.length > 1) {
    const typeNames = existingTypes
      .map((type) => TYPE_NAMES[type])
      .join(" 和 ");
    return {
      valid: false,
      message: `不能同时上传 ${typeNames}，请选择单一类型文件`,
      fileType: null,
    };
  }

  // 4. Word 只能上传 1 个
  if (fileCount.word > 1) {
    return {
      valid: false,
      message: "Word 文件只能上传 1 个",
      fileType: "word",
    };
  }

  // 5. PDF 只能上传 1 个
  if (fileCount.pdf > 1) {
    return {
      valid: false,
      message: "PDF 文件只能上传 1 个",
      fileType: "pdf",
    };
  }

  // 6. 图片最多上传 9 张
  if (fileCount.image > 9) {
    return {
      valid: false,
      message: `图片最多上传 9 张，当前选择了 ${fileCount.image} 张`,
      fileType: "image",
    };
  }

  // 校验通过
  return {
    valid: true,
    message: "校验通过",
    fileType: existingTypes[0], // 直接返回 'word' | 'pdf' | 'image'
  };
}
export default {
  page() {
    return {
      title: "创建接龙",
      meta: [{ name: "description", content: appConfig.description }],
    };
  },
  components: {
    Layout,
    PosPermissionSelector,
    WaterMarkSwitch,
    UploadSourceSelector,
    systemPictures,
    CustomDialogHeader,
    siginFile,
    SetLogicDialog,
    NoticeConfigDialog,
    AppointmentTimeDialog,
    PayImagePicker,
    UploadVideoCom,
  },
  data() {
    return {
      noticeDialogVisible: false,
      noticeConfig: null, // 编辑时传入已有配置，新建时传 null 或不传
      // 设置逻辑弹层相关
      setLogicDialogVisible: false,
      currentEditFieldData: {},
      currentLogicFieldIndex: 0,
      currentLogicListIndex: 0,
      allSignFieldsData: [],

      signFileItemIndex: 0,
      appid: copyrightConfig.AppID,
      title: "Basic Tables",
      items: [
        {
          text: "Tables",
          href: "/",
        },
        {
          text: "Basic",
          active: true,
        },
      ],
      drawer: true,
      direction: "rtl",
      generalCheckTimesArr: [
        {
          value: 0,
          label: "不限制",
        },
        {
          value: 1,
          label: "1次",
        },
        {
          value: 2,
          label: "2次",
        },
        {
          value: 3,
          label: "3次",
        },
        {
          value: 4,
          label: "4次",
        },
        {
          value: 5,
          label: "5次",
        },
        {
          value: 6,
          label: "6次",
        },
        {
          value: 7,
          label: "7次",
        },
        {
          value: 8,
          label: "8次",
        },
        {
          value: 9,
          label: "9次",
        },
        {
          value: 10,
          label: "10次",
        },
        {
          value: 11,
          label: "11次",
        },
        {
          value: 12,
          label: "12次",
        },
        {
          value: 13,
          label: "13次",
        },
        {
          value: 14,
          label: "14次",
        },
        {
          value: 15,
          label: "15次",
        },
        {
          value: 16,
          label: "16次",
        },
        {
          value: 17,
          label: "17次",
        },
        {
          value: 18,
          label: "18次",
        },
        {
          value: 19,
          label: "19次",
        },
        {
          value: 20,
          label: "20次",
        },
      ],
      enablePushArr: [
        {
          label: "接受消息通知",
          value: 1,
        },
        {
          label: "不接收任何消息通知",
          value: 2,
        },
      ],

      value: "",
      checked: true,
      value1: "",
      input: "",
      radio: "1",
      dialogImageUrl: "",
      dialogVisible: false,
      gzhDialogVisible: false,
      wechatFollowStatus: null,
      gzhDialogPromiseResolver: null,
      gzhQrcodeSrc: gzhQrcodeImg,
      // 身份认证小程序码
      authCodeDialogVisible: false,
      authCodeUrl: "",
      fileList: [
        {
          name: "food.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/qualifty/100",
        },
        {
          name: "food2.jpeg",
          url: "https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100",
        },
      ],
      value2: [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)],
      candidateList: [], // 选中的周几
      value3: "",

      map: null,
      point: null,
      markerPoint: {
        address: "",
      },
      location: { lng: 116.403963, lat: 39.915119 }, // 地图中心点
      zoom: 19, // 地图缩放级别
      markLocation: {
        // 标记点的经纬度
        lng: 116.403963,
        lat: 39.915119,
      },
      form: {
        address: "", // 详细地址
        addrPoint: {
          // 详细地址经纬度
          lng: 0,
          lat: 0,
        },
      },
      mk: "", // Marker实例
      value4: "",

      addressDialog: false,
      addressIdx: null,

      poiname: "", //地址名称
      longitude: "", //纬度
      latitude: "", //经度

      // -----------------------------------------------------------------------------
      // 基础设置
      isType: "106", //创建活动的类型
      groupId: "", //群组id
      // 详细信息
      activityDetail: {
        name: "",
        content: "",
        generalCheckTimes: 1, // 高级设置每人可接龙次数
        paymentSwitch: 0,
        rebateSwitch: 0,
        needBuy: 0,
        rebatePercent: 0,
        noticeConfig: {
          noticeEnabled: 0,
        },
        backgroundMusicUrl: "", // 背景音乐 URL（主字段，与详情页一致）
        musicUrl: "", // 兼容字段，提交时与 backgroundMusicUrl 保持一致
        musicName: "", // 背景音乐名称
        actualTimeSwitch: 1, // 活动时间开关 1关 2开（纯展示，不影响任何设置）
        actualBeginTime: "", // 实际活动开始时间（纯展示）
        actualEndTime: "2099-12-31 23:59:59", // 实际活动结束时间（纯展示）
        showAllGroupSwitch: 2, // 名单是否展示全部分组 2-展示 1-不展示
      },
      hideUser: 0, // 隐藏人员名单 0 否 1 是
      hideAttr: 0, // 隐藏活动属性区域 0 否 1 是
      hideRule: 0, // 隐藏修改与信息规则 0 否 1 是
      hideLimit: 0, // 隐藏人数限制与取消规则 0 否 1 是
      foldInfo: 0, // 折叠参与人信息 0 否 1 是
      showFormNum: 1, // 设置可见填表项数量 默认 1
      // 背景音乐（选中项存于 activityDetail.backgroundMusicUrl / musicName，随活动提交）
      bgMusicDialog: false, // 背景音乐选择弹窗
      bgMusicList: [], // 背景音乐列表
      bgMusicLoading: false, // 列表加载中
      bgMusicPlayingId: "", // 当前正在试听播放的音乐 id（空为未播放）
      bgMusicPlayIcon:
        "https://ossfastmake.xlkapp.com/12jielong/lsyJL/playmuic-icon.png",
      bgMusicPauseIcon:
        "https://ossfastmake.xlkapp.com/12jielong/lsyJL/pausemusic-icon.png",
      modularList: [], // 模块列表
      modular1: [], // 模块列表
      indexIdx: 0,
      commonDisabled: false, // 是否可以编辑
      formDrawerShow: false,
      actStartAndEndTime: "",
      // 表单项 类别
      formList: [
        // {
        //   label: "标题",
        //   type: 33,
        // },
        {
          label: "姓名",
          type: 0,
        },
        {
          label: "手机号",
          type: 1,
        },
        {
          label: "数量",
          type: 2,
        },
        {
          label: "金额",
          type: 40,
        },
        {
          label: "文件",
          type: 25,
        },
        {
          label: "手写签名",
          type: 24,
        },
        {
          label: "文件签字",
          type: 36,
        },
        // {
        //     label: '水印拍照',
        //     type: 23,
        // },
        {
          label: "日期/时间",
          type: 3,
        },
        {
          label: "图片",
          type: 4,
        },
        {
          label: "拍照上传",
          type: 35,
        },
        {
          label: "预约",
          type: -5,
        },
        {
          label: "身份证",
          type: 5,
        },
        {
          label: "时间",
          type: 6,
        },
        {
          label: "定位",
          type: 7,
        },
        {
          label: "省/市/区",
          type: 8,
        },
        {
          label: "性别",
          type: 9,
        },
        {
          label: "音频",
          type: 12,
        },
        {
          label: "视频",
          type: 13,
        },
        {
          label: "邮箱",
          type: 14,
        },
        {
          label: "学校",
          type: 15,
        },
        {
          label: "院系",
          type: 16,
        },
        {
          label: "工号",
          type: 17,
        },
        {
          label: "学号",
          type: 18,
        },
        {
          label: "公司",
          type: 19,
        },
        {
          label: "职位",
          type: 20,
        },
        {
          label: "部门",
          type: 21,
        },
        // {
        //     label: '单位',
        //     type: 22,
        // },
        {
          label: "时间区间",
          type: 31,
        },
      ],
      // 报名字段
      listList: [
        {
          signListName: "",
          ifDel: 2,
          addTime: "",
          signField: [],
        },
      ],

      storgeName: [],
      // ---------------------------------------------------------------------------------
      // 打卡内容
      formClock: {
        clockFrequencyName: "每天", //打卡要求
        clockRemindStatus: 1, //打卡提醒开关 1 开 2关
        remindTime: "10:00", //打卡提醒时间
        beginTime: "00:00", //打卡开始时间
        endTime: "23:59", //打卡结束时间
        clockSupplyStatus: 1, //补卡开关  1 开 2关
        supplyTimes: "-1", //补卡次数
        clockLocationStatus: 2, //是否指定打卡地点 1 开 2关
        clockRange: 1000, //打卡范围
        clockFrequency: "0,1,2,3,4,5,6", //打卡要求 周、每天
        // 新加的 有用的
        clockLocationInfo: "", //打卡地点信息
        clockFrequencyType: "3", // 打卡频率类型！！！！！
        clockMaxNum: 1, // 每周、每月打卡 最大次数
        clockMaxSwitch: 2, // 每周、每月最大值开关
        dayOfDate: "", // 每周、每月打卡截止—周几或几号，根据clockFrequencyType变化（周几 存的是 0、1、2、3、4、5、6   月：几号就是几，不变）
        timeOfDay: "", // 每周、每月打卡截止—时分秒
        multiPeriodSwitch: 2, // 多时段打卡开关
        clockInTimeSlot: [
          {
            startTime: "00:00",
            endTime: "23:59",
            ifDel: 2, // 删除是1，未删除是2
            randomDecimal: Date.now(),
          },
        ],
        customDate: "", // 自定义日期 逗号拼接的
        clockSupplyType: -1, //补卡频率类型 0 总共  1=每月｜2=每周｜3=每天 | -1 不限制次数
        checkSwitch: 1, // 允许一天内多次打卡 1关 2开
        checkTimes: 1, // 每天打卡次数
      },
      clockFrequencyName: "",
      markers: {},
      range: "1",
      address: "",
      clockRange: 1000,
      selectData: "每天",
      starttime: "00:00",
      endtime: "23:59",
      show: false,
      show2: false,
      color: "#1877FF",
      candidates: [
        { name: "星期一", value: "0", checked: false },
        { name: "星期二", value: "1", checked: false },
        { name: "星期三", value: "2", checked: false },
        { name: "星期四", value: "3", checked: false },
        { name: "星期五", value: "4", checked: false },
        { name: "星期六", value: "5", checked: false },
        { name: "星期日", value: "6", checked: false },
      ],

      columns3: [
        ["1000米以内", "500米以内", "200米以内", "100米以内", "50米以内"],
      ],
      dakaColumnsArr: [
        {
          label: "1000米以内",
          value: 1000,
        },
        {
          label: "500米以内",
          value: 500,
        },
        {
          label: "200米以内",
          value: 200,
        },
        {
          label: "100米以内",
          value: 100,
        },
      ],
      clockRangeList: [
        {
          name: "不限制次数",
          value: -1,
        },
        {
          name: "「总共」可补卡次数",
          value: 0,
        },
        {
          name: "「每天」可补卡次数",
          value: 3,
        },
        {
          name: "「每周」可补卡次数",
          value: 2,
        },
        {
          name: "「每月」可补卡次数",
          value: 1,
        },
      ],
      disbandBox: false,
      city: "",
      current: 0,
      selectFrequency: 3, // 频率类型 1=每月｜2=每周｜3=每天｜4=法定工作日｜5=法定节假日｜6=自定义周几打卡｜7=自定义日期打卡 | 8=一次性打卡
      lastDayOfMonth: "",
      weekChineseNumbers: ["一", "二", "三", "四", "五", "六", "日"],
      endMonthShow: false,
      endMonthArr: [[], [], []],
      endMonthArr1: [],
      endMonthArr2: [],
      endMonthArr3: [],
      endMonthValue: "",
      endWeekShow: false,
      endWeekArr: [["一", "二", "三", "四", "五", "六", "日"], [], []],
      endWeekArr1: [
        {
          label: "周一",
          value: 0,
        },
        {
          label: "周二",
          value: 1,
        },
        {
          label: "周三",
          value: 2,
        },
        {
          label: "周四",
          value: 3,
        },
        {
          label: "周五",
          value: 4,
        },
        {
          label: "周六",
          value: 5,
        },
        {
          label: "周日",
          value: 6,
        },
      ],
      endWeekArr2: [],
      endWeekArr3: [],

      endWeekValue: "",
      modeRili: "multiple",
      cusRilishow: false,
      customDateArr: [],
      // 打卡频率
      CheckInFrequency: [
        {
          label: "每月",
          value: 1,
        },
        {
          label: "每周",
          value: 2,
        },
        {
          label: "每天",
          value: 3,
        },
        {
          label: "法定工作日",
          value: 4,
        },
        {
          label: "法定节假日",
          value: 5,
        },
        {
          label: "自定义周几打卡",
          value: 6,
        },
        {
          label: "自定义日期打卡",
          value: 7,
        },
        {
          label: "一次性打卡",
          value: 8,
        },
      ],
      monthDay: 0,
      monthHour: 0,
      monthMinute: 0,
      weekDay: 1,
      weekHour: 1,
      weekMinute: 0,
      // 时间段
      timeSlotArr: ["00:00", "23:59"],
      selectedFile: null,
      modulCommonIndex: 0,
      imageUrl: imageUrl,
      modularDelIds: [],
      // 查看活动类型
      selectType: "add", //add
      delListInfo: [],
      activityId: "2",
      previewImgSrc: "", // 图片路径
      previewImgShow: false,
      isModular: false,
      addMapType: 1, // 2-模块 3-设置 1-打卡 4-签到
      imageUploadLimit: 9,
      imgUpMoveSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png",
      imgDownMoveSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png",
      imgCancelSrc:
        "https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg",

      // 高级设置
      shareStatus: "",
      commentStatus: 2,
      confirmWord: "参加活动",
      signSuccessBarrageSwitch: 1, // 报名成功弹幕开关 1-开 2-关 默认开
      select_type: "",
      activityType: 0,
      isanonymous: 1,
      publisher: localStorage.getItem("jlnickname"),
      remindtime: "00:00",
      edit_publisher: "",
      columns1: [["不允许修改", "自定义修改时间", "接龙终止前"]],
      // 允许修改参与信息
      updateSignInfo: 3, // 是否允许修改 1、活动结束前可以  2、不可以取消 3、时间段内可以
      updateSignArr: [
        {
          label: "不允许修改",
          value: 1,
        },
        {
          label: "自定义修改时间",
          value: 2,
        },
        {
          label: "活动终止前",
          value: 3,
        },
      ],
      columns1Show: false,
      columns2: [["不允许删除", "自定义删除时间", "活动终止前"]],
      removeSignStatus: 4,
      cancellation: [["活动终止前", "不可取消", "自定义", "允许取消"]],
      cancellationArr: [
        {
          label: "活动终止前",
          value: 1,
        },
        {
          label: "不可取消",
          value: 2,
        },
        {
          label: "自定义",
          value: 3,
        },
        {
          label: "允许取消",
          value: 4,
        },
      ],
      columns2Show: false,
      anonymousparticipation: 0,

      submitcopy: "参加接龙",
      edit_submit_btn: "",
      edit_partin_btn: "",
      is_notice: 0, // 接龙通知
      is_forward: 0, //转发
      is_remind: 0, //接龙提醒
      cancelTitle: "接龙终止前",
      endregistrationtime: null,
      registrationtime: null,
      zdyTimes: false,
      zdyTimesEnd: false,
      zdyDelTimes: false,
      zdyDelTimesEnd: false,
      enddeletingtime: null,
      startdeletingtime: null,
      delSignTitle: "不允许删除",
      deleteregistration: 1, //是否允许删除报名信息1不允许 ，2自定义，3活动结束前
      is_signUpSet: false, //参与信息设置
      is_destination: 0,
      deliveryaddress: "",
      newSeniorSetInfo: {},
      informationswitch: false, //报名信息设置开关
      custombutton: false, //自定义按钮设置开关
      addresscolumns: [
        [
          "2000米以内",
          "1500米以内",
          "1000米以内",
          "500米以内",
          "200米以内",
          "100米以内",
        ],
      ], //打卡范围 数组
      addresscolumnsArr: [
        {
          label: "2000米以内",
          value: 2000,
        },
        {
          label: "1500米以内",
          value: 1500,
        },
        {
          label: "1000米以内",
          value: 1000,
        },
        {
          label: "500米以内",
          value: 500,
        },
        {
          label: "200米以内",
          value: 200,
        },
        {
          label: "100米以内",
          value: 100,
        },
      ],
      addressShow: false,
      clockRange1: "", //打卡范围
      checkinrange: "", //打卡范围
      specifyaddress: "", //
      ifcopy: false, //是否为复制活动
      chatSwitch: 1, //聊天开关
      auditSwitch: 0, //参与信息审核开关 1开启 0关闭 默认0
      channelCodeSwitch: 1, //渠道码设置开关 1关闭 2开启 默认1
      voteSyncDialogVisible: false, //参与数据同步至投票管家弹窗
      voteSyncCodeUrl: "", //投票管家小程序码
      rebateSwitch: 0, //推荐返利开关 0关闭 1开启
      needBuy: 0, //返利模式：0-分享返利，1-参与返利
      rebatePercent: "", //佣金比例
      rebateModeDialogVisible: false, //返利模式说明弹窗
      thumbs_up: 1, //点赞
      is_comment: 1, //点评
      is_score: 1, //评分
      isMessage: 1, // 评论
      signInfoStatus: 1, //报名信息展示
      isContentFocus: true,
      isInputContentFocus: false,
      isFocus: false,
      modelContentFocus: false,
      modelContentbind: true,
      ishandleFocus: false,
      is_template: "0", // 1-模板 0-不是模板是活动
      valueId: null, //点击输入框索引
      valueId2: null,
      valueId3: null,
      valueId4: null,
      valueId5: null,
      valueId6: null,
      valueId7: null,
      valueId8: null,
      selected1: false,
      selected2: false,
      valueindex: null,
      valueindex1: null,
      selectedItem: null,
      copyStatus: 2, // 是否运行他们复制
      ctStartAndEndTime: "",
      deadline: "",
      deadCancelline: "",
      interdict_people_num: 0, // 人数限制

      seniorShow: false,
      openNameListDrawer: false,
      nameShowContent: "",
      people_num: 0,
      importVisible: false,
      nameListDrawer: false,
      addNameListDrawer: false,
      customizeDrawer: false,
      clockInList: [], // 预存名单
      presetsList: [], // 名单管理列表
      clockShowPresetTitle: "",
      clockShowPresetContent: "",
      nameId: "",
      people_num2: "",
      copywriting: "",
      copyimage: "",
      copyShowWriting: "",
      copyShowImage: "",
      is_draft: 0, // 是否是草稿，0不是 1是草稿
      isrepeatClick: false, //防止连续点击创建
      showName: "列表接龙",
      baseurl: "",
      multipleActivitiesStatus: 1, //是否允许参加多项活动 1、允许参加多项活动  2、不允许参加多项活动
      routeParameter: "", // 链接参数
      pageType: "",
      imgInfo: [],
      isOtherPeople: "", // 1=创建者、2=管理员、3=普通用户
      loadingShow: {},
      activeBuildTitle: "通用接龙",
      musicLink: "",
      musicDialog: false,
      fileIframeShow: false,
      fileUrl: "",
      relatedList: [],
      selectedItems: [],
      totalRow: 0,
      pages: 0,
      pageNum: 1,
      relatedDrawerShow: false,
      propertySetShow: false,
      // 设置选项不可选时间弹窗
      optionTimeSetShow: false,
      // 模块内容未填写弹窗
      incompleteContentDialog: false,
      incompleteContentList: [], // 未填写的内容列表（索引）
      // 格式验证
      validateArr: [
        "不限格式",
        "仅中文",
        "仅英文",
        "仅数字",
        "英文+数字",
        "中文+数字",
        "中文+英文",
        "身份证号",
        "手机号",
        "座机号",
        "邮箱",
        "网址",
      ],
      validateIndex: 0,
      commValue: "",
      commType: "",
      commIndex: "",
      checkboxList1: [
        {
          name: "必填",
          checked: false,
        },
        {
          name: "公开",
          checked: false,
        },
      ],
      checkboxValue1: [],
      commonImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/",
      dateSetList: [
        {
          type: 0,
          value: "09:00 ~ 10:00",
          checked: false,
        },
        {
          type: 1,
          value: "2024-12 ~ 2025-01",
          checked: false,
        },
        {
          type: 2,
          value: "2024-12-12 ~ 2025-01-01",
          checked: false,
        },
        {
          type: 3,
          value: "2024-02-02 09:00 ~ 2024-08-02 19:00",
          checked: false,
        },
      ],
      timeSetList: [
        {
          type: 0,
          value: "23:59:59",
          checked: false,
        },
        {
          type: 1,
          value: "2024-05",
          checked: false,
        },
        {
          type: 2,
          value: "2024-05-01",
          checked: false,
        },
        {
          type: 3,
          value: "2024-05-01 23:59:59",
          checked: false,
        },
      ],
      areaSetList: [
        {
          type: 0,
          value: "省",
          checked: false,
        },
        {
          type: 1,
          value: "省/市",
          checked: false,
        },
        {
          type: 2,
          value: "省/市/区",
          checked: false,
        },
        {
          type: 3,
          value: "省/市/区/详细地址",
          checked: false,
        },
      ],
      displayStyleArr: [
        {
          value: 1,
          label: "列表式",
        },
        {
          value: 2,
          label: "下拉式",
        },
      ],
      wenHaoImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/bd-build-wenhao.svg",
      propertyData: {},
      selectOptionList: [
        {
          name: "拍摄照片",
        },
        {
          name: "从相册选取",
        },
        {
          name: "从微信聊天中选取",
        },
      ],
      selectOptionShow: false,
      showOptionList: [
        {
          name: "列表式",
        },
        {
          name: "下拉式",
        },
      ],
      showOptionShow: false,
      optionName: "列表式",
      imgNumShow: false,
      imgNumArr: [[1, 2, 3, 4, 5, 6, 7, 8, 9]],
      lineCopywriting: "",
      maxShow: false,
      maxValueArr: [
        {
          value: 0,
          label: "不限",
        },
        {
          value: 1,
          label: "1",
        },
      ],
      minShow: false,
      minValueArr: [
        {
          value: 0,
          label: "不限",
        },
        {
          value: 1,
          label: "1",
        },
      ],
      studyContent: "",
      modelContentDel: false,
      placeholderContent: "",
      tipsPH: "请输入提示内容或说明（选填）",
      tipsContent: "",
      taShow: false,
      scrollHandler: "",
      bottomBtnScrollHandler: null, // 底部按钮滚动监听
      isLoading: false,
      imageUploadNumArr: [1, 2, 3, 4, 5, 6, 7, 8, 9],
      batchOptionShow: false,
      isInFolder: 1, // 是否在文件夹内 默认 1 否 2 是
      folderId: "", // 文件夹ID
      nameAddOptions: [
        {
          name: "设定姓名",
        },
        {
          name: "设定分组",
        },
      ],
      nameAddOptionsShow: false,
      nameAddType: 1, // 1姓名还是2分组
      subsetShow: false,
      // 分组弹框中间值
      subsetCenterValueArr: [],
      subsetValueArr: [], // 给后台的值
      filteredArr: [], // 过滤用
      commFzInfo: {},
      commFzIndex: 0,
      fzPopItemInfo: {}, // 弹框中间值
      fzTitle: "", // 弹框中间值
      fzValue: "", // 弹框中间值
      fzNameArr: [],
      packetData: [], // 展示再页面的分组数据
      pickerName: "全部",
      pickerNameSelectShow: false,
      pickerNameSelectArr: [], // 中间值
      pickerNameSelect: 0,
      nameListLength: 0, // 名单人数
      tableData: [
        { name: "张三", studentId: "" },
        { name: "李四", studentId: "" },
        { name: "王五", studentId: "" },
      ],
      showModal: false,
      placeholderText1: "",
      isAi: "0",
      clockNameNumberSwitch: "1", //是否开启学号/编号 1开启 2关闭
      editImgSrc: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/edit.svg",
      nameSortSwitch: false, // 按拼音排序
      subtractFzImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/subtractFz.png",
      addFzImgSrc:
        "http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/addFz.png",
      handleSubShow: false,
      downloadBoxShow: false,
      beginTime: "",
      foreverValidChecked: true,
      startNowChecked: true, // 保存即开始
      actualStartNowChecked: true, // 实际活动时间-保存即开始
      actualForeverValidChecked: true, // 实际活动时间-永久有效
      prevActualEndTime: "", // 实际活动结束时间上一次合法值（选到过去时间时回退用）
      // 时间设置行展开状态（收起时只显示蓝色状态文字，点击展开勾选框+时间框）
      beginTimeShow: false,
      endTimeShow: false,
      actualBeginTimeShow: false,
      actualEndTimeShow: false,
      clockSupplyText: "不限制次数",
      clockSupplyShow: false,
      clockSupplyCenterText: "",
      supplyTxt: "",
      isDelSignInfoPop: false,
      isDelOrder: "",
      signFieldClone: [],
      resultList: [],
      rateType: "", // 打卡频率
      showRanking: 2, // 排行榜 1关2开
      // 预约填表项（type=39）
      appointmentTimeVisible: false, // 预约时间设置弹层显隐
      appointmentEditTarget: { fieldIndex: null, optionIndex: null }, // 当前编辑的预约选项
      batchAppointmentVisible: false, // 批量添加预约项弹窗显隐
      batchAppointmentText: "", // 批量添加文本
      batchAppointmentFieldIndex: null, // 批量添加目标字段
      // 字段类型配置映射
      fieldTypeMap: {
        0: { type: 1, fieldName: "姓名", num: 3 },
        1: { type: 11, fieldName: "手机号" },
        2: { type: 13, fieldName: "数量" },
        40: {
          type: 40,
          fieldName: "金额",
          placeholder: "金额",
          value: "",
          watermarkImageUrl: "",
        },
        3: { type: 3, fieldName: "日期" },
        4: {
          type: 5,
          fieldName: "请上传图片",
          watermarkSwitch: "0",
          watermarkTimeOrPosition: "",
          annotationPermission: null,
          uploadImageType: "1,2,3",
        },
        35: {
          type: 35,
          fieldName: "请拍照上传",
          watermarkSwitch: 0,
          watermarkTimeOrPosition: "1",
          annotationPermission: 2,
          uploadImageType: "1",
          imageUploadLimit: 9,
        },
        5: { type: 10, fieldName: "身份证" },
        6: { type: 15, fieldName: "时间" },
        7: { type: 12, fieldName: "你所在的位置", posPermissions: 1 },
        8: { type: 8, fieldName: "请选择省市区" },
        9: {
          type: 2,
          fieldName: "性别",
          num: 2,
          content: [
            { value: "男", maxNum: -1 },
            { value: "女", maxNum: -1 },
          ],
        },
        10: { type: 14, fieldName: "请上传健康码", num: 7 },
        11: { type: 14, fieldName: "请上传行程码", num: 8 },
        12: { type: 7, fieldName: "请填写音频标题" },
        13: { type: 6, fieldName: "请填写视频标题" },
        14: { type: 19, fieldName: "邮箱", placeholder: "邮箱" },
        15: { type: 21, fieldName: "学校", placeholder: "学校" },
        16: { type: 22, fieldName: "院系", placeholder: "院系" },
        17: { type: 23, fieldName: "工号", placeholder: "工号" },
        18: { type: 24, fieldName: "学号", placeholder: "学号" },
        19: { type: 25, fieldName: "公司", placeholder: "公司" },
        20: { type: 26, fieldName: "职位", placeholder: "职位" },
        21: { type: 27, fieldName: "部门", placeholder: "部门" },
        22: { type: 28, fieldName: "单位", placeholder: "单位" },
        23: {
          type: 20,
          fieldName: "水印拍照",
          placeholder: "水印拍照",
          watermarkImageUrl: "",
        },
        24: {
          type: 29,
          fieldName: "手写签名",
          placeholder: "手写签名",
          value: "",
          watermarkImageUrl: "",
        },
        36: {
          type: 36,
          fieldName: "文件签字",
          placeholder: "文件签字",
          value: "",
          watermarkImageUrl: "",
        },
        25: {
          type: 32,
          fieldName: "文件",
          placeholder: "文件",
          value: "",
          watermarkImageUrl: "",
        },
        31: {
          type: 31,
          fieldName: "时间区间",
          placeholder: "时间区间",
          value: "",
          watermarkImageUrl: "",
        },
        // 特殊类型
        "-99": { type: 1, fieldName: "", num: 4 }, // AI使用
        "-1": { type: 1, fieldName: "", num: 4 }, // 单行文本
        "-2": {
          type: 2,
          fieldName: "单选",
          num: 1,
          content: [{ value: "", maxNum: -1 }],
        },
        "-3": {
          type: 4,
          fieldName: "多选",
          isChoose: 2,
          isChooseNum: 0,
          content: [{ value: "", maxNum: -1 }],
        },
        "-4": { type: 9, fieldName: "" }, // 多行文本
        "-5": {
          type: 39,
          fieldName: "预约",
          timeSlotType: 1,
          appointmentList: [
            {
              optionName: "",
              sortOrder: 0,
              timeSlotType: 1,
              timeSlots: [],
              maxNum: -1,
            },
          ],
        }, // 预约
        33: {
          type: 33,
          fieldName: "标题",
          isRequired: 0,
          num: 3,
          isname: true,
          isFirst: 0,
        },
      },
      nameOrGroup: 0, // 0不启用 1姓名还是2分组
      onlyNameArr: [],
      onlyGroupArr: [],
      fzPreviewShow: false, // 分组预览显示
      kfShow: false,
      // 图片裁剪
      dialogVisibleCro: false,
      // 裁剪配置
      option: {
        img: "https://ossfastmake.xlkapp.com/12xtPictures/xt-1.png", // 裁剪图片的地址
        info: true, // 裁剪框的大小信息
        outputSize: 0.8, // 裁剪生成图片的质量
        outputType: "jpeg", // 裁剪生成图片的格式
        canScale: false, // 图片是否允许滚轮缩放
        autoCrop: true, // 是否默认生成截图框
        autoCropWidth: 500, // 默认生成截图框宽度
        autoCropHeight: 400, // 默认生成截图框高度
        fixedBox: true, // 固定截图框大小不允许改变
        fixed: true, // 是否开启截图框宽高固定比例
        fixedNumber: [5, 4], // 截图框的宽高比例
        full: false, // 是否输出原图比例的截图
        canMoveBox: true, // 截图框能否拖动
        original: false, // 上传图片按照原始比例渲染
        centerBox: true, // 截图框是否被限制在图片里面
        infoTrue: true, // true 为展示真实输出图片宽高 false 展示看到的截图框宽高
      },
      // 防止重复提交
      loading: false,
      // 裁剪过后的图片
      imgUrl: "",

      activityMode: 1, // 1 报名模式 2接龙模式 默认 1
      uploadPicsType: 1, // 1-模块 2-封面 3-分享图设置
      activityModeUrl: "https://ossfastmake.xlkapp.com/12xtPictures/xt-1.png", // 封面图
      maxImgCount: 9, // 上传图片最大数量
      batchPlayerImage: [],
      shareImgPopShow: false,
      shareImageStyle: 1,
      shareImgWord: "系统分享图",
      uploadImgBtnSrc:
        "https://ossfastmake.xlkapp.com/12jielong/bdJL/uploadImgBtn.svg",
      shareImgColumns: [
        {
          label: "系统分享图",
          value: 1,
        },
        {
          label: "上传自定义",
          value: 2,
        },
      ],
      shareImgColumnsValue: 1,
      shareImageUrl:
        "https://ossfastmake.xlkapp.com/12jielong/bdJL/sys-defaultShareImg.jpg", // 系统分享图地址
      shareZdyImageUrl:
        "https://ossfastmake.xlkapp.com/12jielong/bdJL/uploadImgBtn.svg", // 自定义分享图地址
      uploadImgOrVideo: [
        {
          name: "上传图片",
          id: 1,
        },
        {
          name: "上传视频",
          id: 2,
        },
      ],
      uploadImgOrVideoShow: false,
      UsePop: false, // 说明弹框
      imgOrVideo: 1,
      uploader: null,
      timeout: "",
      partSize: "",
      parallel: "",
      retryCount: "",
      retryDuration: "",
      region: "cn-shanghai",
      userId: "1303984639806000",
      file: null,
      stsProgress: 0,
      uploadDisabled: true,
      resumeDisabled: true,
      pauseDisabled: true,
      statusText: "",
      clockListNumber: 5, // 一行展示多少个参与名单 2一排两个 1一排三个，以此类推
      showAllGroupSwitch: 2, // 名单是否展示全部分组 2-展示 1-不展示

      clockListNumArr: [
        {
          value: 2,
          label: "一排2个",
        },
        {
          value: 3,
          label: "一排3个",
        },
        {
          value: 4,
          label: "一排4个",
        },
        {
          value: 5,
          label: "一排5个",
        },
      ],
      showAllGroupArr: [
        {
          value: 2,
          label: "展示全部分组",
        },
        {
          value: 1,
          label: "隐藏全部分组",
        },
      ],
      // 核销
      verificationSwitch: 1, // 核销开关(1-关闭,2-开启)';默认1
      foreverTimeHxChecked: false,
      verificationStartTime: "", // 核销开始时间
      verificationEndTime: "", // 核销结束时间
      hxStartAndEndTime: "",

      // 签到
      foreverTimeQdChecked: false,
      signInStartTime: "", // 核销开始时间
      signInEndTime: "", // 核销结束时间
      signStartAndEndTime: "",

      // 签到参与地点
      signLocationSwitch: 1, // 是否指定签到地点(1-否,2-是) 默认1
      signLocation: "", // 有经纬度
      signLocationDistance: 2000,
      signInAddress: "",
      signLocationDisShow: false,

      // 签退（签退在场时间）
      attendanceDurationArr: [
        { value: 0, label: "不限制" },
        { value: -1, label: "自定义" },
        { value: 5, label: "5分钟" },
        { value: 15, label: "15分钟" },
        { value: 30, label: "30分钟" },
        { value: 45, label: "45分钟" },
        { value: 60, label: "60分钟" },
        { value: 90, label: "90分钟" },
        { value: 120, label: "120分钟" },
        { value: 150, label: "150分钟" },
        { value: 180, label: "180分钟" },
      ], // 签退在场时间档位（分钟）：0-不限制，-1-自定义输入，其余为预设分钟数
      attendanceDurationSelect: 0, // 签退在场时间下拉选中值：0-不限制(默认)，-1-自定义，预设分钟数
      attendanceDurationDialogVisible: false, // 自定义在场时长输入弹窗
      attendanceDurationInput: "", // 弹窗中的在场时长输入（分钟）
      attendanceDurationPrevSelect: 0, // 打开弹窗前选中的档位，取消时回退

      clockInfoObj: {},
      demonstrateTitle: "演示",
      demonVisible: false,
      contentList: {},
      checkInStatusArr: [
        {
          label: "仅创建者和管理员可见",
          id: 1,
        },
        {
          label: "所有人可见",
          id: 2,
        },
      ],
      checkInStatusShow: false,
      checkInStatusWord: "仅创建者和管理员可见",
      checkInStatusSwitch: 1, // 1创建者管理员可见2所有人可见
      clockSwitch: 1, // 默认1关闭2开启.
      programType: 99, // 小程序类型 1-加加 2-报名
      AppID: "",

      // 封面设置相关
      coverSettingDrawer: false,
      // isCoverEnabled: 1, // 是否启用封面（开关）1-开 2-关
      // coverImages: [], // 自定义封面图片数组
      // maxCoverImages: 5, // 最大封面图片数量
      // coverVideoId: '', // 视频ID
      // coverPlayUrl: '', // 视频地址
      // coverPlayCoverImage: '', // 视频封面
      // coverSubCoverImages: [], // 封面子图片地址
      // coverIsVideo: 2, // 是否是视频 1-视频 2-图片
      // coverActivityModeUrl: 'https://ossfastmake.xlkapp.com/12xtPictures/xt-1.png', // 系统封面图
      customCoverDialog: {
        vid: "", //  视频ID
        playUrl: "", //  视频地址
        playCoverImage: "", //  视频封面
        subCoverImages: [], //  封面子图片地址
        maxCoverImages: 5, // 最大封面图片数量
        isVideo: 2, //  是否是视频 1-视频 2-图片
        isCoverEnabled: 1, //  是否启用封面（开关）1-开 2-关
        activityModeUrl: "https://ossfastmake.xlkapp.com/12xtPictures/xt-1.png", // 系统封面图
      },

      vid: "",
      playUrl: "",
      playCoverImage: "",
      subCoverImages: [],
      isVideo: 2,
      isCoverEnabled: 1,
      videoPollTimer: null, // 视频封面轮询定时器句柄
      moduleVideoPollTimer: null, // 模块视频轮询定时器句柄
      moduleVideoPollIdx: null, // 当前轮询的模块索引
      testHeight: "568rpx", //轮播图初始高度  452
      swiperH: [], //轮播图片高度数据
      swiperIndex: 0, //轮播当前所选序列
      turnPictures: [], // 轮播图
      indicatorDots: true,
      autoplay: true,
      duration: 500,
      activityKey: "",
      phoneSwitch: 1, // 是否显示联系信息 默认1 关闭 2开启
      userPhone: "",
      edit_userPhone: "",
      contactType: 1, // 1-手机号 2-微信号 3-手机号和微信同号
      contactTypeShow: false,
      contactTypeArr: [
        {
          label: "手机号",
          id: 1,
        },
        {
          label: "微信号",
          id: 2,
        },
        {
          label: "手机号和微信同号",
          id: 3,
        },
      ],
      contactTypeText: "手机号",
      batch_set_num: "",
      currentFieldItem: null,
      currentFieldIndex: null,
      catchBatchSetNumShowBox: false,

      // 在线收款相关
      paymentSwitch: 0, // 收款方式：1=在线收款 2=无支付仅统计；0=未选择（仅老数据编辑态出现，保存时强制补选）
      fmActivityChargeItemVOS: [], // 收费项列表
      payPickerVisible: false, // 付费项展示图选择器弹窗
      payPickerIndex: -1, // 当前操作的收费项索引
      authInformation: {}, //认证信息
    };
  },
  mounted() {
    var str11 = dayjs().format("DD/MM/YYYY");
    // 页面参数
    this.routeParameter = this.$route.query;
    if (this.routeParameter.activityId) {
      this.activityId = this.routeParameter.activityId;
    }

    if (this.routeParameter.alias) {
      this.activityKey = this.routeParameter.alias;
    }
    if (this.routeParameter.selectType) {
      this.selectType = this.routeParameter.selectType;
    }
    if (this.routeParameter.is_template) {
      this.is_template = Number(this.routeParameter.is_template); // 1-模板 0-不是模板是活动
    }
    if (this.routeParameter.isType) {
      this.isType = this.routeParameter.isType;
    }
    if (this.routeParameter.selectType) {
      this.selectType = this.routeParameter.selectType;
    }
    if (this.routeParameter.folderId) {
      this.folderId = this.routeParameter.folderId;
      // 在文件夹内创建，isInFolder 设置为 2
      this.isInFolder = 2;
    }
    if (this.routeParameter.isInFolder) {
      this.isInFolder = this.routeParameter.isInFolder;
    }
    if (this.routeParameter.isAi) {
      this.isAi = this.routeParameter.isAi;
    }
    if (this.routeParameter.rateType) {
      this.rateType = this.routeParameter.rateType;
    }

    this.pageType = this.routeParameter.pageType;
    this.ifcopy = this.routeParameter.copy;
    this.groupId = this.routeParameter.groupId;

    if (this.isType == 101) {
      this.activeBuildTitle = "收费报名";
    }
    if (this.isType == 109) {
      this.activeBuildTitle = "打卡接龙";
    }
    if (this.isType == 110) {
      this.activeBuildTitle = "周期打卡";
    }
    if (this.isType == 106) {
      this.activeBuildTitle =
        copyrightConfig.AppID == "wx7d8daf6d777947a2" ? "通用报名" : "通用接龙";
    }

    // generalCheckTimesArr已在data中初始化

    this.subAddress();
    this.lastDayOfMonth = this.getLastDayOfMonth();
    // 截止赋值
    var arr1 = [];
    for (var i = 1; i <= 31; i++) {
      var str = i + "号";
      var _json = {
        value: i,
        label: str,
      };
      arr1.push(_json);
    }
    this.endMonthArr1 = arr1;

    var arr2 = [];
    for (var j = 0; j <= 23; j++) {
      if (j < 10) {
        var timeJson1 = {
          value: j,
          label: "0" + j + "时",
        };
        arr2.push(timeJson1);
      } else {
        var timeJson2 = {
          value: j,
          label: j + "时",
        };
        arr2.push(timeJson2);
      }
    }
    this.endMonthArr2 = arr2;
    this.endWeekArr2 = arr2;

    var arr3 = [];
    for (var g = 0; g <= 59; g++) {
      if (g < 10) {
        var timeJson3 = {
          value: g,
          label: "0" + g + "分",
        };
        arr3.push(timeJson3);
      } else {
        var timeJson4 = {
          value: g,
          label: g + "分",
        };
        arr3.push(timeJson4);
      }
    }
    this.endMonthArr3 = arr3;
    this.endWeekArr3 = arr3;

    this.clockPresetsList();
    this.activityDetailFun();
    this.getRelatedList();
    // 确保标题设置生效
    this.$nextTick(() => {
      this.setPageTitle();
      // 初始化底部按钮滚动监听
      this.initBottomBtnScroll();
    });
  },
  watch: {
    gzhDialogVisible(newVal, oldVal) {
      if (!newVal && oldVal) {
        this.handleGzhDialogClosed();
      }
    },
    relatedDrawerShow(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          const scrollableDiv = document.getElementById("scrollable-div");
          if (scrollableDiv) {
            this.scrollHandler = (event) => {
              this.isLoading = false;

              // 添加一个小的容错值(比如5px)来处理可能的小数点误差
              if (
                scrollableDiv.scrollTop + scrollableDiv.clientHeight + 5 >=
                scrollableDiv.scrollHeight
              ) {
                this.pageNum++;
                this.getRelatedList();
              }
            };
            scrollableDiv.addEventListener("scroll", this.scrollHandler);
          }
        });
      } else {
        const scrollableDiv = document.getElementById("scrollable-div");
        if (scrollableDiv && this.scrollHandler) {
          scrollableDiv.removeEventListener("scroll", this.scrollHandler);
        }
      }
    },
    "propertyData.content"(newVal, oldVal) {
      var length = this.propertyData.content.length;
      this.maxValueArr = [];
      this.minValueArr = [];
      for (var i = 0; i <= length; i++) {
        if (i == 0) {
          const bx = {
            value: 0,
            label: "不限",
          };
          this.maxValueArr.push(bx);
          this.minValueArr.push(bx);
        } else {
          const other = {
            value: i,
            label: i,
          };
          this.maxValueArr.push(other);
          this.minValueArr.push(other);
        }
      }
    },
  },
  beforeDestroy() {
    const scrollableDiv = document.getElementById("scrollable-div");
    if (scrollableDiv && this.scrollHandler) {
      scrollableDiv.removeEventListener("scroll", this.scrollHandler);
    }
    // 移除底部按钮的滚动监听
    if (this.bottomBtnScrollHandler) {
      window.removeEventListener("scroll", this.bottomBtnScrollHandler);
    }
    // 清理视频封面轮询定时器
    this._clearVideoPollTimer();
    this._clearModuleVideoPollTimer();
  },
  methods: {
    // 校验失败时：弹出提示并平滑滚动到对应区块
    // refName 为模板中区块的 ref 名称
    warnAndScroll(message, refName) {
      this.$message(message);
      this.scrollToError(refName);
    },
    // 平滑滚动到指定 ref 对应的 DOM 节点
    scrollToError(refName) {
      if (!refName) return;
      this.$nextTick(() => {
        const ref = this.$refs[refName];
        if (!ref) return;
        // ref 可能是原生元素、组件（取 $el）或 v-for 产生的数组
        let el;
        if (Array.isArray(ref)) {
          el = ref[0] && (ref[0].$el || ref[0]);
        } else {
          el = ref.$el || ref;
        }
        if (el && el.scrollIntoView) {
          el.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      });
    },
    openNoticeConfig() {
      this.noticeConfig = this.activityDetail.noticeConfig || {
        noticeEnabled: 0,
      };
      this.noticeDialogVisible = true;
    },
    handleNoticeConfigSave(config) {
      // config 就是完整的须知配置对象
      // 你可以挂载到表单数据上，或发送给后端
      this.activityDetail.noticeConfig = config;
      console.log("须知配置:", config);
    },
    // 获取填表项标签（第 x 项）
    getFormLabel(index) {
      const numToChinese = {
        1: "一",
        2: "二",
        3: "三",
        4: "四",
        5: "五",
        6: "六",
        7: "七",
        8: "八",
        9: "九",
        10: "十",
      };
      const chinese = numToChinese[index] || index;
      return "第" + chinese + "项";
    },
    // 初始化底部按钮滚动监听（防止按钮盖住 footer）
    initBottomBtnScroll() {
      this.bottomBtnScrollHandler = () => {
        const footer = document.querySelector(".footer");
        const btnBox = document.querySelector(".posi-bottom-btn-box");

        if (!footer || !btnBox) return;

        const footerRect = footer.getBoundingClientRect();
        const windowHeight = window.innerHeight;

        // footer 进入视口时，把按钮向上顶
        if (footerRect.top < windowHeight) {
          const overlap = windowHeight - footerRect.top;
          // 0px 是原始 bottom 值，overlap 是 footer 进入视口的高度
          btnBox.style.bottom = `${overlap}px`;
        } else {
          btnBox.style.bottom = "0px";
        }
      };

      window.addEventListener("scroll", this.bottomBtnScrollHandler);
    },
    // 打开设置逻辑弹层
    openSetLogicDialog(fieldItem, fieldIndex, listIndex) {
      console.log("openSetLogicDialog called", {
        fieldItem,
        fieldIndex,
        listIndex,
      });
      this.currentEditFieldData = JSON.parse(JSON.stringify(fieldItem));
      this.currentLogicFieldIndex = fieldIndex;
      this.currentLogicListIndex = listIndex;
      this.allSignFieldsData = this.listList[listIndex].signField || [];
      this.setLogicDialogVisible = true;
      console.log(
        "setLogicDialogVisible set to true",
        this.setLogicDialogVisible,
      );
    },

    // 保存设置逻辑
    handleSetLogicSave(data) {
      // 更新 listList 中对应的数据
      const fieldData = data.fieldData;
      const fieldIndex = data.fieldIndex;
      const listIndex = data.listIndex;

      if (
        this.listList[listIndex] &&
        this.listList[listIndex].signField &&
        this.listList[listIndex].signField[fieldIndex]
      ) {
        // 更新选项内容（包含 logicRules）
        this.listList[listIndex].signField[fieldIndex].content =
          fieldData.content;
        this.$message.success("保存成功");
      }
    },

    // 设置页面标题
    setPageTitle() {
      // 根据 AppID 确定后缀
      let suffix = "接龙加加";
      if (copyrightConfig.AppID === "wx7d8daf6d777947a2") {
        suffix = "报名管家";
      }

      document.title = `创建接龙 - ${suffix}`;
      console.log(document.title, "document.title");
    },

    // 去认证（打开小程序码）
    goAuthPage() {
      this.authCodeUrl =
        // "https://ossfastmake.xlkapp.com/mini_code/index_infowx7d8daf6d777947a2_new_test_9425.png";
        "https://ossfastmake.xlkapp.com/mini_code/index_infowx7d8daf6d777947a2_new_pro_4233.png";
      this.authCodeDialogVisible = true;
    },

    // 计算显示索引（排除 type===33 的标题项）
    getFieldDisplayIndex(fieldIndex, listIndex) {
      const signField = this.listList[listIndex].signField;
      let displayIndex = 0;
      for (let i = 0; i <= fieldIndex; i++) {
        if (signField[i].type != 33) {
          displayIndex++;
        }
      }
      return displayIndex;
    },

    // 获取选项的逻辑规则说明文字
    getLogicRuleText(option, fieldIndex, listIndex) {
      if (!option || !option.logicRules || option.logicRules.length === 0)
        return "";
      const rule = option.logicRules[0];
      const allSignFields = this.listList[listIndex].signField || [];

      if (rule.ruleType === "SHOW") {
        const ids = String(rule.jumpToQuestionId).split(",");
        const segments = ids
          .map((id) => {
            const rawId = id.trim();
            const parts = rawId.split(":");
            const fieldPart = parts[0];
            const hasPartial = parts.length > 1;

            // 优先通过显示的序号匹配
            let index = allSignFields.findIndex(
              (f, idx) =>
                f.type != 33 &&
                String(this.getFieldDisplayIndex(idx, listIndex)) === fieldPart,
            );
            // 如果没找到，再通过 id 或 索引匹配
            if (index === -1) {
              index = allSignFields.findIndex(
                (f, idx) =>
                  String(f.id) === fieldPart || String(idx) === fieldPart,
              );
            }
            if (index > -1) {
              const displayNum = this.getFieldDisplayIndex(index, listIndex);
              return `第${displayNum}题${hasPartial ? "(部分选项)" : ""}`;
            }
            return null;
          })
          .filter((s) => s !== null);

        if (segments.length > 0) {
          return "显示" + segments.join(",");
        }
      }

      if (rule.ruleType === "JUMP") {
        if (rule.jumpToQuestionId === -1 || rule.jumpToQuestionId === "-1") {
          return "跳转至结束";
        }
        const targetStr = String(rule.jumpToQuestionId).trim();
        // 优先通过显示的序号匹配
        let index = allSignFields.findIndex(
          (f, idx) =>
            f.type != 33 &&
            String(this.getFieldDisplayIndex(idx, listIndex)) === targetStr,
        );
        // 如果没找到，再通过 id 或 索引匹配
        if (index === -1) {
          index = allSignFields.findIndex(
            (f, idx) => String(f.id) === targetStr || String(idx) === targetStr,
          );
        }
        if (index > -1) {
          return (
            "跳转至第" + this.getFieldDisplayIndex(index, listIndex) + "题"
          );
        }
      }
      return "";
    },

    getGzhDialogShowCount() {
      if (typeof window === "undefined" || !window.localStorage) {
        return 0;
      }
      try {
        const storedValue = window.localStorage.getItem(GZH_DIALOG_LIMIT_KEY);
        const parsedValue = Number(storedValue);
        return Number.isNaN(parsedValue) ? 0 : parsedValue;
      } catch (error) {
        console.warn("getGzhDialogShowCount error", error);
        return 0;
      }
    },
    setGzhDialogShowCount(count) {
      if (typeof window === "undefined" || !window.localStorage) {
        return;
      }
      try {
        const normalizedValue = Math.max(0, Number(count) || 0);
        window.localStorage.setItem(
          GZH_DIALOG_LIMIT_KEY,
          String(normalizedValue),
        );
      } catch (error) {
        console.warn("setGzhDialogShowCount error", error);
      }
    },
    shouldLimitGzhDialog() {
      return this.selectType === "add";
    },
    canShowGzhDialog() {
      if (!this.shouldLimitGzhDialog()) {
        return true;
      }
      return this.getGzhDialogShowCount() < GZH_DIALOG_MAX_SHOW;
    },
    recordGzhDialogShow() {
      if (!this.shouldLimitGzhDialog()) {
        return;
      }
      const currentCount = this.getGzhDialogShowCount();
      this.setGzhDialogShowCount(currentCount + 1);
    },
    waitForGzhDialogClose() {
      this.resolveGzhDialogPromise();
      return new Promise((resolve) => {
        this.gzhDialogPromiseResolver = resolve;
      });
    },
    resolveGzhDialogPromise() {
      if (typeof this.gzhDialogPromiseResolver === "function") {
        this.gzhDialogPromiseResolver();
        this.gzhDialogPromiseResolver = null;
      }
    },
    handleGzhDialogClosed() {
      this.resolveGzhDialogPromise();
    },
    closeGzhDialog() {
      this.gzhDialogVisible = false;
    },
    showGzhDialog(options = {}) {
      const respectLimit = Object.prototype.hasOwnProperty.call(
        options,
        "respectLimit",
      )
        ? options.respectLimit
        : this.shouldLimitGzhDialog();
      const waitForClose = Object.prototype.hasOwnProperty.call(
        options,
        "waitForClose",
      )
        ? options.waitForClose
        : false;
      if (respectLimit && !this.canShowGzhDialog()) {
        return waitForClose ? Promise.resolve(false) : false;
      }
      this.gzhDialogVisible = true;
      if (respectLimit) {
        this.recordGzhDialogShow();
      }
      if (waitForClose) {
        return this.waitForGzhDialogClose();
      }
      return true;
    },
    async handleEnablePushChange(value) {
      if (
        this.selectType !== "add" ||
        (this.activityDetail && this.activityDetail.id)
      ) {
        return;
      }
      if (Number(value) === 1) {
        await this.checkWechatFollowStatus();
      }
    },
    async checkWechatFollowStatus(options = {}) {
      const showDialog =
        options && Object.prototype.hasOwnProperty.call(options, "showDialog")
          ? options.showDialog
          : true;
      const respectLimit =
        options && Object.prototype.hasOwnProperty.call(options, "respectLimit")
          ? options.respectLimit
          : this.shouldLimitGzhDialog();
      if (this.wechatFollowStatus === 2) {
        return true;
      }
      if (this.wechatFollowStatus === 1) {
        if (showDialog) {
          await this.showGzhDialog({ respectLimit, waitForClose: true });
        }
        return false;
      }
      try {
        const { status, data } = await isFollowWechat({});
        if (status === 1) {
          const followStatusRaw =
            typeof data === "object" && data !== null
              ? data.followStatus ?? data.status ?? data.value
              : data;
          const followStatus = Number(followStatusRaw);
          if (!Number.isNaN(followStatus)) {
            this.wechatFollowStatus = followStatus;
            if (followStatus === 2) {
              return true;
            }
          }
        }
        if (showDialog) {
          await this.showGzhDialog({ respectLimit, waitForClose: true });
        }
        return false;
      } catch (error) {
        console.error("checkWechatFollowStatus error", error);
        this.$message.error("获取关注状态失败，请稍后再试");
        return false;
      }
    },
    // 批量设置数量
    batchSetNum(fieldItem, fieldIndex) {
      this.currentFieldItem = fieldItem;
      this.currentFieldIndex = fieldIndex;
      this.catchBatchSetNumShowBox = true;
    },
    confirmBatchSetNum() {
      // 批量设置数量
      if (this.currentFieldItem && this.currentFieldItem.content) {
        // 为当前字段的所有选项设置相同的数量
        this.currentFieldItem.content.forEach((item, index) => {
          // 如果输入为空，设置为-1表示数量不限
          item.maxNum =
            this.batch_set_num === "" ||
              this.batch_set_num === null ||
              this.batch_set_num === undefined
              ? -1
              : parseInt(this.batch_set_num) || 0;
        });

        // 关闭弹窗并清空输入
        this.catchBatchSetNumShowBox = false;
        this.batch_set_num = "";
        this.$message("批量设置数量成功");
      } else {
        this.$message("数据错误，请重试");
      }
    },
    // 处理数量值变化
    handleNumValueChange(event, item) {
      console.log("handleNumValueChange处理数量值变化", event, item);
      // 检查item是否存在
      if (!item) {
        console.warn("handleNumValueChange: item is undefined");
        return;
      }
      const value = event;
      // if (value === "" || value === null || value === undefined) {
      //   item.maxNum = -1; // 空值设为-1表示无限
      // } else {

      // }
      item.maxNum = parseInt(value) || 0;
      console.log(item.maxNum, "item.maxNumitem.maxNum");
    },
    // 处理数量值获得焦点
    handleNumValueFocus(item) {
      // 检查item是否存在
      if (!item) {
        console.warn("handleNumValueFocus: item is undefined");
        return;
      }
      // 如果当前值是-1（无限），清空输入框让用户输入
      if (item.maxNum === -1) {
        item.maxNum = "";
      }
    },
    // 处理选项截止时间变更
    handleOptionDeadlineChange(val, item) {
      if (val) {
        // 设置截止时间，时间固定为 00:00:00
        this.$set(item, "validateDateTo", val + " 00:00:00");
        this.$set(item, "tempDeadline", val);
      } else {
        this.$set(item, "validateDateTo", "");
        this.$set(item, "tempDeadline", null);
      }
    },
    // 清除选项截止时间
    clearOptionDeadline(item, index) {
      this.$set(item, "validateDateTo", "");
      this.$set(item, "tempDeadline", null);
    },
    // 显示日期选择器
    showDatePicker(item, index) {
      // 如果已有截止时间，从中提取日期部分
      if (item.validateDateTo) {
        const datePart = item.validateDateTo.split(" ")[0];
        this.$set(item, "tempDeadline", datePart);
      }
      // 使用动态 ref 获取对应索引的日期选择器
      this.$nextTick(() => {
        const picker = this.$refs["deadlinePicker-" + index];
        if (picker) {
          // 如果是数组取第一个，否则直接使用
          const pickerEl = Array.isArray(picker) ? picker[0] : picker;
          if (pickerEl && pickerEl.focus) {
            pickerEl.focus();
          }
        }
      });
    },
    // 保存活动时同步maxNum到fmFieldNumList
    syncMaxNumToFieldNumListForSave(fieldData) {
      // 检查是否是单选或多选类型
      if (
        (fieldData.type === 2 ||
          fieldData.type === 4 ||
          fieldData.type === 9) &&
        fieldData.content &&
        Array.isArray(fieldData.content)
      ) {
        // 确保fmFieldNumList存在
        if (!fieldData.fmFieldNumList) {
          fieldData.fmFieldNumList = [];
        }

        // 遍历content中的每个选项，同步maxNum到fmFieldNumList
        fieldData.content.forEach((option, optionIndex) => {
          // 如果fmFieldNumList中没有对应索引的项，创建一个
          if (!fieldData.fmFieldNumList[optionIndex]) {
            fieldData.fmFieldNumList[optionIndex] = {
              id: null,
              itemId: null,
              ifDel: 2,
              addTime: new Date()
                .toISOString()
                .replace("T", " ")
                .substring(0, 19),
              filedNumId: null,
              maxNum: option.maxNum !== undefined ? option.maxNum : -1,
              optionName: null,
              value: option.value || null,
            };
          } else {
            // 更新已存在项的maxNum
            fieldData.fmFieldNumList[optionIndex].maxNum =
              option.maxNum !== undefined ? option.maxNum : -1;
            fieldData.fmFieldNumList[optionIndex].value = option.value || null;
          }
        });
      }
    },
    // 处理选项值变化
    handleOptionValueChange(event, fieldIndex, optionIndex) {
      const value = event.detail.value;
      // 使用 $set 确保响应式更新
      this.$set(
        this.listList[this.indexIdx].signField[fieldIndex].content[optionIndex],
        "value",
        value,
      );

      // 强制更新视图
      this.$forceUpdate();

      const updatedValue =
        this.listList[this.indexIdx].signField[fieldIndex].content[optionIndex]
          .value;
    },
    // 打开封面设置
    openCoverSetting() {
      // 初始化封面设置数据
      this.customCoverDialog.isCoverEnabled = this.isCoverEnabled;
      this.customCoverDialog.activityModeUrl = this.activityModeUrl;
      this.customCoverDialog.subCoverImages = this.subCoverImages;
      this.customCoverDialog.isVideo = this.isVideo;
      this.customCoverDialog.vid = this.vid;
      this.customCoverDialog.playUrl = this.playUrl;
      if (this.customCoverDialog.subCoverImages.length >= 1) {
        this.customCoverDialog.isCoverEnabled = 2;
      }
      this.coverSettingDrawer = true;
    },

    // 关闭封面设置
    closeCoverSetting() {
      this.coverSettingDrawer = false;
    },

    // 保存封面设置
    saveCoverSetting() {
      this.vid = this.customCoverDialog.vid;
      this.playUrl = this.customCoverDialog.playUrl;
      this.playCoverImage = this.customCoverDialog.playCoverImage;
      this.subCoverImages = this.customCoverDialog.subCoverImages;
      this.isVideo = this.customCoverDialog.isVideo;
      this.isCoverEnabled = this.customCoverDialog.isCoverEnabled;
      this.activityModeUrl = this.customCoverDialog.activityModeUrl;

      // 整合activityModeUrl和subCoverImages到turnPictures数组
      this.turnPictures = [];
      // 如果activityModeUrl不为空字符串，则添加到数组开头
      if (this.activityModeUrl && this.activityModeUrl.trim() !== "") {
        this.turnPictures.push(this.activityModeUrl);
      }
      // 如果subCoverImages不为空数组，则添加到turnPictures中
      if (this.subCoverImages && this.subCoverImages.length > 0) {
        this.turnPictures = this.turnPictures.concat(this.subCoverImages);
      }

      if (this.isCoverEnabled == 2 && this.activityModeUrl) {
        // 删除 turnPictures 数组里的第一个
        this.turnPictures.splice(0, 1);
      }

      this.coverSettingDrawer = false;
      this.$message.success("封面设置保存成功");
    },

    // 选择系统封面
    selectSystemCover() {
      this.$refs.systemPictures.openSysPop(1);
    },

    // 确认选择系统封面
    confirmSystemCover(item) {
      this.customCoverDialog.activityModeUrl = item.url;
      this.customCoverDialog.isVideo = 2; // 系统封面是图片
    },

    // 上传自定义封面图片
    handleCoverImageUpload(event) {
      this.selectedFile = event.target.files;

      // 检查当前图片数量限制
      const currentImageCount = this.customCoverDialog.subCoverImages.length;
      const maxImages = this.customCoverDialog.maxCoverImages;

      if (currentImageCount >= maxImages) {
        this.$message.warning(`最多只能上传${maxImages}张自定义封面图片`);
        event.target.value = "";
        return;
      }

      // 检查选择的文件数量是否会超过限制
      const remainingSlots = maxImages - currentImageCount;
      const filesToProcess = Math.min(this.selectedFile.length, remainingSlots);

      if (this.selectedFile.length > remainingSlots) {
        this.$message.warning(`最多只能再上传${remainingSlots}张图片`);
      }

      var pettern = /^image/;
      for (let i = 0; i < filesToProcess; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          event.target.value = "";
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("请上传大小不超过5MB文件");
          event.target.value = "";
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.isVideo = 2;
                this.customCoverDialog.isCoverEnabled = 2;
                this.subCoverImages.push(this.imageUrl + response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }

      // 清空文件输入框
      event.target.value = "";
    },

    // 上传封面视频
    handleCoverVideoUpload(event) {
      // 重新上传时清掉旧轮询
      this._clearVideoPollTimer();
      this.file = event.target.files[0];
      console.log("this.file", this.file);
      if (this.customCoverDialog.subCoverImages.length > 5) {
        this.$message("最多可上传5张自定义封面图片!");
        return;
      }
      if (!this.file) {
        this.$message("请先选择需要上传的文件!");
        return;
      }

      // 检查文件格式
      const lastArr = this.file.name.split(".");
      if (lastArr[1] !== "mp4") {
        this.$message("文件格式不正确，请上传MP4格式视频");
        event.target.value = "";
        return;
      }

      // 检查文件大小
      if (this.file.size / 1048576 > 10) {
        this.$message("请上传大小不超过10MB文件");
        event.target.value = "";
        return;
      }

      const fileURL = URL.createObjectURL(this.file);
      this.customCoverDialog.playUrl = fileURL;

      var Title = this.file.name;
      var userData = '{"Vod":{}}';

      if (this.uploader) {
        this.uploader.stopUpload();
        this.stsProgress = 0;
        this.statusText = "";
      }

      this.uploader = this.createUploader();
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
      this.customCoverDialog.isVideo = 1;
    },

    // 删除自定义封面图片
    deleteCoverImage(index) {
      this.customCoverDialog.subCoverImages.splice(index, 1);
    },
    // 删除视频
    deleteVideo() {
      this._clearVideoPollTimer();
      this.customCoverDialog.isVideo = 2;
      this.customCoverDialog.playUrl = "";
    },
    // 添加自定义封面图片到数组
    addCoverImage(imageUrl) {
      if (
        this.customCoverDialog.subCoverImages.length <
        this.customCoverDialog.maxCoverImages
      ) {
        this.customCoverDialog.subCoverImages.push(imageUrl);
      } else {
        this.$message.warning(
          `最多只能上传${this.customCoverDialog.maxCoverImages}张自定义封面图片`,
        );
      }
    },

    // 选择自定义封面
    selectCustomCover(imageUrl) {
      this.customCoverDialog.activityModeUrl = imageUrl;
      this.customCoverDialog.isVideo = 2; // 图片
      this.$message.success("已选择该图片作为封面");
    },

    // 切换封面启用状态
    toggleCoverEnabled(value) {
      console.log("切换封面启用状态:", value);
      this.customCoverDialog.isCoverEnabled = value;
    },

    demonstrate(n) {
      this.contentList = {};
      if (n == 1) {
        this.contentList = {
          title: "版式选择演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/bdJL/bm-yanshi.png",
        };
      }
      if (n == 2) {
        this.contentList = {
          title: "填表项设置演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/bdJL/tbx-tishi.jpg",
        };
      }
      if (n == 3) {
        this.contentList = {
          title: "匿名参与使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/niming-tishi.png",
        };
      }
      if (n == 4) {
        this.contentList = {
          title: "显示发布人信息使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/faburen-tishi.jpg",
        };
      }
      if (n == 5) {
        this.contentList = {
          title: "群聊演示弹框",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/qunliao-tishi.jpg",
        };
      }
      if (n == 6) {
        this.contentList = {
          title: "核销演示弹框",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/hexiao-tishi.jpg",
        };
      }
      if (n == 7) {
        this.contentList = {
          title: "签到码演示弹框",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/qiandao-tishi.jpg",
        };
      }
      if (n == 8) {
        this.contentList = {
          title: "撤销签到功能使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/chexiaoqd-tishi.jpg",
        };
      }
      if (n == 9) {
        this.contentList = {
          title: "参与信息使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/bbxxtishi1.jpg",
        };
      }
      if (n == 10) {
        this.contentList = {
          title: "指定参与地点使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/canyudidian-tishi.jpg",
        };
      }
      if (n == 11) {
        this.contentList = {
          title: "添加名单使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/add-mingdan-tishi.png",
        };
      }
      if (n == 12) {
        this.contentList = {
          title: "加密浏览分享数据演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/jimiliulanshuju-tishi-jiami.jpg",
        };
      }
      if (n == 13) {
        this.contentList = {
          title: "内容展开收起使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/bdJL/collExpand-tips.png",
        };
      }
      if (n == 14) {
        this.contentList = {
          title: "签到数据大屏使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/dataBigScreen-yanshi.png",
        };
      }
      if (n == 15) {
        this.contentList = {
          title: "标题添加使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/title-yanshi.jpg",
        };
      }
      if (n == 17) {
        this.contentList = {
          title: "隐藏人员名单使用演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/ycrymdsy.png",
        };
      }
      if (n == 18) {
        this.contentList = {
          title: "隐藏活动属性区域使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/ychdsxqysy.png",
        };
      }
      if (n == 19) {
        this.contentList = {
          title: "隐藏修改参与信息规则使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/ycxgcyxxgzsy.png",
        };
      }
      if (n == 20) {
        this.contentList = {
          title: "隐藏人数限制与取消规则使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/hideLimit-tishi.png",
        };
      }
      if (n == 21) {
        this.contentList = {
          title: "折叠参与者信息使用演示",
          imgurl:
            "https://ossfastmake.xlkapp.com/12jielong/lsyJL/zdcyzxxsy.png",
        };
      }
      if (n == 23) {
        this.contentList = {
          title: "收费报名使用教程演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/111111.png",
        };
      }
      if (n == 24) {
        this.contentList = {
          title: "文件签字使用说明演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/222222.png",
        };
      }
      if (n == 25) {
        this.contentList = {
          title: "参与数据同步至投票管家演示",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/bdJL/bm-tb.jpg",
        };
      }
      if (n == 26) {
        this.contentList = {
          title: "推荐返利使用说明",
          imgurl: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/tjfl-ys.jpg",
        };
      }
      if (n == 27) {
        this.contentList = {
          title: "报名成功弹幕使用演示",
          imgurl: "https://ossfastmake.mustke.com/12jielong/lsyJL/danmuyanshi.jpg",
        };
      }
      this.demonVisible = true;
    },
    clockListNumFn(n) {
      this.clockListNumber = n;
      this.activityDetail.clockListNumber = n;
    },
    showAllGroupFn(e) {
      this.showAllGroupSwitch = e;
      this.activityDetail.showAllGroupSwitch = e;
    },
    // 预设名单开关：开启且无名单时注入默认名单；关闭仅隐藏展示区，名单保留在内存
    presetNameSwitchChange(e) {
      this.clockSwitch = e;
      this.activityDetail.clockSwitch = Number(e);
      if (
        e == 2 &&
        (!this.packetData || this.packetData.length === 0) &&
        (!this.subsetValueArr || this.subsetValueArr.length === 0)
      ) {
        this.subsetValueArr = [
          {
            clockInList: "李某某,王某某",
            listGroupName: "",
            clockInListNum: 2,
          },
        ];
        this.subsetCenterValueArr = JSON.parse(
          JSON.stringify(this.subsetValueArr),
        );
        this.packetData = ["李某某", "王某某"];
        this.nameListLength = 2;
        this.nameAddType = 1;
        this.pickerName = "全部";
      }
    },
    ...mapActions("commonData", ["saveIsOpenShare"]),

    openIV() {
      this.uploadImgOrVideoShow = true;
    },
    IVClick(e) { },
    handleCoverImgUpload(event) {
      this.selectedFile = event.target.files;
      console.log(event.target.value);
      const iptElm = document.getElementById("uploadImageBtn");
      const url = URL.createObjectURL(iptElm.files[0]);
      this.option["img"] = url;
      this.dialogVisibleCro = true;
    },
    handleVideoFmUpload(e) {
      this.file = e.target.files[0];
      if (!this.file) {
        alert("请先选择需要上传的文件!");
        return;
      }
      console.log(e.target.files[0], "e.target======");
      const fileURL = URL.createObjectURL(this.file);
      console.log(fileURL, "fileURL=====");
      this.customCoverDialog.playUrl = fileURL;
      var Title = this.file.name;
      var userData = '{"Vod":{}}';
      if (this.uploader) {
        this.uploader.stopUpload();
        this.authProgress = 0;
        this.statusText = "";
      }
      this.uploader = this.createUploader();
      // 首先调用 uploader.addFile(event.target.files[i], null, null, null, userData)
      console.log(userData);
      this.uploader.addFile(this.file, null, null, null, userData);
      this.uploadDisabled = false;
      this.pauseDisabled = true;
      this.resumeDisabled = false;
    },
    // 开始上传
    stsUpload() {
      // 然后调用 startUpload 方法, 开始上传
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.uploadDisabled = true;
        this.pauseDisabled = false;
      }
    },
    // 暂停上传
    pauseUpload() {
      if (this.uploader !== null) {
        this.uploader.stopUpload();
        this.resumeDisabled = false;
        this.pauseDisabled = true;
      }
    },
    // 恢复上传
    resumeUpload() {
      if (this.uploader !== null) {
        this.uploader.startUpload();
        this.resumeDisabled = true;
        this.pauseDisabled = false;
      }
    },
    /* global AliyunUpload */
    createUploader() {
      const self = this;
      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const uploader = new AliyunUpload.Vod({
        timeout: self.timeout || 60000,
        partSize: Math.round(self.partSize || 1048576),
        parallel: self.parallel || 5,
        retryCount: self.retryCount || 3,
        retryDuration: self.retryDuration || 2,
        region: self.region,
        userId: self.userId,
        localCheckpoint: true, //此参数是禁用服务端缓存
        // 添加文件成功
        addFileSuccess: (uploadInfo) => {
          self.uploadDisabled = false;
          self.resumeDisabled = false;
          self.statusText = "添加文件成功, 等待上传...";
          console.log("addFileSuccess: " + uploadInfo.file.name);
          self.stsUpload();
        },
        // 开始上传
        onUploadstarted: (uploadInfo) => {
          console.log("onUploadstarted", uploadInfo);

          axios
            .post(serverConfig.baseURL + "/videoTx/getVideoPathToken", "", {
              headers: {
                "Content-Type": "application/json",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              console.log("response", response);
              var result = response.data;
              console.log("result", response);
              if (result.status == 1) {
                console.log("result", result.data.AccessKeyId);
                uploader.setSTSToken(
                  uploadInfo,
                  result.data.AccessKeyId,
                  result.data.AccessKeySecret,
                  result.data.SecurityToken,
                );
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });

          self.statusText = "文件开始上传...";
          console.log(
            "onUploadStarted:" +
            uploadInfo.file.name +
            ", endpoint:" +
            uploadInfo.endpoint +
            ", bucket:" +
            uploadInfo.bucket +
            ", object:" +
            uploadInfo.object,
          );
        },

        // 文件上传成功
        onUploadSucceed: (uploadInfo) => {
          console.log(
            "onUploadSucceed: " +
            uploadInfo.file.name +
            ", endpoint:" +
            uploadInfo.endpoint +
            ", bucket:" +
            uploadInfo.bucket +
            ", object:" +
            uploadInfo.object,
          );
          console.log(uploadInfo, "上传成功！！！！");
          self.activityDetail.vid = uploadInfo.videoId;
          // self.activityDetail.playUrl = uploadInfo.endpoint + '/' +uploadInfo.object;
          self.activityDetail.isVideo = 1;
          self.statusText = "文件上传成功!";

          // 如果是封面设置模式，更新封面设置数据 + 轮询拉取封面
          if (self.coverSettingDrawer) {
            self.customCoverDialog.vid = uploadInfo.videoId;
            self.customCoverDialog.isVideo = 1;
            self.statusText = "等待视频处理完成...";
            self._pollVideoPath(uploadInfo.videoId);
          }
        },
        // 文件上传失败
        onUploadFailed: (uploadInfo, code, message) => {
          console.log(
            "onUploadFailed: file:" +
            uploadInfo.file.name +
            ",code:" +
            code +
            ", message:" +
            message,
          );
          self.statusText = "文件上传失败!";
        },
        // 取消文件上传
        onUploadCanceled: (uploadInfo, code, message) => {
          console.log(
            "Canceled file: " +
            uploadInfo.file.name +
            ", code: " +
            code +
            ", message:" +
            message,
          );
          self.statusText = "文件已暂停上传";
        },
        // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
        onUploadProgress: (uploadInfo, totalSize, progress) => {
          console.log(
            "onUploadProgress:file:" +
            uploadInfo.file.name +
            ", fileSize:" +
            totalSize +
            ", percent:" +
            Math.ceil(progress * 100) +
            "%",
          );
          const progressPercent = Math.ceil(progress * 100);
          self.stsProgress = progressPercent;
          self.statusText = "文件上传中...";
        },
        // 上传凭证超时
        onUploadTokenExpired: function (uploadInfo) {
          // 如果是上传方式二即根据 STSToken 实现时，从新获取STS临时账号用于恢复上传
          // 上传文件过大时可能在上传过程中 sts token 就会失效, 所以需要在 token 过期的回调中调用 resumeUploadWithSTSToken 方法
          // 这里是测试接口, 所以我直接获取了 STSToken
          // let stsUrl = 'http://demo-vod.cn-shanghai.aliyuncs.com/voddemo/CreateSecurityToken?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=67999yyuuuy&AppVersion=1.0.0'
          // axios.get(stsUrl).then(({data}) => {
          //     let info = data.SecurityTokenInfo
          //     let accessKeyId = info.AccessKeyId
          //     let accessKeySecret = info.AccessKeySecret
          //     let secretToken = info.SecurityToken
          //     let expiration = info.Expiration
          //     uploader.resumeUploadWithSTSToken(accessKeyId, accessKeySecret, secretToken, expiration)
          // })

          this.$message("文件上传超时");
          self.statusText = "文件超时...";
        },
        // 全部文件上传结束
        onUploadEnd: (uploadInfo) => {
          loading.close();
          console.log("onUploadEnd: uploaded all the files");
          self.statusText = "文件上传完毕";
        },
      });
      return uploader;
    },

    // 轮询拉取视频封面/播放地址:VOD 转码/截图未完成时需要重试,每 2s 一次,最多 30 次
    _pollVideoPath(videoId, times = 0) {
      const MAX_TIMES = 30;
      const INTERVAL = 2000;
      // 已有轮询则先清掉,避免并发
      this._clearVideoPollTimer();
      const tick = async () => {
        if (times >= MAX_TIMES) {
          this._clearVideoPollTimer();
          this.$message.error("视频处理超时,请稍后再试");
          this.statusText = "视频处理超时";
          return;
        }
        try {
          const result = await getVideoPathUrl({ videoId });
          console.log("[_pollVideoPath] response:", { videoId, times, result });
          // 兼容多种返回结构:result.msg / result.data.playUrl 等
          const payload = result.data || result;
          const playUrl =
            payload.playUrl ||
            payload.url ||
            payload.videoUrl ||
            result.msg ||
            "";
          const coverImage =
            payload.playCoverImage ||
            payload.coverImage ||
            payload.coverUrl ||
            payload.cover ||
            "";
          if (!playUrl) {
            // 还没拿到 URL,继续轮询(可能还在处理)
            console.log("[_pollVideoPath] 暂未拿到 playUrl,继续轮询");
            times += 1;
            this.videoPollTimer = setTimeout(tick, INTERVAL);
            return;
          }
          if (this.customCoverDialog.vid === videoId) {
            this.$set(this.customCoverDialog, "playUrl", playUrl);
            this.$set(this.customCoverDialog, "playCoverImage", coverImage);
            this.$set(this.customCoverDialog, "isVideo", 1);
          }
          this.statusText = "视频处理完成";
          this.$message.success("视频处理完成");
          this._clearVideoPollTimer();
        } catch (err) {
          console.log("轮询视频信息异常", err);
          times += 1;
          this.videoPollTimer = setTimeout(tick, INTERVAL);
        }
      };
      this.videoPollTimer = setTimeout(tick, INTERVAL);
    },
    _clearVideoPollTimer() {
      if (this.videoPollTimer) {
        clearTimeout(this.videoPollTimer);
        this.videoPollTimer = null;
      }
    },
    handleFail(res) {
      console.log("上传失败", res);
    },
    IVClose() {
      this.uploadImgOrVideoShow = false;
    },
    openShareImgPop() {
      this.shareImgPopShow = true;
    },
    shareImgCancel() {
      this.shareImgPopShow = false;
    },
    shareImgConfirm(e) {
      console.log(e);
      this.activityDetail.shareImageStyle = e;
      this.shareImageStyle = e;
    },
    checkInConfirm(e) {
      this.activityDetail.checkInStatusSwitch = e;
      this.checkInStatusSwitch = e;
    },
    selectSysPic() {
      this.showModal = true;
      this.$refs.systemPictures.openSysPop(1);
    },
    changeXTShareImg() {
      this.$refs.systemPictures.openSysPop(2);
    },
    sureSelect(item) {
      console.log("this.showModal", this.showModal);
      // 如果是封面设置模式，更新封面设置数据
      if (this.coverSettingDrawer) {
        this.customCoverDialog.activityModeUrl = item;
        this.customCoverDialog.isVideo = 2;
      } else {
        this.activityModeUrl = item;
        this.activityDetail.activityModeUrl = item;
        this.activityDetail.isVideo = 2;
      }
      this.showModal = false;
    },
    shareSelect(item) {
      this.showModal = false;
      if (this.activityDetail.shareImageStyle == 1) {
        this.shareImageUrl = item;
        this.activityDetail.shareImageUrl = item;
      } else {
        this.shareZdyImageUrl = item;
        this.activityDetail.shareZdyImageUrl = item;
      }
    },
    handleSearch(tagName) {
      console.log("搜索场景关键词:", tagName);
      // 调用子组件的 getSysPics 方法进行搜索
      this.$refs.systemPictures.getSysPics();
    },
    changeMode(num) {
      this.activityMode = num;
      this.activityDetail.activityMode = num;
    },
    // 选择图片（加在图片上的事件，点击图片，获取图片的链接地址）
    selectImage(src) {
      // 设置图片Base64
      this.setImageBase64(src, (base64) => {
        this.option.img = base64;
        this.dialogVisibleCro = true;
      });
    },

    // 设置图片Base64
    setImageBase64(src, callback) {
      const image = new Image();
      // 支持跨域
      image.crossOrigin = "anonymous";
      // 处理缓存
      image.src = src + "?v=" + Math.random();
      // 动态生成
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const ctx = canvas.getContext("2d");
        ctx.drawImage(image, 0, 0, image.width, image.height);
        const result = canvas.toDataURL("image/png");
        callback && callback(result);
      };
    },

    // 确认裁剪
    finish() {
      this.$refs.cropper.getCropData((data) => {
        const file = this.base64ToFile(data, "cropped-image.png");

        var parm = {
          file,
          type: "modularImg",
        };
        axios
          .post(serverConfig.baseURL + "/file/uploadFile", parm, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Token": localStorage.getItem("token"),
            },
          })
          .then((res) => {
            this.activityModeUrl = this.imageUrl + res.data.msg;
            this.activityDetail.activityModeUrl = this.imageUrl + res.data.msg;
            this.activityDetail.isVideo = 2;
            this.dialogVisibleCro = false;
          });
      });
    },
    base64ToFile(base64, filename) {
      const arr = base64.split(",");
      const mime = arr[0].match(/:(.*?);/)[1];
      const bstr = atob(arr[1]); // 解码 base64
      let n = bstr.length;
      const u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    // 关闭裁剪
    closeCropper() {
      this.dialogVisibleCro = false;
    },

    handleShareImgUpload(event) {
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile[0].type)) {
        this.$message("文件格式不正确");
        event.target.value = "";
        return;
      }
      if (this.selectedFile[0].size / 1048576 > 5) {
        this.$message("请上传大小不超过5MB文件");
        event.target.value = "";
      } else {
        var parm = {
          file: this.selectedFile[0],
          type: "modularImg",
        };

        axios
          .post(serverConfig.baseURL + "/file/uploadFile", parm, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Token": localStorage.getItem("token"),
            },
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.uploadPicsType = 3;
              this.shareZdyImageUrl = this.imageUrl + response.data.msg;
            }
          })
          .catch((error) => {
            event.target.value = "";
            console.log("err:", error);
          });
      }
    },

    editFzNameList() {
      if (this.nameAddType == 1) {
        this.openNameListDrawerFun();
        this.nameAddOptionsShow = false;
      }
      if (this.nameAddType == 2) {
        // 更新中间值
        this.subsetCenterValueArr = JSON.parse(
          JSON.stringify(this.subsetValueArr),
        );
        this.subsetCenterValueArr.forEach((item) => {
          item.clockInListNum = this.parseNameList(item.clockInList).length;
        });

        if (this.pickerName == "全部") {
          this.subsetShow = true;
        } else {
          // 根据pickerName的值，找到数组subsetCenterValueArr对应的值，深度赋值fzPopItemInfo
          this.commFzIndex = this.subsetCenterValueArr.findIndex(
            (item) => item.listGroupName == this.pickerName,
          );
          this.fzPopItemInfo = JSON.parse(
            JSON.stringify(this.subsetCenterValueArr[this.commFzIndex]),
          );
          this.fzTitle = this.fzPopItemInfo.listGroupName;
          this.fzValue = this.fzPopItemInfo.clockInList;
          this.handlerBlur();
          this.showModal = true;
          this.copyTextAreaShow = true;
          this.modelContentDel = true;
          setTimeout(() => {
            this.placeholderText1 =
              "请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为100个名单。可复制粘贴";
          }, 350);

          this.handleSubShow = true;
        }
      }
    },
    // 获取时分秒 23:12:12
    getCurrentTime() {
      const now = new Date();
      // 使用 padStart 确保两位数格式（兼容所有现代浏览器）
      const hour = String(now.getHours()).padStart(2, "0");
      const minute = String(now.getMinutes()).padStart(2, "0");
      const second = String(now.getSeconds()).padStart(2, "0");
      return `${hour}:${minute}:${second}`;
    },
    //调用ai生成接龙信息
    getCreateMessage(isAi) {
      console.log("isAi", isAi);
      const sfm = this.getCurrentTime();
      if (isAi == "1") {
        var activityInfo = localStorage.getItem("activityInfo");
        console.log("activityInfo11111111111", activityInfo);
        activityInfo = JSON.parse(activityInfo);
        if (activityInfo && typeof activityInfo === "object") {
          if (activityInfo.activityName) {
            this.activityDetail.name = activityInfo.activityName;
          }
          if (activityInfo.description) {
            this.activityDetail.content = activityInfo.description;
          }
          if (activityInfo.startTime) {
            if (activityInfo.startTime.length > 10) {
              this.activityDetail.beginTime = activityInfo.startTime;
            } else {
              this.activityDetail.beginTime =
                activityInfo.startTime + " " + sfm;
            }
          }
          if (activityInfo.endTime) {
            if (activityInfo.startTime.length > 10) {
              this.activityDetail.beginTime = activityInfo.startTime;
            } else {
              this.activityDetail.beginTime =
                activityInfo.startTime + " " + sfm;
            }
          }
          if (activityInfo.formItems) {
            const itemArray = activityInfo.formItems.split(",");
            this.resultList = itemArray.map((item) => {
              const matchedItem = this.formList.find((form) =>
                item.includes(form.label),
              );
              if (matchedItem) {
                return { label: matchedItem.label, type: matchedItem.type };
              }
              return { label: item, type: -99 }; //手动添加了专属
            });
            console.log("处理后的表单项:", this.resultList);

            this.resultList.forEach((item) => {
              // console.log(item,item.label,item.type);
              this.addForm(item.type, item.label);
            });
          }
          console.log("赋值后的name:", this.activityDetail.name);
          console.log("赋值后的content:", this.activityDetail.content);
        }
      }
    },
    startNowChange(e) {
      this.startNowChecked = e;
      if (e == true) {
        // 保存即开始，使用当前时间
        const time = new Date();
        this.activityDetail.beginTime = this.timestampToTime(time);
      } else {
        this.activityDetail.beginTime = "";
      }
    },
    foreverValidChange(e) {
      this.foreverValidChecked = e;
      if (e == true) {
        this.activityDetail.endTime = "2099-12-31 23:59:59";
      }
    },
    actualStartNowChange(e) {
      this.actualStartNowChecked = e;
      if (e == true) {
        // 保存即开始，使用当前时间
        this.activityDetail.actualBeginTime = this.timestampToTime(
          new Date()
        );
      } else {
        this.activityDetail.actualBeginTime = "";
      }
    },
    actualForeverValidChange(e) {
      this.actualForeverValidChecked = e;
      if (e == true) {
        this.activityDetail.actualEndTime = "2099-12-31 23:59:59";
        this.prevActualEndTime = "2099-12-31 23:59:59";
      } else if (this.activityDetail.actualEndTime == "2099-12-31 23:59:59") {
        // 取消"永久有效"显示时间框时，默认选中当前时间而不是哨兵值 2099
        const nowTime = this.timestampToTime(new Date());
        this.activityDetail.actualEndTime = nowTime;
        this.prevActualEndTime = nowTime;
      }
    },
    // 实际活动结束时间不能选择当前时间之前的时间（"永久有效"哨兵值除外）
    actualEndTimeChange(val) {
      if (!val) {
        this.prevActualEndTime = "";
        return;
      }
      if (
        val !== "2099-12-31 23:59:59" &&
        new Date(val).getTime() < Date.now()
      ) {
        this.$message("不能选择当前时间之前的时间");
        this.activityDetail.actualEndTime = this.prevActualEndTime;
        return;
      }
      this.prevActualEndTime = val;
    },
    // 时间展示：截取到分钟（yyyy-MM-dd HH:mm）
    formatTimeToMinute(t) {
      return t ? t.slice(0, 16) : "";
    },
    // 保存前时间归一化：结束类时间秒位 :00 归一为 :59，哨兵值原样保留
    normalizeTimeForSave(time, isEnd) {
      if (!time || time === "2099-12-31 23:59:59") {
        return time;
      }
      if (isEnd && time.endsWith(":00")) {
        return time.slice(0, -2) + "59";
      }
      return time;
    },
    foreverHxValidChange(e) {
      this.foreverTimeHxChecked = e;
      if (e == true) {
        this.activityDetail.verificationEndTime = "2099-12-31 23:59:59";
      }
    },
    foreverQdValidChange(e) {
      this.foreverTimeQdChecked = e;
      if (e == true) {
        this.activityDetail.signInEndTime = "2099-12-31 23:59:59";
      }
    },
    signInSwitchChange(e) {
      // 开启签到后每人只能报名一次：报名次数不是 1 时才提示并重置为 1，已是 1 则无需提示
      if (e == 2) {
        if (this.activityDetail.generalCheckTimes != 1) {
          this.$message("开启签到，只允许报名一次");
          this.activityDetail.generalCheckTimes = 1;
        }
      } else {
        // 关闭签到时联动关闭签退：签退须挂在签到开启(signInSwitch=2)之下
        this.resetSignOutSetting();
      }
    },
    signOutSwitchChange(e) {
      if (e == 2) {
        // 开启签退默认「不限制」（attendanceDuration 为 null，后端视为不限制）
        this.attendanceDurationSelect = 0;
        this.activityDetail.attendanceDuration = null;
      } else {
        // 关闭签退时重置为不限制，避免残留值随表单提交
        this.resetSignOutSetting();
      }
    },
    resetSignOutSetting() {
      this.activityDetail.signOutSwitch = 1;
      this.attendanceDurationSelect = 0;
      this.attendanceDurationInput = "";
      this.activityDetail.attendanceDuration = null;
    },
    attendanceDurationChange(e) {
      if (e == 0) {
        // 不限制：提交 null（后端 null/0 均视为不限制）
        this.attendanceDurationPrevSelect = e;
        this.activityDetail.attendanceDuration = null;
        return;
      }
      if (e == -1) {
        // 切自定义：弹窗输入，清空输入框不带上一次的值，取消时回退档位
        this.attendanceDurationInput = "";
        this.openAttendanceDurationDialog();
        return;
      }
      this.attendanceDurationPrevSelect = e;
      this.activityDetail.attendanceDuration = e;
    },
    openAttendanceDurationDialog() {
      this.attendanceDurationDialogVisible = true;
    },
    confirmAttendanceDurationDialog() {
      var val = Number(this.attendanceDurationInput);
      if (
        this.attendanceDurationInput === "" ||
        isNaN(val) ||
        !Number.isInteger(val) ||
        val <= 0
      ) {
        this.$message("请输入正确的签退在场时间");
        return;
      }
      if (val > this.signInWindowMinutes) {
        this.$message("设置在场时长不能超出签到开始和结束总时长");
        return;
      }
      this.activityDetail.attendanceDuration = val;
      // 下拉直接显示输入的数字（动态档位），不再停留在「自定义」
      this.attendanceDurationSelect = val;
      this.attendanceDurationPrevSelect = val;
      this.attendanceDurationDialogVisible = false;
    },
    cancelAttendanceDurationDialog() {
      // 取消输入：下拉回退到打开弹窗前的档位，提交值保持不变
      this.attendanceDurationSelect = this.attendanceDurationPrevSelect;
      this.attendanceDurationDialogVisible = false;
    },
    generalCheckTimesChange(e) {
      // 签到已开启时次数不允许改为非 1 值：提示并改回 1
      if (this.activityDetail.signInSwitch == 2 && e != 1) {
        this.$message("开启签到，只允许报名一次");
        this.activityDetail.generalCheckTimes = 1;
      }
    },
    selectOptionClick(e) {
      console.log(e);
      this.formClock.clockSupplyType = e;
      if (e == 0) {
        this.supplyTxt = "总共";
      }
      if (e == 3) {
        this.supplyTxt = "每天";
      }
      if (e == 2) {
        this.supplyTxt = "每周";
      }
      if (e == 1) {
        this.supplyTxt = "每月";
      }
      this.disbandBox = true;
    },
    confirmModal() {
      if (this.clockSupplyCenterText === "") {
        this.$message("补卡次数不能为空");
        return false;
      }
      this.formClock.supplyTimes = this.clockSupplyCenterText;
      this.clockSupplyText = this.formClock.supplyTimes;
      this.clockSupplyShow = true;
      this.disbandBox = false;
    },
    saveToDraft() {
      this.$confirm("是否保存为草稿?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.is_draft = 1;
          // 存为草稿
          this.submit();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消",
          });
        });
    },
    confirmChangeForm() {
      // 走删除接口
      this.isDelOrder = 1;
      this.isDelSignInfoPop = false;
      // 编辑填表项接口
      this._updateSignList(this.signFieldClone, this.activityDetail.id);
    },
    // 分组取消/保存
    popupSaveFzFn(index) {
      if (index == 0) {
        this.subsetShow = false;
      }
      if (index == 1) {
        if (this.subsetCenterValueArr.length === 0) {
          this.$message("分组不能为空");
          return false;
        }
        let enter = true;
        for (let i = 0; i < this.subsetCenterValueArr.length; i++) {
          if (this.subsetCenterValueArr[i].clockInList === "") {
            this.$message(
              this.subsetCenterValueArr[i].listGroupName + "分组名单不能为空",
            );
            enter = false;
            break;
          }
        }
        if (enter == false) {
          return false;
        }
        this.nameAddType = 2;
        this.filteredArr = JSON.parse(
          JSON.stringify(this.subsetCenterValueArr),
        );
        this.updateSignPeoplePicker();
        this.subsetShow = false;
      }
    },
    // 编辑/添加
    addOrEditFz(index) {
      if (index == 0) {
        this.placeholderText1 = "";
        this.handleSubShow = false;
        this.showModal = false;
        this.copyTextAreaShow = false;
        this.modelContentDel = false;
        this.fzValue = "";
      }
      if (index == 1) {
        if (this.fzTitle === "") {
          this.$message("分组名称不能为空");
          return false;
        }
        if (this.fzValue === "") {
          this.$message("分组名单不能为空");
          return false;
        }
        this.subsetCenterValueArr[this.commFzIndex].listGroupName =
          this.fzTitle;
        this.subsetCenterValueArr[this.commFzIndex].clockInList = this.fzValue;

        this.subsetCenterValueArr.forEach((item) => {
          item.clockInListNum = this.parseNameList(item.clockInList).length;
        });

        this.handleSubShow = false;
        this.showModal = false;
        this.copyTextAreaShow = false;
        this.modelContentDel = false;
        this.fzValue = "";
        this.placeholderText1 = "";
        this.activityDetail.clockNameNumberSwitch = this.clockNameNumberSwitch;
        // 从卡片「编辑本组名单」直接进入（设置分组抽屉未开）时，确定后立即同步提交数据并选中该组
        if (!this.subsetShow) {
          this.updateSignPeoplePicker();
          this.selectGroupTab(this.fzTitle);
        }
      }
    },
    // 更新下拉选项 更新为全部
    updateSignPeoplePicker() {
      this.subsetValueArr = JSON.parse(
        JSON.stringify(this.subsetCenterValueArr),
      );
      this.pickerName = "全部";
      // 更新分组的下拉
      this.pickerNameSelectArr = [
        {
          label: "全部",
          value: 0,
        },
      ];
      var subArr = [];
      this.subsetValueArr.forEach((item, subIndex) => {
        subArr.push({
          label: item.listGroupName,
          value: subIndex + 1,
        });
      });
      const uniqueArr = [...new Set(subArr)];
      this.pickerNameSelectArr.push(...uniqueArr);

      // 更新全部名单
      let valueAll = "";
      this.subsetValueArr.forEach((son, i) => {
        valueAll += "," + son.clockInList;
      });
      // 处理一下 变成数组 可能需要做监听？
      let arr = this.parseNameList(valueAll);
      this.nameListLength = arr.length; // 更新名单人数
      this.packetData = arr;
    },
    clockNameNumberSwitchChange(e) {
      this.clockNameNumberSwitch = e;
      this.activityDetail.clockNameNumberSwitch = e;
    },
    clockSwitchFn(e) {
      this.clockSwitch = e;
      this.activityDetail.clockSwitch = e;
    },
    downloadNameBox() {
      this.downListShow = true;
      this.downloadBoxShow = true;
      this.$refs.downloadBox.open();
    },
    downloadGzhQrcode() {
      this.downloadImage(this.gzhQrcodeSrc, "接龙情况通知");
    },
    downloadImage(imgsrc, name = "qrcode") {
      if (!imgsrc) return;
      const image = new Image();
      image.setAttribute("crossOrigin", "anonymous");
      image.onload = () => {
        const canvas = document.createElement("canvas");
        canvas.width = image.width;
        canvas.height = image.height;
        const context = canvas.getContext("2d");
        context.fillStyle = "#FFFFFF";
        context.fillRect(0, 0, canvas.width, canvas.height);
        context.drawImage(image, 0, 0, image.width, image.height);
        const url = canvas.toDataURL("image/png");
        const a = document.createElement("a");
        a.download = name || "qrcode";
        a.href = url;
        a.click();
      };
      image.src = imgsrc;
    },
    // 清空
    emptyFn() {
      this.fzValue = "";
      this.fzNameArr = [];
      this.onlyGroupArr = [];
      this.fzPreviewShow = false;
      this.people_num2 = 0;
    },
    // 预存名单
    prestore() {
      // uni.navigateTo({
      //     url: '/pages-mine/nameList/nameList'
      // })
    },

    // 选择分组
    selectGrouping(e) {
      const selectedItem = this.pickerNameSelectArr.find(
        (item) => item.value === e,
      );
      this.pickerName = selectedItem ? selectedItem.label : "全部";
      this.pickerNameSelectShow = false;
      // 切换下面的数据
      // 筛选逻辑（示例：保留所有 listGroupName 存在的项）
      if (e != 0) {
        this.filteredArr = this.subsetValueArr.filter((item) => {
          return item.listGroupName === this.pickerName; // 精确匹配
        });
      } else {
        this.filteredArr = JSON.parse(JSON.stringify(this.subsetValueArr));
      }

      // 筛选packetData
      let valueAll = "";
      this.filteredArr.forEach((son, i) => {
        valueAll += "," + son.clockInList;
      });
      // 处理一下 变成数组 可能需要做监听？
      this.packetData = this.parseNameList(valueAll);
    },

    // 分组标签切换：「全部」合并所有分组，具体分组只取该组名单
    selectGroupTab(groupName) {
      if (this.pickerName === groupName) {
        return;
      }
      this.pickerName = groupName;
      if (groupName === "全部") {
        this.filteredArr = JSON.parse(JSON.stringify(this.subsetValueArr));
      } else {
        this.filteredArr = this.subsetValueArr.filter(
          (item) => item.listGroupName === groupName,
        );
      }
      let valueAll = "";
      this.filteredArr.forEach((son) => {
        valueAll += "," + son.clockInList;
      });
      this.packetData = this.parseNameList(valueAll);
    },
    // 「添加分组」：无分组普通名单首次点击把「全部」名单带入分组1；
    // 已有分组追加新分组并避开已占用的「分组N」编号（自定义名分组同样占位）
    addGroupTab() {
      this.nameAddType = 2;
      const groups = JSON.parse(JSON.stringify(this.subsetValueArr));
      let maxNo = 0;
      groups.forEach((item) => {
        const match = /^分组(\d+)$/.exec(item.listGroupName || "");
        if (match) {
          maxNo = Math.max(maxNo, Number(match[1]));
        }
      });
      let newName;
      const plainIndex = groups.findIndex(
        (item) => !item.listGroupName || item.listGroupName.trim() === "",
      );
      if (plainIndex !== -1) {
        // 空分组名条目为普通名单容器：把「全部」名单带入分组1（名单为空时预填默认名单）
        newName = "分组" + (maxNo + 1);
        groups[plainIndex].listGroupName = newName;
        if (
          !groups[plainIndex].clockInList ||
          groups[plainIndex].clockInList.trim() === ""
        ) {
          groups[plainIndex].clockInList = "李某某,王某某";
        }
      } else {
        newName = "分组" + Math.max(groups.length + 1, maxNo + 1);
        groups.push({
          listGroupName: newName,
          clockInList: "李某某,王某某",
        });
      }
      this.subsetCenterValueArr = groups;
      this.subsetCenterValueArr.forEach((item) => {
        item.clockInListNum = this.parseNameList(item.clockInList).length;
      });
      this.subsetValueArr = JSON.parse(
        JSON.stringify(this.subsetCenterValueArr),
      );
      // 全部人数 = 各分组合计
      let valueAll = "";
      this.subsetValueArr.forEach((son) => {
        valueAll += "," + son.clockInList;
      });
      this.nameListLength = this.parseNameList(valueAll).length;
      // 选中新分组并展示其名单
      this.selectGroupTab(newName);
    },
    // 「删除本组」：删除当前选中分组并回到全部（默认名分组补位重命名，自定义名不动）
    removeGroupTab() {
      if (this.pickerName === "全部") {
        return;
      }
      const groupName = this.pickerName;
      this.$confirm("确定要删除「" + groupName + "」及其名单吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.subsetValueArr = this.subsetValueArr.filter(
            (item) => (item.listGroupName || "") !== groupName,
          );
          // 从中间删除后，剩余默认名「分组N」按新位置补位重命名，自定义分组名保持不变
          this.subsetValueArr.forEach((item, index) => {
            if (/^分组\d+$/.test(item.listGroupName || "")) {
              item.listGroupName = `分组${index + 1}`;
            }
          });
          // 分组删光后回到普通名单模式：恢复与首次开启一致的默认名单
          if (this.subsetValueArr.length === 0) {
            this.nameAddType = 1;
            this.subsetValueArr = [
              {
                clockInList: "李某某,王某某",
                listGroupName: "",
              },
            ];
          }
          this.subsetCenterValueArr = JSON.parse(
            JSON.stringify(this.subsetValueArr),
          );
          this.subsetCenterValueArr.forEach((item) => {
            item.clockInListNum = this.parseNameList(item.clockInList).length;
          });
          // 切回全部并重算名单
          this.pickerName = "全部";
          this.filteredArr = JSON.parse(JSON.stringify(this.subsetValueArr));
          let valueAll = "";
          this.subsetValueArr.forEach((son) => {
            valueAll += "," + son.clockInList;
          });
          this.packetData = this.parseNameList(valueAll);
          this.nameListLength = this.packetData.length;
        })
        .catch(() => { });
    },

    // 减去
    subtractFzItem(index) {
      this.subsetCenterValueArr.splice(index, 1);
      // 从中间删除后，剩余默认名「分组N」按新位置补位重命名，自定义分组名保持不变
      this.subsetCenterValueArr.forEach((item, idx) => {
        if (/^分组\d+$/.test(item.listGroupName || "")) {
          item.listGroupName = `分组${idx + 1}`;
        }
      });
    },
    // 编辑
    editFzItem(index, item) {
      this.placeholderText1 = "";
      this.commFzInfo = item;
      this.commFzIndex = index;
      this.fzPopItemInfo = JSON.parse(JSON.stringify(item));
      // 处理数据
      this.handleSubShow = true;
      this.modelContentDel = true;
      this.fzTitle = this.fzPopItemInfo.listGroupName;

      this.fzValue = this.fzPopItemInfo.clockInList;
      this.handlerBlurFz();

      this.showModal = true;
      this.copyTextAreaShow = true;
      this.modelContentDel = true;

      setTimeout(() => {
        this.placeholderText1 =
          "请输入姓名名单，每个名单可用中英文逗号,换行隔开，最大输入为2000个名单。可复制粘贴";
      }, 350);
    },
    addFzItem() {
      // 新分组编号避开已占用的「分组N」（自定义名分组同样占位），按数组末尾索引往后排号
      let maxNo = 0;
      this.subsetCenterValueArr.forEach((item) => {
        const match = /^分组(\d+)$/.exec(item.listGroupName || "");
        if (match) {
          maxNo = Math.max(maxNo, Number(match[1]));
        }
      });
      var obj = {
        clockInList: "",
        listGroupName: "分组" + Math.max(this.subsetCenterValueArr.length + 1, maxNo + 1),
      };
      this.subsetCenterValueArr.push(obj);
    },
    relayList() {
      this.nameAddOptionsShow = true;
    },
    nameAddChange() {
      // this.nameAddType = this.nameOrGroup;
      if (this.nameOrGroup == 0) {
        this.nameAddOptionsShow = false;
        this.clockSwitch = 1;
        this.activityDetail.clockSwitch = 1;
      }

      if (this.nameOrGroup == 1) {
        this.nameAddType = 1;
        this.clockSwitch = 2;
        this.activityDetail.clockSwitch = 2;

        this.openNameListDrawerFun();

        this.nameAddOptionsShow = false;
      }
      if (this.nameOrGroup == 2) {
        this.nameAddType = 2;
        this.clockSwitch = 2;
        this.activityDetail.clockSwitch = 2;
        // 更新中间值
        this.subsetCenterValueArr = JSON.parse(
          JSON.stringify(this.subsetValueArr),
        );
        // 如果没有分组，创建两个分组：第一个有默认姓名，第二个为空
        if (this.subsetCenterValueArr.length === 0) {
          this.subsetCenterValueArr = [
            {
              clockInList: "李某某,王某某",
              listGroupName: "分组1",
              clockInListNum: 2,
            },
            {
              clockInList: "",
              listGroupName: "分组2",
              clockInListNum: 0,
            },
          ];
        } else {
          // 确保至少有两个分组
          if (this.subsetCenterValueArr.length < 2) {
            // 如果只有一个分组，添加第二个空分组
            if (this.subsetCenterValueArr.length === 1) {
              // 如果第一个分组没有姓名，添加默认姓名
              if (
                !this.subsetCenterValueArr[0].clockInList ||
                this.subsetCenterValueArr[0].clockInList.trim() === ""
              ) {
                this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
                this.subsetCenterValueArr[0].clockInListNum = 2;
              }
              // 添加第二个空分组
              this.subsetCenterValueArr.push({
                clockInList: "",
                listGroupName: "分组2",
                clockInListNum: 0,
              });
            }
          } else {
            // 如果已有两个或更多分组，确保第一个分组有默认姓名（如果为空）
            if (
              !this.subsetCenterValueArr[0].clockInList ||
              this.subsetCenterValueArr[0].clockInList.trim() === ""
            ) {
              this.subsetCenterValueArr[0].clockInList = "李某某,王某某";
              this.subsetCenterValueArr[0].clockInListNum = 2;
            }
          }
        }

        this.subsetCenterValueArr.forEach((item) => {
          item.clockInListNum = this.parseNameList(item.clockInList).length;
          if (item.listGroupName == "") {
            item.listGroupName =
              "分组" + (this.subsetCenterValueArr.indexOf(item) + 1);
          }
        });

        // 不立即同步到 subsetValueArr，只在保存时才同步

        // 更新分组的下拉列表（根据subsetValueArr，因为这是实际保存的值）
        // 如果subsetValueArr为空，显示默认分组1
        this.pickerName = "全部";
        this.pickerNameSelectArr = [
          {
            label: "全部",
            value: 0,
          },
        ];
        var subArr = [];
        if (this.subsetValueArr && this.subsetValueArr.length > 0) {
          // 只将有数据的分组加入下拉列表
          this.subsetValueArr.forEach((item, subIndex) => {
            let clockInList = item.clockInList || "";
            clockInList = clockInList.trim();
            // 只添加有数据的分组
            if (clockInList !== "") {
              subArr.push({
                label: item.listGroupName || `分组${subIndex + 1}`,
                value: subIndex + 1,
              });
            }
          });
        }
        // 如果所有分组都没有数据，显示默认分组1
        if (subArr.length === 0) {
          subArr.push({
            label: "分组1",
            value: 1,
          });
        }
        const uniqueArr = [...new Set(subArr)];
        this.pickerNameSelectArr.push(...uniqueArr);
        if (!this.packetData || this.packetData.length === 0) {
          // 从subsetCenterValueArr的第一个分组获取数据
          if (
            this.subsetCenterValueArr.length > 0 &&
            this.subsetCenterValueArr[0].clockInList
          ) {
            const arr = this.parseNameList(
              this.subsetCenterValueArr[0].clockInList,
            );
            this.packetData = arr;
            this.nameListLength = arr.length;
          } else {
            // 如果没有分组数据，设置默认值
            this.packetData = ["李某某", "王某某"];
            this.nameListLength = 2;
          }
        }

        this.subsetShow = true;
        this.nameAddOptionsShow = false;
      }
    },
    // 提示--上传图片
    uploadPromptImage(event) {
      this.selectedFile = event.target.files[0];
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile.type)) {
        this.$message("文件格式不正确");
        return;
      }
      if (this.selectedFile.size / 1048576 > 5) {
        this.$message("图片大小小于5M");
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.propertyData.promptImage = data.msg;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
        });
    },
    //属性设置提交
    propertySet() {
      if (this.propertyData.type == 4) {
        if (this.propertyData.isRequired == 0) {
          this.propertyData.minValue = 0;
        }
        if (this.propertyData.isRequired == 1) {
          if (this.propertyData.minValue == 0) {
            this.propertyData.minValue = 1;
          }
        }
        // 如果是多选，最少不能大于最多
        if (
          this.propertyData.maxValue != 0 &&
          this.propertyData.minValue > this.propertyData.maxValue
        ) {
          this.$message("最少可选不能大于最多可选");
          return false;
        }
      }
      if (
        (this.propertyData.type == 5 || this.propertyData.type == 35) &&
        this.propertyData.watermarkSwitch == 1 &&
        this.propertyData.watermarkTimeOrPosition.length == 0
      ) {
        this.$message("最少选择一个水印类型");
        return;
      }

      // 验证上传方式至少选择一个
      if (
        (this.propertyData.type == 5 || this.propertyData.type == 35) &&
        (!this.propertyData.uploadImageType ||
          this.propertyData.uploadImageType === "")
      ) {
        this.$message("请至少选择一种上传方式");
        return;
      }

      // this.propertyData.isRequiredChecked == true?this.propertyData.isRequired = 1 : this.propertyData.isRequired = 0
      // this.propertyData.isOpenChecked == true?this.propertyData.isOpen = 1 : this.propertyData.isOpen = 0
      this.listList[0].signField[this.commIndex] = { ...this.propertyData };
      console.log(
        this.listList[0].signField[this.commIndex].isRequired,
        "信息-公开必填",
      );
      console.log(this.propertyData.isRequired, "信息-属性设置");
      this.propertySetShow = false;
    },
    imgNumCheckChange(e) {
      this.propertyData.imageUploadLimit = e;
    },
    // 文本格式-
    formatCheckChange(e) {
      this.propertyData.isFormatCheck = e;
    },
    // 属性设置-
    attributeSet(info, index) {
      this.commIndex = index;
      this.commType = info.type;
      info.currentIndex = index;
      this.propertyData = { ...info };
      // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
      if (this.propertyData.type == 5 || this.propertyData.type == 35) {
        if (
          this.propertyData.annotationPermission === null ||
          this.propertyData.annotationPermission === undefined ||
          this.propertyData.annotationPermission === ""
        ) {
          this.propertyData.annotationPermission = "2";
        } else {
          // 确保是字符串类型，因为开关使用的是字符串 "1" 和 "2"
          this.propertyData.annotationPermission = String(
            this.propertyData.annotationPermission,
          );
        }
      }
      this.commType = this.propertyData.type;
      this.tipsContent = this.propertyData.promptExplanation;
      this.propertySetShow = true;
    },

    openStudyPopup(type) {
      this.studyContent =
        "开启后，参与人可在地图中搜索定位，若需要显示参与人实时位置，请不要开启";
      this.$refs.studyBox.open();
    },
    closeStudyBox() {
      this.$refs.studyBox.close();
    },
    // 打开设置选项不可选时间弹窗
    openOptionTimeSet(fieldItem, fieldIndex) {
      this.commIndex = fieldIndex;
      this.currentFieldItem = fieldItem;
      // 如果已有日期格式是 yyyy-MM-dd，转换为 yyyy-MM-dd HH:mm:ss
      if (fieldItem.content) {
        fieldItem.content.forEach((opt) => {
          if (opt.validateDateTo && opt.validateDateTo.length === 10) {
            opt.validateDateTo = opt.validateDateTo + " 00:00:00";
          }
        });
      }
      this.optionTimeSetShow = true;
    },
    // 关闭设置选项不可选时间弹窗
    handleOptionTimeClose() {
      this.optionTimeSetShow = false;
      // 关闭时不重置 currentFieldItem，因为 propertyData 是响应式的，修改会同步到原字段
    },
    // 确认设置选项不可选时间
    confirmOptionTimeSet() {
      this.optionTimeSetShow = false;
      this.$message("设置成功");
    },
    // 禁用日期选择（只能选今天及以后的日期）
    disabledDate(time) {
      // 可以禁用过去的日期，根据需求调整
      return time.getTime() < Date.now() - 8.64e7; // 禁用昨天及之前的日期
    },
    // 批量
    batchOptions() {
      this.lineCopywriting = "";
      this.placeholderContent = "";
      this.batchOptionShow = true;
    },
    closeBatch() {
      this.placeholderContent = "";
      this.$refs.batchAdd.close();
      this.lineCopywriting = "";
    },
    // 换行添加
    addLineBreak() {
      if (this.lineCopywriting == "") {
        this.$message("请添加选项");
        return false;
      }
      var ary = this.lineCopywriting.split("\n");
      if (ary.length > 15) {
        this.$message("一行一个选项，最大支持添加15个");
        return false;
      }
      for (var i = 0; i < ary.length; i++) {
        if (ary[i] != null && ary[i].trim() != "") {
          var inp = {
            value: ary[i],
          };
          this.propertyData.content.push(inp);
        }
      }
      this.lineCopywriting = "";
      this.placeholderContent = "";
      this.batchOptionShow = false;
    },
    // 添加选项
    addOption() {
      var obj = {
        value: "",
      };
      this.propertyData.content.push(obj);
    },
    //删除轮播图
    trash(index) {
      if (this.propertyData.content.length == 1) {
        this.$message("请至少保留一项");
        return false;
      }
      this.propertyData.content.splice(index, 1);
      if (
        Number(this.propertyData.maxValue) >= this.propertyData.content.length
      ) {
        this.propertyData.maxValue = this.propertyData.content.length;
      }
      if (
        Number(this.propertyData.minValue) >= this.propertyData.content.length
      ) {
        this.propertyData.minValue = this.propertyData.content.length;
      }
    },
    // 上移
    upTr(index) {
      if (index == 0) {
        this.$message("已经是第一项");
        return false;
      }
      //在上一项插入该项
      this.propertyData.content.splice(
        index - 1,
        0,
        this.propertyData.content[index],
      );
      //删除后一项
      this.propertyData.content.splice(index + 1, 1);
    },
    // 下移
    downTr(index) {
      if (index == this.propertyData.content.length - 1) {
        this.$message("已经是最后一项");
        return false;
      }
      //在下一项插入该项
      this.propertyData.content.splice(
        index + 2,
        0,
        this.propertyData.content[index],
      );
      // 删除前一项
      this.propertyData.content.splice(index, 1);
    },
    // 日期
    attributeTimeChange(type, index) {
      this.propertyData.timeSelectType = Number(index);
      this.$forceUpdate();
      console.log(
        this.propertyData.timeSelectType,
        "this.propertyData.timeSelectType",
      );
      console.log(index, "index");
    },
    // 地域
    attributeAreaChange(type, index) {
      this.propertyData.areaSelectType = index;
      this.$forceUpdate();
    },
    attributeDateChange(type, index) {
      this.propertyData.dateSelectType = index;
      this.$forceUpdate();
    },

    checkFun(n) {
      console.log(n);
      if (this.propertyData.type == 4) {
        if (this.propertyData.isRequired == 0) {
          this.propertyData.minValue = 0;
        }
        if (this.propertyData.isRequired == 1) {
          this.propertyData.minValue = 1;
        }
      }
      this.propertyData.isRequired = n;
    },
    openFn(n) {
      this.propertyData.isOpen = n;
    },

    addgljl(idx) {
      this.modulCommonIndex = idx;
      // 获取当前已关联的活动ID数组
      const associatedIds =
        this.modularList[this.modulCommonIndex].info.associationActivityId ||
        [];

      // 遍历relatedList，设置checked状态
      this.relatedList = this.relatedList.map((item) => {
        return {
          ...item,
          checked: associatedIds.some(
            (associatedItem) => associatedItem.id === item.id,
          ),
        };
      });

      this.relatedDrawerShow = true;
    },
    relateItemChange(e, info, index) {
      info.checked = e;
    },
    relatedAdd() {
      const newArray = [];
      this.relatedList.forEach((item) => {
        if (item.checked === true) {
          const newItem = {
            id: item.id,
            name: item.name,
            activity_type: item.activity_type,
            activity_big_type: item.activity_big_type,
          };
          newArray.push(newItem);
        }
      });
      this.modularList[this.modulCommonIndex].info.associationActivityId =
        newArray;
      this.relatedDrawerShow = false;
    },
    delRelatedFiles(fileIndex, fatherIndex) {
      this.modularList[fatherIndex].info.associationActivityId.splice(
        fileIndex,
        1,
      );
    },
    async getRelatedList() {
      if (this.isLoading) return; // 防止重复加载
      this.isLoading = true;
      const { data, msg, status } = await getCreateList({
        pageNum: this.pageNum,
        pageSize: 15,
        activityBigType: "",
        recordType: 1,
        isDraft: "",
        activityType: "",
        activeState: this.activeState,
        timeRange: "",
        startTime: "",
        endTime: "",
        sortType: 1,
        activityName: "",
      });
      if (this.pageNum == 1) {
        this.relatedList = [];
      }
      this.totalRow = data.total;
      this.pages = data.pages;
      this.pageNum = data.pageNum;
      data.list.forEach((item, index) => {
        item.checked = false;
      });

      // 过滤掉当前活动 ID 的数据
      const filteredList = data.list.filter(
        (item) => item.id.toString() !== this.activityId.toString(),
      );
      this.relatedList = this.relatedList.concat(filteredList);
      this.$forceUpdate();
    },

    relatedDrawerClose() {
      this.relatedDrawerShow = false;
    },
    subsetDrawerClose() {
      // 检查是否有有效数据（检查subsetValueArr，因为subsetCenterValueArr是中间值，可能被修改但未保存）
      let hasData = false;
      if (this.subsetValueArr && this.subsetValueArr.length > 0) {
        // 检查是否有分组包含非空的名单
        hasData = this.subsetValueArr.some((item) => {
          let clockInList = item.clockInList || "";
          clockInList = clockInList.trim();
          return clockInList !== "";
        });
      }

      // 如果没有数据,设置为默认分组1
      if (!hasData) {
        this.subsetValueArr = [
          {
            clockInList: "李某某,王某某",
            listGroupName: "分组1",
            clockInListNum: 2,
          },
        ];
        // 更新packetData和nameListLength
        const arr = this.parseNameList("李某某,王某某");
        this.packetData = arr;
        this.nameListLength = arr.length;
      }

      // 更新分组的下拉列表（只将有数据的分组加入下拉列表）
      this.pickerName = "全部";
      this.pickerNameSelectArr = [
        {
          label: "全部",
          value: 0,
        },
      ];
      var subArr = [];
      if (this.subsetValueArr && this.subsetValueArr.length > 0) {
        // 只将有数据的分组加入下拉列表
        this.subsetValueArr.forEach((item, subIndex) => {
          let clockInList = item.clockInList || "";
          clockInList = clockInList.trim();
          // 只添加有数据的分组
          if (clockInList !== "") {
            subArr.push({
              label: item.listGroupName || `分组${subIndex + 1}`,
              value: subIndex + 1,
            });
          }
        });
      }
      // 如果所有分组都没有数据，显示默认分组1
      if (subArr.length === 0) {
        subArr.push({
          label: "分组1",
          value: 1,
        });
      }
      const uniqueArr = [...new Set(subArr)];
      this.pickerNameSelectArr.push(...uniqueArr);

      // 清空中间值
      this.subsetCenterValueArr = [];
      this.subsetShow = false;
    },
    handleSubDrawerClose() {
      this.handleSubShow = false;
      this.fzPreviewShow = false;
    },

    propertyDrawerClose() {
      this.propertySetShow = false;
    },

    openMusic(info) {
      var link = info.fileUrl;
      this.musicLink = this.imageUrl + link;
      this.musicDialog = true;
    },

    async submit() {
      if (this.isrepeatClick) {
        return;
      }
      this.isrepeatClick = true;

      if (this.is_draft == 0 && Number(this.activityDetail.enablePush) === 1) {
        const isFollowed = await this.checkWechatFollowStatus({
          showDialog: true,
        });
        if (!isFollowed) {
          this.activityDetail.enablePush = 2;
        }
      }

      //校验是否填写了接龙标题
      if (this.activityDetail.name == "" || this.activityDetail.name == null) {
        this.warnAndScroll("请填写接龙标题", "titleBlock");
        this.isrepeatClick = false;
        return false;
      }
      if (this.selectType == "add") {
        this.activityDetail.templateId = this.activityDetail.id;
        delete this.activityDetail.id;
      }

      // 如果不是草稿
      if (this.is_draft == 0) {
        var isStop = false;
        var isture = true;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          var formClockObj = this.formClock;
          if (formClockObj.clockRemindStatus == 1) {
            if (formClockObj.remindTime == "") {
              this.warnAndScroll("打卡提醒时间不能为空！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          if (formClockObj.clockSupplyStatus == 1) {
            if (formClockObj.supplyTimes === "") {
              this.warnAndScroll("允许补卡次数不能为空！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          if (formClockObj.clockLocationStatus == 1) {
            if (formClockObj.address == "") {
              this.warnAndScroll("地点位置不能为空！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            } else if (formClockObj.clockRange == "") {
              this.warnAndScroll("打卡范围不能为空！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            }
          }

          // 判断是否选中日期
          if (this.selectFrequency == 7) {
            if (this.customDateArr.length == 0) {
              this.warnAndScroll("请选择日期！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            }
          }
          // 自定义周几：是否选择周几
          if (this.selectFrequency == 6) {
            if (formClockObj.clockFrequency == "") {
              this.warnAndScroll("请选择周几打卡！", "clockSettingBlock");
              isture = false;
              this.isrepeatClick = false;
            }
          }
        }

        if (this.activityDetail.removeSignStatus == 3) {
          if (this.activityDetail.removeSignEndTime == null) {
            this.warnAndScroll("自定义开始日期不能为空", "formFieldsBlock");
            isture = false;
          } else if (this.activityDetail.removeSignBeginTime == null) {
            this.warnAndScroll("自定义结束日期不能为空", "formFieldsBlock");
            isture = false;
          }
        }
        if (isture == false) {
          this.isrepeatClick = false;
          return;
        }
        // 表单项验证
        if (this.listList[this.indexIdx]) {
          this.listList[this.indexIdx].signField.map((item, index) => {
            if (isStop) {
              this.isrepeatClick = false;
              return;
            }

            if (item.name == "") {
              isStop = true;
              this.warnAndScroll(
                "请填写第" + (index + 1) + "个报名信息列",
                "formFieldsBlock",
              );
              this.isrepeatClick = false;
            }
            if (item.type == 1) {
              if (item.fieldName == "") {
                isStop = true;
                this.warnAndScroll("请填写填空标题", "formFieldsBlock");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 9) {
              if (item.fieldName == "") {
                isStop = true;
                this.warnAndScroll("请填写多行输入标题", "formFieldsBlock");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 2) {
              for (let i = 0; i < item.content.length; i++) {
                for (let j = i + 1; j < item.content.length; j++) {
                  if (item.content[i].value === item.content[j].value) {
                    isStop = true;
                    this.warnAndScroll(
                      "单选选项内容不能重复",
                      "formFieldsBlock",
                    );
                    this.isrepeatClick = false;
                    break;
                  }
                }
              }

              item.content.map((itm, idx) => {
                if (itm.value == "") {
                  isStop = true;
                  this.warnAndScroll(
                    "请填写单选选项内容",
                    "formFieldsBlock",
                  );
                  this.isrepeatClick = false;
                }
              });
              if (item.fieldName == "") {
                isStop = true;
                this.warnAndScroll("请填写单选标题", "formFieldsBlock");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 4) {
              for (let i = 0; i < item.content.length; i++) {
                for (let j = i + 1; j < item.content.length; j++) {
                  if (item.content[i].value === item.content[j].value) {
                    isStop = true;
                    this.warnAndScroll(
                      "多选选项内容不能重复",
                      "formFieldsBlock",
                    );
                    this.isrepeatClick = false;
                    break;
                  }
                }
              }
              item.content.map((itm, idx) => {
                if (itm.value == "") {
                  isStop = true;
                  this.warnAndScroll(
                    "请填写多选选项内容",
                    "formFieldsBlock",
                  );
                  this.isrepeatClick = false;
                }
              });
              if (item.fieldName == "") {
                isStop = true;
                this.warnAndScroll("请填写多选标题", "formFieldsBlock");
                this.isrepeatClick = false;
              }
            }
            if (item.type == 39) {
              if (item.fieldName == "") {
                isStop = true;
                this.warnAndScroll("请填写预约标题", "formFieldsBlock");
                this.isrepeatClick = false;
              }
              if (!isStop) {
                const checkResult = validateAppointmentField(item);
                if (!checkResult.valid) {
                  isStop = true;
                  this.warnAndScroll(checkResult.message, "formFieldsBlock");
                  this.isrepeatClick = false;
                }
              }
              if (!isStop && Array.isArray(item.appointmentList)) {
                const names = item.appointmentList.map((o) =>
                  (o.optionName || "").trim()
                );
                for (let i = 0; i < names.length; i++) {
                  for (let j = i + 1; j < names.length; j++) {
                    if (names[i] && names[i] === names[j]) {
                      isStop = true;
                      this.warnAndScroll(
                        "预约选项名称不能重复",
                        "formFieldsBlock"
                      );
                      this.isrepeatClick = false;
                      break;
                    }
                  }
                  if (isStop) break;
                }
              }
            }
          });
        }
        if (this.activityDetail.removeSignStatus == 3) {
          if (
            this.activityDetail.removeSignBeginTime &&
            this.activityDetail.removeSignEndTime
          ) {
            if (
              new Date(this.activityDetail.removeSignBeginTime).getTime() >
              new Date(this.activityDetail.removeSignEndTime).getTime()
            ) {
              isStop = true;
              this.warnAndScroll("结束日期不能小于开始日期", "formFieldsBlock");
              this.isrepeatClick = false;
            }
          }
        }
        if (this.activityDetail.beginTime && this.activityDetail.endTime) {
          if (
            new Date(this.activityDetail.beginTime).getTime() >
            new Date(this.activityDetail.endTime).getTime()
          ) {
            isStop = true;
            this.warnAndScroll("结束时间不能小于开始时间", "titleBlock");
            this.isrepeatClick = false;
          }
        }
        // 活动时间（纯展示）：开启后校验实际活动开始/结束时间先后
        if (
          this.activityDetail.actualTimeSwitch == 2 &&
          this.activityDetail.actualEndTime
        ) {
          const actualBeginTime = this.activityDetail.actualBeginTime
            ? this.activityDetail.actualBeginTime
            : this.timestampToTime(new Date());
          if (
            new Date(actualBeginTime).getTime() >
            new Date(this.activityDetail.actualEndTime).getTime()
          ) {
            isStop = true;
            this.warnAndScroll(
              "活动结束时间不能早于活动开始时间",
              "actualTimeBlock"
            );
            this.isrepeatClick = false;
          }
        }

        // 签到码
        if (
          this.activityDetail.signInSwitch == 2 &&
          this.activityDetail.signLocationSwitch == 2
        ) {
          if (!this.activityDetail.signInAddress) {
            isStop = true;
            this.warnAndScroll("请选择指定参与地点", "signInSettingBlock");
            this.isrepeatClick = false;
          }
          if (!this.activityDetail.signLocationDistance) {
            isStop = true;
            this.warnAndScroll("请选择参与范围", "signInSettingBlock");
            this.isrepeatClick = false;
          }
        }

        // 签退：不限制(null)直接放行；自定义未填写/非法或超出签到起止总时长才拦截
        if (
          this.activityDetail.signInSwitch == 2 &&
          this.activityDetail.signOutSwitch == 2
        ) {
          var signOutDuration = Number(this.activityDetail.attendanceDuration);
          if (this.attendanceDurationSelect == -1 && !signOutDuration) {
            isStop = true;
            this.warnAndScroll("请设置签退在场时间", "signInSettingBlock");
            this.isrepeatClick = false;
          } else if (
            signOutDuration &&
            (!Number.isInteger(signOutDuration) || signOutDuration <= 0)
          ) {
            isStop = true;
            this.warnAndScroll("请设置签退在场时间", "signInSettingBlock");
            this.isrepeatClick = false;
          } else if (
            signOutDuration &&
            signOutDuration > this.signInWindowMinutes
          ) {
            isStop = true;
            this.warnAndScroll(
              "设置在场时长不能超出签到开始和结束总时长",
              "signInSettingBlock"
            );
            this.isrepeatClick = false;
          }
        }

        if (isStop) {
          this.isrepeatClick = false;
          return;
        }
      }

      this.activityDetail.signShowType = this.showName == "列表接龙" ? 1 : 2;

      this.activityDetail.shareTitle = "";
      this.activityDetail.shareCotent = "";
      this.activityDetail.shareBtnWord = "";
      this.activityDetail.shareBack = "";
      this.activityDetail.shareLogo = "";
      this.activityDetail.shareImg = "";

      // 高级设置
      this.activityDetail.shareStatus = this.shareStatus;
      this.activityDetail.commentStatus = this.commentStatus;
      this.activityDetail.updateSignInfo = this.updateSignInfo;
      this.activityDetail.confirmWord = this.confirmWord;
      this.activityDetail.copyStatus = this.copyStatus;
      this.activityDetail.signSuccessBarrageSwitch = this.signSuccessBarrageSwitch; //报名成功弹幕开关，未手动切换时默认值 1 也会提交

      // 新加的 2024/8/1
      this.activityDetail.isanonymous = this.isanonymous;
      this.activityDetail.publisher =
        this.publisher || localStorage.getItem("jlnickname"); //发布人姓名
      this.activityDetail.is_notice = this.is_notice; //接龙情况通知开关

      this.activityDetail.copywriting = this.copywriting; //自定义文案
      this.activityDetail.copyimage = this.copyimage; //自定义图片

      this.activityDetail.is_destination = this.is_destination; //指定接龙位置
      this.activityDetail.deliveryaddress = this.deliveryaddress; //指定接龙位置坐标

      this.activityDetail.submitcopy =
        this.isType == "109" || this.submitcopy ? this.submitcopy : "提交"; //报名页面提交按钮文案
      this.activityDetail.registrationtime = this.registrationtime; //修改报名信息开始时间
      this.activityDetail.endregistrationtime = this.endregistrationtime; //修改报名信息结束时间
      this.activityDetail.custombutton = 1; //uni.getStorageSync('custombutton')//自定义按钮标题，总开关
      this.activityDetail.checkinrange = this.checkinrange; //打卡范围
      this.activityDetail.anonymousparticipation = this.anonymousparticipation; //匿名参与
      this.activityDetail.specifyaddress = this.specifyaddress;

      this.activityDetail.deleteregistration = this.deleteregistration; //修改报名信息
      this.activityDetail.startdeletingtime = this.startdeletingtime; //删除报名信息开始时间
      this.activityDetail.enddeletingtime = this.enddeletingtime; //修改报名信息结束时间

      this.activityDetail.is_forward = this.is_forward;
      this.activityDetail.thumbs_up = this.thumbs_up;
      this.activityDetail.chatSwitch = this.chatSwitch;
      this.activityDetail.is_comment = this.is_comment;
      this.activityDetail.is_score = this.is_score;
      this.activityDetail.isMessage = this.isMessage;
      this.activityDetail.showRanking = this.showRanking;
      this.activityDetail.hideUser = this.hideUser;
      // 如果类型为 101，强制设置这些选项为关闭状态
      if (this.isType == "101") {
        this.activityDetail.anonymousparticipation = 0; // 匿名参与 - 关闭
        this.activityDetail.chatSwitch = 2; // 群聊 - 关闭
        this.activityDetail.thumbs_up = 2; // 点赞 - 关闭
        this.activityDetail.is_comment = 2; // 点评 - 关闭
        this.activityDetail.is_score = 2; // 评分 - 关闭
        this.activityDetail.isMessage = 2; // 评论 - 关闭
        this.activityDetail.verificationSwitch = 1; // 核销开关 - 关闭
        this.activityDetail.signInSwitch = 1; // 签到开关 - 关闭
        this.activityDetail.signOutSwitch = 1; // 签退开关 - 关闭
        this.activityDetail.attendanceDuration = null; // 签退签退在场时间 - 清空
      }
      // 废弃字段置空
      this.activityDetail.musicId = "";
      // musicUrl 与 backgroundMusicUrl 保持一致（兼容字段）
      this.activityDetail.musicUrl = this.activityDetail.backgroundMusicUrl;

      // 创建 - 处理封面赋值
      this.activityDetail.activityModeUrl = this.activityModeUrl;
      this.activityDetail.vid = this.vid;
      this.activityDetail.playUrl = this.playUrl;
      this.activityDetail.isVideo = this.isVideo;
      this.activityDetail.isCoverEnabled = this.isCoverEnabled;
      this.activityDetail.subCoverImages = this.subCoverImages
        ? this.subCoverImages.join(",")
        : "";

      // 3.4更新
      this.activityDetail.phoneSwitch = this.phoneSwitch;
      this.activityDetail.userPhone = this.userPhone;

      if (
        this.activityDetail.phoneSwitch == 2 &&
        this.activityDetail.userPhone == ""
      ) {
        this.warnAndScroll("请填写联系信息", "contactSettingBlock");
        isStop = true;
      }

      this.activityDetail.contactType = this.contactType;
      if (this.activityDetail.phoneSwitch == 2) {
        // 根据contactType进行验证
        if (this.contactType == 1) {
          // 手机号验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.userPhone)) {
            this.warnAndScroll("请输入正确的手机号", "contactSettingBlock");
            isStop = true;
          }
        } else if (this.contactType == 2) {
          // 微信号验证
          const wechatRegex = /^[a-zA-Z][a-zA-Z0-9_-]{5,19}$/;
          if (!wechatRegex.test(this.userPhone)) {
            this.warnAndScroll("请输入正确的微信号", "contactSettingBlock");
            isStop = true;
          }
        } else if (this.contactType == 3) {
          // 手机号和微信同号验证
          const phoneRegex = /^1[3-9]\d{9}$/;
          if (!phoneRegex.test(this.userPhone)) {
            this.warnAndScroll(
              "请输入正确的手机号或微信号",
              "contactSettingBlock",
            );
            isStop = true;
          }
        }
      }

      // 收费报名(101)必须选择支付方式；老数据 paymentSwitch=0 编辑保存时强制补选
      if (this.isType == "101" && this.paymentSwitch != 1 && this.paymentSwitch != 2) {
        this.warnAndScroll("请选择支付方式", "paymentBlock");
        this.isrepeatClick = false;
        return;
      }

      // 收款方式（在线收款/无支付仅统计）收费项验证
      if ((this.paymentSwitch == 1 || this.paymentSwitch == 2) && this.fmActivityChargeItemVOS.length > 0) {
        for (let i = 0; i < this.fmActivityChargeItemVOS.length; i++) {
          const item = this.fmActivityChargeItemVOS[i];
          const displayIndex = i + 1;

          // 验证名称（必填）
          if (item.itemName === "" || item.itemName === null) {
            this.warnAndScroll(
              `请填写第${displayIndex}个收费项的名称`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          }

          // 验证单价
          if (item.unitPrice === "免费") {
            // 免费，跳过验证
          } else if (item.unitPrice === "" || item.unitPrice === null) {
            // 空值，跳过验证
          } else {
            const priceVal = parseFloat(item.unitPrice);
            if (priceVal === 0) {
              // 0 转为免费
            } else if (priceVal < 0.01) {
              this.warnAndScroll(
                `第${displayIndex}个收费项单价最低为 0.01 元`,
                "paymentBlock",
              );
              this.isrepeatClick = false;
              return;
            } else if (priceVal > 999999) {
              this.warnAndScroll(
                `第${displayIndex}个收费项金额过大`,
                "paymentBlock",
              );
              this.isrepeatClick = false;
              return;
            }
          }

          // 验证库存
          if (item.stock === "" || item.stock === null) {
            // 空表示不限，跳过验证
          } else {
            const stockVal = parseInt(item.stock, 10);
            if (stockVal > 100000) {
              this.warnAndScroll(
                `第${displayIndex}个收费项库存数量不可超过 100000`,
                "paymentBlock",
              );
              this.isrepeatClick = false;
              return;
            }
          }

          // 验证最少可购数量
          const minBuyNum = parseInt(item.minBuyNum) || 1;
          if (minBuyNum < 1) {
            this.warnAndScroll(
              `第${displayIndex}个收费项最少可购数量不能小于 1`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          } else if (minBuyNum > 20) {
            this.warnAndScroll(
              `第${displayIndex}个收费项最少可购数量不能大于 20`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          }

          // 验证最多可购数量
          const maxBuyNum = parseInt(item.maxBuyNum) || 20;
          if (maxBuyNum < 1) {
            this.warnAndScroll(
              `第${displayIndex}个收费项最多可购数量不能小于 1`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          } else if (maxBuyNum > 20) {
            this.warnAndScroll(
              `第${displayIndex}个收费项最多可购数量不能大于 20`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          }

          // 验证最少不能大于最多
          if (minBuyNum > maxBuyNum) {
            this.warnAndScroll(
              `第${displayIndex}个收费项的最少可购数量不能大于最多可购数量`,
              "paymentBlock",
            );
            this.isrepeatClick = false;
            return;
          }

          // 验证库存与最多可购数量的关系
          if (
            item.stock !== undefined &&
            item.stock !== null &&
            item.stock !== ""
          ) {
            const stockVal = parseInt(item.stock, 10);
            if (maxBuyNum > stockVal) {
              this.warnAndScroll(
                `第${displayIndex}个收费项的最多可购数量不能超过库存`,
                "paymentBlock",
              );
              this.isrepeatClick = false;
              return;
            }
          }
        }
      }
      if (this.fmActivityChargeItemVOS.length > 10) {
        this.warnAndScroll("收费项最多添加 10 个", "paymentBlock");
        this.isrepeatClick = false;
        return;
      }

      if (isStop) {
        this.isrepeatClick = false;
        return;
      }

      const time = new Date();
      const nowTime = this.timestampToTime(time);
      this.activityDetail.beginTime = this.activityDetail.beginTime
        ? this.activityDetail.beginTime
        : nowTime;
      // 活动时间（纯展示）：开启时未填实际开始时间则兜底为当前时间；结束时间秒位归一为 :59
      if (
        this.activityDetail.actualTimeSwitch == 2 &&
        !this.activityDetail.actualBeginTime
      ) {
        this.activityDetail.actualBeginTime = nowTime;
      }
      this.activityDetail.actualEndTime = this.normalizeTimeForSave(
        this.activityDetail.actualEndTime,
        true
      );

      // 转格式
      this.modular1 = JSON.parse(JSON.stringify(this.modularList));
      this.incompleteContentList = []; // 清空未填写内容列表
      // 重置 isStop，用于模块内容验证
      isStop = false;
      this.modular1.map((item, index) => {
        if (this.is_draft == 0) {
          if (isStop) {
            this.isrepeatClick = false;
            return;
          }
          // 只检查接龙标题是否填写
          if (item.type == 1 && item.info.title == "") {
            isStop = true;
            this.warnAndScroll("请填写接龙标题", "titleBlock");
          } else {
            // 检查其他模块内容是否填写，未填写则记录索引
            let hasContent = false;
            if (item.type == 1 && item.info.value === "") {
              hasContent = false;
            } else if (item.type == 3 && item.info.imgarr.length === 0) {
              // 小图
              hasContent = false;
            } else if (item.type == 4 && !item.info.address) {
              // 地址
              hasContent = false;
            } else if (item.type == 5 && item.info.filesArr.length === 0) {
              // 文件
              hasContent = false;
            } else if (item.type == 6 && item.info.filesArr.length === 0) {
              // 音频
              hasContent = false;
            } else if (item.type == 7 && !item.info.videoId && !item.info.fileUrl) {
              // 视频 - 兼容 VOD(videoId)和 OSS 旧数据(fileUrl)
              hasContent = false;
            } else if (item.type == 9 && item.info.imgarr.length === 0) {
              // 大图
              hasContent = false;
            } else if (
              item.type == 10 &&
              (!item.info.link || !item.info.officialAccountTitle)
            ) {
              // 公众号
              hasContent = false;
            } else if (
              item.type == 11 &&
              (!item.info.videoId || !item.info.videoNumberID)
            ) {
              // 视频号
              hasContent = false;
            } else if (
              item.type == 12 &&
              (!item.info.appid || !item.info.pagePath || !item.info.appTitle)
            ) {
              // 其他小程序
              hasContent = false;
            } else if (item.type == 13 && !item.info.copy_region_conten) {
              // 可复制内容
              hasContent = false;
            } else if (
              item.type == 14 &&
              item.info.associationActivityId.length === 0
            ) {
              // 关联接龙
              hasContent = false;
            } else {
              hasContent = true;
            }
            if (!hasContent) {
              this.incompleteContentList.push(index);
            }
          }
        }
        item.info = JSON.stringify(item.info);
      });

      // 检查是否有未填写的模块内容
      if (this.incompleteContentList.length > 0 && !isStop) {
        this.incompleteContentDialog = true;
        this.isrepeatClick = false;
        return;
      }

      // 如果不是草稿
      if (this.is_draft == 0) {
        if (this.activityDetail.is_destination == 1) {
          if (this.activityDetail.specifyaddress == "") {
            this.warnAndScroll(
              "请选择指定参与地点",
              "participateLocationBlock",
            );
            isStop = true;
          } else if (this.activityDetail.checkinrange == "") {
            this.warnAndScroll("参与范围不能为空", "participateLocationBlock");
            isStop = true;
          }
        }
        if (isStop) {
          this.isrepeatClick = false;
          return;
        }
      }

      //
      if (this.foreverTimeHxChecked) {
        this.activityDetail.verificationStartTime = this.verificationStartTime;
        this.activityDetail.verificationEndTime = "2099-12-31 23:59:59";
      }
      this.submitFn();
    },
    submitFn() {
      console.log("去创建");
      // 如果开启了名单功能，检查名单是否为空
      if (this.clockSwitch == 2) {
        // 添加人员名单模式
        if (this.nameAddType == 1 && this.packetData.length == 0) {
          this.$message("请添加参与名单");
          this.isrepeatClick = false;
          return false;
        }
        if (this.nameAddType == 2 && this.subsetCenterValueArr.length === 0) {
          this.$message("分组不能为空");
          this.isrepeatClick = false;
          return false;
        }
        let enter = true;
        for (let i = 0; i < this.subsetCenterValueArr.length; i++) {
          if (this.subsetCenterValueArr[i].clockInList === "") {
            this.$message(
              this.subsetCenterValueArr[i].listGroupName + "分组名单不能为空",
            );
            enter = false;
            break;
          }
        }
        if (enter == false) {
          this.isrepeatClick = false;
          return false;
        }
      }
      const appliction = []; //报名填表项
      let fmClockIn = {};
      let clockInList;
      let projectDelIds;

      if (
        this.isType == "109" ||
        this.isType == "110" ||
        this.isType == "104"
      ) {
        fmClockIn = this.formClock;
      }
      // 预设名单关闭时名单仅保留在内存（供再次开启恢复），不随提交发送
      clockInList = this.clockSwitch == 2 ? this.subsetValueArr : [];
      this.activityDetail.coverImg = this.baseurl;
      this.activityDetail.createSource = 2; //创建来源 1:小程序 2:pc
      let signFieldClone = "";
      signFieldClone = JSON.parse(JSON.stringify(this.listList));
      signFieldClone[this.indexIdx].signField.push(...this.delListInfo);
      signFieldClone.map((item, index) => {
        item.signField.map((itm) => {
          if (itm.type == 39) {
            // 预约填表项：appointmentList 直传数组不 stringify，同步 fmFieldNumList
            this.syncAppointmentFieldNumListForSave(itm);
            return {};
          }
          if (itm.content != "" && itm.content != null) {
            //同步maxNum到fmFieldNumList
            this.syncMaxNumToFieldNumListForSave(itm);
            return (itm.content = JSON.stringify(itm.content));
          } else {
            return {};
          }
        });
      });
      this.signFieldClone = signFieldClone;
      this.loadingShow = this.$loading({
        lock: true,
        text: "保存中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      this.activityDetail.activityType = this.isType;
      // 同步 nameSortSwitch 到 activityDetail
      this.activityDetail.nameSortSwitch = this.nameSortSwitch ? 1 : 0;
      // 同步 auditSwitch 到 activityDetail
      this.activityDetail.auditSwitch = this.auditSwitch;
      // 同步 channelCodeSwitch 到 activityDetail
      this.activityDetail.channelCodeSwitch = this.channelCodeSwitch;

      // 创建/编辑活动
      updateActivity({
        ...this.activityDetail,
        endTime: this.foreverValidChecked
          ? "2099-12-31 23:59:59"
          : this.activityDetail.endTime,
        // signList: signFieldClone,
        modular: this.modular1,
        modularDelIds: this.modularDelIds,
        //"removeSignStatus":this.removeSignStatus, //新修改
        multipleActivitiesStatus: this.multipleActivitiesStatus,
        projectVos: appliction, ///报名填表项
        fmClockIn: fmClockIn, //打卡
        activityBigType: "1", //接龙大类型 接龙1 通知2
        activityType: this.isType,
        clockInList: clockInList, //预存名单列表
        projectDelIds: projectDelIds,
        groupId: this.groupId ? this.groupId : "",
        interdict_people_num: this.interdict_people_num,
        is_draft: this.is_draft,
        isInFolder: this.folderId ? 2 : this.isInFolder || 1,
        folderId: this.folderId ? this.folderId : "",
        // 隐藏设置相关字段
        hideUser: this.hideUser,
        hideAttr: this.hideAttr,
        hideRule: this.hideRule,
        hideLimit: this.hideLimit,
        foldInfo: this.foldInfo,
        noticeConfig: this.activityDetail.noticeConfig,
        showFormNum: this.showFormNum,
        // 收款方式（在线收款/无支付仅统计）收费项数据；未选择收款方式时为 null（与小程序一致）
        fmActivityChargeItemVOS:
          (this.paymentSwitch == 1 || this.paymentSwitch == 2) &&
            this.fmActivityChargeItemVOS.length > 0
            ? this.fmActivityChargeItemVOS.map((item) => ({
              ...item,
              unitPrice: item.unitPrice === "免费" ? "0" : item.unitPrice,
              showImg: item.showImg || "",
            }))
            : null,
      }).then((res) => {
        if (res.status == 1) {
          // 调用辅助接口updateActivitySignList
          if (this.selectType == "add") {
            try {
              updateActivitySignList({
                id: res.data,
                signList: signFieldClone,
              });
            } catch (error) {
              console.error("调用updateActivitySignList失败:", error);
            }
          }
          if (this.selectType == "update") {
            // 判断填表项的状态，再决定是否保存
            this._isUpdateSignList(signFieldClone, res.data);
          } else {
            this.loadingShow.close();
            this.$message({
              message: "保存成功",
              type: "success",
            });
            // 如果是草稿 跳到index
            if (this.is_draft == 1 && !this.groupId) {
              router.push("/home");
              return false;
            }
            // 如果是群组草稿 跳到群组详情
            if (this.is_draft == 1 && this.groupId) {
              // todo
              return false;
            }

            // todo 去创建成功页 触发commonData.js页中的saveIsOpenShare方法，改变isOpenShare的值为true
            this.saveIsOpenShare(true);
            // 如果在文件夹中创建的，返回文件夹页面
            if (this.folderId) {
              router.replace({
                path: "/folderDetails",
                query: { folderId: this.folderId },
              });
            } else {
              router.replace("/releaseNotes");
            }
          }
        } else {
          this.loadingShow.close();
          this.$message(res.msg);
          this.isrepeatClick = false;
        }
      }).catch((err) => {
        // 请求级失败（HTTP 错误/超时）时关闭全屏 loading，避免一直“保存中...”
        this.loadingShow.close();
        this.isrepeatClick = false;
        if (err) {
          this.$message(err);
        }
      });
    },
    // 判断填表项状态
    async _isUpdateSignList(signList, id) {
      const result = await isUpdateSignList({
        signList: signList,
        id: this.activityDetail.id,
        userId: this.activityDetail.userId,
      });
      if (result.status == 1) {
        this.loadingShow.close();
        this.isrepeatClick = false;
        this.isDelSignInfoPop = true;
      }
      if (result.status == 2) {
        // 去保存和删除
        this.isDelOrder = "";
        this._updateSignList(signList, id);
      }
    },
    // 编辑填表项
    async _updateSignList(signList, id) {
      const result = await updateSignList({
        signList: signList,
        id: this.activityId,
        userId: this.activityDetail.userId,
      });
      if (result.status == 1) {
        this.loadingShow.close();
        this.$message({
          message: "保存成功",
          type: "success",
        });
        // 如果是草稿 跳到index
        if (this.is_draft == 1) {
          router.push("/home");
          return false;
        }
        // 如果在文件夹中创建的，返回文件夹页面
        if (this.folderId) {
          router.replace({
            path: "/folderDetails",
            query: { folderId: this.folderId },
          });
        } else {
          router.replace("/releaseNotes");
        }
      } else {
        this.loadingShow.close();
        this.$message(result.msg);
        this.isrepeatClick = false;
      }
    },
    // 确认发布（处理未填写内容的情况）
    confirmPublish() {
      this.incompleteContentDialog = false;
      // 重新调用 submit，让 submit 重新设置 isrepeatClick
      this.isrepeatClick = false;
      this.submitFn();
    },
    // 活动详情
    activityDetailFun() {
      const obj = {};
      if (this.activityKey) {
        obj.activityKey = this.activityKey;
        obj.selectType = this.selectType;
        obj.is_template = this.is_template;
      } else {
        obj.activityId = this.activityId;
        obj.selectType = this.selectType;
        obj.is_template = this.is_template;
      }
      activityDetail({
        ...obj,
      }).then((res) => {
        if (res.status == 403) {
          this.$message({
            message: res.msg,
            type: "warning",
            duration: 2000,
          });
          setTimeout(() => {
            router.replace("/home");
          }, 2000);
        }
        this.DataScreenUrl = res.data.screenUrl;
        this.activityDetail = res.data.activityDetail;
        // 活动时间（纯展示）字段兜底：旧数据无 actual 字段时按默认值处理
        if (this.activityDetail.actualTimeSwitch == null) {
          this.$set(this.activityDetail, "actualTimeSwitch", 1);
        }
        if (this.activityDetail.actualBeginTime == null) {
          this.$set(this.activityDetail, "actualBeginTime", "");
        }
        if (this.activityDetail.actualEndTime == null) {
          this.$set(this.activityDetail, "actualEndTime", "2099-12-31 23:59:59");
        }
        // 签退设置字段兜底：老数据/后端模板未返回时默认关闭、时长不限
        if (this.activityDetail.signOutSwitch == null) {
          this.$set(this.activityDetail, "signOutSwitch", 1);
        }
        if (this.activityDetail.attendanceDuration == null) {
          this.$set(this.activityDetail, "attendanceDuration", null);
        }
        // 确保 noticeConfig 存在
        if (!this.activityDetail.noticeConfig) {
          this.activityDetail.noticeConfig = {
            noticeEnabled: 0,
            noticeContent: "",
            noticeDuration: 0,
            noticeTiming: 1,
            noticeConfirmType: 1,
            noticeTitle: "必读须知",
            noticeButtonText: "已读并确认以上内容",
          };
        }
        // 将后端平铺的 noticeConfig 字段合并到 noticeConfig 对象
        if (res.data.noticeConfig) {
          this.activityDetail.noticeConfig = {
            ...this.activityDetail.noticeConfig,
            ...res.data.noticeConfig,
          };
        }
        this.authInformation = res.data.authInformation;
        this.activityId = this.activityDetail.id;
        this.activityDetail.activityId = this.activityId;
        this.activityDetail.id = this.activityId;
        if (res.data.activityDetail.beginTime) {
          this.actStartAndEndTime = [
            res.data.activityDetail.beginTime,
            res.data.activityDetail.endTime,
          ];
        }
        if (this.selectType == "add") {
          var startTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
          this.activityDetail.beginTime = startTime;
          this.activityDetail.endTime = "2099-12-31 23:59:59";
          this.actStartAndEndTime = [startTime, "2099-12-31 23:59:59"];
          // 新建时默认：保存即开始 + 永久有效
          this.startNowChecked = true;
          this.foreverValidChecked = true;
          // 活动时间（纯展示）：新建/复制等入口不回填 actual 字段，保持默认值
          this.activityDetail.actualTimeSwitch = 1;
          this.activityDetail.actualBeginTime = "";
          this.activityDetail.actualEndTime = "2099-12-31 23:59:59";
        } else {
          // 编辑模式：如果有开始时间，取消"保存即开始"勾选
          if (this.activityDetail.beginTime) {
            this.startNowChecked = false;
          }
        }
        if (this.activityDetail.endTime == "2099-12-31 23:59:59") {
          this.foreverValidChecked = true;
        } else {
          this.foreverValidChecked = false;
        }
        // 活动时间（纯展示）回显：开始为空=保存即开始；结束为哨兵=永久有效
        this.actualStartNowChecked = !this.activityDetail.actualBeginTime;
        this.actualForeverValidChecked =
          this.activityDetail.actualEndTime == "2099-12-31 23:59:59";
        this.prevActualEndTime = this.activityDetail.actualEndTime;

        res.data.modular.forEach((item) => {
          if (item.type == 4) {
            var obj = {
              lng: 116.403963,
              lat: 39.915119,
            };
            item.location = obj;
          }
          // 容错:info 可能是字符串也可能是对象;解析失败不影响后续
          try {
            if (typeof item.info === "string") {
              item.info = item.info.replace(/\n/g, "\\n").replace(/↵/g, " ");
              item.info = JSON.parse(item.info);
            } else if (item.info == null) {
              item.info = {};
            }
          } catch (e) {
            console.error("[activityDetailFun] modular item.info 解析失败,跳过本条:", item, e);
            item.info = item.info || {};
            return;
          }
          if (this.selectType == "add") {
            delete item.id;
            delete item.activityId;
          }
        });
        this.modularList = res.data.modular;
        // 编辑活动加载完后,异步把 type==7 视频模块的 videoId 解析成 fileUrl
        this.autoLoadModuleVideoUrls();

        if (res.data.modular.length <= 1) {
          var textarea = document.querySelector(".el-textarea__inner");
          textarea.addEventListener("input", (e) => {
            textarea.style.height = "100px";
            textarea.style.height = e.target.scrollHeight + "px";
          });
        }

        // 填表项
        let signFieldCloneS = "";
        signFieldCloneS = JSON.parse(JSON.stringify(res.data.signList));
        signFieldCloneS.map((itm) => {
          itm.signField.map((item) => {
            item.isUniqueCheckChecked = item.isUniqueCheck == 1 ? true : false;
            item.isRequiredChecked = item.isRequired == 1 ? true : false;
            item.isOpenChecked = item.isOpen == 1 ? true : false;
            if (item.type == 11 || item.type == 10) {
              item.encryption = 1;
            }
            // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
            if (item.type == 5) {
              if (
                item.annotationPermission === null ||
                item.annotationPermission === undefined ||
                item.annotationPermission === ""
              ) {
                item.annotationPermission = "2";
              } else {
                // 确保是字符串类型，因为开关使用的是字符串 "1" 和 "2"
                item.annotationPermission = String(item.annotationPermission);
              }
            }
            // 预约填表项：appointmentList 兼容 JSON 字符串；复制活动清零报名计数
            if (item.type == 39) {
              if (typeof item.appointmentList === "string") {
                try {
                  item.appointmentList = JSON.parse(item.appointmentList);
                } catch (e) {
                  item.appointmentList = [];
                }
              }
              if (!Array.isArray(item.appointmentList)) {
                item.appointmentList = [];
              }
              item.appointmentList.forEach((option) => {
                if (!Array.isArray(option.timeSlots)) {
                  option.timeSlots = [];
                }
              });
              if (this.ifcopy) {
                resetAppointmentTimeSlotCounts(item);
              }
            }
            if (item.content != "" && item.content != null) {
              return (item.content = JSON.parse(item.content));
            } else {
              item["num"] = 3;
              return {};
            }
          });
        });
        this.listList = signFieldCloneS;

        // 在线收款数据回显
        if (
          (this.selectType === "update" || this.selectType === "add") &&
          res.data.fmActivityChargeItemVOS &&
          res.data.fmActivityChargeItemVOS.length > 0
        ) {
          // 复制模式下需要清除 id，让后端生成新的 id
          if (this.selectType === "add") {
            this.fmActivityChargeItemVOS = res.data.fmActivityChargeItemVOS.map(
              (item) => ({
                ...item,
                id: undefined, // 清除 id，让后端生成新的
                hasVerification: 0, // 重置报名状态
                unitPrice: this.formatUnitPriceValue(item.unitPrice),
                minBuyNum: item.minBuyNum || 1,
                maxBuyNum: item.maxBuyNum || 20,
              }),
            );
          } else {
            this.fmActivityChargeItemVOS = res.data.fmActivityChargeItemVOS.map(
              (item) => ({
                ...item,
                stock: item.remainingStock,
                unitPrice: this.formatUnitPriceValue(item.unitPrice),
                minBuyNum: item.minBuyNum || 1,
                maxBuyNum: item.maxBuyNum || 20,
              }),
            );
          }
          console.log(
            this.fmActivityChargeItemVOS,
            "this.fmActivityChargeItemVOS 收费项数据",
          );
        }

        // 第一个姓名增加标记不能删除不能移动
        this.$nextTick(() => {
          let count = 0;
          for (let i = 0; i < this.listList.length; i++) {
            const signField = this.listList[i].signField;
            for (let j = 0; j < signField.length; j++) {
              if (count === 0) {
                if (signField[j].type === 1) {
                  signField[j].isFirst = 1;
                  ++count;
                }
              }
            }
          }
        });

        // 接龙名单
        if (res.data.clockNameList && res.data.clockNameList.length) {
          // res.data.clockNameList.forEach(item => {
          //     if (res.data.activityDetail.isTemplate == 1) {
          //         this.packetData.push(item.clockName)
          //     } else {
          //         this.packetData.push(item.clockName)
          //         this.packetData.map((res, index) => {
          //             if (res == "") {
          //                 this.packetData.splice(index, 1)
          //             }
          //         })
          //     }
          // })

          var nameStr = "";
          res.data.clockNameList.forEach((item) => {
            nameStr += item.clockName + ",";
            this.packetData = nameStr.split(",");
            this.packetData.map((res, index) => {
              if (res == "") {
                this.packetData.splice(index, 1);
              }
            });
          });
          this.subsetValueArr = res.data.clockNameList.map((item) => {
            return {
              clockInList: item.clockName,
              listGroupName: item.listGroupName ? item.listGroupName : "",
            };
          });
          // 使用 reduce 按 listGroupName 分组合并
          const mergedArr = Object.entries(
            this.subsetValueArr.reduce((acc, cur) => {
              const key = cur.listGroupName;
              if (!acc[key]) {
                acc[key] = [];
              }
              acc[key].push(cur.clockInList);
              return acc;
            }, {}),
          ).map(([groupName, clockInLists]) => ({
            listGroupName: groupName,
            clockInList: clockInLists.join(","),
          }));

          console.log(mergedArr, "mergedArrwhat?");
          this.subsetValueArr = mergedArr;

          // 计算每个分组的人数
          this.subsetValueArr.forEach((item) => {
            item.clockInListNum = this.parseNameList(item.clockInList).length;
          });

          // 名单人数
          this.nameListLength = this.packetData.length;
          this.pickerName = "全部";
          // 更新分组的下拉
          // 更新分组的下拉
          this.pickerNameSelectArr = [
            {
              label: "全部",
              value: 0,
            },
          ];
          var subArr = [];
          this.subsetValueArr.forEach((item, subIndex) => {
            subArr.push({
              label: item.listGroupName,
              value: subIndex + 1,
            });
          });
          const uniqueArr = [...new Set(subArr)];
          this.pickerNameSelectArr.push(...uniqueArr);

          // 判断是不是分组
          // 检查合并后的数组，如果有多个分组，或者分组名称有实际值（非空字符串），则是分组模式
          // 如果创建时是"仅添加名单"，所有项的listGroupName都是空字符串，合并后只有一个分组
          // 如果创建时是"添加分组+名单"，会有多个分组，或者分组名称有实际值
          const hasMultipleGroups = this.subsetValueArr.length > 1;
          const hasGroupName = this.subsetValueArr.some((item) => {
            const groupName = item.listGroupName;
            return groupName && groupName !== "" && groupName.trim() !== "";
          });

          if (hasMultipleGroups || hasGroupName) {
            this.nameAddType = 2;
          } else {
            this.nameAddType = 1;
          }
          console.log(this.nameAddType, "是不是分组啊--- 2是1不是");

          this.subsetCenterValueArr = JSON.parse(
            JSON.stringify(this.subsetValueArr),
          );
          this.subsetCenterValueArr.forEach((item) => {
            item.clockInListNum = this.parseNameList(item.clockInList).length;
          });
        }

        // 打卡接龙
        if (res.data.clockInfo) {
          // 这里做了兼容，给两个字段默认值
          this.clockInfoObj = res.data.clockInfo;
          this.formClock = {
            ...res.data.clockInfo,
            checkSwitch: res.data.clockInfo.checkSwitch || 1,
            checkTimes: res.data.clockInfo.checkTimes || 1,
          };
          this.selectData = res.data.clockInfo.clockFrequencyName;
          this.clockFrequencyName = res.data.clockInfo.clockFrequencyName;
          //自定义周几赋值
          res.data.clockInfo.clockFrequency.split(",").forEach((item) => {
            this.candidates.forEach((e) => {
              if (e.value == item) {
                e.checked = "true";
                this.candidateList.push(e.value);
              }
            });
          });
          // 打卡地点
          if (res.data.clockInfo.clockLocationInfo) {
            console.log(
              res.data.clockInfo.clockLocationInfo,
              "res.data.clockInfo.clockLocationInfo",
            );
            this.formClock.address = JSON.parse(
              res.data.clockInfo.clockLocationInfo,
            ).address;
            this.formClock.clockRange = res.data.clockInfo.clockRange;
          }
          this.selectFrequency = res.data.clockInfo.clockFrequencyType;
          this.formClock.clockFrequencyType =
            res.data.clockInfo.clockFrequencyType;
          // 一次性打卡不支持补卡：回显时强制关闭，避免历史脏数据
          if (this.formClock.clockFrequencyType == 8) {
            this.formClock.clockSupplyStatus = 2;
          }
          console.log(this.selectFrequency, "this.selectFrequency===");

          // 处理时间段
          if (
            res.data.clockInfo.clockInTimeSlot &&
            res.data.clockInfo.clockInTimeSlot.length
          ) {
            res.data.clockInfo.clockInTimeSlot.forEach((item, index) => {
              item.ifDel = 2;
              // item.startAndEnd = [item.startTime.toString(),item.endTime.toString()]
              const a = [item.startTime.toString(), item.endTime.toString()];
              this.$set(item, "startAndEnd", a);
            });
            this.formClock.clockInTimeSlot = res.data.clockInfo.clockInTimeSlot;

            if (res.data.clockInfo.clockInTimeSlot.length > 1) {
              this.formClock.multiPeriodSwitch = 1;
            }
          }
          this.$forceUpdate();

          // 日期选择
          this.formClock.customDate = res.data.clockInfo.customDate;
          this.customDateArr = res.data.clockInfo.customDate.split(",");
          // 截止日期
          this.formClock.dayOfDate = res.data.clockInfo.dayOfDate;
          this.formClock.timeOfDay = res.data.clockInfo.timeOfDay;
          if (this.selectFrequency == 1) {
            this.monthDay = res.data.clockInfo.dayOfDate;
          }
          if (this.formClock.timeOfDay) {
            var str1 = this.formClock.timeOfDay.substring(0, 2);
            this.endMonthArr2.forEach((item, index) => {
              if (item.value == str1) {
                this.monthHour = index;
              }
            });
          }
          if (this.formClock.timeOfDay) {
            var str2 = this.formClock.timeOfDay.substring(3);
            this.endMonthArr3.forEach((item, index) => {
              if (item.value == str2) {
                this.monthMinute = index;
              }
            });
          }

          this.formClock.clockFrequency = res.data.clockInfo.clockFrequency;
          this.formClock.checkboxValue1 =
            res.data.clockInfo.clockFrequency.split(",");

          this.weekDay = this.formClock.dayOfDate;
          this.monthDay = this.formClock.dayOfDate;

          // 打卡最大次数
          if (
            res.data.clockInfo.clockFrequencyType == 1 ||
            res.data.clockInfo.clockFrequencyType == 2
          ) {
            this.formClock.clockMaxNum = res.data.clockInfo.clockMaxNum;
            if (res.data.clockInfo.clockMaxNum > 1) {
              this.formClock.clockMaxSwitch = 1;
            } else {
              this.formClock.clockMaxSwitch = 2;
            }
            this.$forceUpdate();
          }
          this.interdict_people_num =
            res.data.activityDetail.interdict_people_num;
          this.is_draft = res.data.activityDetail.is_draft;
        } else {
          var clockObj = this.formClock;
          this.clockInfoObj = clockObj;
          if (this.rateType) {
            clockObj.selectFrequency = this.rateType;
            this.selectFrequency = this.rateType;
            clockObj.clockFrequencyType = this.rateType;
            // clockFrequencyName
            if (this.rateType == "1") {
              clockObj.clockFrequencyName = "每月";
            }
            if (this.rateType == "2") {
              clockObj.clockFrequencyName = "每周";
            }
            if (this.rateType == "3") {
              clockObj.clockFrequencyName = "每天";
            }

            if (this.rateType == "4") {
              clockObj.clockFrequencyName = "法定工作日";
            }
            if (this.rateType == "5") {
              clockObj.clockFrequencyName = "法定节假日";
            }
            if (this.rateType == "6") {
              clockObj.clockFrequencyName = "自定义周几打卡";
            }
            if (this.rateType == "7") {
              clockObj.clockFrequencyName = "自定义日期打卡";
            }
            if (this.rateType == "8") {
              clockObj.clockFrequencyName = "一次性打卡";
            }

            this.selectData = clockObj.clockFrequencyName;
            var selectDataArr = {
              value: [clockObj.clockFrequencyName],
            };

            this.clickin(Number(this.rateType));
          }
        }

        // 高级设置
        var detailInfo = res.data.activityDetail;
        this.publisher = detailInfo.publisher
          ? detailInfo.publisher
          : localStorage.getItem("jlnickname");
        this.copyStatus = detailInfo.copyStatus;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.type == "104"
        ) {
          this.confirmWord = "参与打卡";
        } else if (this.selectType == "add") {
          // 创建时参与按钮文字默认「参加活动」，编辑时沿用活动已保存的文案
          this.confirmWord = "参加活动";
        } else {
          this.confirmWord = detailInfo.confirmWord;
        }
        this.is_forward = detailInfo.is_forward;
        this.updateSignInfo =
          this.selectType == "update" ? detailInfo.updateSignInfo : 3;
        this.activityDetail.removeSignStatus =
          this.selectType == "update" ? detailInfo.removeSignStatus : 4;
        this.removeSignStatus =
          this.selectType == "update" ? detailInfo.removeSignStatus : 4;
        this.copywriting = detailInfo.copywriting;
        this.copyimage = detailInfo.copyimage;
        this.is_destination = detailInfo.is_destination;
        this.deliveryaddress = detailInfo.deliveryaddress;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          this.submitcopy = "立即打卡";
        } else {
          this.submitcopy = detailInfo.submitcopy;
        }
        this.commentStatus =
          this.selectType == "update" ? detailInfo.commentStatus : 2;
        this.signInfoStatus = detailInfo.signInfoStatus;
        this.custombutton = detailInfo.custombutton;
        this.anonymousparticipation = detailInfo.anonymousparticipation;
        this.deleteregistration = detailInfo.deleteregistration;
        this.checkinrange = detailInfo.checkinrange
          ? detailInfo.checkinrange
          : 2000;
        this.specifyaddress = detailInfo.specifyaddress;
        if (
          this.isType == "109" ||
          this.isType == "110" ||
          this.isType == "104"
        ) {
          this.confirmWord = "参与打卡";
        } else if (this.selectType == "add") {
          // 创建时参与按钮文字默认「参加活动」，编辑时沿用活动已保存的文案
          this.confirmWord = "参加活动";
        } else {
          this.confirmWord = detailInfo.confirmWord;
        }
        this.startdeletingtime = detailInfo.startdeletingtime;
        this.enddeletingtime = detailInfo.enddeletingtime;
        // deadline -修改报名信息时间范围
        this.activityDetail.registrationtime = detailInfo.registrationtime;
        this.activityDetail.endregistrationtime =
          detailInfo.endregistrationtime;
        if (detailInfo.registrationtime) {
          this.deadline = [
            detailInfo.registrationtime,
            detailInfo.endregistrationtime,
          ];
        }

        if (detailInfo.removeSignBeginTime) {
          this.deadCancelline = [
            detailInfo.removeSignBeginTime,
            detailInfo.removeSignEndTime,
          ];
        }

        this.thumbs_up = detailInfo.thumbs_up;
        this.chatSwitch = detailInfo.chatSwitch;
        this.is_comment = detailInfo.is_comment;
        this.is_score = detailInfo.is_score;
        this.isMessage = detailInfo.isMessage;
        this.showRanking = detailInfo.showRanking;
        this.hideUser = detailInfo.hideUser;
        this.hideAttr = detailInfo.hideAttr;
        this.hideRule = detailInfo.hideRule;
        this.hideLimit = detailInfo.hideLimit;
        this.foldInfo = detailInfo.foldInfo;
        this.showFormNum = detailInfo.showFormNum;
        // paymentSwitch 后端可能返回字符串，统一转数字；老数据 0 保持未选择态，保存时强制补选
        this.paymentSwitch = Number(detailInfo.paymentSwitch) || 0;
        this.activityDetail.paymentSwitch = this.paymentSwitch;
        this.needBuy = detailInfo.needBuy;
        this.rebateSwitch = detailInfo.rebateSwitch;
        this.auditSwitch =
          detailInfo.auditSwitch != null ? detailInfo.auditSwitch : 0;
        // 如果类型为 101，强制设置这些选项为关闭状态
        if (this.isType == "101") {
          this.anonymousparticipation = 0; // 匿名参与 - 关闭
          this.chatSwitch = 2; // 群聊 - 关闭
          this.thumbs_up = 2; // 点赞 - 关闭
          this.is_comment = 2; // 点评 - 关闭
          this.is_score = 2; // 评分 - 关闭
          this.isMessage = 2; // 评论 - 关闭
          this.updateSignInfo = 1; // 允许修改参与信息 - 不允许
          this.removeSignStatus = 1; // 报名后是否允许取消 - 不允许
          this.activityDetail.verificationSwitch = 1; // 核销开关 - 关闭
          this.activityDetail.signInSwitch = 1; // 签到开关 - 关闭
          this.activityDetail.signOutSwitch = 1; // 签退开关 - 关闭
          // 新建收费报名：收款方式默认「无支付仅统计」，并预置一个默认收费项
          // （复制活动与草稿编辑已回显收款方式/收费项，不覆盖；编辑场景沿用已保存状态）
          if (this.selectType == "add" && !this.ifcopy && this.is_draft != 1) {
            this.paymentSwitch = 2;
            this.activityDetail.paymentSwitch = 2;
            if (this.fmActivityChargeItemVOS.length === 0) {
              this.addDefaultPaymentItem();
            }
          }
        }
        this.activityMode = detailInfo.activityMode;
        this.shareImageStyle = detailInfo.shareImageStyle;
        this.shareZdyImageUrl = detailInfo.shareZdyImageUrl;
        this.clockListNumber = detailInfo.clockListNumber;
        this.checkInStatusSwitch = detailInfo.checkInStatusSwitch;
        // 回显签退签退在场时间：空/0 回显「不限制」，非空直接选中数字档
        // （非预设值由隐藏 el-option 回显「N分钟」）
        if (this.activityDetail.signOutSwitch == 2) {
          var durationVal = Number(this.activityDetail.attendanceDuration);
          this.attendanceDurationSelect = durationVal ? durationVal : 0;
          this.attendanceDurationPrevSelect = this.attendanceDurationSelect;
        }
        this.clockSwitch = detailInfo.clockSwitch.toString();
        // 回显名单「展示全部分组」设置：2-展示 1-不展示，旧数据缺字段时默认展示
        this.showAllGroupSwitch = Number(detailInfo.showAllGroupSwitch) || 2;
        this.activityDetail.showAllGroupSwitch = this.showAllGroupSwitch;
        this.removeSignStatus = detailInfo.removeSignStatus;
        this.channelCodeSwitch = detailInfo.channelCodeSwitch;
        // 回显报名成功弹幕开关：后端未返回时回退开启（1-开 2-关，值为 2 是 truthy 不会被覆盖）
        this.signSuccessBarrageSwitch = detailInfo.signSuccessBarrageSwitch || 1;
        this.activityDetail.clockSwitch = detailInfo.clockSwitch;
        // 回显 nameSortSwitch
        this.nameSortSwitch = detailInfo.nameSortSwitch == 1;

        // 根据clockSwitch和nameAddType设置nameOrGroup
        if (this.clockSwitch == 1 || this.clockSwitch == "1") {
          this.nameOrGroup = 0; // 不启用
        } else if (this.clockSwitch == 2 || this.clockSwitch == "2") {
          if (this.nameAddType == 1) {
            this.nameOrGroup = 1; // 仅添加名单
          } else if (this.nameAddType == 2) {
            this.nameOrGroup = 2; // 添加分组+名单
          }
        }

        this.shareImageUrl = detailInfo.shareImageUrl
          ? detailInfo.shareImageUrl
          : "https://ossfastmake.xlkapp.com/12jielong/bdJL/sys-defaultShareImg.jpg";
        detailInfo.shareImageUrl = detailInfo.shareImageUrl
          ? detailInfo.shareImageUrl
          : "https://ossfastmake.xlkapp.com/12jielong/bdJL/sys-defaultShareImg.jpg";
        this.shareZdyImageUrl = detailInfo.shareZdyImageUrl
          ? detailInfo.shareZdyImageUrl
          : "https://ossfastmake.xlkapp.com/12jielong/bdJL/uploadImgBtn.svg";
        detailInfo.shareZdyImageUrl = detailInfo.shareZdyImageUrl
          ? detailInfo.shareZdyImageUrl
          : "https://ossfastmake.xlkapp.com/12jielong/bdJL/uploadImgBtn.svg";

        // 编辑 - 处理封面赋值
        this.vid = detailInfo.vid ? detailInfo.vid : "";
        this.playUrl = detailInfo.playUrl ? detailInfo.playUrl : "";
        this.isVideo = detailInfo.isVideo ? detailInfo.isVideo : 2;
        this.isCoverEnabled = detailInfo.isCoverEnabled
          ? detailInfo.isCoverEnabled
          : 1;
        this.subCoverImages = detailInfo.subCoverImages
          ? detailInfo.subCoverImages.split(",")
          : [];
        this.activityModeUrl = detailInfo.activityModeUrl
          ? detailInfo.activityModeUrl
          : "https://ossfastmake.xlkapp.com/12xtPictures/xt-1.png";

        this.phoneSwitch = detailInfo.phoneSwitch;
        this.userPhone = detailInfo.userPhone;
        this.contactType = detailInfo.contactType ? detailInfo.contactType : 3;

        // 整合activityModeUrl和subCoverImages到turnPictures数组
        this.turnPictures = [];
        // 如果activityModeUrl不为空字符串，则添加到数组开头
        if (this.activityModeUrl && this.activityModeUrl.trim() !== "") {
          this.turnPictures.push(this.activityModeUrl);
        }
        // 如果subCoverImages不为空数组，则添加到turnPictures中
        if (this.subCoverImages && this.subCoverImages.length > 0) {
          this.turnPictures = this.turnPictures.concat(this.subCoverImages);
        }

        if (this.isCoverEnabled == 2 && this.activityModeUrl) {
          // 删除 turnPictures 数组里的第一个
          this.turnPictures.splice(0, 1);
        }

        if (this.activityMode == 1) {
          this.shareImgWord = "系统分享图";
        } else {
          this.shareImgWord = "上传自定义";
        }

        // 核销签到
        var ksTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
        var jsTime = dayjs().add(7, "day").format("YYYY-MM-DD HH:mm:ss");
        // 核销
        this.verificationStartTime =
          this.activityDetail.verificationStartTime || ksTime;
        this.verificationEndTime =
          this.activityDetail.verificationEndTime || jsTime;
        if (this.verificationEndTime === "2099-12-31 23:59:59") {
          this.foreverTimeHxChecked = true;
        }
        this.signInStartTime = this.activityDetail.signInStartTime || ksTime;
        this.signInEndTime = this.activityDetail.signInEndTime || jsTime;
        if (this.signInEndTime === "2099-12-31 23:59:59") {
          this.foreverTimeQdChecked = true;
        }
        // 如果activityDetail中没有对应的时间，则设置默认值
        if (!this.activityDetail.verificationStartTime) {
          this.activityDetail.verificationStartTime = ksTime;
        }
        if (!this.activityDetail.signInStartTime) {
          this.activityDetail.signInStartTime = ksTime;
        }
        if (!this.activityDetail.verificationEndTime) {
          this.activityDetail.verificationEndTime = jsTime;
        }
        if (!this.activityDetail.signInEndTime) {
          this.activityDetail.signInEndTime = jsTime;
        }
        if (this.selectType == "add") {
          this.hxStartAndEndTime = [ksTime, jsTime];
          this.signStartAndEndTime = [ksTime, jsTime];
        }

        if (this.selectType == "update" || this.ifcopy) {
          this.isanonymous = detailInfo.isanonymous;
        }
        this.multipleActivitiesStatus = detailInfo.multipleActivitiesStatus; //是否允许参加多个活动

        this.showName = detailInfo.signShowType == 1 ? "列表接龙" : "网格接龙";

        this.coverimgClone();
        this.clockPresetsList();
        if (this.selectType != "add") {
          this._getSignList();
          this._getProjectManageAdmin();
        }
        if (this.isAi == "1") {
          this.getCreateMessage(this.isAi);
        }
      });
    },
    // 获取封面图片接口
    async coverimgClone() {
      const { data, msg, status } = await getCoverimgTemplate();
      this.imgInfo = data;
      this.baseurl = this.baseurl ? this.baseurl : data[0].coverImg;
      this.imgInfo.map((item, index) => {
        item.imgShowLv = false;
      });
      this.imgInfo[0].imgShowLv = true;
      if (this.activityId != 2) {
        this.baseurl = this.activityDetail.coverImg;
      } else {
        this.baseurl ? this.baseurl : this.imgInfo[0].path;
      }
    },
    // 获取报名人数
    async _getSignList() {
      const { data, msg, status } = await getSignList({
        activityId: this.activityDetail.id,
        signShowType: this.activityDetail.signShowType,
      });

      if (status == 1) {
        if (data.pageInfo.list && data.pageInfo.list.length > 0) {
          this.commonDisabled = true;
        } else {
          console.log(data, "无人报名吗");
        }
      }
    },
    // 判断身份
    async _getProjectManageAdmin() {
      const result = await getProjectManageAdmin({
        activityId: this.activityId,
      });
      if (result.status != 901) {
        this.isOtherPeople = result.data;
        if (this.activityId == 2) {
          this.isOtherPeople = 1;
        }
      }
    },

    // 编辑名单
    nameLists(id) {
      this.nameId = id;
      this.clockPresetsDetail();
    },
    async clockPresetsDetail() {
      const { data, status } = await clockPresetsDetail({
        id: this.nameId,
      });
      if (status == 1) {
        this.clockShowPresetTitle = data.clockPresetTitle;
        this.clockShowPresetContent = data.clockPresetContent;
        this.handlerBlur();
        this.addNameListDrawer = true;
      }
    },
    FocusInterdictPeople() {
      if (this.interdict_people_num == 0) {
        this.interdict_people_num = "";
      }
    },
    BlurInterdictPeople(e) {
      if (this.interdict_people_num == 0 || this.interdict_people_num == "") {
        this.interdict_people_num = 0;
      }
    },
    oninputFun(e) {
      // 正则表达式，匹配正整数和0
      const regex = /^(?:0|[1-9]\d*)$/;
      // 判断输入值是否匹配正则表达式
      if (!regex.test(e)) {
        // 如果不匹配，则将输入值重置为上一个合法的值
        e = e.replace(regex, "");
      }
    },
    cannotEdit() {
      this.$message({
        message: "当前活动已经有人报名，不能修改",
        type: "warning",
      });
    },
    // 名单分隔规则：仅中英文逗号和换行是分隔符，空格属于名单内容本身
    parseNameList(content) {
      if (!content) return [];
      let arr = content.split(/[\n\r+,，]/g);
      arr = arr.map((item) => item.trim());
      return arr.filter((item) => item != "");
    },
    handlerBlur() {
      // var reg = /([\n\r])+/g
      // this.clockShowPresetContent = this.clockShowPresetContent.trim()
      this.people_num2 = this.parseNameList(this.clockShowPresetContent).length;
    },
    handlerBlurOnlyName() {
      let arr = this.parseNameList(this.nameShowContent);
      this.people_num = arr.length;
      // 按拼音排序
      if (this.nameSortSwitch) {
        arr.sort((a, b) =>
          a.localeCompare(b, "zh-Hans-CN-pinyin", { numeric: true }),
        );
      }
      this.onlyNameArr = arr;
    },
    // 按拼音排序开关变化
    nameSortSwitchChangeFn() {
      this.handlerBlurOnlyName();
    },
    handlerBlurFz() {
      // var reg = /([\n\r])+/g
      // this.fzValue = this.fzValue.trim()
      let arr = this.parseNameList(this.fzValue);
      // 按拼音排序
      if (this.nameSortSwitch) {
        arr.sort((a, b) =>
          a.localeCompare(b, "zh-Hans-CN-pinyin", { numeric: true }),
        );
      }
      this.people_num2 = arr.length;
      this.onlyGroupArr = arr;
      // 有内容时自动显示预览
      if (arr.length > 0) {
        this.fzPreviewShow = true;
      }
    },

    presetsDel(id) {
      this.nameId = id;
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          this.confirmDelete();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    EchoList(info) {
      if (this.openNameListDrawer == true) {
        // 追加内容，如果已有内容则换行追加
        if (this.nameShowContent && this.nameShowContent.trim()) {
          this.nameShowContent += "\n" + info.clockPresetContent;
        } else {
          this.nameShowContent = info.clockPresetContent;
        }
        this.handlerBlurOnlyName();
      }
      if (this.handleSubShow == true) {
        // 选中预存名单时，把名单名称回填为分组名称
        if (info.clockPresetTitle) {
          this.fzTitle = info.clockPresetTitle;
        }
        // 分组名单也改为追加模式
        if (this.fzValue && this.fzValue.trim()) {
          this.fzValue += "\n" + info.clockPresetContent;
        } else {
          this.fzValue = info.clockPresetContent;
        }
        this.handlerBlurFz();
      }
      this.nameListDrawer = false;
    },
    // 删除名单
    async confirmDelete() {
      const { msg, status } = await clockPresetsDel({
        id: this.nameId,
      });
      if (status == 1) {
        this.$message({
          type: "success",
          message: msg,
        });
        this.clockPresetsList();
      } else {
        this.$message(msg);
      }
    },
    // 获取名单管理列表
    clockPresetsList() {
      clockPresetsList({
        pageNum: 1,
        pageSize: 10,
      }).then((res) => {
        this.presetsList = res.data.list;
      });
    },

    // -添加模块
    addModule(num) {
      // 自定义内容1
      if (num == 0) {
        const kk = {
          type: 1,
          isCloneTf: 1,
          info: {
            value: "",
            title: "",
          },
        };
        this.modularList.push(kk);
      }
      // 小图
      if (num == 2) {
        var bb = {
          type: 3,
          isCloneTf: 1,
          info: {
            value: "图片",
            imgarr: [],
          },
        };
        this.modularList.push(bb);
      }
      // 位置
      if (num == 3) {
        var cc = {
          type: 4,
          isCloneTf: 1,
          info: {
            value: "地址",
            name: "",
            address: "",
            latitude: "",
            longitude: "",
          },
          location: {
            lng: 116.403963,
            lat: 39.915119,
          },
        };
        this.modularList.push(cc);
      }
      // 文件
      if (num == 4) {
        var dd = {
          type: 5,
          isCloneTf: 1,
          info: {
            value: "文件",
            filesArr: [],
            watermarkSwitch: "0",
            watermarkTimeOrPosition: "",
            annotationPermission: null,
            uploadImageType: "",
          },
        };
        this.modularList.push(dd);
      }
      // 音频
      if (num == 5) {
        var ee = {
          type: 6,
          isCloneTf: 1,
          info: {
            value: "音频",
            name: "",
            size: "",
            lastName: "",
            fileUrl: "",
            filesArr: [],
          },
        };
        this.modularList.push(ee);
      }
      // 视频
      if (num == 6) {
        var ff = {
          type: 7,
          isCloneTf: 1,
          info: {
            value: "视频",
            name: "",
            size: "",
            lastName: "",
            fileUrl: "",
          },
        };
        this.modularList.push(ff);
      }
      // 大图
      if (num == 7) {
        var gg = {
          type: 9,
          isCloneTf: 1,
          info: {
            value: "大图",
            imgarr: [],
          },
        };
        this.modularList.push(gg);
      }
      // 一键复制
      if (num == 11) {
        var ggg = {
          type: 13,
          isCloneTf: 1,
          info: {
            value: "一键复制区",
            copy_region_conten: "",
          },
        };
        this.modularList.push(ggg);
      }
      // 公众号
      if (num == 8) {
        var gzh = {
          type: 10,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "公众号标题",
            link: "",
            officialAccountTitle: "",
          },
        };
        this.modularList.push(gzh);
      }
      // 视频号
      if (num == 9) {
        var sph = {
          type: 11,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "视频号标题",
            videoId: "",
            videoNumberID: "",
            videoNumberTitle: "",
          },
        };
        this.modularList.push(sph);
      }

      // 其他小程序
      if (num == 10) {
        var qtxcx = {
          type: 12,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "其他小程序标题",
            appid: "",
            pagePath: "",
            appTitle: "",
          },
        };
        this.modularList.push(qtxcx);
      }
      // 关联接龙
      if (num == 12) {
        var gljl = {
          type: 14,
          isCloneTf: 1,
          randomDecimal: Date.now(),
          info: {
            value: "关联接龙",
            associationActivityId: [],
          },
        };
        this.modularList.push(gljl);
      }

      this.$forceUpdate();
    },
    // 工厂函数
    createField(item, name) {
      const base = {
        isRequired: 1,
        isOpen: 1,
        encryption: 0,
        isUniqueCheck: 0,
        isFormatCheck: 0,
        randomDecimal: Date.now(),
        promptSwitch: 2,
        promptImage: "",
        promptExplanation: "",
        displayStyle: 1, // 默认1列表式 2 下拉式';
        maxValue: 0,
        minValue: 1,
        positionSwitch: 1,
        content: "",
        dateSelectType: 2, // 格式默认2
        areaSelectType: 2,
        timeSelectType: 2, // 默认第3个
        annotationPermission: 2, //是否允许用户自行批注
      };
      // 深拷贝字段模板，避免多个实例共享引用导致互相影响
      let config = this.fieldTypeMap[item]
        ? JSON.parse(JSON.stringify(this.fieldTypeMap[item]))
        : null;
      if (!config) return null;
      // AI使用和特殊类型处理
      if (item == -99) config = { ...config, fieldName: name };
      // 多选/单选/性别等特殊content
      if (item == 9 || item == -2 || item == -3) {
        // 已在映射中处理
      }
      // 合并基础配置和字段配置
      const field = { ...base, ...config };

      // 对于包含 content 的类型，确保每个 option 都是独立对象
      if (Array.isArray(field.content)) {
        field.content = field.content.map((opt) => ({ ...opt }));
      }
      if (field.type === 10 || field.type === 11) {
        field.encryption = 1; // 开启加密
      } else {
        field.encryption = 0; // 关闭加密
      }
      // 对于type 5的字段，确保annotationPermission有默认值（如果为null或undefined，设置为"2"）
      if (
        field.type === 5 &&
        (field.annotationPermission === null ||
          field.annotationPermission === undefined)
      ) {
        field.annotationPermission = "2";
      }

      // 设置 uploadImageType 默认值
      // type 5（图片）默认支持拍照 + 相册 + 图片 (1,2,3)
      // type 35（拍照上传）默认仅支持拍照 (1)
      if (field.type === 5 && !field.uploadImageType) {
        field.uploadImageType = "1,2,3";
      } else if (field.type === 35 && !field.uploadImageType) {
        field.uploadImageType = "1";
      }

      return field;
    },

    // 优化后的 addForm
    addForm(item, name) {
      console.log("我的添加 -------", item, name);

      const field = this.createField(item, name);
      console.log(field, "field");
      if (!field) return;
      if (this.isAi == "0") {
        this.$message({
          showClose: true,
          message: `已经添加了「${field.fieldName || name || "字段"}」`,
          type: "success",
        });
      }
      if (item === 36) {
        //1232323
        this.demonstrate(24);
      }
      this.listList[this.indexIdx].signField.push(field);
      this.$forceUpdate();
    },

    // 打开预存名单列表
    openNamelistFun() {
      this.nameListDrawer = true;
    },
    // 添加接龙名单
    sureAddNameList() {
      var reg = /([\n\r])+/g;
      this.nameShowContent = this.nameShowContent.trim().replace(reg, "\n");
      let arr = this.parseNameList(this.nameShowContent);

      if (arr.length > 2000) {
        this.$message("名单人数不能超过2000");
        return;
      }
      this.packetData = arr;
      this.nameListLength = arr.length;
      this.openNameListDrawer = false;
      this.subsetValueArr = [
        {
          clockInList: this.packetData.join(),
          listGroupName: "",
          clockInListNum: arr.length,
        },
      ];
      this.nameAddType = 1;
      // 清值
      this.subsetCenterValueArr = [];
      this.pickerName = "全部";
    },
    importFiles(event) {
      this.selectedFile = event.target.files[0];
      const lastArr = this.selectedFile.name.split(".");
      if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
        this.$message("文件格式不正确");
        return;
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularFile",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFileExcel", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.clockShowPresetContent = data.data;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
        });
    },
    toAddRoster() {
      this.nameId = "";
      this.clockShowPresetTitle = "";
      this.clockShowPresetContent = "";
      this.people_num2 = 0;
      this.addNameListDrawer = true;
    },
    // 添加预存名单列表
    async clockPresetsAdd() {
      const arr = this.parseNameList(this.clockShowPresetContent);
      if (arr.length > 2000) {
        this.$message("名单人数不能超过2000");
        return false;
      }
      if (this.clockShowPresetTitle == "") {
        this.$message("名单标题不可以为空");
        return false;
      }
      if (this.clockShowPresetContent == "") {
        this.$message("预存名单不可以为空");
        return false;
      }
      // 添加
      if (this.nameId == "") {
        const { msg, status } = await clockPresetsAdd({
          clockPresetTitle: this.clockShowPresetTitle,
          clockPresetContent: this.clockShowPresetContent,
        });
        if (status == 1) {
          this.$message(msg);
          this.clockPresetsList();
        }
        this.$message(msg);
        this.addNameListDrawer = false;
      }
      // 编辑
      if (this.nameId != "") {
        const { msg, status } = await clockPresetsUpdate({
          clockPresetTitle: this.clockShowPresetTitle,
          clockPresetContent: this.clockShowPresetContent,
          id: this.id,
        });
        if (status == 1) {
          this.clockPresetsList();
        }
        this.$message(msg);
        this.addNameListDrawer = false;
      }
    },
    openCus() {
      this.copyShowWriting = this.copywriting;
      this.copyShowImage = this.copyimage;
      this.customizeDrawer = true;
    },
    // 打开背景音乐选择弹窗
    openBgMusicDialog() {
      this.bgMusicDialog = true;
      this.getBgMusicList();
    },
    // 获取背景音乐列表
    getBgMusicList() {
      this.bgMusicLoading = true;
      getBackgroundMusicList()
        .then((res) => {
          if (res && res.status === 1) {
            const d = res.data;
            // 兼容 data 为数组或 { list: [] } 两种返回结构
            this.bgMusicList = Array.isArray(d) ? d : (d && d.list) || [];
          } else {
            this.bgMusicList = [];
          }
          this.bgMusicLoading = false;
        })
        .catch(() => {
          this.bgMusicList = [];
          this.bgMusicLoading = false;
        });
    },
    // 点击"使用"：选择该背景音乐并关闭弹窗（传 null 表示选择"无音乐"）
    useBgMusic(item) {
      this.pauseBgMusic();
      if (item && item.url) {
        this.activityDetail.backgroundMusicUrl = item.url;
        this.activityDetail.musicName = item.name;
      } else {
        this.activityDetail.backgroundMusicUrl = "";
        this.activityDetail.musicName = "";
      }
      this.bgMusicDialog = false;
    },
    // 试听：切换播放/暂停（同一曲目再点一次为暂停，换曲目先停上一个）
    toggleBgMusic(item) {
      if (!item || !item.url) return;
      if (this.bgMusicPlayingId === item.id) {
        this.pauseBgMusic();
        return;
      }
      if (this.bgAudio) {
        this.bgAudio.pause();
        this.bgAudio.currentTime = 0;
      }
      const audio = new Audio(item.url);
      audio.addEventListener("ended", () => {
        this.bgMusicPlayingId = "";
      });
      this.bgAudio = audio; // 非响应式实例属性，避免 Audio 被响应式化
      this.bgMusicPlayingId = item.id;
      audio.play();
    },
    // 停止试听播放
    pauseBgMusic() {
      if (this.bgAudio) {
        this.bgAudio.pause();
      }
      this.bgMusicPlayingId = "";
    },
    // 下载excel模板
    downExam() {
      window.open(serverConfig.baseURL + "/excel/模板.xlsx", "_self");
    },
    sureCoverImgFun() {
      this.copywriting = this.copyShowWriting;
      this.copyimage = this.copyShowImage;
      this.customizeDrawer = false;
    },
    openNameListDrawerFun() {
      // 如果名单为空，添加默认的"李某某"和"王某某"
      if (!this.packetData || this.packetData.length === 0) {
        this.packetData = ["李某某", "王某某"];
        this.nameListLength = 2;
      }
      // 弹框赋值
      this.nameShowContent = this.packetData.join();
      // 按弹框实际内容重算合计与预览，避免沿用旧的 people_num
      this.handlerBlurOnlyName();
      this.openNameListDrawer = true;
      this.nameAddType = 1;
    },
    emptyName() {
      this.clockShowPresetContent = "";
      this.people_num2 = 0;
    },
    // 导入
    importExcel(event) {
      console.log(event, "eventevent");

      this.selectedFile = event.target.files[0];
      const lastArr = this.selectedFile.name.split(".");

      if (lastArr[1] != "xls" && lastArr[1] != "xlsx") {
        this.$message("文件格式不正确");
        event.target.value = "";
        return;
      }

      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularFile",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFileExcel", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          const data = response.data;

          if (this.nameAddType == 1) {
            if (data.status == 1) {
              this.nameShowContent = data.data;
              this.fzValue = data.data;

              let arr = this.parseNameList(this.nameShowContent);
              this.onlyNameArr = arr;
              this.onlyGroupArr = arr;
              this.people_num = arr.length;
            } else {
              this.$message(response.data.msg);
            }
          } else {
            if (data.status == 1) {
              this.fzValue = data.data;
              let arr = this.parseNameList(this.fzValue);
              this.onlyGroupArr = arr;
              this.people_num2 = arr.length;
              // that.clockShowPresetContent  =  that.clockShowPresetContent+ data.data;
            } else {
              this.$message(response.data.msg);
            }
          }
          this.importVisible = false;
          event.target.value = "";
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
          event.target.value = "";
        });
    },
    customizeClose() {
      this.customizeDrawer = false;
    },
    // 上传自定义封面
    uploadCopyImage(event) {
      this.selectedFile = event.target.files[0];
      var pettern = /^image/;
      if (!pettern.test(this.selectedFile.type)) {
        this.$message("文件格式不正确");
        return;
      }
      if (this.selectedFile.size / 1048576 > 5) {
        this.$message("图片大小小于5M");
      }
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };
      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          loading.close();
          var data = response.data;
          if (data.status == 1) {
            this.copyShowImage = data.msg;
          } else {
            this.$message(response.data.msg);
          }
        })
        .catch((error) => {
          loading.close();
          console.log("上传error", error);
        });
    },
    delCopyImage() {
      this.copyShowImage = "";
    },
    clearName() {
      this.nameShowContent = "";
      this.onlyNameArr = [];
      this.people_num = 0;
    },
    nameListClose() {
      this.openNameListDrawer = false;
    },
    importClose() {
      this.importVisible = false;
    },
    addNameDrawer() {
      this.addNameListDrawer = false;
    },
    closeAddNameDrawer() {
      this.addNameListDrawer = false;
    },
    nameListDrawerFun() {
      this.nameListDrawer = false;
    },
    // 复制填表项
    copyThisSignField(sonIndex, fatherIndex) {
      var data = JSON.parse(
        JSON.stringify(this.listList[fatherIndex].signField[sonIndex]),
      );
      // 复制时清空 id,让后端生成新的 id(同 listList fmActivityChargeItemVOS 复制模式)
      data.id = undefined;
      this.listList[fatherIndex].signField.splice(sonIndex + 1, 0, data);
    },
    // 月截止日期处理
    endMonthFunFirst(e) {
      this.monthDay = e;
      this.formClock.dayOfDate = e;
    },
    endMonthFunSecond(e) {
      var str = this.endMonthArr2[e].label;
      this.formClock.timeOfDay =
        str + ":" + this.endMonthArr2[this.monthMinute].label;
    },
    endMonthFunThird(e) {
      var str = this.endMonthArr3[e].label;
      this.formClock.timeOfDay =
        this.endMonthArr2[this.monthHour].label + ":" + str;
    },
    // 周截止日期处理
    endWeekFunFirst(e) {
      this.weekDay = e;
      this.formClock.dayOfDate = e;
    },
    clockMultiPeriodSwitchFn(e) {
      this.formClock.multiPeriodSwitch = e;
      if (e == 2) {
        this.formClock.clockInTimeSlot.forEach((item, index) => {
          if (index >= 1) {
            item.ifDel = 1;
          }
        });
      }
    },
    // 添加时间段
    addTimes() {
      var _json = {
        startTime: "00:00",
        endTime: "23:59",
        startAndEnd: ["00:00", "23:59"],
        ifDel: 2,
        randomDecimal: Date.now(),
      };
      this.formClock.clockInTimeSlot.push(_json);
      this.$forceUpdate();
    },
    timesDel(idx) {
      var l = 0;
      this.formClock.clockInTimeSlot.forEach((item) => {
        if (item.ifDel == 2) {
          l++;
        }
      });
      if (l == 1) {
        this.$message("至少保留一个时间段");
        return false;
      }
      this.formClock.clockInTimeSlot[idx].ifDel = 1;
      this.$forceUpdate();
    },
    // 时间段选择
    clockInTimeSlot(e, idx) {
      this.formClock.clockInTimeSlot[idx].startAndEnd = e;
      this.formClock.clockInTimeSlot[idx].startTime = e[0];
      this.formClock.clockInTimeSlot[idx].endTime = e[1];
    },

    clockLocationFn(e) {
      this.formClock.clockLocationStatus = e;
      this.addMapType = 1;
    },

    clockRangeChange(e) {
      this.formClock.clockRange = e;
    },

    supplyFn(e) {
      console.log(e);
      this.formClock.clockSupplyStatus = e;
    },

    // 日期多选
    multipleDateSure(e) {
      this.customDateArr = e;
      this.formClock.customDate = e.join(",");
    },
    // -打卡频率
    clickin(e) {
      this.CheckInFrequency.forEach((item) => {
        if (item.value == e) {
          this.selectData = item.label;
        }
      });

      this.selectFrequency = e;
      this.formClock.clockFrequencyType = e;
      // 一次性打卡不支持补卡，强制关闭
      if (e == 8) {
        this.formClock.clockSupplyStatus = 2;
      }
      // 每月
      if (e == 1) {
        this.formClock.timeOfDay = "20:00";
        // 日期处理
        this.lastDayOfMonth = this.lastDayOfMonth.slice(-2);
        // 如果选择了开始时间
        var beginTime = this.activityDetail.beginTime;
        if (beginTime) {
          var year = beginTime.substring(0, 4);
          var month = beginTime.substring(5, 7);
          const lastDay = new Date(year, month, 0).getDate();
          this.lastDayOfMonth = lastDay;
        }
        this.formClock.dayOfDate = this.lastDayOfMonth;
        this.monthDay = Number(this.lastDayOfMonth);
        this.monthHour = 20;
        this.monthMinute = 0;
        this.endMonthValue =
          this.formClock.dayOfDate + "号 " + this.formClock.timeOfDay;
      }
      // 每周
      if (e == 2) {
        this.formClock.timeOfDay = "20:00";
        this.formClock.dayOfDate = "6";
        this.weekDay = 6;
        this.weekHour = 20;
        this.weekMinute = 0;
        this.endWeekValue =
          "周" +
          this.weekChineseNumbers[this.formClock.dayOfDate] +
          " " +
          this.formClock.timeOfDay;
      }
      // 每天
      if (e == 3) {
        this.formClock.clockFrequency = "0,1,2,3,4,5,6";
      }
      // 法定工作日，法定节假日，自定义周几打卡，自定义日期打卡，一次性打卡 设置一样
    },
    candidateChange(e) {
      if (this.selectFrequency == 6) {
        this.formClock.clockFrequency = e.join(",");
      }
      if (this.selectFrequency == 3) {
        this.formClock.clockFrequency = "0,1,2,3,4,5,6";
      }
    },
    clockMaxSwitchFn(e) {
      this.formClock.clockMaxSwitch = e;
      if (e == 2) {
        this.formClock.clockMaxNum = 1;
      }
    },
    checkinRangeChange(e) {
      this.checkinrange = e;
    },
    signRangeChange(e) {
      this.activityDetail.signLocationDistance = e;
    },
    signInfoIsOpenFun(e) {
      this.signInfoStatus = e;
      this.activityDetail.signInfoStatus = e;
    },
    signChange(e) {
      this.updateSignInfo = e;
    },
    deadlineTimeFun(e) {
      this.deadline = e;
      this.activityDetail.registrationtime = e[0];
      this.activityDetail.endregistrationtime = e[1];
    },
    deadCancelTimeFun(e) {
      this.deadCancelline = e;
      this.activityDetail.removeSignBeginTime = e[0];
      this.activityDetail.removeSignEndTime = e[1];
    },
    actStartAndEndTimeFun(e) {
      this.actStartAndEndTime = e;
      this.activityDetail.beginTime = e[0];
      this.activityDetail.endTime = e[1];
    },
    hxStartAndEndTimeFun(e) {
      this.hxStartAndEndTime = e;
      this.activityDetail.verificationStartTime = e[0];
      this.activityDetail.verificationEndTime = e[1];
    },
    qdStartAndEndTimeFun(e) {
      this.signStartAndEndTime = e;
      this.activityDetail.signInStartTime = e[0];
      this.activityDetail.signInEndTime = e[1];
    },
    removeSignChange(e) {
      this.removeSignStatus = e;
      this.activityDetail.removeSignStatus = e;
    },
    // addInp(item, index, fatherIndex) {
    //   var inp = {
    //     value: "",
    //     maxNum: -1,
    //   };
    //   this.listList[fatherIndex].signField[index].content.push(inp);
    //   this.$forceUpdate();
    // },
    // 添加选项
    addInp(item, index) {
      console.log(this.listList, index, "listList");
      var inp = {
        value: "",
        maxNum: -1,
        randomDecimal: Date.now(),
      };
      // 使用 $set 确保响应式更新
      const content = this.listList[this.indexIdx].signField[index].content;
      this.$set(this.listList[this.indexIdx].signField[index], "content", [
        ...content,
        inp,
      ]);

      this.$forceUpdate();
    },
    // 删除添加项
    delInp(item, index, indexIdx, listIndex) {
      this.listList[listIndex].signField[indexIdx].content.splice(index, 1);
      this.$forceUpdate();
    },
    // 预约：添加预约项
    addAppointmentOption(fieldIndex) {
      const field = this.listList[this.indexIdx].signField[fieldIndex];
      if (!Array.isArray(field.appointmentList)) {
        this.$set(field, "appointmentList", []);
      }
      field.appointmentList.push(createAppointmentOption(""));
      this.$forceUpdate();
    },
    // 预约：删除预约项（至少保留一项）
    delAppointmentOption(fieldIndex, optionIndex) {
      const field = this.listList[this.indexIdx].signField[fieldIndex];
      if (!Array.isArray(field.appointmentList)) return;
      if (field.appointmentList.length <= 1) {
        this.$message({
          showClose: true,
          message: "请至少保留一项",
          type: "warning",
        });
        return;
      }
      field.appointmentList.splice(optionIndex, 1);
      this.$forceUpdate();
    },
    // 预约：打开批量添加弹窗
    openBatchAppointment(fieldIndex) {
      this.batchAppointmentFieldIndex = fieldIndex;
      this.batchAppointmentText = "";
      this.batchAppointmentVisible = true;
    },
    // 预约：确认批量添加（一行一个，最多15个）
    confirmBatchAppointment() {
      const text = (this.batchAppointmentText || "").trim();
      if (!text) {
        this.$message({
          showClose: true,
          message: "请输入预约项内容",
          type: "warning",
        });
        return;
      }
      const lines = text
        .split("\n")
        .map((l) => l.trim())
        .filter((l) => l);
      if (lines.length > 15) {
        this.$message({
          showClose: true,
          message: "一行一个选项，最大支持添加15个",
          type: "warning",
        });
        return;
      }
      const field =
        this.listList[this.indexIdx].signField[this.batchAppointmentFieldIndex];
      if (!Array.isArray(field.appointmentList)) {
        this.$set(field, "appointmentList", []);
      }
      lines.forEach((name) => {
        const opt = createAppointmentOption(name);
        opt.sortOrder = field.appointmentList.length;
        field.appointmentList.push(opt);
      });
      this.batchAppointmentVisible = false;
      this.$message({ showClose: true, message: "添加成功", type: "success" });
      this.$forceUpdate();
    },
    // 预约：打开时间设置弹层
    openAppointmentTime(fieldIndex, optionIndex) {
      this.appointmentEditTarget = { fieldIndex, optionIndex };
      this.appointmentTimeVisible = true;
    },
    // 预约：弹层保存回写（timeSlotType 写在 option 层，对齐后端现状）
    handleAppointmentTimeSave({ timeSlots, timeSlotType }) {
      const { fieldIndex, optionIndex } = this.appointmentEditTarget;
      const field =
        this.listList[this.indexIdx] &&
        this.listList[this.indexIdx].signField[fieldIndex];
      if (!field || !field.appointmentList || !field.appointmentList[optionIndex]) {
        this.appointmentTimeVisible = false;
        return;
      }
      this.$set(field.appointmentList[optionIndex], "timeSlots", timeSlots);
      this.$set(field.appointmentList[optionIndex], "timeSlotType", timeSlotType);
      this.appointmentTimeVisible = false;
      this.$forceUpdate();
    },
    // 预约：选项时间摘要
    appointmentOptionSummary(option) {
      return getAppointmentOptionSummary(option);
    },
    // 预约：保存活动时同步 fmFieldNumList（与 appointmentList 按索引对齐）
    syncAppointmentFieldNumListForSave(fieldData) {
      if (fieldData.type !== 39 || !Array.isArray(fieldData.appointmentList)) {
        return;
      }
      if (!Array.isArray(fieldData.fmFieldNumList)) {
        fieldData.fmFieldNumList = [];
      }
      fieldData.appointmentList.forEach((option, optionIndex) => {
        if (!fieldData.fmFieldNumList[optionIndex]) {
          fieldData.fmFieldNumList[optionIndex] = {
            id: null,
            itemId: null,
            ifDel: 2,
            addTime: dayjs().format("YYYY-MM-DD HH:mm:ss"),
            filedNumId: null,
            maxNum: option.maxNum !== undefined ? option.maxNum : -1,
            optionName: option.optionName || null,
            value: null,
            validateDateTo: null,
          };
        } else {
          fieldData.fmFieldNumList[optionIndex].maxNum =
            option.maxNum !== undefined ? option.maxNum : -1;
          fieldData.fmFieldNumList[optionIndex].optionName =
            option.optionName || null;
        }
      });
      // 截掉多余项，保持与 appointmentList 等长
      fieldData.fmFieldNumList.length = fieldData.appointmentList.length;
    },
    // 是否保密
    encryptionChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].encryption = e;
      this.$forceUpdate();
    },
    // 是否必填
    isRequiredChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isRequired = e;
      this.$forceUpdate();
    },
    // 是否公开
    isOpenChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isOpen = e;
      this.$forceUpdate();
    },
    // 是否重复
    isUniqueCheckChange(e, sonIndex, fatherIndex) {
      this.listList[fatherIndex].signField[sonIndex].isUniqueCheck =
        e == true ? 1 : 0;
    },
    // 日期格式
    bindValidateTimePickerChange(e, sonIndex, fatherIndex) {
      this.validateIndex = e;
      this.listList[fatherIndex].signField[sonIndex].timeSelectType =
        this.validateIndex;
    },
    // 省市区
    bindValidateAreaPickerChange(e, sonIndex, fatherIndex) {
      this.validateIndex = e;
      this.listList[fatherIndex].signField[sonIndex].areaSelectType =
        this.validateIndex;
    },
    // 打开抽屉
    openfieldList() {
      this.formDrawerShow = true;
    },

    openFullScreen2() {
      const loading = this.$loading({
        lock: true,
        text: "Loading",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      setTimeout(() => {
        loading.close();
      }, 2000);
    },
    // 上传文件
    handleFileUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;
      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (let i = 0; i < this.selectedFile.length; i++) {
        const name = this.selectedFile[i].name;
        const size = this.selectedFile[i].size;
        // 判断后缀名
        const lastArr = this.selectedFile[i].name.split(".");
        if (
          lastArr[1] != "pdf" &&
          lastArr[1] != "ppt" &&
          lastArr[1] != "doc" &&
          lastArr[1] != "docx" &&
          lastArr[1] != "xls" &&
          lastArr[1] != "xlsx" &&
          lastArr[1] != "zip"
        ) {
          loading.close();
          event.target.value = "";
          this.$message("文件格式不正确");
          return;
        } else {
          if (this.selectedFile[i].size / 1048576 > 10) {
            loading.close();
            event.target.value = "";
            this.$message("请上传大小不超过10MB文件");
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularFile",
            };
            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                loading.close();
                if (response.data.status == 1) {
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  this.modularList[this.modulCommonIndex].info.filesArr.push(
                    _json,
                  );
                }
              })
              .catch((error) => {
                event.target.value = "";
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },
    // 上传签字文件
    async handleSignFileUpload(event, idx) {
      const selectedFile = event.target.files;
      const result = validateUploadFiles(selectedFile);
      console.log(result);
      if (!result.valid) {
        return this.$message.error(result.message);
      }
      this.signFileItemIndex = idx;
      const uploadReuslt = {};
      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      if (["word", "pdf"].includes(result.fileType)) {
        axios
          .post(
            serverConfig.baseURL + "/file/uploadSignatureFile",
            {
              file: selectedFile[0],
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            },
          )
          .then((response) => {
            const res = response.data;
            if (res.status === 1) {
              console.log("-----------------文件----------------------");
              console.log(res.data);
              console.log("-----------------文件----------------------");
              this.$refs.siginFileRef.initData({
                mode: "create",
                fileType: "file",
                siginFileIndex: this.signFileItemIndex,
                data: res.data,
              });
            }
          })
          .catch((error) => {
            console.log("err:", error);
          })
          .finally(() => {
            event.target.value = "";
            loading.close();
          });
      } else {
        const uploadPromises = Array.from(selectedFile).map((filePath) => {
          return new Promise((resolve, reject) => {
            axios
              .post(
                serverConfig.baseURL + "/file/uploadFile",
                { file: filePath, type: "modularFile" },
                {
                  headers: {
                    "Content-Type": "multipart/form-data",
                    "Access-Token": localStorage.getItem("token"),
                  },
                },
              )
              .then((response) => {
                const res = response.data;
                if (res.status === 0) {
                  resolve(null);
                  return this.$message.error("文件不能超过5MB");
                }
                resolve({
                  pageId: generateUUID(),
                  pageIndex: 0,
                  imageUrl: this.imageUrl + res.msg,
                  regions: [],
                });
              })
              .catch((error) => {
                console.log("err:", error);
              })
              .finally(() => {
                event.target.value = "";
                loading.close();
              });
          });
        });
        try {
          // 等待所有上传完成
          const results = await Promise.all(uploadPromises);
          // 过滤掉 null 的结果
          const uploadImageList = results.filter((item) => item !== null);
          const initImageData = {
            originalFileName: "签名图片",
            fileType: "image",
            pages: uploadImageList.map((item, index) => {
              return {
                ...item,
                pageIndex: index,
              };
            }),
          };
          // console.log(initImageData);
          // console.log(this.$refs.siginFileRef);
          this.$refs.siginFileRef.initData({
            mode: "create",
            fileType: "image",
            siginFileIndex: this.signFileItemIndex,
            data: initImageData,
          });
        } catch (err) {
          console.log(err, "上传失败");
        }
      }
    },
    changeSignFileHandler(fieldItem, fieldIndex, optType) {
      this.$refs.siginFileRef.initData({
        mode: optType === 0 ? "preview" : "edit",
        fileType: fieldItem.content.fileType,
        siginFileIndex: fieldIndex,
        data: fieldItem.content,
      });
    },
    closeHandler() { },
    saveHandler(data) {
      const signFileInfo = JSON.parse(data);
      const index = signFileInfo.siginFileIndex;
      delete signFileInfo.siginFileIndex;
      if (this.listList[this.indexIdx].signField[index]) {
        this.listList[this.indexIdx].signField[index].content = signFileInfo;
      }
    },
    // 上传音频
    handleMpThreeUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;

      // 加载中
      const loading = this.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      for (let i = 0; i < this.selectedFile.length; i++) {
        const name = this.selectedFile[i].name;
        const size = this.selectedFile[i].size;
        // 判断后缀名
        const lastArr = this.selectedFile[i].name.split(".");
        if (lastArr[1] != "mp3") {
          loading.close();
          event.target.value = "";
          this.$message("文件格式不正确");
          return;
        } else {
          if (this.selectedFile[i].size / 1048576 > 10) {
            loading.close();
            event.target.value = "";
            this.$message("请上传大小不超过10MB文件");
            break;
          } else {
            var parm = {
              file: this.selectedFile[i],
              type: "modularMP3",
            };

            axios
              .post(serverConfig.baseURL + "/file/uploadFile", parm, {
                headers: {
                  "Content-Type": "multipart/form-data",
                  "Access-Token": localStorage.getItem("token"),
                },
              })
              .then((response) => {
                loading.close();
                if (response.data.status == 1) {
                  var _json = {
                    name: name,
                    size: size,
                    fileUrl: response.data.msg,
                    lastName: lastArr[1],
                  };
                  this.modularList[this.modulCommonIndex].info.filesArr.push(
                    _json,
                  );
                }
              })
              .catch((error) => {
                loading.close();
                console.log("err:", error);
              });
          }
        }
      }
    },

    // 上传视频 - 改为视频云点播 VOD 上传 + 轮询封面
    handleMpFourUpload(event, idx) {
      // 兼容旧的 <input type="file"> 入口:把选中的 File 走 VOD 上传,
      // 与 <UploadVideoCom> 的 chooseVideo 行为保持一致
      const file = event && event.target && event.target.files && event.target.files[0];
      if (!file) return;
      if (event && event.target) event.target.value = "";
      this._startModuleVideoUpload(file, idx);
    },
    // 供 UploadVideoCom 的 @uploadstarted 回调:仅记录开始,不阻塞
    handleModuleVideoStarted(idx) {
      this.modulCommonIndex = idx;
    },
    // 供 UploadVideoCom 的 @success 回调:VOD 上传完成后存 videoId + blob 本地预览
    // - videoId:后端按 videoId 取播放地址
    // - info.fileUrl:放 UploadVideoCom 通过 URL.createObjectURL(file) 生成的 blob URL,
    //   让用户上传完立即能在 <video> 里看到视频(无需等后端转码)
    // - playCoverImage 是封面设置(customCoverDialog)用的字段,模块视频这里不要碰
    handleModuleVideoSuccess(payload, idx) {
      this.modulCommonIndex = idx;
      const info = this.modularList[idx].info;
      // 旧 blob 预览 revoke 释放内存
      if (info.fileUrl && /^blob:/.test(info.fileUrl)) {
        try { URL.revokeObjectURL(info.fileUrl); } catch (e) { /* ignore */ }
      }
      info.videoId = payload.videoId || "";
      info.name = payload.fileName || "";
      info.size = payload.fileSize || "";
      const lastArr = (payload.fileName || "").split(".");
      info.lastName = lastArr.length > 1 ? lastArr[lastArr.length - 1] : "";
      // 用 UploadVideoCom 抛出来的 blob 预览作为视频 src,视频就放在 fileUrl 里
      info.fileUrl = payload.previewUrl || info.fileUrl || "";
      this.$set(this.modularList[idx], "info", { ...info });
      this.$message.success("视频上传成功");
    },
    // 供 UploadVideoCom 的 @fail 回调
    handleModuleVideoFail(res, idx) {
      console.log("模块视频上传失败", idx, res);
      this.$message.error((res && res.message) || "视频上传失败");
    },
    // 内部:直接以 File 触发 VOD 上传(供旧 <input> 入口使用)
    _startModuleVideoUpload(file, idx) {
      const lastArr = file.name.split(".");
      const ext = lastArr.length > 1 ? lastArr[lastArr.length - 1].toLowerCase() : "";
      if (ext !== "mp4") {
        this.$message.warning("文件格式不正确,请上传MP4格式视频");
        return;
      }
      if (file.size / 1048576 > 10) {
        this.$message.warning("请上传大小不超过10MB文件");
        return;
      }
      const info = this.modularList[idx].info;
      // 与封面 customCoverDialog 行为一致:选完文件立刻给一个本地预览,
      // 上传期间用户能看到视频;上传成功后 fileUrl 保持这个 blob URL,
      // 直到下一次重新上传时被 revoke 替换
      if (info.fileUrl && /^blob:/.test(info.fileUrl)) {
        try { URL.revokeObjectURL(info.fileUrl); } catch (e) { /* ignore */ }
      }
      info.videoId = "";
      info.fileUrl = URL.createObjectURL(file);
      info.name = file.name;
      info.size = file.size;
      info.lastName = ext;
      this.$set(this.modularList[idx], "info", { ...info });
      this._initAndStartVodUpload(file, idx);
    },
    /**
     * VOD 上传 + STS:与封面设置(createUploader)同一套逻辑,但目标写入 modularList
     */
    _initAndStartVodUpload(file, idx) {
      const self = this;
      const loading = self.$loading({
        lock: true,
        text: "上传中...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      const VodCtor =
        (typeof window !== "undefined" && window.AliyunUpload && window.AliyunUpload.Vod) ||
        (typeof AliyunUpload !== "undefined" && AliyunUpload.Vod);
      if (typeof VodCtor !== "function") {
        loading.close();
        self.$message.error("AliyunUpload SDK 未加载");
        return;
      }
      // 上传前先清掉该模块的旧轮询(避免上一个视频未完成时插入新视频)
      self._clearModuleVideoPollTimer();
      const uploader = new VodCtor({
        timeout: 60000,
        partSize: 1048576,
        parallel: 5,
        retryCount: 3,
        retryDuration: 2,
        region: self.region || "cn-shanghai",
        userId: self.userId || "",
        localCheckpoint: true,
        addFileSuccess: () => {
          uploader.startUpload();
        },
        onUploadstarted: (uploadInfo) => {
          axios
            .post(serverConfig.baseURL + "/videoTx/getVideoPathToken", "", {
              headers: {
                "Content-Type": "application/json",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              const result = response.data;
              if (result && result.status == 1 && result.data) {
                uploader.setSTSToken(
                  uploadInfo,
                  result.data.AccessKeyId,
                  result.data.AccessKeySecret,
                  result.data.SecurityToken,
                );
              }
            })
            .catch((err) => {
              console.log("getVideoPathToken err:", err);
            });
        },
        onUploadSucceed: (uploadInfo) => {
          loading.close();
          self.handleModuleVideoSuccess(
            {
              videoId: uploadInfo.videoId,
              fileName: file.name,
              fileSize: file.size,
            },
            idx,
          );
        },
        onUploadFailed: (uploadInfo, code, message) => {
          loading.close();
          console.log("模块视频上传失败:", code, message);
          self.$message.error("文件上传失败");
        },
        onUploadCanceled: () => {
          loading.close();
        },
        onUploadProgress: () => { },
        onUploadTokenExpired: () => {
          loading.close();
          self.$message.error("文件上传超时");
        },
        onUploadEnd: () => {
          loading.close();
        },
      });
      uploader.addFile(
        file,
        null,
        null,
        null,
        self.vodTemplateGroupId
          ? JSON.stringify({ Vod: { TemplateGroupId: self.vodTemplateGroupId } })
          : '{"Vod":{}}',
      );
    },
    /**
     * 轮询拉取模块视频的播放地址 + 封面:VOD 转码/截图未完成时需要重试,每 2s 一次,最多 30 次
     */
    _pollModuleVideoCover(videoId, idx, times = 0) {
      const MAX_TIMES = 30;
      const INTERVAL = 2000;
      this._clearModuleVideoPollTimer();
      const tick = async () => {
        // 模块已被删除 / 用户换视频(目标索引已变更):停止轮询
        if (
          !this.modularList[idx] ||
          this.modularList[idx].info.videoId !== videoId
        ) {
          this._clearModuleVideoPollTimer();
          return;
        }
        if (times >= MAX_TIMES) {
          this._clearModuleVideoPollTimer();
          this.$message.error("视频处理超时,请稍后再试");
          return;
        }
        try {
          const result = await getVideoPathUrl({ videoId });
          const payload = result.data || result;
          const playUrl =
            payload.playUrl ||
            payload.url ||
            payload.videoUrl ||
            result.msg ||
            "";
          const coverImage =
            payload.playCoverImage ||
            payload.coverImage ||
            payload.coverUrl ||
            payload.cover ||
            "";
          if (!playUrl) {
            times += 1;
            this.moduleVideoPollTimer = setTimeout(tick, INTERVAL);
            return;
          }
          const info = { ...this.modularList[idx].info };
          // 用 VOD 在线 URL 替换本地 blob 预览,顺手把旧的 blob URL revoke 掉
          if (info.fileUrl && /^blob:/.test(info.fileUrl) && info.fileUrl !== playUrl) {
            try { URL.revokeObjectURL(info.fileUrl); } catch (e) { /* ignore */ }
          }
          info.fileUrl = playUrl;
          info.playCoverImage = coverImage;
          this.$set(this.modularList[idx], "info", info);
          this.$message.success("视频处理完成");
          this._clearModuleVideoPollTimer();
        } catch (err) {
          console.log("轮询模块视频异常", err);
          times += 1;
          this.moduleVideoPollTimer = setTimeout(tick, INTERVAL);
        }
      };
      this.moduleVideoPollTimer = setTimeout(tick, INTERVAL);
    },
    _clearModuleVideoPollTimer() {
      if (this.moduleVideoPollTimer) {
        clearTimeout(this.moduleVideoPollTimer);
        this.moduleVideoPollTimer = null;
      }
    },
    /**
     * 编辑活动加载完成后,自动把 modular 里 type==7 视频的 videoId 解析成可播 fileUrl
     * 兼容 VOD(videoId)、OSS 旧数据(相对 fileUrl)、blob 预览(blob: 跨会话必失效,强制刷新)
     */
    async _resolveModuleVideoUrl(item) {
      const info = item.info || {};
      if (!info.videoId) return "";
      // blob: 跨会话必然失效(ERR_FILE_NOT_FOUND),编辑页加载时一律重新拉
      // http(s) 绝对地址认为是有效的,跳过(避免覆盖用户上传后回填的预览)
      const fileUrl = info.fileUrl || "";
      if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
      const videoId = info.videoId;
      try {
        const result = await getVideoPathUrl({ videoId });
        const payload = result.data || result || {};
        const playUrl =
          payload.playUrl ||
          payload.url ||
          payload.videoUrl ||
          (result && result.msg) ||
          "";
        const coverImage =
          payload.playCoverImage ||
          payload.coverImage ||
          payload.coverUrl ||
          payload.cover ||
          "";
        if (playUrl) {
          // 通过 $set 触发响应式更新
          this.$set(item, "info", {
            ...info,
            fileUrl: playUrl,
            playCoverImage: coverImage || info.playCoverImage || "",
          });
        } else {
          console.error("[_resolveModuleVideoUrl] 获取地址失败:", { videoId, result });
        }
        return playUrl;
      } catch (error) {
        console.error("[_resolveModuleVideoUrl] 异常:", { videoId, error });
        return "";
      }
    },
    /**
     * 编辑活动入口:加载完 modularList 之后调用,3 个/批并发解析 type==7 的视频地址
     */
    async autoLoadModuleVideoUrls() {
      if (!Array.isArray(this.modularList) || this.modularList.length === 0) return;
      // 有 videoId 且 fileUrl 不是 http(s) 绝对地址的项都强制刷新
      // (blob: 跨会话失效;空 / 相对路径 / OSS 旧数据都需要重新解析)
      const videoItems = this.modularList.filter(
        (it) =>
          it &&
          it.type == 7 &&
          it.info &&
          it.info.videoId &&
          !/^https?:\/\//i.test(it.info.fileUrl || ""),
      );
      console.log("[autoLoadModuleVideoUrls] 待处理视频模块:", videoItems.length, videoItems);
      if (videoItems.length === 0) return;
      const batchSize = 3;
      for (let i = 0; i < videoItems.length; i += batchSize) {
        const batch = videoItems.slice(i, i + batchSize);
        await Promise.allSettled(batch.map((it) => this._resolveModuleVideoUrl(it)));
        if (i + batchSize < videoItems.length) {
          await new Promise((resolve) => setTimeout(resolve, 500));
        }
      }
    },
    // 上传图片
    handleImgUpload(event, idx) {
      this.modulCommonIndex = idx;
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      for (let i = 0; i < 9; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          event.target.value = "";
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("请上传大小不超过5MB文件");
          event.target.value = "";
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.modularList[idx].info.imgarr.push(response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }
    },
    // 上传小图
    handleSmallImgUpload(event, idx) {
      this.modulCommonIndex = idx;
      // 9个
      const imgCounts = this.modularList[idx].info.imgarr.length;
      const theRest = 9 - imgCounts;
      if (event.target.files.length > theRest) {
        this.$message("只能上传9张小图");
        return;
      }
      this.selectedFile = event.target.files;
      var pettern = /^image/;
      for (let i = 0; i < 9; i++) {
        if (!pettern.test(this.selectedFile[i].type)) {
          this.$message("文件格式不正确");
          return;
        }
        if (this.selectedFile[i].size / 1048576 > 5) {
          this.$message("图片大小小于5M");
        } else {
          var parm = {
            file: this.selectedFile[i],
            type: "modularImg",
          };

          axios
            .post(serverConfig.baseURL + "/file/uploadFile", parm, {
              headers: {
                "Content-Type": "multipart/form-data",
                "Access-Token": localStorage.getItem("token"),
              },
            })
            .then((response) => {
              if (response.data.status == 1) {
                this.modularList[idx].info.imgarr.push(response.data.msg);
              }
            })
            .catch((error) => {
              event.target.value = "";
              console.log("err:", error);
            });
        }
      }
    },
    submitUploadBigImage() {
      const formData = new FormData();
      formData.append("image", this.selectedFile);
      var parm = {
        file: this.selectedFile,
        type: "modularImg",
      };

      axios
        .post(serverConfig.baseURL + "/file/uploadFile", parm, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Access-Token": localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log("图片上传成功", response);
        })
        .catch((error) => {
          console.log("图片上传失败", error);
        });
    },
    anonymousFun(e) {
      this.isanonymous = e;
    },
    phoneSwitchChange(e) {
      this.phoneSwitch = e;
    },

    copyStatusFun(e) {
      this.copyStatus = e;
    },
    forwardFun(e) {
      const a = e ? 1 : 2;
      this.shareStatus = a;
      this.is_forward = e ? 1 : 0;
    },
    anonymouspartFun(e) {
      this.anonymousparticipation = e;
    },
    commentFun(e) {
      this.commentStatus = e;
    },
    changeChatSwitch(e) {
      this.chatSwitch = e;
    },
    thumbsUpFun(e) {
      this.thumbs_up = e;
    },
    isCommentFun(e) {
      this.is_comment = e;
    },

    isScoreFun(e) {
      this.is_score = e;
    },
    isMessageFun(e) {
      this.isMessage = e;
    },

    rankingFun(e) {
      this.showRanking = e;
    },
    hideUserFun(e) {
      this.hideUser = e;
    },
    isDestinationFun(e) {
      this.is_destination = e;
    },
    clockRemindFun(e) {
      this.formClock.clockRemindStatus = e;
    },
    // 打卡提醒时间
    clockTime(e) {
      this.formClock.remindTime = e;
    },
    // 表单项上移下移删除
    topNuoPng(item, index, type, listIdx) {
      var data = [];
      if (type == 1) {
        data = this.listList;
      } else if (type == 2) {
        if (index == 1) {
          return false;
        }
        data = this.listList[listIdx].signField;
        // 检查上一项是否为第一个姓名（isFirst === 1），如果是则不能移动
        if (data[index - 1]?.isFirst === 1) {
          return;
        }
      } else if (type == 3) {
        data = this.modular;
      } else if (type == 4) {
        // 标题类型，可以移动到最上面
        data = this.listList[listIdx].signField;
      }
      if (index == 0) {
        return false;
      }
      //在上一项插入该项
      data.splice(index - 1, 0, data[index]);
      //删除后一项
      data.splice(index + 1, 1);
    },
    // 下移
    bottomNuoPng(item, index, type, listIdx) {
      var data = [];
      if (type == 1) {
        data = this.listList;
      } else if (type == 2) {
        data = this.listList[listIdx].signField;
      } else if (type == 3) {
        data = this.modular;
      } else if (type == 4) {
        // 标题类型，可以自由下移
        data = this.listList[listIdx].signField;
      }

      if (index == data.length - 1) {
        return false;
      }
      //在下一项插入该项
      data.splice(index + 2, 0, data[index]);
      // 删除前一项
      data.splice(index, 1);
    },
    // 删除表单项
    delMuKuai(itm, ind, idx) {
      this.indexIdx = idx;
      if (this.selectType == "update") {
        itm["ifDel"] = 1;
        this.delListInfo.push(itm);
      }
      this.listList[this.indexIdx].signField.splice(ind, 1);
    },
    // 大图上移下移
    upBigImg(index, fatherIndex) {
      // 上移

      if (index == 0) {
        this.$message({
          message: "已经是第一项",
          type: "warning",
        });
        return false;
      }
      //在上一项插入该项
      this.modularList[fatherIndex].info.imgarr.splice(
        index - 1,
        0,
        this.modularList[fatherIndex].info.imgarr[index],
      );
      //删除后一项
      this.modularList[fatherIndex].info.imgarr.splice(index + 1, 1);
    },
    downBigImg(index, fatherIndex) {
      // 下移

      if (index == this.modularList[fatherIndex].info.imgarr.length - 1) {
        this.$message({
          message: "已经是最后一项",
          type: "warning",
        });
        return false;
      }
      //在下一项插入该项
      this.modularList[fatherIndex].info.imgarr.splice(
        index + 2,
        0,
        this.modularList[fatherIndex].info.imgarr[index],
      );
      // 删除前一项
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 大图删除
    delBigImg(index, fatherIndex) {
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 小图删除
    delSmallPic(index, fatherIndex) {
      this.modularList[fatherIndex].info.imgarr.splice(index, 1);
    },
    // 文件删除
    delFiles(index, fatherIndex) {
      this.modularList[fatherIndex].info.filesArr.splice(index, 1);
    },

    //选择位置
    openAddress(idx) {
      this.addMapType = 1;
      this.addressDialog = true;
      this.addressIdx = idx;
    },
    openMap(idx) {
      this.modulCommonIndex = idx;
      this.addMapType = 2;
      this.addressDialog = true;
      this.addressIdx = idx;
    },
    openJoininAddress() {
      this.addMapType = 3;
      this.addressDialog = true;
    },
    openSignAddress() {
      this.addMapType = 4;
      this.addressDialog = true;
    },

    subAddress() {
      window.addEventListener(
        "message",
        (event) => {
          // 接收位置信息，用户选择确认位置点后选点组件会触发该事件，回传用户的位置信息
          const loc = event.data;
          // _this.addressData = []
          if (loc && loc.module == "locationPicker") {
            //防止其他应用也会向该页面post信息，需判断module是否为'locationPicker'
            this.address = loc.poiaddress;
            this.poiname = loc.poiname;
            this.latitude = loc.latlng.lat;
            this.longitude = loc.latlng.lng;
          }
        },
        false,
      );
    },
    //地图选点确定
    submitMap() {
      if (
        this.address == null ||
        this.latitude == null ||
        this.longitude == null
      ) {
        this.$message.error("请先选择地址！");
        return;
      }

      this.addressDialog = false;
      // 模块
      if (this.addMapType == 2) {
        this.modularList[this.modulCommonIndex].info.address = this.address;
        this.modularList[this.modulCommonIndex].info.latitude = this.latitude;
        this.modularList[this.modulCommonIndex].info.longitude = this.longitude;
        this.modularList[this.modulCommonIndex].info.name = this.poiname;
        this.modularList[this.modulCommonIndex].location = {
          lng: this.longitude,
          lat: this.latitude,
        };
      }
      // 设置
      if (this.addMapType == 3) {
        this.specifyaddress = this.address;
        this.deliveryaddress = `${this.latitude},${this.longitude}`;
      }
      // 打卡
      if (this.addMapType == 1) {
        var info = {
          name: this.poiname,
          address: this.address,
          latitude: this.latitude,
          longitude: this.longitude,
        };
        this.formClock.clockLocationInfo = JSON.stringify(info);
        this.formClock.address = this.address;
      }
      // 签到
      if (this.addMapType == 4) {
        this.activityDetail.signLocation = `${this.latitude},${this.longitude}`;
        this.activityDetail.signInAddress = this.address;
      }
    },

    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(() => {
          done();
        })
        .catch(() => { });
    },
    formDrawerClose() {
      this.formDrawerShow = false;
    },
    handleRemove(file, fileList) {
      console.log(file, fileList);
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    submitUpload() {
      this.$refs.upload.submit();
    },

    handlePreview(file) {
      console.log(file);
    },

    getLastDayOfMonth(date = new Date()) {
      // 使用示例
      // 创建一个新的日期对象，设置为下一个月的第一天
      const nextMonth = new Date(date.getFullYear(), date.getMonth() + 1, 1);

      // 减去一天，即得到当前月的最后一天
      const lastDay = new Date(nextMonth - 1);

      // 返回结果，根据需要可以返回不同的格式
      // 这里返回的是日期对象的字符串形式
      return lastDay.toISOString().split("T")[0]; // 如果你想要的是 YYYY-MM-DD 格式

      // 或者直接返回日期对象
      // return lastDay;
    },
    // 对象数组进行去重
    uniqueBy(a, key) {
      const seen = new Set();
      return a.filter((item) => {
        const k = key(item);
        return seen.has(k) ? false : seen.add(k);
      });
    },
    getClickInfo(address) {
      this.markLocation.lat = address.point.lat;
      this.markLocation.lng = address.point.lng;
    },
    searchMap(address) {
      // 创建地址解析器实例，平时用不了，加个window完美胡恶化！
      const myGeo = new window.BMap.Geocoder();

      new myGeo.getPoint(address, (e) => {
        this.markLocation.lat = e.lat;
        this.markLocation.lng = e.lng;
      });
    },
    checkDetail(e) {
      console.log(e, "uuuuuu");
    },
    // 模块上移下移删除
    moveUp(index) {
      if (index == 0) {
        this.$message({
          message: "已经是第一项",
          type: "warning",
        });
        return false;
      }
      //在上一项插入该项
      this.modularList.splice(index - 1, 0, this.modularList[index]);
      //删除后一项
      this.modularList.splice(index + 1, 1);
    },
    moveDown(index) {
      if (index == this.modularList.length - 1) {
        this.$message({
          message: "已经是最后一项",
          type: "warning",
        });
        return false;
      }
      //在下一项插入该项
      this.modularList.splice(index + 2, 0, this.modularList[index]);
      // 删除前一项
      this.modularList.splice(index, 1);
    },
    delmodular(item, index) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (
            item.id != null &&
            item.id != undefined &&
            this.selectType == "update"
          ) {
            this.modularDelIds.push(item.id);
          }
          this.modularList.splice(index, 1);
          this.$message({
            type: "success",
            message: "删除成功!",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 查看大图
    seeBigImg(src) {
      this.previewImgSrc = src;
      this.previewImgShow = true;
    },
    hidePreview() {
      this.previewImgShow = false;
    },

    timestampToTime(date) {
      if (date == "" || !date) {
        return "";
      }
      var date2 = new Date(date);
      var y = date2.getFullYear();
      var m = date2.getMonth() + 1;
      m = m < 10 ? "0" + m : m;
      var d = date2.getDate();
      d = d < 10 ? "0" + d : d;
      var h = date2.getHours();
      h = h < 10 ? "0" + h : h;
      var minute = date2.getMinutes();
      minute = minute < 10 ? "0" + minute : minute;
      var second = date2.getSeconds();
      second = second < 10 ? "0" + second : second;
      return y + "-" + m + "-" + d + " " + h + ":" + minute + ":" + second;
    },
    // 打卡次数处理让这个次数始终大于0的正整数
    handleInput(value) {
      let num = value.replace(/[^\d]/g, "");
      num = num === "" ? "" : Math.max(0, parseInt(num, 10));
      this.formClock.checkTimes = num;
    },
    handleClockSupplyCenterTextInput(value) {
      let num = value.replace(/[^\d]/g, "");
      num = num === "" ? "" : Math.max(0, parseInt(num, 10));
      this.clockSupplyCenterText = num;
    },

    // ==================== 在线收款相关方法 ====================

    // 收款方式变化：1=在线收款 2=无支付仅统计（el-select v-model 已同步顶层 paymentSwitch）
    onlinePaymentSwitchFn(e) {
      this.activityDetail.paymentSwitch = e;
      // 无支付仅统计无支付订单、无返利：关掉返利开关，避免区块隐藏后残留的 rebateSwitch=1 被提交
      if (e === 2 && this.rebateSwitch == 1) {
        this.rebateSwitch = 0;
        this.activityDetail.rebateSwitch = 0;
        this.activityDetail.rebatePercent = "";
      }
      // 两种收款方式都依赖收费项：无收费项时补一条默认收费项
      if ((e === 1 || e === 2) && this.fmActivityChargeItemVOS.length === 0) {
        this.addDefaultPaymentItem();
      }
    },

    // 预置默认收费项（新建 101 与选择收款方式时共用，与小程序一致）
    addDefaultPaymentItem() {
      this.fmActivityChargeItemVOS.push({
        itemName: "报名费",
        showImg: "",
        unitPrice: "1",
        stock: "999", // 空表示不限，默认给 999
        minBuyNum: 1,
        maxBuyNum: 10,
      });
    },

    // 添加收费项
    addPaymentItem() {
      this.fmActivityChargeItemVOS.push({
        itemName: "",
        showImg: "",
        unitPrice: "",
        stock: "", // 空表示不限
        minBuyNum: 1,
        maxBuyNum: 20,
      });
    },

    // 推荐返利开关变化
    rebateSwitchFn(e) {
      this.rebateSwitch = e;
      this.activityDetail.rebateSwitch = e;
    },
    needBuyFn(e) {
      this.needBuy = e;
      this.activityDetail.needBuy = e;
    },
    // 打开返利模式说明弹窗
    openRebateModeDialog() {
      this.rebateModeDialogVisible = true;
    },
    // 参与数据同步至投票管家
    openVoteSyncDialog() {
      if (!this.activityDetail || !this.activityDetail.id) return;
      const activityId = this.activityDetail.id;
      const activityType = this.isType;
      const scene = "id=" + activityId + "&st=see&ity=" + activityType;
      getActivityCode({
        activityId: activityId,
        page: "pages/solataireGroupDetails/solataireGroupDetails",
        scene: scene,
      }).then((res) => {
        if (res.status == 1) {
          this.voteSyncCodeUrl = this.imageUrl + res.data.smallCode;
          this.voteSyncDialogVisible = true;
        }
      });
    },

    // 统一格式化金额为两位小数（空值保持为空）
    formatUnitPriceValue(value) {
      if (
        value === "" ||
        value === null ||
        value === undefined ||
        value === "免费"
      ) {
        return "";
      }
      const parsed = Number(value);
      if (Number.isNaN(parsed)) {
        return "";
      }
      return parsed.toFixed(2);
    },

    formatUnitPrice(item) {
      if (!item) return;
      item.unitPrice = this.formatUnitPriceValue(item.unitPrice);
    },

    // 删除收费项
    deletePaymentItem(index) {
      const item = this.fmActivityChargeItemVOS[index];
      // 已有报名记录的收费项禁止删除（后端同样强制，前端提前拦截）
      if (item && item.hasVerification == 1) {
        this.$message.warning("该收费项已有人报名，不能删除");
        return;
      }
      this.$confirm("确定要删除该收费项吗？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          if (this.fmActivityChargeItemVOS.length <= 1) {
            this.$message.warning("至少保留一个收费项");
            return;
          }
          this.fmActivityChargeItemVOS.splice(index, 1);
        })
        .catch(() => {
          // 用户取消删除
        });
    },

    // 上传收费项图片
    uploadPaymentImage(index) {
      const input = document.createElement("input");
      input.type = "file";
      input.accept = "image/*";
      input.onchange = (e) => {
        const file = e.target.files[0];
        if (!file) return;

        // 验证文件格式
        var pettern = /^image/;
        if (!pettern.test(file.type)) {
          this.$message("文件格式不正确");
          e.target.value = "";
          return;
        }

        // 验证文件大小（不超过 5MB）
        if (file.size / 1048576 > 5) {
          this.$message("请上传大小不超过 5MB 的文件");
          e.target.value = "";
          return;
        }

        var parm = {
          file: file,
          type: "chargeImage",
        };

        axios
          .post(serverConfig.baseURL + "/file/uploadChargeableFile", parm, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Access-Token": localStorage.getItem("token"),
            },
          })
          .then((response) => {
            if (response.data.status == 1) {
              this.fmActivityChargeItemVOS[index].showImg =
                this.imageUrl + response.data.msg;
            }
          })
          .catch((error) => {
            e.target.value = "";
            console.log("err:", error);
          });
      };
      input.click();
    },

    // 删除收费项展示图
    removePaymentImage(index) {
      if (!this.fmActivityChargeItemVOS[index]) return;
      this.fmActivityChargeItemVOS[index].showImg = "";
    },

    // 打开付费项展示图选择器
    openPayImagePicker(index) {
      this.payPickerIndex = index;
      this.payPickerVisible = true;
    },
    // 确认选择展示图
    handlePayImageConfirm(url) {
      if (
        this.payPickerIndex >= 0 &&
        this.fmActivityChargeItemVOS[this.payPickerIndex]
      ) {
        this.fmActivityChargeItemVOS[this.payPickerIndex].showImg = url;
      }
      this.payPickerVisible = false;
    },
    // 自定义上传展示图
    handlePayImageCustomUpload() {
      this.payPickerVisible = false;
      if (this.payPickerIndex >= 0) {
        this.uploadPaymentImage(this.payPickerIndex);
      }
    },
  },
  computed: {
    ...mapState(["isOpenShare"]),
    // 签到起止总时长（分钟）：签退签退在场时间档位置灰与超窗校验依据；
    // 永久有效（结束时间 2099 哨兵）时差值极大，等效不限制
    signInWindowMinutes() {
      var start = this.activityDetail.signInStartTime;
      var end = this.activityDetail.signInEndTime;
      if (!start || !end) {
        return 0;
      }
      return dayjs(end).diff(dayjs(start), "minute");
    },
    // 非预设的自定义分钟数档位：仅供选中项回显「N分钟」label，
    // 以隐藏 el-option 渲染，不出现在下拉列表中
    attendanceDurationOptions() {
      var val = Number(this.activityDetail.attendanceDuration);
      if (val && !this.attendanceDurationArr.some((item) => item.value === val)) {
        return { value: val, label: val + "分钟" };
      }
      return null;
    },
    // 模块视频上传用的阿里云 VOD 转码模板组 ID
    // rightsLevel(由 topbar.vue 在登录后写入 localStorage):
    //   1 = 普通用户 → 普通模板组
    //   2 = 会员     → 会员模板组
    vodTemplateGroupId() {
      const rightsLevel = Number(localStorage.getItem("rightsLevel") || 1);
      const isVip = rightsLevel === 2;
      return isVip ? VOD_TEMPLATE_GROUP_VIP : VOD_TEMPLATE_GROUP_NORMAL;
    },
    // 预约：当前弹层编辑的选项对象
    currentAppointmentOption() {
      const target = this.appointmentEditTarget;
      if (target.fieldIndex === null || target.optionIndex === null) return null;
      const group = this.listList[this.indexIdx];
      const field = group && group.signField[target.fieldIndex];
      return field && Array.isArray(field.appointmentList)
        ? field.appointmentList[target.optionIndex] || null
        : null;
    },
    // 填表项总数（最多 3 个）
    totalFormItems() {
      // 计算 listList 中所有 signField 的总数
      let total = 0;
      if (this.listList && this.listList.length > 0) {
        this.listList.forEach((item) => {
          if (item.signField && Array.isArray(item.signField)) {
            total += item.signField.length;
          }
        });
      }
      // 最多显示 3 个选项
      return Math.min(total, 3);
    },
    setMb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else {
          const infoSize = size / 1048576;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return (
              "音频大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return (
              "视频大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          } else {
            return (
              "文件大小：" +
              (Math.floor(infoSize) == 0
                ? Math.floor(size / 1024) + "KB"
                : Math.floor(infoSize) + "MB")
            );
          }
        }
      };
    },
    setKb() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "文件大小：" + 0 + "KB";
        } else {
          const infoSize = size / 1024;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "KB";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "KB";
          } else {
            return "文件大小：" + Math.floor(infoSize) + "KB";
          }
        }
      };
    },
    setB() {
      return (size, fileType) => {
        if (size == "") {
          return "";
        } else if (size == 0) {
          return "文件大小：" + 0 + "B";
        } else {
          const infoSize = size;
          if (
            fileType == "mp3" ||
            fileType == "MP3" ||
            fileType == "Mp3" ||
            fileType == "mP3"
          ) {
            return "音频大小：" + Math.floor(infoSize) + "B";
          } else if (
            fileType == "mp4" ||
            fileType == "MP4" ||
            fileType == "Mp4" ||
            fileType == "mP4"
          ) {
            return "视频大小：" + Math.floor(infoSize) + "B";
          } else {
            return "文件大小：" + Math.floor(infoSize) + "B";
          }
        }
      };
    },
    // 按拼音排序后的名单（用于显示）
    sortedPacketData() {
      if (!this.nameSortSwitch) {
        return this.packetData;
      }
      return [...this.packetData].sort((a, b) =>
        a.localeCompare(b, "zh-Hans-CN-pinyin", { numeric: true }),
      );
    },
    // 名单「展示全部分组」下拉文案
    showAllGroupText() {
      const item = this.showAllGroupArr.find(
        (i) => i.value == this.showAllGroupSwitch,
      );
      return item ? item.label : "展示全部分组";
    },
    // 分组标签栏数据：过滤普通名单容器（空分组名），返回 { name, count }
    groupTabNames() {
      return this.subsetValueArr
        .filter((item) => item.listGroupName && item.listGroupName.trim() !== "")
        .map((item) => ({
          name: item.listGroupName,
          count: this.parseNameList(item.clockInList).length,
        }));
    },
    // 按拼音排序后的分组名单（用于显示）
    sortedOnlyGroupArr() {
      if (!this.nameSortSwitch) {
        return this.onlyGroupArr;
      }
      return [...this.onlyGroupArr].sort((a, b) =>
        a.localeCompare(b, "zh-Hans-CN-pinyin", { numeric: true }),
      );
    },
    // 按拼音排序后的人员名单（用于显示）
    sortedOnlyNameArr() {
      if (!this.nameSortSwitch) {
        return this.onlyNameArr;
      }
      return [...this.onlyNameArr].sort((a, b) =>
        a.localeCompare("zh-Hans-CN-pinyin", { numeric: true }),
      );
    },
    // 是否已认证：个人认证(authStatus==3)或商户认证(merchantStatus==3)任一成功即算已认证
    hasAuthenticated() {
      const auth = this.authInformation || {};
      return (
        Number(auth.authStatus) === 3 || Number(auth.merchantStatus) === 3
      );
    },
    // 收款方式选项（101 收费报名：1=在线收款 2=无支付仅统计）
    // 老数据 paymentSwitch=0 时补一个禁用占位项显示「请选择收款方式」，选中 1/2 后自动消失
    paymentModeOptions() {
      const options = [
        { value: 1, label: "在线收款", icon: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/wzfjtj-icon-2.svg", desc: "用户选择付费项需支付款项，资金可提现" },
        { value: 2, label: "无支付仅统计", icon: "https://ossfastmake.xlkapp.com/12jielong/lsyJL/zxfk-icon-2.svg", desc: "用户选择付费项报名仅做统计不支付费用" },
      ];
      if (this.paymentSwitch !== 1 && this.paymentSwitch !== 2) {
        options.unshift({ value: this.paymentSwitch, label: "请选择支付方式", disabled: true });
      }
      return options;
    },
    // 当前选中收款方式对应的图标，显示在下拉框输入区左侧
    selectedPaymentIcon() {
      const option = this.paymentModeOptions.find(
        (item) => item.value === this.paymentSwitch,
      );
      return option && option.icon ? option.icon : "";
    },
    // 提现服务费比例文案：未认证 0.8%~1.5%；个人认证 1.5%；二级商户 0.8%
    withdrawFeeRate() {
      const auth = this.authInformation || {};
      if (Number(auth.merchantStatus) === 3) return "0.8%";
      if (Number(auth.authStatus) === 3) return "1.5%";
      return "0.8%~1.5%";
    },
    // 时间设置行右侧蓝色状态文字（勾选"保存即开始/永久有效"或值为空/哨兵时显示对应文案，否则显示到分钟）
    beginTimeText() {
      if (this.startNowChecked || !this.activityDetail.beginTime) {
        return "保存即开始";
      }
      return this.formatTimeToMinute(this.activityDetail.beginTime);
    },
    endTimeText() {
      if (
        this.foreverValidChecked ||
        !this.activityDetail.endTime ||
        this.activityDetail.endTime == "2099-12-31 23:59:59"
      ) {
        return "永久有效";
      }
      return this.formatTimeToMinute(this.activityDetail.endTime);
    },
    actualBeginTimeText() {
      if (
        this.actualStartNowChecked ||
        !this.activityDetail.actualBeginTime
      ) {
        return "保存即开始";
      }
      return this.formatTimeToMinute(this.activityDetail.actualBeginTime);
    },
    actualEndTimeText() {
      if (
        this.actualForeverValidChecked ||
        !this.activityDetail.actualEndTime ||
        this.activityDetail.actualEndTime == "2099-12-31 23:59:59"
      ) {
        return "永久有效";
      }
      return this.formatTimeToMinute(this.activityDetail.actualEndTime);
    },
  },
};
</script>

<template>
  <Layout>
    <div class="kf">
      <img class="kf-tx" @click="kfShow = true" v-show="kfShow == false"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-touxiang.png" alt="" />
      <img class="kf-qr" v-show="kfShow == true && appid == 'wx1e899bddb256a5ca'"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-jiajia-qr.png" alt="" />
      <img class="kf-qr" v-show="kfShow == true && appid == 'wx7d8daf6d777947a2'" style="width: 190px; top: 8px"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-guanjia-qr.png" alt="" />
      <img class="kf-close" @click="kfShow = false" v-show="kfShow == true"
        src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kf-chabutton.png" alt="" />
    </div>

    <div class="row">
      <div class="outBox">
        <div class="bigTitle">
          {{ selectType == "add" ? "创建" : "编辑" }}{{ activeBuildTitle }}
        </div>

        <!--      封面-->
        <div class="blockBox">
          <div class="flex-depart-center fm-block">
            <div class="flex-depart-center-top fm-select">
              <span>版式选择</span>
              <img class="yanshiBtn" @click="demonstrate(1)"
                src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" />
            </div>
            <div class="fm-b-right ms-block flex-depart-center">
              <div class="ms" @click="changeMode(2)" :class="{ 'ms-active': activityMode == 2 }">
                接龙模式
              </div>
              <div class="ms" @click="changeMode(1)" :class="{ 'ms-active': activityMode == 1 }">
                报名模式
              </div>
            </div>
          </div>
          <div class="fm-flex" v-if="activityMode == 1">
            <!--                        <img :src="activityModeUrl" v-if="isVideo == 2" alt="">-->
            <div class="fm-pics-block" v-if="isVideo == 2">
              <el-carousel indicator-position="outside">
                <el-carousel-item v-for="(item, index) in turnPictures" :key="index">
                  <div class="pic-out-box" :style="{
                    background: 'url(' + item + ') no-repeat center',
                    backgroundSize: 'cover',
                  }"></div>
                </el-carousel-item>
              </el-carousel>
            </div>
            <div v-if="isVideo == 1" style="background-color: #000; margin-top: 10px">
              <video controls width="420" height="240">
                <source :src="playUrl" type="video/mp4" />
                Sorry, your browser doesn't support embedded videos.
              </video>
            </div>

            <div class="fm-btns flex-depart-center">
              <!-- <el-button @click="selectSysPic">选择系统封面</el-button>
                            <el-dropdown>
                                <el-button type="primary">
                                    上传自定义封面<i class="el-icon-arrow-down el-icon--right"></i>
                                </el-button>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item>
                                        <input class="updateFileBtn" type="file" id="uploadImageBtn" accept="image/*"
                                               @change="(event) => handleCoverImgUpload(event)"/>
                                        上传图片
                                    </el-dropdown-item>
                                    <el-dropdown-item>
                                        <input class="updateFileBtn" type="file" id="videoInput5" accept=".mp4"
                                               @change="(event) => handleVideoFmUpload(event)"/>
                                        上传视频
                                    </el-dropdown-item>
                                </el-dropdown-menu>
                            </el-dropdown> -->
              <!-- <div class="zdy-btn" @click="openIV">上传自定义封面</div>
                            <span>推荐上传图片的宽高比例为5:4</span> -->
              <el-button type="primary" @click="openCoverSetting">
                封面设置
              </el-button>
            </div>
          </div>
        </div>

        <div class="blockBox" ref="titleBlock">
          <!--                    <div class="block-title">接龙名称</div>-->
          <div class="centerTitle" style="margin-top: -5px">
            <el-input v-model="activityDetail.name" placeholder="请输入标题" style="text-align: center"
              maxlength="30"></el-input>
          </div>
          <div class="b-marT-10" :class="{
            zsy: modularList.length <= 1,
            nozsy: modularList.length >= 2,
          }">
            <el-input type="textarea" class="zsy-inner" v-model="activityDetail.content" placeholder="请输入内容"
              rows="5"></el-input>
          </div>
          <!-- todo 详情页展示列表 -->

          <div v-for="(item, index) in modularList" :key="index">
            <!-- 内容 -->
            <div class="block-for-box" v-if="item.type == 1">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.title" placeholder="请输入标题"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10" v-if="item.info.value">
                <el-input type="textarea" v-model="item.info.value" placeholder="请输入内容" rows="5"></el-input>
              </div>
            </div>
            <!-- 大图 -->
            <div class="block-for-box" v-if="item.type == 9">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="大图"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10" v-for="(imgItem, imgIndex) in item.info.imgarr" :key="imgIndex">
                <div class="flex-depart-top">
                  <div class="big-img">
                    <!--                                        <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/5c2333976171b.jpg" alt="">-->
                    <img :src="imageUrl + imgItem" alt="" />
                  </div>
                  <div class="flex-depart-column-top-left b-handle">
                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                      @click="upBigImg(imgIndex, index)" />
                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                      @click="downBigImg(imgIndex, index)" />
                    <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                      @click="delBigImg(imgIndex, index)" />
                  </div>
                </div>
              </div>
              <div class="addSmallBtn b-marT-10" style="border: 1px dashed #4a73f7" v-if="item.info.imgarr.length < 9">
                <input class="updateFileBtn" type="file" id="imageInput" multiple accept="image/*"
                  @change="(event) => handleImgUpload(event, index)" />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传大图
              </div>
            </div>
            <!-- 小图 -->
            <div class="block-for-box" v-if="item.type == 3">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="小图"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10 flex-depart-left-warp">
                <div class="smallImgbox seeBigImgHover" v-for="(imgItem, imgIndex) in item.info.imgarr" :key="imgIndex">
                  <div class="handle2">
                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-chakandatu.svg"
                      @click="seeBigImg(imgItem)" alt="" />
                    <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shanchuxiaotu.svg"
                      @click="delSmallPic(imgIndex, index)" alt="" />
                  </div>
                  <div class="imgBg" :style="{
                    background: `url(${imageUrl + imgItem}) no-repeat center`,
                    backgroundSize: 'cover',
                  }"></div>
                </div>
                <div class="upl-smallImg" style="border: 1px solid #dedfe2" v-if="item.info.imgarr.length < 9">
                  <input class="updateFileBtn" type="file" id="imageInput2" multiple accept="image/*"
                    @change="(event) => handleSmallImgUpload(event, index)" />
                  <i class="el-icon-circle-plus"></i>
                  <span>上传小图</span>
                </div>
              </div>
            </div>
            <!-- 地点 -->
            <div class="block-for-box" v-if="item.type == 4">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="地址"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>

              <div class="b-marT-10">
                <div style="font-weight: bold">{{ item.info.name }}</div>
                <div>{{ item.info.address }}</div>
                <el-button v-if="!item.info.address" @click="openMap(index)" class="map-btn">选择位置</el-button>
                <el-button v-if="item.info.address" @click="openMap(index)" class="map-btn">重新选择</el-button>
              </div>
            </div>
            <!-- 文件 -->
            <div class="block-for-box" v-if="item.type == 5">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="文件"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <div class="filesStyle flex-depart-center hoverColor1"
                  v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex">
                  <div class="flex-depart-left">
                    <img v-if="fileItem.lastName == 'doc'" :src="imageUrl + '/static/announcement/word.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'docx'" :src="imageUrl + '/static/announcement/word.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'pdf'" :src="imageUrl + '/static/announcement/PDF.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'ppt'" :src="imageUrl + '/static/announcement/PPT.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'xls'" :src="imageUrl + '/static/index/excel.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'xlsx'" :src="imageUrl + '/static/index/excel.png'"
                      class="Img3" />
                    <img v-else-if="fileItem.lastName == 'zip'"
                      src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/zip.svg" class="Img3" />
                    <span>{{ fileItem.name }}</span>/
                    <span v-if="fileItem.size / 1024 <= 1">{{
                      setB(fileItem.size, fileItem.lastName)
                    }}</span>
                    <span v-else-if="
                      fileItem.size / 1024 >= 1 &&
                      fileItem.size / 1048576 <= 1
                    ">{{ setKb(fileItem.size, fileItem.lastName) }}</span>
                    <span v-else-if="fileItem.size / 1048576 >= 1">{{
                      setMb(fileItem.size, fileItem.lastName)
                    }}</span>
                  </div>
                  <i class="el-icon-delete del" @click="delFiles(fileIndex, index)"></i>
                </div>
              </div>
              <div class="addSmallBtn b-marT-10">
                <input class="updateFileBtn" type="file" id="imageInput3" multiple
                  accept=".xls,.xlsx,.docx,.pdf,.ppt,.zip" @change="(event) => handleFileUpload(event, index)" />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传文件
              </div>
            </div>
            <!-- 音频 -->
            <div class="block-for-box" v-if="item.type == 6">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="音频"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <div class="filesStyle flex-depart-center hoverColor1"
                  v-for="(fileItem, fileIndex) in item.info.filesArr" :key="fileIndex">
                  <div class="flex-depart-left" @click="openMusic(fileItem)" style="cursor: pointer">
                    <img :src="imageUrl + '/static/announcement/MP3.png'" class="Img3" />
                    <span>{{ fileItem.name }}</span>/
                    <span v-if="fileItem.size / 1024 <= 1">{{
                      setB(fileItem.size, fileItem.lastName)
                    }}</span>
                    <span v-else-if="
                      fileItem.size / 1024 >= 1 &&
                      fileItem.size / 1048576 <= 1
                    ">{{ setKb(fileItem.size, fileItem.lastName) }}</span>
                    <span v-else-if="fileItem.size / 1048576 >= 1">{{
                      setMb(fileItem.size, fileItem.lastName)
                    }}</span>
                  </div>
                  <i class="el-icon-delete del" @click="delFiles(fileIndex, index)"></i>
                </div>
              </div>
              <div class="addSmallBtn b-marT-10">
                <input class="updateFileBtn" type="file" id="imageInput4" accept=".mp3" multiple
                  @change="(event) => handleMpThreeUpload(event, index)" />
                <i class="el-icon-circle-plus"></i>&nbsp;点击上传音频
              </div>
            </div>
            <!-- 视频 -->
            <div class="block-for-box" v-if="item.type == 7">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="视频"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10" :key="item.info.fileUrl" v-if="item.info.fileUrl != ''">
                <video controls width="450">
                  <source
                    :src="/^(https?:|blob:)/i.test(item.info.fileUrl) ? item.info.fileUrl : imageUrl + item.info.fileUrl"
                    type="video/mp4" />
                  Sorry, your browser doesn't support embedded videos.
                </video>
              </div>
              <!-- 模块视频不展示封面:封面字段 playCoverImage 是封面设置(customCoverDialog)用的 -->
              <!-- <div
                class="b-marT-10"
                v-if="item.info.playCoverImage"
                style="font-size: 12px; color: #909399;"
              >
                封面:
                <a
                  :href="item.info.playCoverImage"
                  target="_blank"
                  rel="noopener"
                  >{{ item.info.playCoverImage }}</a
                >
              </div> -->
              <div class="addSmallBtn b-marT-10">
                <upload-video-com upload-mode="vod" target="module" :show-progress="false"
                  :template-group-id="vodTemplateGroupId"
                  style="display: flex; justify-content: center; align-items: center; width: 100%; height: 100%;"
                  :trigger-text="item.info.fileUrl == '' ? '点击上传视频' : '更改视频'
                    " @uploadstarted="() => handleModuleVideoStarted(index)"
                  @success="(payload) => handleModuleVideoSuccess(payload, index)"
                  @fail="(res) => handleModuleVideoFail(res, index)">
                  <template #trigger="{ chooseVideo, loading }">
                    <span
                      style="display: inline-flex; align-items: center; justify-content: center; cursor: pointer; gap: 4px;"
                      :style="{ pointerEvents: loading ? 'none' : 'auto', opacity: loading ? 0.6 : 1 }"
                      @click="chooseVideo">
                      <i :class="loading ? 'el-icon-loading' : 'el-icon-circle-plus'
                        "></i><span>{{
                          item.info.fileUrl == "" ? "点击上传视频" : "更改视频"
                        }}</span>
                    </span>
                  </template>
                </upload-video-com>
              </div>
              <input type="file" accept=".mp4" style="display: none" :id="`moduleVideoFallback_${index}`"
                @change="(event) => handleMpFourUpload(event, index)" />
            </div>

            <!-- 公众号 -->
            <div class="block-for-box" v-if="item.type == 10">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="公众号"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">标题</p>
                <el-input class="f-ipt" v-model="item.info.officialAccountTitle" placeholder="请输入公众号文章标题"></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">公众号文章链接</p>
                <el-input class="f-ipt" v-model="item.info.link" placeholder="请输入公众号文章链接"></el-input>
              </div>
            </div>

            <!-- 视频号 -->
            <div class="block-for-box" v-if="item.type == 11">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="视频号"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频号标题</p>
                <el-input class="f-ipt" v-model="item.info.videoNumberTitle" placeholder="请输入视频号标题"></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频号ID</p>
                <el-input class="f-ipt" v-model="item.info.videoNumberID" placeholder="请输入以sph开头的视频号ID"></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">视频ID</p>
                <el-input class="f-ipt" v-model="item.info.videoId" placeholder="请输入视频ID"></el-input>
              </div>
            </div>

            <!-- 其他小程序 -->
            <div class="block-for-box" v-if="item.type == 12">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="其他小程序标题"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">标题</p>
                <el-input class="f-ipt" v-model="item.info.appTitle" placeholder="请输入小程序展示标题"></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">小程序APPID</p>
                <el-input class="f-ipt" v-model="item.info.appid" placeholder="请输入小程序APPID"></el-input>
              </div>
              <div class="b-marT-10">
                <p class="model-title1">小程序页面路径</p>
                <el-input class="f-ipt" v-model="item.info.pagePath" placeholder="请输入小程序页面路径"></el-input>
              </div>
            </div>

            <!-- 关联接龙 -->
            <div class="block-for-box" v-if="item.type == 14">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="其他小程序标题"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10 gljl-block flex-depart-center" @click="addgljl(index)"
                v-for="(fileItem, fileIndex) in item.info.associationActivityId" :key="fileIndex">
                <div>{{ fileItem.name }}</div>
                <i class="el-icon-delete del" @click.stop="delRelatedFiles(fileIndex, index)"></i>
              </div>

              <div class="b-marT-10">
                <div class="gl-btnStyle" @click="addgljl(index)">
                  点击添加关联接龙
                </div>
              </div>
            </div>

            <!-- 可复制内容 -->
            <div class="block-for-box" v-if="item.type == 13">
              <div class="flex-depart-center">
                <div class="tl-item bf-item flex-depart-left">
                  <el-input class="f-ipt" v-model="item.info.value" placeholder="可复制内容"></el-input>
                </div>
                <div class="f-handle tr-item">
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shangyi.png" alt=""
                    @click="moveUp(index)" />
                  <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-xiayi.png" alt=""
                    @click="moveDown(index)" />
                  <img src="https://ossfastmake.xlkapp.com/12jielong/lsyJL/model_shanchu.svg" alt=""
                    @click="delmodular(item, index)" />
                </div>
              </div>
              <div class="b-marT-10">
                <el-input type="textarea" v-model="item.info.copy_region_conten" rows="5"
                  placeholder="请输入可复制内容"></el-input>
              </div>
            </div>
          </div>

          <!-- todo 详情页展示添加按钮 -->
          <div class="handle-box b-marT-10">
            <div class="flex-depart-left h-item" @click="addModule(0)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-zdingyi.svg" alt="" />
              <span>自定义内容</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(7)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-datu.svg" alt="" />
              <span>大图</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(2)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-jiugongge.svg" alt=""
                style="margin-right: 3px" />
              <span>九宫格图片</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(3)">
              <i style="font-size: 17px; margin-right: 3px" class="el-icon-location-outline"></i>
              <span>位置</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(4)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-wenjian.svg" alt="" />
              <span>文件</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(5)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-yinpin.svg" alt="" />
              <span>音频</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(6)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipin.svg" alt="" />
              <span>视频</span>
            </div>

            <div class="flex-depart-left h-item" @click="addModule(8)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-gongzhonghao.svg" alt="" />
              <span>公众号</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(9)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-shipinhao.svg" alt="" />
              <span>视频号</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(10)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-qitaxiaochegnxu.svg" alt="" />
              <span>其他小程序</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(12)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-guanlian.svg" alt="" />
              <span>关联接龙</span>
            </div>
            <div class="flex-depart-left h-item" @click="addModule(11)">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/pc-kefuzi.svg" alt="" />
              <span>可复制内容</span>
            </div>
          </div>
        </div>
        <div class="blockBox" style="position: relative; padding: 10px 15px"
          v-if="(!groupId || groupId == 'undefined') && isType != 101">
          <div class="flex-depart-center name-title">
            <div class="name-title-left">
              <div class="name-title-main">
                <span>预设名单</span>
                <img src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt=""
                  style="position: relative;" class="yanshiBtn" @click="demonstrate(11)" />
              </div>
              <div class="name-title-sub">直观的看到已参与和未参与的人员名单</div>
            </div>
            <el-switch v-model="clockSwitch" @change="presetNameSwitchChange($event)" active-color="#1877FF"
              inactive-color="rgb(230, 230, 230)" active-value="2" inactive-value="1"></el-switch>
          </div>

          <template v-if="clockSwitch == 2">
            <div class="packet-tools">
              <div class="packet-left">
                <div class="packet-count">每排数量</div>
                <div class="packet-dropdown">
                  <el-dropdown @command="clockListNumFn">
                    <span class="el-dropdown-link">
                      {{ `一排${clockListNumber}个` }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in clockListNumArr" :key="item.value" :command="item.value">{{
                        item.label }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
                <div class="packet-dropdown packet-dropdown--group">
                  <el-dropdown @command="showAllGroupFn">
                    <span class="el-dropdown-link">
                      {{ showAllGroupText }}
                      <i class="el-icon-arrow-down el-icon--right"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item v-for="item in showAllGroupArr" :key="item.value" :command="item.value">{{
                        item.label }}</el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="packet-right">预览仅展示4排</div>
            </div>

            <div class="group-tab-bar">
              <div class="group-tab-scroll">
                <div class="group-tab-list">
                  <div class="group-tab-item" :class="{ 'group-tab-item--active': pickerName === '全部' }"
                    @click="selectGroupTab('全部')">
                    全部<span class="group-tab-count">({{ nameListLength }})</span>
                  </div>
                  <div v-for="group in groupTabNames" :key="group.name" class="group-tab-item" :class="{
                    'group-tab-item--active': pickerName === group.name,
                  }" @click="selectGroupTab(group.name)">
                    {{ group.name
                    }}<span class="group-tab-count">({{ group.count }})</span>
                  </div>
                </div>
              </div>
              <div class="group-tab-add" @click="addGroupTab">添加分组</div>
            </div>

            <div class="jlName" v-if="packetData.length">
              <div class="listName">
                <div class="spanDiv" v-for="(item, index) in sortedPacketData.slice(
                  0,
                  (activityDetail.clockListNumber || 5) * 4 - 1,
                )" :key="index" :style="{
                  lineHeight:
                    activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                  width:
                    activityDetail.clockListNumber === 2
                      ? 'calc(50% - 8px)'
                      : activityDetail.clockListNumber === 3
                        ? 'calc(33.33% - 8px)'
                        : activityDetail.clockListNumber === 4
                          ? 'calc(25% - 8px)'
                          : 'calc(20% - 8px)',
                }">
                  <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                    index + 1
                  }}</span>
                  {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                </div>
              </div>
            </div>

            <div class="group-action-bar" v-if="pickerName !== '全部' || groupTabNames.length === 0">
              <div class="group-action group-action-edit" @click="editFzNameList">
                编辑本组名单
              </div>
              <div class="group-action-del" v-if="pickerName !== '全部'" @click="removeGroupTab">
                删除本组
              </div>
            </div>
          </template>
        </div>

        <!-- 在线收款模块 -->
        <div v-if="isType == '101'" class="blockBox" ref="paymentBlock" style="position: relative; padding: 10px 15px">
          <div class="online-payment-header">
            <div class="online-payment-title">
              <span>支付方式</span>
            </div>
            <div class="payment-select-wrap">
              <img v-if="selectedPaymentIcon" class="payment-select-icon" :src="selectedPaymentIcon" alt="" />
              <el-select v-model="paymentSwitch" @change="onlinePaymentSwitchFn" placeholder="请选择支付方式" size="small"
                style="width: 150px">
                <el-option v-for="item in paymentModeOptions" :key="item.value" :label="item.label" :value="item.value"
                  :disabled="item.disabled">
                  <img v-if="item.icon" class="payment-option-icon" :src="item.icon" alt="" />
                  <span>{{ item.label }}</span>
                  <span v-if="item.desc" style="float: right; color: #8492a6; font-size: 12px; margin-left: 15px">{{
                    item.desc
                  }}</span>
                </el-option>
              </el-select>
            </div>
          </div>

          <!-- 开启后显示说明文字 -->
          <div v-if="paymentSwitch == 1" class="payment-tip">
            <template v-if="!hasAuthenticated">
              根据相关法律法规，您需完成身份认证，认证成功才可提现，且设置收费产生付费活动报名订单时，平台将按
              {{ withdrawFeeRate }} 的比例收取提现服务费，
              <span style="color: #1877ff; cursor: pointer" @click="goAuthPage()">快去认证吧 &gt;</span>
            </template>
            <template v-else>
              您已认证，且设置收费产生付费活动报名订单时，平台将按 {{ withdrawFeeRate }} 的比例收取提现服务费。
            </template>
          </div>

          <!-- 收费项列表 -->
          <div v-if="paymentSwitch == 1 || paymentSwitch == 2">
            <div class="payment-section-title">
              <span>{{ paymentSwitch == 1 ? "收费项设置" : "项目" }}</span>
            </div>

            <div v-for="(item, index) in fmActivityChargeItemVOS" :key="index" class="payment-item-box">
              <!-- 多个收费项时显示标题 -->
              <div v-if="fmActivityChargeItemVOS.length > 1" class="payment-item-title">
                <span>收费项{{ index + 1 }}</span>
                <span class="delete-payment-text" @click="deletePaymentItem(index)">
                  <i class="el-icon-delete"></i> 删除
                </span>
              </div>

              <div class="payment-item-content">
                <!-- 名称 -->
                <div class="payment-row">
                  <span class="payment-label"><span class="required">*</span> 名称：</span>
                  <el-input v-model="item.itemName" placeholder="请填写名称" class="payment-input-full" maxlength="30"
                    show-word-limit></el-input>
                </div>

                <!-- 展示图 -->
                <div class="payment-row">
                  <span class="payment-label">展示图：</span>
                  <div class="payment-upload-right" @click="openPayImagePicker(index)">
                    <div v-if="item.showImg" class="payment-image-preview-small">
                      <img :src="item.showImg" alt="展示图" />
                      <i class="el-icon-close payment-image-delete-btn" @click.stop="removePaymentImage(index)"></i>
                    </div>
                    <div v-else class="payment-upload-btn-small">
                      <i class="el-icon-plus"></i>
                    </div>
                    <span class="change-btn">更换</span>
                  </div>
                </div>

                <!-- 单价 -->
                <div class="payment-row">
                  <span class="payment-label">单价：</span>
                  <el-input v-model="item.unitPrice" type="number" placeholder="免费" class="payment-input-small" min="0"
                    @blur="formatUnitPrice(item)">
                    <div slot="prefix" style="
                        height: 100%;
                        width: 25px;
                        text-align: center;
                        transition: all 0.3s;
                        line-height: 40px;
                        font-size: 16px;
                      ">
                      ¥
                    </div>
                  </el-input>
                </div>

                <!-- 库存设置 -->
                <div class="payment-row">
                  <span class="payment-label">库存设置：</span>
                  <el-input v-model="item.stock" type="number" placeholder="不限" class="payment-input-small"
                    min="0"></el-input>
                </div>

                <!-- 每人最少/最多可购 - 同一排 -->
                <div class="payment-row payment-row-double">
                  <div class="payment-double-item">
                    <span class="payment-label">每人最少可购：</span>
                    <el-select v-model="item.minBuyNum" placeholder="请选择" size="small" style="width: 120px">
                      <el-option v-for="num in 20" :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                  <div class="payment-double-item">
                    <span class="payment-label">每人最多可购：</span>
                    <el-select v-model="item.maxBuyNum" placeholder="请选择" size="small" style="width: 120px">
                      <el-option v-for="num in 20" :key="num" :label="num" :value="num"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
            </div>

            <!-- 添加收费项按钮 -->
            <div class="b-marT-20 flex-depart-center-center">
              <div class="addBtnStyle" @click="addPaymentItem" :style="{
                opacity: fmActivityChargeItemVOS.length >= 10 ? 0.5 : 1,
                cursor:
                  fmActivityChargeItemVOS.length >= 10
                    ? 'not-allowed'
                    : 'pointer',
              }" v-if="fmActivityChargeItemVOS.length < 10">
                <i class="el-icon-circle-plus-outline" style="position: relative; top: -1px"></i>{{ paymentSwitch == 1 ?
                  "添加收费项"
                  : "添加项目" }}
              </div>
              <div class="addBtnStyle" style="opacity: 0.5; cursor: not-allowed" v-else>
                <i class="el-icon-circle-plus-outline" style="position: relative; top: -1px"></i>{{ paymentSwitch == 1 ?
                  "添加收费项"
                  : "添加项目" }}
              </div>
            </div>
          </div>
        </div>

        <div v-if="isType == '101' && paymentSwitch == 1" class="blockBox"
          style="position: relative; padding: 10px 15px">
          <div class="online-payment-header">
            <div class="online-payment-title">
              <span>推荐返利</span>
              <img class="yanshiBtn" @click="demonstrate(26)"
                src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" />
            </div>
            <el-switch v-model="rebateSwitch" @change="rebateSwitchFn" :active-value="1" :inactive-value="0"
              active-color="#1877ff"></el-switch>
          </div>
          <!-- 返利模式设置 -->
          <div v-if="rebateSwitch == 1" style="padding: 10px 15px">
            <div class="settingBox b-marT-10 flex-depart-center">
              <div>
                <span class="sTitle">返利模式<img class="yanshiBtn" @click="openRebateModeDialog"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              </div>
              <div>
                <el-radio-group v-model="needBuy" @input="needBuyFn">
                  <el-radio :label="0">分享返利</el-radio>
                  <el-radio :label="1">参与返利</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">返利佣金比例</span>
              <div>
                <el-input-number v-model="activityDetail.rebatePercent" :min="0" :max="50" :step="1" size="small"
                  style="width: 120px"></el-input-number>
                <span style="margin-left: 5px; color: #999">%</span>
              </div>
            </div>
          </div>
        </div>
        <!-- todo 填表项循环 -->
        <div class="blockBox" ref="formFieldsBlock">
          <div class="block-title" style="
              display: flex;
              align-items: center;
              justify-content: space-between;
            ">
            <div class="block-title-wrap">
              填表项设置<img class="yanshiBtn" @click="demonstrate(2)"
                src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" />
            </div>
            <div class="title-section" style="display: flex; align-items: center">
              <img :src="wenHaoImgSrc" style="
                  width: 16px;
                  height: 16px;
                  cursor: pointer;
                  margin-right: 6px;
                " @click="demonstrate(15)" />
              <span style="
                  color: #1877ff;
                  cursor: pointer;
                  font-size: 14px;
                  font-weight: normal;
                " @click="addForm(33, '标题')">添加标题</span>
            </div>
          </div>
          <div class="cannotEditStyle" v-if="commonDisabled == true">
            *编辑填表项，已报名的人员信息会有所变动。
          </div>
          <div v-for="(listItem, listIndex) in listList" :key="listIndex">
            <div v-for="(fieldItem, fieldIndex) in listItem.signField" :key="fieldIndex">
              <div v-if="fieldItem.type == 1">
                <!--姓名等-->
                <div class="f-block flex-depart-leftStart" v-if="fieldItem.num == 3">
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="姓名"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else-if="fieldItem.num == 4">
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="姓名"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else>
                  <div class="left-ttype">单行文本</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="姓名"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div>
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--标题-->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 33">
                <div class="left-ttype">标题</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="标题" maxlength="30"></el-input>
                    </div>
                    <div class="f-handle tr-item">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 4, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 4, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                </div>
              </div>
              <!--数量-->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 13">
                <div class="left-ttype">数量</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="数量"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!--金额-->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 40">
                <div class="left-ttype">金额</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="金额"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 手机号 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 11">
                <div class="left-ttype">手机号</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="手机号"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 身份证-->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 10">
                <div class="left-ttype">身份证</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="身份证"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 时间 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 15">
                <div class="left-ttype">时间</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="时间"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div></div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 位置 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 12">
                <div class="left-ttype">位置</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="你所在的位置"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 预约填表项 -->
              <template v-if="fieldItem.type == 39">
                <div class="f-block flex-depart-leftStart">
                  <div class="left-ttype">预约</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" maxlength="30"
                          placeholder="预约项目"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div v-for="(option, optionIndex) in fieldItem.appointmentList"
                      :key="option.randomDecimal || optionIndex">
                      <div class="selectBox-item appointment-item b-marT-10">
                        <div class="appointment-line">
                          <div class="selectBox-item-index">
                            {{ optionIndex + 1 }}、
                          </div>
                          <el-input class="opt-name-input" v-model="option.optionName"
                            placeholder="请输入预约项名称"></el-input>
                          <i class="el-icon-remove-outline" @click="
                            delAppointmentOption(fieldIndex, optionIndex)
                            "></i>
                        </div>
                        <div class="appointment-time-row">
                          <span class="addOptStyle opt-time-link" @click="
                            openAppointmentTime(fieldIndex, optionIndex)
                            ">
                            {{
                              appointmentOptionSummary(option) || "设置预约时间"
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div class="b-marT-10" style="
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                      ">
                      <div>
                        <span class="addOptStyle" @click="addAppointmentOption(fieldIndex)">
                          + 添加预约项
                        </span>
                        <el-divider direction="vertical"></el-divider>
                        <span class="addOptStyle" @click="openBatchAppointment(fieldIndex)">
                          批量添加预约项
                        </span>
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div style="display: flex; gap: 15px">
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 单选/性别/其他 -->
              <template v-if="fieldItem.type == 2">
                <div class="f-block flex-depart-leftStart" v-if="fieldItem.num == 1">
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义内容"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div v-for="(itexb, idx) in fieldItem.content" :key="idx">
                      <div class="flex-depart-left selectBox-item b-marT-10">
                        <div class="selectBox-item-index">{{ idx + 1 }}、</div>
                        <el-input class="opt-name-input" v-model="itexb.value" placeholder="请输入自定义内容"></el-input>
                        <el-input class="opt-num-input" maxlength="10" :value="itexb.maxNum === -1 ? '' : itexb.maxNum"
                          placeholder="数量不限" @input="handleNumValueChange($event, itexb)"
                          @focus="handleNumValueFocus(itexb)">
                          ></el-input>
                        <i class="el-icon-remove-outline" @click="delInp(fieldItem, idx, fieldIndex, listIndex)"></i>
                      </div>
                      <!-- 逻辑设置说明文字 -->
                      <div class="logic-rule-desc" v-if="getLogicRuleText(itexb, fieldIndex, listIndex)">
                        {{ getLogicRuleText(itexb, fieldIndex, listIndex) }}
                      </div>
                    </div>

                    <div class="b-marT-10" style="
                        display: flex;
                        justify-content: flex-end;
                        align-items: center;
                      ">
                      <div>
                        <span class="addOptStyle" @click="addInp(fieldItem, fieldIndex, listIndex)">
                          + 添加单选选项
                        </span>
                        <el-divider direction="vertical"></el-divider>
                        <span class="addOptStyle" @click="
                          openSetLogicDialog(fieldItem, fieldIndex, listIndex)
                          ">设置逻辑、跳题</span>
                        <el-divider direction="vertical"></el-divider>
                        <span @click="batchSetNum(fieldItem, fieldIndex)" class="addOptStyle">
                          批量设置数量
                        </span>
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div style="display: flex; gap: 15px">
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else-if="fieldItem.num == 2">
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="性别"></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div v-for="(itexb, idx) in fieldItem.content" :key="idx">
                      <div class="flex-depart-left selectBox-item b-marT-10">
                        {{ idx + 1 }}、
                        <el-input v-model="itexb.value" placeholder="男" disabled></el-input>
                        <i v-if="fieldItem.content.length > 2" class="el-icon-remove-outline"></i>
                      </div>
                      <!-- 逻辑设置说明文字 -->
                      <div class="logic-rule-desc" v-if="getLogicRuleText(itexb, fieldIndex, listIndex)">
                        {{ getLogicRuleText(itexb, fieldIndex, listIndex) }}
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div style="display: flex; gap: 15px">
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                        <span class="sxsz" style="color: #1877ff" @click="
                          openSetLogicDialog(fieldItem, fieldIndex, listIndex)
                          ">设置逻辑、跳题</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="f-block flex-depart-leftStart" v-else>
                  <div class="left-ttype">单选</div>
                  <div class="inner-main-box">
                    <div class="flex-depart-center">
                      <div class="tl-item flex-depart-left">
                        {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                        <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder=""></el-input>
                      </div>
                      <div class="f-handle tr-item" v-if="fieldIndex != 0">
                        <img :src="imgUpMoveSrc" alt="" @click="
                          topNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgDownMoveSrc" alt="" @click="
                          bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                          " />
                        <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                      </div>
                    </div>
                    <div v-for="(itexb, idx) in fieldItem.content" :key="idx">
                      <div class="flex-depart-left selectBox-item b-marT-10">
                        {{ idx + 1 }}、
                        <el-input v-model="itexb.value" maxlength="50" placeholder="" disabled></el-input>
                        <el-input maxlength="10" :value="itexb.maxNum === -1 ? '' : itexb.maxNum" placeholder="数量不限"
                          @input="handleNumValueChange($event, itexb)" @focus="handleNumValueFocus(itexb)"></el-input>
                        <i v-if="fieldItem.content.length > 2" class="el-icon-remove-outline"></i>
                      </div>
                      <!-- 逻辑设置说明文字 -->
                      <div class="logic-rule-desc" v-if="getLogicRuleText(itexb, fieldIndex, listIndex)">
                        {{ getLogicRuleText(itexb, fieldIndex, listIndex) }}
                      </div>
                    </div>
                    <div class="flex-depart-center-end b-marT-10">
                      <div>
                        <span class="addOptStyle" @click="addInp(fieldItem, fieldIndex, listIndex)">
                          + 添加单选选项
                        </span>
                        <el-divider direction="vertical"></el-divider>
                        <span class="addOptStyle" @click="
                          openSetLogicDialog(fieldItem, fieldIndex, listIndex)
                          ">设置逻辑、跳题</span>
                        <el-divider direction="vertical"></el-divider>
                        <span @click="batchSetNum(fieldItem, fieldIndex)" class="addOptStyle">
                          批量设置数量
                        </span>
                      </div>
                    </div>
                    <div class="flex-depart-center b-marT-10">
                      <div style="display: flex; gap: 15px">
                        <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                        <span class="sxsz" style="color: #1877ff" @click="
                          openSetLogicDialog(fieldItem, fieldIndex, listIndex)
                          ">设置逻辑、跳题</span>
                      </div>
                      <div class="flex-depart-center-end checkedState">
                        <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            encryptionChange($event, fieldIndex, listIndex)
                        ">
                          保密
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isRequiredChange($event, fieldIndex, listIndex)
                        ">
                          必填
                        </el-checkbox>
                        <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                          ($event) =>
                            isOpenChange($event, fieldIndex, listIndex)
                        ">
                          公开
                        </el-checkbox>
                        <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                          <i class="el-icon-circle-plus"></i>复制
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </template>
              <!-- 音频 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 7">
                <div class="left-ttype">音频</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="音频"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 视频 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 6">
                <div class="left-ttype">视频</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请填写视频标题"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多选 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 4">
                <div class="left-ttype">多选</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义内容"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-left selectBox-item b-marT-10" v-for="(ite1, idx1) in fieldItem.content"
                    :key="idx1">
                    <div class="selectBox-item-index">{{ idx1 + 1 }}、</div>
                    <el-input class="opt-name-input" v-model="ite1.value" placeholder="请输入自定义内容"></el-input>
                    <el-input class="opt-num-input" maxlength="10" :value="ite1.maxNum === -1 ? '' : ite1.maxNum"
                      placeholder="数量不限" @input="handleNumValueChange($event, ite1)" @focus="handleNumValueFocus(ite1)">
                      ></el-input>

                    <i class="el-icon-remove-outline" @click="delInp(fieldItem, idx1, fieldIndex, listIndex)"></i>
                  </div>
                  <div class="b-marT-10" style="
                      display: flex;
                      justify-content: space-between;
                      align-items: center;
                    ">
                    <div style="flex: 1"></div>
                    <div class="addOptStyle" @click="addInp(fieldItem, fieldIndex, listIndex)">
                      + 添加多选选项
                    </div>
                    <div style="flex: 1; display: flex; justify-content: flex-end">
                      <div class="addOptStyle" @click="batchSetNum(fieldItem, fieldIndex)">
                        批量设置数量
                      </div>
                    </div>
                  </div>

                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多行文本 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 9">
                <div class="left-ttype">多行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义标题"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 学校/院系/公司/职位/部门/单位 -->
              <div class="f-block flex-depart-leftStart" v-if="
                fieldItem.type == 21 ||
                fieldItem.type == 22 ||
                fieldItem.type == 25 ||
                fieldItem.type == 26 ||
                fieldItem.type == 27 ||
                fieldItem.type == 28
              ">
                <div class="left-ttype">单行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义标题"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 邮箱/工号/学号 -->
              <div class="f-block flex-depart-leftStart" v-if="
                fieldItem.type == 19 ||
                fieldItem.type == 23 ||
                fieldItem.type == 24
              ">
                <div class="left-ttype">单行文本</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义标题"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 水印拍照 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 20">
                <div class="left-ttype">水印拍照</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="水印拍照"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 日期 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 3">
                <div class="left-ttype">日期</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请输入自定义标题"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 多图 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 5">
                <div class="left-ttype">图片</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="图片"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div class="flex-depart-left">
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 拍照上传 -->
              <div class="f-block flex-depart-leftStart" v-else-if="fieldItem.type == 35">
                <div class="left-ttype">拍照上传</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请拍照上传"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div class="flex-depart-left">
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 省市区 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 8">
                <div class="left-ttype">省市区</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="请选择省市区"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 文件 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 32">
                <div class="left-ttype">文件</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="文件"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 手写签名 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 29">
                <div class="left-ttype">手写签名</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="文件"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <!-- 文件签字 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 36">
                <div class="left-ttype">文件签字</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="文件"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="add-signfile" v-if="!fieldItem.content">
                    <input class="updateFileBtn" type="file" multiple accept=".docx,.pdf,.doc,image/*" @change="
                      (event) => handleSignFileUpload(event, fieldIndex)
                    " />
                    + 点击上传签字文件
                  </div>
                  <div class="signfile-content" v-else>
                    <div class="fileName">
                      {{
                        fieldItem.content.fileType === "file"
                          ? fieldItem.content.originalFileName
                          : "签名图片"
                      }}
                    </div>
                    <div class="file-action">
                      <div class="file-action-item" @click="changeSignFileHandler(fieldItem, fieldIndex, 0)">
                        预览
                      </div>
                      <div class="file-action-item" @click="changeSignFileHandler(fieldItem, fieldIndex, 1)">
                        编辑
                      </div>
                      <div class="file-action-item" @click="fieldItem.content = ''">
                        重新上传
                      </div>
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <!-- 时间区间 -->
              <div class="f-block flex-depart-leftStart" v-if="fieldItem.type == 31">
                <div class="left-ttype">时间区间</div>
                <div class="inner-main-box">
                  <div class="flex-depart-center">
                    <div class="tl-item flex-depart-left">
                      {{ getFieldDisplayIndex(fieldIndex, listIndex) }}、
                      <el-input class="f-ipt" v-model="fieldItem.fieldName" placeholder="时间区间"></el-input>
                    </div>
                    <div class="f-handle tr-item" v-if="fieldIndex != 0">
                      <img :src="imgUpMoveSrc" alt="" @click="topNuoPng(fieldItem, fieldIndex, 2, listIndex)" />
                      <img :src="imgDownMoveSrc" alt="" @click="
                        bottomNuoPng(fieldItem, fieldIndex, 2, listIndex)
                        " />
                      <img :src="imgCancelSrc" alt="" @click="delMuKuai(fieldItem, fieldIndex, listIndex)" />
                    </div>
                  </div>
                  <div class="flex-depart-center b-marT-10">
                    <div>
                      <span class="sxsz" @click="attributeSet(fieldItem, fieldIndex)">属性设置</span>
                    </div>
                    <div class="flex-depart-center-end checkedState">
                      <el-checkbox v-model="fieldItem.encryption" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          encryptionChange($event, fieldIndex, listIndex)
                      ">
                        保密
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isRequired" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isRequiredChange($event, fieldIndex, listIndex)
                      ">
                        必填
                      </el-checkbox>
                      <el-checkbox v-model="fieldItem.isOpen" :true-label="1" :false-label="0" @change="
                        ($event) =>
                          isOpenChange($event, fieldIndex, listIndex)
                      ">
                        公开
                      </el-checkbox>
                      <div class="flex-depart-left ch-copy" @click="copyThisSignField(fieldIndex, listIndex)">
                        <i class="el-icon-circle-plus"></i>复制
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="b-marT-20 flex-depart-center-center">
            <div class="addBtnStyle" @click="openfieldList">
              <i class="el-icon-circle-plus-outline" style="position: relative; top: -1px"></i>添加填写项
            </div>
          </div>
        </div>
        <!-- todo 设置 -->
        <template>
          <div class="set-out-box">
            <div class="settingBox b-marT-10 flex-depart-center timeSelectRow" :class="{ tsRowOpen: beginTimeShow }"
              @click="beginTimeShow = !beginTimeShow">
              <span class="sTitle fs16">报名开始时间</span>
              <div class="timeSelectValue">
                <span class="tsValue">{{ beginTimeText }}</span>
                <i class="el-icon-arrow-right tsArrow" :class="{ tsArrowOpen: beginTimeShow }"></i>
              </div>
            </div>
            <div class="tsExpandRow" v-show="beginTimeShow">
              <el-checkbox v-model="startNowChecked" @change="startNowChange">保存即开始
              </el-checkbox>
              <el-date-picker v-model="activityDetail.beginTime" v-show="startNowChecked == false"
                class="tsExpandPicker" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"></el-date-picker>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center timeSelectRow" :class="{ tsRowOpen: endTimeShow }"
              @click="endTimeShow = !endTimeShow">
              <span class="sTitle fs16">报名截止时间</span>
              <div class="timeSelectValue">
                <span class="tsValue">{{ endTimeText }}</span>
                <i class="el-icon-arrow-right tsArrow" :class="{ tsArrowOpen: endTimeShow }"></i>
              </div>
            </div>
            <div class="tsExpandRow" v-show="endTimeShow">
              <el-checkbox v-model="foreverValidChecked" @change="foreverValidChange">永久有效
              </el-checkbox>
              <el-date-picker v-model="activityDetail.endTime" v-show="foreverValidChecked == false"
                class="tsExpandPicker" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"></el-date-picker>
            </div>
            <!-- 活动时间（实际活动时间，纯展示，不影响任何设置） -->
            <div class="settingBox b-marT-10 flex-depart-center">
              <div>
                <span class="sTitle fs16">活动时间</span>
                <div style="font-size: 12px; color: #999">
                  实际的活动时间仅做展示，并不影响任何设置。
                </div>
              </div>
              <div>
                <el-switch v-model="activityDetail.actualTimeSwitch" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <span ref="actualTimeBlock"></span>
            <div class="settingBox b-marT-10 flex-depart-center timeSelectRow"
              :class="{ tsRowOpen: actualBeginTimeShow }" v-if="activityDetail.actualTimeSwitch == 2"
              @click="actualBeginTimeShow = !actualBeginTimeShow">
              <span class="sTitle fs16">活动开始时间</span>
              <div class="timeSelectValue">
                <span class="tsValue">{{ actualBeginTimeText }}</span>
                <i class="el-icon-arrow-right tsArrow" :class="{ tsArrowOpen: actualBeginTimeShow }"></i>
              </div>
            </div>
            <div class="tsExpandRow" v-show="actualBeginTimeShow" v-if="activityDetail.actualTimeSwitch == 2">
              <el-checkbox v-model="actualStartNowChecked" @change="actualStartNowChange">保存即开始
              </el-checkbox>
              <el-date-picker v-model="activityDetail.actualBeginTime" v-show="actualStartNowChecked == false"
                class="tsExpandPicker" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"></el-date-picker>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center timeSelectRow" :class="{ tsRowOpen: actualEndTimeShow }"
              v-if="activityDetail.actualTimeSwitch == 2" @click="actualEndTimeShow = !actualEndTimeShow">
              <span class="sTitle fs16">活动结束时间</span>
              <div class="timeSelectValue">
                <span class="tsValue">{{ actualEndTimeText }}</span>
                <i class="el-icon-arrow-right tsArrow" :class="{ tsArrowOpen: actualEndTimeShow }"></i>
              </div>
            </div>
            <!-- <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle fs16">报名截止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox
                  v-model="foreverValidChecked"
                  @change="foreverValidChange"
                  >永久有效
                </el-checkbox>
                <div
                  class="flex-depart-center"
                  v-show="foreverValidChecked == false"
                  style="margin-left: 10px"
                >
                  <el-date-picker
                    v-model="activityDetail.endTime"
                    type="datetime"
                    format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="选择日期时间"
                  ></el-date-picker>
                </div>
              </div>
            </div> -->
            <div class="tsExpandRow" v-show="actualEndTimeShow" v-if="activityDetail.actualTimeSwitch == 2">
              <el-checkbox v-model="actualForeverValidChecked" @change="actualForeverValidChange">永久有效
              </el-checkbox>
              <el-date-picker v-model="activityDetail.actualEndTime" v-show="actualForeverValidChecked == false"
                class="tsExpandPicker" type="datetime" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间" @change="actualEndTimeChange"></el-date-picker>
            </div>
            <!-- -------------------打卡部分开始---------------------- -->
            <div class="settingBox b-marT-10 flex-depart-center seniorStyle" @click="seniorShow = !seniorShow"
              v-if="isType == '109' || isType == '110'">
              <span class="sTitle fs16"><b></b>打卡设置</span>
            </div>
            <span ref="clockSettingBlock"></span>
            <div v-if="isType == '109' || isType == '110'">
              <div class="settingBox b-marT-10 flex-depart-center">
                <span class="sTitle">打卡提醒</span>
                <div>
                  <el-switch v-model="formClock.clockRemindStatus" @change="clockRemindFun" :active-value="1"
                    :inactive-value="2" active-color="#1877ff"></el-switch>
                </div>
              </div>
              <div class="settingBox flex-depart-center" v-if="formClock.clockRemindStatus == 1">
                <span class="sTitle">打卡提醒时间</span>
                <div>
                  <el-time-picker v-model="formClock.remindTime" format="HH:mm" value-format="HH:mm" placeholder="任意时间点"
                    @change="clockTime"></el-time-picker>
                </div>
              </div>
              <div class="settingBox b-marT-10 flex-depart-center">
                <span class="sTitle">打卡频率</span>
                <div>
                  <el-select v-model="selectFrequency" placeholder="请选择" @change="clickin">
                    <el-option v-for="item in CheckInFrequency" :key="item.value" :label="item.label"
                      :value="item.value"></el-option>
                  </el-select>
                </div>
              </div>
              <template v-if="selectFrequency == 3">
                <div class="settingBox b-marT-10 flex-depart-center">
                  <span class="sTitle">允许一天内多次打卡</span>
                  <div>
                    <el-switch v-model="formClock.checkSwitch" :active-value="2" :inactive-value="1"
                      active-color="#1877ff"></el-switch>
                  </div>
                </div>
                <div class="settingBox b-marT-10 flex-depart-center" v-if="formClock.checkSwitch == 2">
                  <span class="sTitle">每天打卡次数</span>
                  <div style="
                      display: flex;
                      align-items: center;
                      justify-content: flex-end;
                    ">
                    <el-input v-model="formClock.checkTimes" size="small" placeholder="请输入" @input="handleInput"
                      class="w-50" />
                  </div>
                </div>
              </template>

              <div class="settingBox flex-depart-center" v-if="selectFrequency == 6">
                <el-checkbox-group v-model="candidateList" @change="candidateChange">
                  <el-checkbox v-for="item in candidates" :key="item.value" :label="item.value">
                    {{ item.name }}
                  </el-checkbox>
                </el-checkbox-group>
              </div>
              <div class="settingBox b-marT-10 flex-depart-center" v-if="selectFrequency == 7">
                <span class="sTitle">打卡日期选择<label class="cus-dates">已选择{{ customDateArr.length }}个日期</label></span>
                <div>
                  <el-date-picker type="dates" v-model="customDateArr" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                    placeholder="选择一个或多个日期" @change="multipleDateSure"></el-date-picker>
                </div>
              </div>
              <div class="settingBox b-marT-10" v-if="selectFrequency == 1 || selectFrequency == 2">
                <div class="flex-depart-center">
                  <span class="sTitle">允许每{{
                    selectFrequency == 1 ? "月" : "周"
                  }}多次打卡</span>
                  <div>
                    <el-switch v-model="formClock.clockMaxSwitch" @change="clockMaxSwitchFn" :active-value="1"
                      :inactive-value="2" active-color="#1877ff"></el-switch>
                  </div>
                </div>
                <div class="flex-depart-center" style="padding-top: 10px" v-if="
                  (selectFrequency == 1 || selectFrequency == 2) &&
                  formClock.clockMaxSwitch == 1
                ">
                  <div>每{{ selectFrequency == 1 ? "月" : "周" }}打卡</div>
                  <div>
                    <el-input style="width: 100px" v-model="formClock.clockMaxNum"
                      placeholder="请输入内容"></el-input>&nbsp;次
                  </div>
                </div>
              </div>
              <div class="settingBox b-marT-10 flex-depart-center" v-if="selectFrequency == 1 || selectFrequency == 2">
                <span class="sTitle">每{{ selectFrequency == 1 ? "月" : "周" }}截止打卡时间</span>
                <div class="flex-depart-center-end">
                  <div class="deadline sw80" v-if="selectFrequency == 1">
                    <el-select v-model="monthDay" placeholder="请选择" @change="endMonthFunFirst">
                      <el-option v-for="item in endMonthArr1" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </div>
                  <div class="deadline sw80" v-if="selectFrequency == 2">
                    <el-select v-model="weekDay" placeholder="请选择" @change="endWeekFunFirst">
                      <el-option v-for="item in endWeekArr1" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </div>
                  <div class="deadline sw80">
                    <el-select v-model="monthHour" placeholder="请选择" @change="endMonthFunSecond">
                      <el-option v-for="item in endMonthArr2" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </div>
                  <div class="deadline sw80">
                    <el-select v-model="monthMinute" placeholder="请选择" @change="endMonthFunThird">
                      <el-option v-for="item in endMonthArr3" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="settingBox b-marT-10" v-if="
                selectFrequency == 3 ||
                selectFrequency == 4 ||
                selectFrequency == 5 ||
                selectFrequency == 6 ||
                selectFrequency == 7
              ">
                <div class="flex-depart-center">
                  <span class="sTitle">多时段打卡</span>
                  <div>
                    <el-switch v-model="formClock.multiPeriodSwitch" @change="clockMultiPeriodSwitchFn"
                      :active-value="1" :inactive-value="2" active-color="#1877ff"></el-switch>
                  </div>
                </div>
                <div class="mar-top10">打卡时间段:</div>
                <div class="flex-depart-left b-marT-10 rangeTimes" v-for="(item, index) in formClock.clockInTimeSlot"
                  :key="index" v-show="item.ifDel == 2">
                  <el-time-picker is-range v-model="item.startAndEnd" format="HH:mm" value-format="HH:mm"
                    range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"
                    @change="(e) => clockInTimeSlot(e, index)"></el-time-picker>
                  <i class="el-icon-delete-solid" @click="timesDel(index)"></i>
                </div>
                <div class="b-marT-10 add-rangeTimes" @click="addTimes" v-if="formClock.multiPeriodSwitch == 1">
                  添加时间段
                </div>
              </div>
              <div class="settingBox b-marT-10">
                <div class="flex-depart-center">
                  <span class="sTitle">指定打卡地点</span>
                  <div>
                    <el-switch v-model="formClock.clockLocationStatus" @change="clockLocationFn" :active-value="1"
                      :inactive-value="2" active-color="#1877ff"></el-switch>
                  </div>
                </div>
              </div>
              <div class="settingBox b-marT-10" v-if="formClock.clockLocationStatus == 1">
                <div class="flex-depart-center" v-if="formClock.clockLocationStatus == 1">
                  <span class="new-block-style2">参与地点</span>
                  <div>
                    {{ formClock.address }}
                    <el-button @click="openAddress()" class="map-btn">选择位置</el-button>
                  </div>
                </div>
              </div>

              <div class="settingBox b-marT-10" v-if="formClock.clockLocationStatus == 1">
                <div class="flex-depart-center mar-top10" v-if="formClock.clockLocationStatus == 1">
                  <span class="new-block-style2">打卡范围</span>
                  <div>
                    <el-select v-model="formClock.clockRange" placeholder="请选择" @change="clockRangeChange">
                      <el-option v-for="item in dakaColumnsArr" :key="item.value" :label="item.label"
                        :value="item.value"></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div class="settingBox b-marT-10" v-if="formClock.clockFrequencyType != 8">
                <div class="flex-depart-center">
                  <span class="sTitle">允许补卡</span>
                  <div>
                    <el-switch v-model="formClock.clockSupplyStatus" @change="supplyFn" :active-value="1"
                      :inactive-value="2" active-color="#1877ff"></el-switch>
                  </div>
                </div>
                <div class="flex-depart-center mar-top10" v-if="formClock.clockSupplyStatus == 1">
                  <span>补卡次数</span>
                  <div>
                    <el-select v-model="formClock.clockSupplyType" placeholder="请选择" @change="selectOptionClick">
                      <el-option v-for="item in clockRangeList" :key="item.value" :label="item.name"
                        :value="item.value"></el-option>
                    </el-select>
                    <span v-if="
                      clockSupplyShow == true &&
                      formClock.clockSupplyType != -1
                    " style="margin-left: 10px">{{ clockSupplyText }} 次</span>
                  </div>
                </div>
              </div>
            </div>

            <!-- -----------------打卡部分结束------------------------- -->
          </div>

          <div class="settingBox b-marT-10 flex-depart-center seniorStyle" @click="seniorShow = !seniorShow">
            <span class="sTitle fs16"><b></b>发布人信息</span>
          </div>
          <div class="set-out-box">
            <div class="settingBox b-marT-10">
              <div class="flex-depart-center">
                <span class="sTitle">
                  显示发布人信息
                  <img class="yanshiBtn" @click="demonstrate(4)"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" />
                </span>
                <div>
                  <template>
                    <el-switch v-model="isanonymous" @change="anonymousFun" :active-value="1" :inactive-value="0"
                      active-color="#1877ff"></el-switch>
                  </template>
                </div>
              </div>
              <div class="mar-top10" v-if="isanonymous == 1">
                发布人：
                <el-input style="width: 94%" v-model="publisher" placeholder="请输入内容"></el-input>
              </div>
            </div>

            <div class="settingBox b-marT-10">
              <span ref="contactSettingBlock"></span>
              <div class="flex-depart-center">
                <span class="sTitle">
                  显示联系信息
                  <img class="yanshiBtn" @click="demonstrate(4)"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" />
                </span>
                <div>
                  <template>
                    <el-switch v-model="phoneSwitch" @change="phoneSwitchChange" :active-value="2" :inactive-value="1"
                      active-color="#1877ff"></el-switch>
                  </template>
                </div>
              </div>
              <div class="mar-top10" v-if="phoneSwitch == 2">
                联系方式：
                <el-select v-model="contactType" placeholder="请选择">
                  <el-option v-for="item in contactTypeArr" :key="item.id" :label="item.label" :value="item.id">
                  </el-option>
                </el-select>
              </div>
              <div class="mar-top10" v-if="phoneSwitch == 2">
                联系号码：
                <el-input style="width: 94%" v-model="userPhone" placeholder="请输入内容" maxlength="20"></el-input>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center seniorStyle">
              <span class="sTitle fs16"><b></b>{{ appid == "wx1e899bddb256a5ca" ? "接龙" : "报名" }}设置</span>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">接龙情况通知 </span>
              <div class="flex-depart-center-end">
                <el-select v-model="activityDetail.enablePush" placeholder="请选择" @change="handleEnablePushChange">
                  <el-option v-for="item in enablePushArr" :key="item.value" :label="item.label" :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle">匿名参与
                <img class="yanshiBtn" @click="demonstrate(3)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="anonymousparticipation" @change="anonymouspartFun" :active-value="1"
                  :inactive-value="0" active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10" v-if="isType != '109' && isType != '110'">
              <span ref="participateLocationBlock"></span>
              <div class="flex-depart-center">
                <span class="sTitle">指定参与地点<img class="yanshiBtn" @click="demonstrate(10)"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
                <div>
                  <el-switch v-model="is_destination" @change="isDestinationFun" :active-value="1" :inactive-value="0"
                    active-color="#1877ff"></el-switch>
                </div>
              </div>
            </div>
            <div class="settingBox flex-depart-center b-marT-10" v-if="is_destination == 1">
              <span class="new-block-style2">参与地点</span>
              <div>
                {{ specifyaddress }}
                <el-button @click="openJoininAddress()" class="map-btn">选择位置</el-button>
              </div>
            </div>

            <div class="settingBox flex-depart-center b-marT-10" v-if="is_destination == 1">
              <span class="new-block-style2">参与范围</span>
              <div style="width: 440px">
                <el-select v-model="checkinrange" placeholder="请选择" @change="checkinRangeChange">
                  <el-option v-for="item in addresscolumnsArr" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="isType == 106 || clockInfoObj.clockFrequencyType == 8">
              <span class="sTitle">每人可{{
                appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
              }}次数</span>
              <div class="flex-depart-center-end">
                <el-select v-model="activityDetail.generalCheckTimes" placeholder="请选择"
                  @change="generalCheckTimesChange">
                  <el-option v-for="item in generalCheckTimesArr" :key="item.value" :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">禁止他人复制该{{
                appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
              }}</span>
              <div>
                <el-switch v-model="copyStatus" @change="copyStatusFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">禁止他人转发该{{
                appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
              }}</span>
              <div>
                <el-switch v-model="is_forward" @change="forwardFun" :active-value="1" :inactive-value="0"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center seniorStyle">
              <span class="sTitle fs16"><b></b>页面内容可见设置</span>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="activityMode == 1">
              <span class="sTitle">隐藏活动属性区域
                <img class="yanshiBtn" @click="demonstrate(18)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="hideAttr" :active-value="1" :inactive-value="0" active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">隐藏修改与信息规则
                <img class="yanshiBtn" @click="demonstrate(19)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="hideRule" :active-value="1" :inactive-value="0" active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">隐藏人数限制与取消规则
                <img class="yanshiBtn" @click="demonstrate(20)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="hideLimit" :active-value="1" :inactive-value="0" active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">隐藏人员名单
                <img class="yanshiBtn" @click="demonstrate(17)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>

              <div>
                <el-switch v-model="hideUser" @change="hideUserFun" :active-value="1" :inactive-value="0"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">折叠参与人信息
                <img class="yanshiBtn" @click="demonstrate(21)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="foldInfo" :active-value="1" :inactive-value="0" active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox flex-depart-center" v-if="foldInfo == 1">
              <span class="sTitle">设置可见填表项数量</span>
              <div>
                <el-select v-model="showFormNum" placeholder="请选择">
                  <el-option v-for="i in totalFormItems" :key="i" :label="getFormLabel(i)" :value="i" />
                </el-select>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center seniorStyle">
              <span class="sTitle fs16"><b></b>自定义设置</span>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">参与按钮文字</span>
              <div class="flex-depart-center-end">
                <el-input style="width: 200px" v-model="confirmWord" placeholder="请输入内容，最多输入9个字"
                  maxlength="9"></el-input>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">提交信息按钮文字</span>
              <div class="flex-depart-center-end">
                <el-input v-model="submitcopy" placeholder="请输入内容，最多输入15个字" maxlength="15"></el-input>
              </div>
            </div>

            <!--                        <div class="settingBox b-marT-10 flex-depart-center">-->
            <!--                            <span class="sTitle">开启留言</span>-->
            <!--                            <div>-->
            <!--                                <el-radio-group v-removeAriaHidden v-model="commentStatus" @input="commentFun">-->
            <!--                                    <el-radio :label="1">开启</el-radio>-->
            <!--                                    <el-radio :label="2">关闭</el-radio>-->
            <!--                                </el-radio-group>-->
            <!--                            </div>-->
            <!--                        </div>-->

            <div class="settingBox b-marT-10 flex-depart-center" v-if="activityMode == 2">
              <span class="sTitle">自定义分享图</span>
              <div>
                <el-select v-model="shareImageStyle" placeholder="请选择" @change="shareImgConfirm">
                  <el-option v-for="item in shareImgColumns" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center" v-if="activityMode == 2">
              <span class="sTitle" v-if="shareImageStyle == 1">设置系统分享图</span>
              <span class="sTitle" v-if="shareImageStyle == 2">设置自定义分享图</span>
              <div>
                <div class="edit-share" v-if="shareImageStyle == 1" @click="changeXTShareImg">
                  <img class="sm-1" :src="shareImageUrl" mode="aspectFill" />
                  <span>更换</span>
                </div>
                <div class="edit-share" v-if="shareImageStyle == 2">
                  <img class="sm-1" :src="shareZdyImageUrl" />
                  <span><input class="updateFileBtn" type="file" id="imageShareInput2" accept="image/*"
                      @change="(event) => handleShareImgUpload(event)" />上传</span>
                </div>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">{{
                appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
              }}后自定义展示页面</span>
              <div class="setText" @click="openCus">设置</div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="activityMode == 1">
              <span class="sTitle">加密浏览分享数据<img class="yanshiBtn" @click="demonstrate(12)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="activityDetail.encryptBrowsing" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="isType != '109' && isType != '110' && isType != '104'">
              <span class="sTitle">报名成功弹幕<img class="yanshiBtn" @click="demonstrate(27)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="signSuccessBarrageSwitch" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">内容字体大小</span>
              <div>
                <el-radio-group v-removeAriaHidden v-model="activityDetail.fontSize">
                  <el-radio :label="1">默认</el-radio>
                  <el-radio :label="2">较小</el-radio>
                  <el-radio :label="3">较大</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">内容展开收起设置<img class="yanshiBtn" @click="demonstrate(13)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-radio-group v-removeAriaHidden v-model="activityDetail.expandSet">
                  <el-radio :label="1">自动展开</el-radio>
                  <el-radio :label="2">自动收起</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center">
              <span class="sTitle">添加背景音乐</span>
              <div class="setText" @click="openBgMusicDialog">
                {{ activityDetail.musicName || "无音乐" }}
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center seniorStyle" style="background-color: #fff !important"
              v-if="isType != '109' && isType != '110'">
              <div class="sTitle fs16"><b></b>必读须知</div>
              <div class="s-right">
                <el-switch v-model="activityDetail.noticeConfig.noticeEnabled" active-color="#1877ff" :active-value="1"
                  :inactive-value="0" :disabled="!activityDetail.noticeConfig">
                </el-switch>
                <span v-if="activityDetail.noticeConfig.noticeEnabled === 1" @click="openNoticeConfig">设置</span>
              </div>
            </div>


            <div class="settingBox b-marT-10 flex-depart-center seniorStyle">
              <span class="sTitle fs16"><b></b>功能按钮设置</span>
            </div>


            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle">点赞</span>
              <div>
                <el-switch v-model="thumbs_up" @change="thumbsUpFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle">点评</span>
              <div>
                <el-switch v-model="is_comment" @change="isCommentFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle">评分</span>
              <div>
                <el-switch v-model="is_score" @change="isScoreFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle">评论</span>
              <div>
                <el-switch v-model="isMessage" @change="isMessageFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType == '109' || isType == '104'">
              <span class="sTitle">排行榜</span>
              <div>
                <el-switch v-model="showRanking" @change="rankingFun" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center mar-top10" v-if="isType == '106' && isType != '101'">
              <span class="sTitle">核销设置<img class="yanshiBtn" @click="demonstrate(6)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="activityDetail.verificationSwitch" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.verificationSwitch == 2 && isType != '101'">
              <span class="sTitle new-block-style2">核销起止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox v-model="foreverTimeHxChecked" @change="foreverHxValidChange">永久有效
                </el-checkbox>
                <div class="flex-depart-center" v-show="foreverTimeHxChecked == true" style="margin-left: 10px">
                  <el-date-picker v-model="verificationStartTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                </div>
                <div v-show="foreverTimeHxChecked == false" style="margin-left: 10px">
                  <el-date-picker v-model="hxStartAndEndTime" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                    @change="hxStartAndEndTimeFun"></el-date-picker>
                </div>
              </div>
            </div>

            <div class="settingBox b-marT-10 mar-top10" v-if="isType != '101'">
              <span ref="signInSettingBlock"></span>
              <div class="flex-depart-center">
                <span class="sTitle">签到设置<img class="yanshiBtn" @click="demonstrate(7)"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
                <div>
                  <el-switch v-model="activityDetail.signInSwitch" @change="signInSwitchChange" :active-value="2"
                    :inactive-value="1" active-color="#1877ff"></el-switch>
                </div>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">签到起止时间</span>
              <div class="flex-depart-center mar-bot-check-0">
                <el-checkbox v-model="foreverTimeQdChecked" @change="foreverQdValidChange">永久有效
                </el-checkbox>
                <div class="flex-depart-center" v-show="foreverTimeQdChecked == true" style="margin-left: 10px">
                  <el-date-picker v-model="signInStartTime" type="datetime" format="yyyy-MM-dd HH:mm:ss"
                    value-format="yyyy-MM-dd HH:mm:ss" placeholder="选择日期时间"></el-date-picker>
                </div>
                <div v-show="foreverTimeQdChecked == false" style="margin-left: 10px">
                  <el-date-picker v-model="signStartAndEndTime" type="datetimerange" range-separator="至"
                    start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                    @change="qdStartAndEndTimeFun"></el-date-picker>
                </div>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">显示签到状态</span>
              <div>
                <el-select v-model="checkInStatusSwitch" placeholder="请选择" @change="checkInConfirm">
                  <el-option v-for="item in checkInStatusArr" :key="item.id" :label="item.label"
                    :value="item.id"></el-option>
                </el-select>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">是否允许撤销签到<img class="yanshiBtn" @click="demonstrate(8)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="activityDetail.revokeSign" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">指定签到地点</span>
              <div>
                <el-switch v-model="activityDetail.signLocationSwitch" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>

            <div class="settingBox flex-depart-center b-marT-10"
              v-if="activityDetail.signLocationSwitch == 2 && isType != '101'">
              <span class="sTitle new-block-style1">参与地点</span>
              <div>
                {{ activityDetail.signInAddress }}
                <el-button @click="openSignAddress()" class="map-btn">选择位置</el-button>
              </div>
            </div>

            <div class="settingBox flex-depart-center b-marT-10"
              v-if="activityDetail.signLocationSwitch == 2 && isType != '101'">
              <span class="sTitle new-block-style1">参与范围</span>
              <div>
                <el-select v-model="activityDetail.signLocationDistance" placeholder="请选择" @change="signRangeChange">
                  <el-option v-for="item in addresscolumnsArr" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">签退</span>
              <div>
                <el-switch v-model="activityDetail.signOutSwitch" @change="signOutSwitchChange" :active-value="2"
                  :inactive-value="1" active-color="#1877ff"></el-switch>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center"
              v-if="activityDetail.signOutSwitch == 2 && activityDetail.signInSwitch == 2 && isType != '101'">
              <span class="sTitle">签退在场时间</span>
              <div>
                <el-select v-model="attendanceDurationSelect" placeholder="请选择" @change="attendanceDurationChange">
                  <el-option v-for="item in attendanceDurationArr" :key="item.value" :label="item.label"
                    :value="item.value" :disabled="item.value > signInWindowMinutes"></el-option>
                  <el-option v-if="attendanceDurationOptions" :key="attendanceDurationOptions.value"
                    :label="attendanceDurationOptions.label" :value="attendanceDurationOptions.value"
                    v-show="false"></el-option>
                </el-select>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType == '106'">
              <div>
                <span class="sTitle">渠道码设置</span>
                <div style="font-size: 12px; color: #999">
                  开启后，请在「管理」中生成来源渠道专属二维码
                </div>
              </div>
              <div>
                <el-switch v-model="channelCodeSwitch" :active-value="2" :inactive-value="1"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType == '106'">
              <div>
                <span class="sTitle">参与数据同步至投票管家<img class="yanshiBtn" @click="demonstrate(25)"
                    src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
                <div style="font-size: 12px; color: #999">
                  非实时同步，需在「管理」中手动选择数据
                </div>
              </div>
              <div>
                <span v-if="selectType == 'add'" style="color: #999; font-size: 14px">请先创建</span>
                <el-button v-else type="primary" size="small" @click="openVoteSyncDialog">设置</el-button>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center seniorStyle">
              <span class="sTitle fs16"><b></b>参与信息设置</span>
            </div>
            <div class="settingBox  flex-depart-center mar-top10">
              <span class="sTitle">展示参与信息<img class="yanshiBtn" @click="demonstrate(9)"
                  src="https://ossfastmake.xlkapp.com/12jielong/bdJL/yanshi4.0.svg" alt="" /></span>
              <div>
                <el-switch v-model="signInfoStatus" @change="signInfoIsOpenFun" :active-value="1" :inactive-value="2"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType == '106'">
              <span class="sTitle">参与信息需要审核</span>
              <div>
                <el-switch v-model="auditSwitch" :active-value="1" :inactive-value="0"
                  active-color="#1877ff"></el-switch>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle new-block-style2">允许修改参与信息</span>
              <div>
                <el-select v-model="updateSignInfo" placeholder="请选择" @change="signChange">
                  <el-option v-for="item in updateSignArr" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox flex-depart-center" style="padding-top: 0"
              v-show="updateSignInfo == 2 && isType != '101'">
              <span class="sTitle new-block-style2">时间范围</span>
              <div>
                <el-date-picker v-model="deadline" type="datetimerange" range-separator="至" start-placeholder="开始日期"
                  end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss" @change="deadlineTimeFun"></el-date-picker>
              </div>
            </div>

            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != '101'">
              <span class="sTitle new-block-style2">报名后是否允许取消</span>
              <div>
                <el-select v-model="removeSignStatus" placeholder="请选择" @change="removeSignChange">
                  <el-option v-for="item in cancellationArr" :key="item.value" :label="item.label"
                    :value="item.value"></el-option>
                </el-select>
              </div>
            </div>
            <div class="settingBox flex-depart-center" style="padding-top: 0"
              v-if="removeSignStatus == 3 && isType != '101'">
              <span class="sTitle new-block-style2">时间范围</span>
              <div>
                <el-date-picker v-model="deadCancelline" type="datetimerange" range-separator="至"
                  start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd HH:mm:ss"
                  @change="deadCancelTimeFun"></el-date-picker>
              </div>
            </div>
            <div class="settingBox b-marT-10 flex-depart-center" v-if="isType != 101">
              <div class="new-block-style2">
                <span class="sTitle">限制参与人数</span>
                <p style="margin-bottom: 0; color: #505d69">
                  0人即为不限制参与人数
                </p>
              </div>

              <div class="flex-depart-center-end danwei">
                <!--                                <el-input style="width: 200px" v-model="interdict_people_num"-->
                <!--                                          @input="interdict_people_num=interdict_people_num.replace(/^\.+|[^\d]+/g,'')"-->
                <!--                                          @focus="FocusInterdictPeople()" @blur="BlurInterdictPeople" placeholder="请输入内容"></el-input>&nbsp;人-->
                <input type="text" v-model="interdict_people_num" @input="
                  interdict_people_num = interdict_people_num.replace(
                    /^\.+|[^\d]+/g,
                    '',
                  )
                  " @focus="FocusInterdictPeople()" @blur="BlurInterdictPeople" placeholder="请输入参与人数" />&nbsp;人
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>

    <!-- todo 去创建 -->
    <div class="posi-bottom-btn-box flex-depart-center-center">
      <div class="yl flex-depart-center-center" v-if="selectType == 'add' || is_draft == 1" @click="saveToDraft">
        存草稿
      </div>
      <div class="saveDatabox flex-depart-center-center" @click="submit">
        {{ selectType == "update" ? "保存" : "免费创建" }}
      </div>
    </div>
    <div style="height: 90px"></div>

    <!--查看大图-->
    <div class="previewImgBox" @click="hidePreview" v-if="previewImgShow == true">
      <i class="closePImg el-icon-circle-close"></i>
      <img class="inner-p-img" :src="imageUrl + previewImgSrc" alt="" />
    </div>

    <systemPictures ref="systemPictures" @shareSelect="shareSelect" @sureSelect="sureSelect" @search="handleSearch">
    </systemPictures>

    <!--抽屉-表单项弹框 -->
    <el-drawer :visible.sync="formDrawerShow" :direction="direction" size="450px" :withHeader="false"
      :before-close="formDrawerClose">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加填写项</span>
          <!-- <i class="el-icon-close" @click="formDrawerClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="formDrawerClose" />
        </div>
        <div class="underline"></div>
        <div class="af-title">通用填写项</div>
        <div class="ty-block flex-depart-center b-marT-10">
          <div class="ty-b-item" @click="addForm(-1)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>单行文本</div>
            <p>填写文字、数字的单行文本</p>
          </div>
          <div class="ty-b-item" @click="addForm(-4)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>多行文本</div>
            <p>填写多行文本或数字信息</p>
          </div>
        </div>
        <div class="ty-block flex-depart-center b-marT-10">
          <div class="ty-b-item" @click="addForm(-2)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>单选</div>
            <p>可以设置分组、分类、标签</p>
          </div>
          <div class="ty-b-item" @click="addForm(-3)">
            <i class="el-icon-circle-plus addFBtn"></i>
            <div>多选</div>
            <p>设置多项选择的填表项</p>
          </div>
        </div>
        <div class="af-title b-marT-10">常用填写项</div>
        <div class="b-marT-10 cy-box">
          <div class="cy-item" v-for="(item, index) in formList" :key="item.type" @click="addForm(item.type, index)">
            <span>{{ item.label }}</span><i class="el-icon-circle-plus addFBtn2"></i>
          </div>
          <div class="cy-item" style="visibility: hidden"></div>
          <div class="cy-item" style="visibility: hidden"></div>
        </div>
      </div>
    </el-drawer>
    <!--抽屉-名单 -->
    <el-drawer :visible.sync="openNameListDrawer" :direction="direction" size="450px" :withHeader="false"
      :before-close="nameListClose">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加人员名单</span>
          <!-- <i class="el-icon-close" @click="nameListClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="nameListClose" />
        </div>
        <div class="underline"></div>
        <div class="nl-title">姓名名单</div>
        <div style="color: #a5a4a4; font-size: 12px; margin: 10px 0">
          注：每个名单可用逗号，换行隔开，最大可添加 2000 个名单
        </div>
        <div class="b-marT-10">
          <el-input type="textarea" rows="15" v-model="nameShowContent" @input="handlerBlurOnlyName($event)"
            placeholder="请输入姓名名单" class="textareName"></el-input>
        </div>
        <div class="clockNameNumberSwitchDiv" style="
            display: flex;
            justify-content: space-between;
            align-items: center;
            margin-top: 10px;
          ">
          <div style="display: flex; align-items: center; flex-wrap: wrap">
            <el-switch v-model="clockNameNumberSwitch" @change="clockNameNumberSwitchChange($event)"
              active-color="#1877FF" inactive-color="rgb(230, 230, 230)" active-value="1"
              inactive-value="2"></el-switch>
            <div style="margin-left: 6px">添加编号/学号</div>
            <el-checkbox v-model="nameSortSwitch" @change="nameSortSwitchChangeFn"
              style="margin-left: 16px;margin-bottom:0">按拼音排序</el-checkbox>
          </div>
          <div>合计:{{ people_num }}人</div>
        </div>
        <div class="flex-depart-center b-marT-10">
          <div class="daoru" @click="importVisible = true">从Excel导入</div>
          <div class="qingkong" @click="clearName">
            <i class="el-icon-delete"></i>清空内容
          </div>
        </div>
        <div class="flex-depart-center b-marT-20 addnameBtns">
          <el-button round @click="openNamelistFun">预存名单</el-button>
          <el-button round type="primary" @click="sureAddNameList">确定</el-button>
        </div>

        <div v-if="onlyNameArr.length > 0">
          <div class="preview-title">预览（仅展示四排）</div>
          <div class="jl-box" :style="{ paddingBottom: '0' }" style="
              margin-bottom: 0 !important;
              margin-top: 0;
              background-color: transparent !important;
            ">
            <div class="jlName" style="padding: 0 !important">
              <div class="listName newSpanWidth">
                <div class="spanDiv" v-for="(item, index) in sortedOnlyNameArr.slice(0, 24)" :key="index" :style="{
                  lineHeight:
                    activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                }">
                  <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                    index + 1
                  }}</span>
                  {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
    <!-- 弹出层-名单导入 -->
    <el-dialog :visible.sync="importVisible" width="30%" class="no-padding-top" :show-close="false"
      :before-close="importClose">
      <template slot="title">
        <CustomDialogHeader title="Excel表格导入" @close="importVisible = false" />
      </template>
      <div>
        <el-button @click="downExam">下载excel模板</el-button>
        <el-button type="primary" class="updateFileBtn-out"><input class="updateFileBtn" type="file" id="imageInput7"
            accept=".xls,.xlsx" @change.stop="importExcel" />导入
        </el-button>
        <div class="b-marT-10" style="color: #f56c6c">
          注：Excel表格内的内容默认值读取第一列内容
        </div>
      </div>
    </el-dialog>
    <el-dialog :visible.sync="gzhDialogVisible" width="360px" :show-close="false" custom-class="gzh-follow-dialog">
      <div slot="title" class="gzh-dialog-header">
        <span>接龙情况通知</span>
        <i class="el-icon-close" @click="closeGzhDialog"></i>
      </div>
      <div class="gzh-dialog-content">
        <img class="gzh-dialog-qrcode" :src="gzhQrcodeSrc" alt="公众号二维码" />
        <p>扫码关注公众号接受消息通知</p>
        <el-button type="primary" class="gzh-download-btn" round @click="downloadGzhQrcode">
          下载二维码
        </el-button>
      </div>
    </el-dialog>

    <!--抽屉-预存名单列表 -->
    <el-drawer :visible.sync="nameListDrawer" :direction="direction" size="450px" :withHeader="false"
      :before-close="nameListDrawerFun">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>预存名单列表</span>
          <!-- <i class="el-icon-close" @click="nameListDrawerFun"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="nameListDrawerFun" />
        </div>
        <div class="underline"></div>
        <div class="flex-depart-center b-marT-10 ycn" v-for="(item, index) in presetsList" :key="index"
          @click="EchoList(item)">
          <div class="n-name">{{ item.clockPresetTitle }}</div>
          <div class="n-handle">
            <span @click.stop="nameLists(item.id)">编辑</span>
            <span @click.stop="presetsDel(item.id)">删除</span>
          </div>
        </div>
        <el-button type="primary" class="b-marT-10" round @click="toAddRoster">添加姓名名单</el-button>
      </div>
    </el-drawer>
    <!--抽屉-添加预存名单 -->
    <el-drawer :visible.sync="addNameListDrawer" :direction="direction" size="450px" :withHeader="false"
      :before-close="addNameDrawer">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>添加预存名单</span>
          <!-- <i class="el-icon-close" @click="addNameDrawer"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="addNameDrawer" />
        </div>
        <div class="nl-title">名单标题</div>
        <div class="b-marT-10">
          <el-input v-model="clockShowPresetTitle" @input="handlerBlur()" placeholder="请输入内容"></el-input>
        </div>
        <div class="nl-title b-marT-10">
          预存名单 <span>合计:{{ people_num2 }}人</span>
        </div>
        <div class="b-marT-10">
          <el-input type="textarea" rows="15" v-model="clockShowPresetContent" @input="handlerBlur()"
            placeholder="请输入姓名名单" class="textareName"></el-input>
        </div>
        <div class="flex-depart-center b-marT-10">
          <div class="daoru updateFileBtn-out">
            从Excel导入
            <input class="updateFileBtn" type="file" id="imageInput8" accept=".xls,.xlsx" @change.stop="importFiles" />
          </div>
          <div class="qingkong" @click="emptyName">
            <i class="el-icon-delete"></i>清空内容
          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="closeAddNameDrawer">取消</el-button>
          <el-button type="primary" @click="clockPresetsAdd">确定</el-button>
        </div>
      </div>
    </el-drawer>
    <!--抽屉-接龙后自定义展示页面 -->
    <el-drawer :visible.sync="customizeDrawer" :direction="direction" size="450px" :withHeader="false"
      :before-close="customizeClose">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>{{
            appid == "wx1e899bddb256a5ca" ? "接龙" : "报名"
          }}后自定义展示页面</span>
          <!-- <i class="el-icon-close" @click="customizeClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="customizeClose" />
        </div>
        <div class="underline"></div>
        <div class="duiHao">
          <img src="https://ossfastmake.xlkapp.com//12jielong/lsyJL/successdh.png" alt="" />
        </div>
        <div class="b-marT-10 cw">
          <el-input v-model="copyShowWriting" placeholder="请输入自定义文字"></el-input>
        </div>
        <div class="b-marT-20 flex-depart-center-center" v-if="!copyShowImage">
          <div class="upl-smallImg upl-smallImg2">
            <input class="updateFileBtn" type="file" accept="image/*" id="imageInput9" @change="uploadCopyImage" />
            <i class="el-icon-circle-plus"></i>
            <span>点击上传图片</span>
          </div>
        </div>
        <div class="b-marT-20 flex-depart-center-center copy-image-out" v-if="copyShowImage">
          <img src="https://ossfastmake.xlkapp.com//static/0307/del.svg" @click.stop="delCopyImage" alt=""
            class="del-copy-img" />
          <img class="copy-image" :src="imageUrl + copyShowImage" alt="" />
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="customizeDrawer = false">取消</el-button>
          <el-button type="primary" @click="sureCoverImgFun">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--关联接龙-->
    <el-drawer :visible.sync="relatedDrawerShow" :direction="direction" size="450px" :withHeader="false"
      :before-close="relatedDrawerClose">
      <div class="drawerOutBox">
        <div class="drawer-nav-top">
          <div></div>
          <span>关联接龙</span>
          <!-- <i class="el-icon-close" @click="relatedDrawerClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="relatedDrawerClose" />
        </div>
        <div class="underline"></div>
        <div class="call-out" id="scrollable-div">
          <div class="b-marT-10 bg-gray pad-10" v-for="(item, index) in relatedList" :key="item.value">
            <div class="flex-depart-center-top">
              <el-checkbox v-model="item.checked"
                @change="($event) => relateItemChange($event, item, index)"></el-checkbox>
              <div class="cell-box">
                <p class="cell-name">{{ item.name }}</p>
                <div class="cell-addTime">{{ item.add_time }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="relatedDrawerShow = false">取消</el-button>
          <el-button type="primary" @click="relatedAdd">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--属性设置-->
    <el-drawer :visible.sync="propertySetShow" :direction="direction" size="450px" :withHeader="false"
      :before-close="propertyDrawerClose">
      <div class="drawerOutBox drawerOutBox-nopadding gray-bg">
        <div class="drawer-nav-top" style="padding: 0 20px">
          <div></div>
          <span>属性设置</span>
          <!-- <i class="el-icon-close" @click="propertyDrawerClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="propertyDrawerClose" />
        </div>
        <div class="propertySet-box">
          <!--标题-->
          <div class="title-block flex-depart-top2">
            <div class="tb-left font-weight600">
              <label class="x">*</label>标题
            </div>
            <div style="width: 85%">
              <el-input v-model="propertyData.fieldName" placeholder="请输入内容"></el-input>
            </div>
          </div>

          <!--文本格式-->
          <div class="wb-setting-block">
            <div class="zz" v-if="
              commType == -1 ||
              commType == 9 ||
              commType == 1 ||
              commType == 11 ||
              commType == 19 ||
              commType == 23 ||
              commType == 24 ||
              commType == 21 ||
              commType == 22 ||
              commType == 25 ||
              commType == 26 ||
              commType == 27 ||
              commType == 28
            ">
              <span class="font-weight600">文本格式：</span>
              <el-select v-model="propertyData.isFormatCheck" placeholder="请选择" @change="formatCheckChange">
                <el-option v-for="(vItem, vIndex) in validateArr" :key="vIndex" :label="vItem"
                  :value="vIndex"></el-option>
              </el-select>
            </div>
            <div class="no-repeat" v-if="
              commType == -1 ||
              commType == 9 ||
              commType == 1 ||
              commType == 11 ||
              commType == 19 ||
              commType == 23 ||
              commType == 24
            ">
              <div>
                <div class="no-title">记录唯一性 不可以重复</div>
                <div class="no-tips">例如学号 工号只能一个接龙者使用。</div>
              </div>
              <el-switch v-model="propertyData.isUniqueCheck" active-value="1" inactive-value="0" active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)"></el-switch>
            </div>
          </div>

          <!--文件数量-->
          <div class="files-num" v-if="commType == 5 || commType == 35">
            <span class="font-weight600">最多可上传文件数量：</span>
            <div class="set-box">
              <el-select v-model="propertyData.imageUploadLimit" placeholder="请选择" @change="imgNumCheckChange">
                <el-option v-for="(imgItem, imgIndex) in imageUploadNumArr" :key="imgIndex" :label="imgItem"
                  :value="imgIndex"></el-option>
              </el-select>
            </div>
          </div>
          <!--单选展示样式-->
          <div class="files-num" v-if="commType == 2 || commType == 4">
            <span class="font-weight600">展示样式：</span>
            <div class="set-box">
              <el-select v-model="propertyData.displayStyle" placeholder="请选择" @change="imgNumCheckChange">
                <el-option v-for="dItem in displayStyleArr" :key="dItem.value" :label="dItem.label"
                  :value="dItem.value"></el-option>
              </el-select>
            </div>
          </div>
          <!--单选多选-->
          <div class="radio-block" v-if="commType == 2 || commType == 4">
            <template v-for="(contentItem, contentIndex) in propertyData.content">
              <div class="rb-item" :key="'item-' + contentIndex">
                <div class="rb-left">
                  <div>{{ contentIndex + 1 }}</div>
                  <div style="width: 265px; margin-left: 10px">
                    <div class="opt-row">
                      <el-input class="opt-name" v-model="contentItem.value" placeholder="请输入选项名称"></el-input>
                      <el-input class="opt-num" maxlength="10" :value="contentItem.maxNum === -1 ? '' : contentItem.maxNum
                        " placeholder="数量不限" @input="handleNumValueChange($event, contentItem)"
                        @focus="handleNumValueFocus(contentItem)"></el-input>
                    </div>
                    <!-- 选项截止时间 -->
                    <div class="opt-deadline-row" v-if="commType == 2">
                      <span class="deadline-link" @click="showDatePicker(contentItem, contentIndex)">
                        <template v-if="!contentItem.validateDateTo">+ 设置选项截止时间（选填）</template>
                        <template v-else>截止时间：{{ contentItem.validateDateTo }}</template>
                      </span>
                      <el-button v-if="contentItem.validateDateTo" type="text" class="clear-deadline-btn" @click.stop="
                        clearOptionDeadline(contentItem, contentIndex)
                        ">清除</el-button>
                      <el-date-picker :ref="'deadlinePicker-' + contentIndex" v-model="contentItem.tempDeadline"
                        type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" :picker-options="{
                          disabledDate: (time) =>
                            time.getTime() < Date.now() - 86400000,
                        }" @change="
                          (val) => handleOptionDeadlineChange(val, contentItem)
                        " class="hidden-date-picker"></el-date-picker>
                    </div>
                  </div>
                </div>
                <div class="rb-right">
                  <img :src="commonImgSrc + 'bdJL/move-shang.svg'" @click="upTr(contentIndex)" />
                  <img :src="commonImgSrc + 'bdJL/move-xia.svg'" @click="downTr(contentIndex)" />
                  <img :src="commonImgSrc + 'bdJL/move-del.svg'" @click="trash(contentIndex)" />
                </div>
              </div>
            </template>
          </div>
          <div class="radio-add" v-if="commType == 2 || commType == 4">
            <span @click="addOption">添加选项</span>
            <span @click="batchOptions">批量添加选项</span>
            <span @click="batchSetNum(propertyData, commIndex)">批量设置数量</span>
          </div>

          <div class="files-num" v-if="commType == 4">
            <span class="font-weight600">最多可选：</span>
            <div class="set-box">
              <el-select v-model="propertyData.maxValue" placeholder="请选择">
                <el-option v-for="(mItem, mIndex) in maxValueArr" :key="mIndex" :label="mItem.label"
                  :value="mItem.value"></el-option>
              </el-select>
            </div>
          </div>
          <div class="files-num" v-if="commType == 4">
            <span class="font-weight600">最少可选：</span>
            <el-select v-model="propertyData.minValue" placeholder="请选择">
              <el-option v-for="(mItem, mIndex) in minValueArr" :key="mIndex" :label="mItem.label"
                :value="mItem.value"></el-option>
            </el-select>
          </div>
          <!--地址格式-->
          <div class="area-block" v-if="commType == 8">
            <div class="tt-title">选择格式：</div>
            <div class="tt-list" v-for="(item, index) in areaSetList" :key="item.type"
              @click="attributeAreaChange(item.type, index)">
              <span>{{ item.value }}</span>
              <img v-if="index != Number(propertyData.areaSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg" />
              <img v-if="index == Number(propertyData.areaSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg" />
            </div>
          </div>
          <!--日期-->
          <div class="area-block" v-if="commType == 3">
            <div class="tt-title">选择格式：</div>
            <div class="tt-list" v-for="(item, index) in timeSetList" :key="item.type"
              @click="attributeTimeChange(item.type, index)">
              <span>{{ item.value }}</span>
              <img v-if="index != Number(propertyData.timeSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg" />
              <img v-if="index == Number(propertyData.timeSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg" />
            </div>
          </div>
          <!--时间区间-->
          <div class="area-block" v-if="commType == 31">
            <div class="tt-title">选择格式：</div>
            <div class="tt-list" v-for="(item, index) in dateSetList" :key="item.type"
              @click="attributeDateChange(item.type, index)">
              <span>{{ item.value }}</span>
              <img v-if="index != Number(propertyData.dateSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/no-chose.svg" />
              <img v-if="index == Number(propertyData.dateSelectType)"
                src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/has-chose.svg" />
            </div>
          </div>
          <!--必填/公开-->
          <div class="bx-block">
            <div class="bx-item">
              <!--                            <el-checkbox v-model="propertyData.isRequiredChecked" @change="checkFun">必填</el-checkbox>-->
              <el-checkbox v-model="propertyData.isRequired" :true-label="1" :false-label="0" @change="checkFun">必填
              </el-checkbox>
            </div>
            <div class="bx-item">
              <!--                            <el-checkbox v-model="propertyData.isOpenChecked">公开</el-checkbox>-->
              <el-checkbox v-model="propertyData.isOpen" :true-label="1" :false-label="0" @change="openFn">公开
              </el-checkbox>
            </div>
          </div>

          <!--提示-->
          <div class="tips-block">
            <div class="tip-title">
              <span class="font-weight600">提示</span>
              <el-switch v-model="propertyData.promptSwitch" active-color="#1877FF" inactive-color="rgb(230, 230, 230)"
                active-value="1" inactive-value="2"></el-switch>
            </div>
            <div v-show="propertyData.promptSwitch == 1" class="padding-0-20">
              <el-divider></el-divider>
              <div class="tip-t-area">
                <el-input type="textarea" :rows="4" placeholder="请输入提示内容或说明（选填）" maxlength="50"
                  v-model="propertyData.promptExplanation"></el-input>
              </div>
              <template v-if="propertyData.promptImage">
                <div class="up-box1">
                  <input class="updateFileBtn" type="file" id="imageInput11" accept="image/*"
                    @change="uploadPromptImage" />
                  <img class="up-img-fun1" :src="imageUrl + propertyData.promptImage" alt="" />
                </div>
              </template>
              <template v-if="!propertyData.promptImage">
                <div class="up-box1">
                  <input class="updateFileBtn" type="file" id="imageInput10" accept="image/*"
                    @change="uploadPromptImage" />
                  <img class="up-img-fun1"
                    src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/bdJL/up-img-fun.svg" alt="" />
                </div>
              </template>
            </div>
          </div>
          <!-- 地点选择 -->
          <PosPermissionSelector v-model="propertyData.posPermissions" v-if="commType == 12">
          </PosPermissionSelector>
          <!-- 水印选择 -->
          <WaterMarkSwitch v-if="commType == 5 || commType == 35" v-model="propertyData.watermarkSwitch"
            :watermarkTimeOrPosition="propertyData.watermarkTimeOrPosition" @update:watermarkTimeOrPosition="
              (val) => (propertyData.watermarkTimeOrPosition = val)
            ">
          </WaterMarkSwitch>
          <!-- 上传方式选择 -->
          <UploadSourceSelector v-if="commType == 5 || commType == 35" v-model="propertyData.uploadImageType">
          </UploadSourceSelector>
          <div class="tips-block" v-if="commType == 5 || commType == 35">
            <div class="tip-title">
              <span class="font-weight600">是否允许用户自助批注</span>
              <el-switch v-model="propertyData.annotationPermission" active-color="#1877FF"
                inactive-color="rgb(230, 230, 230)" active-value="1" inactive-value="2"></el-switch>
            </div>
          </div>
        </div>
        <div class="flex-depart-center-end b-marT-10 drawBottomBtn" style="position: static">
          <el-button @click="propertySetShow = false">取消</el-button>
          <el-button type="primary" @click="propertySet">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!-- 设置选项不可选时间弹窗 -->
    <el-dialog :visible.sync="optionTimeSetShow" width="450px" :show-close="false" :before-close="handleOptionTimeClose"
      custom-class="option-time-set-dialog">
      <template slot="title">
        <CustomDialogHeader title="设置选项截止时间" @close="handleOptionTimeClose" />
      </template>
      <div class="option-time-set-box">
        <div class="option-time-header">
          <span class="header-title">已有选项</span>
          <span class="header-title">截止时间</span>
        </div>
        <div class="option-item" v-for="(option, idx) in currentFieldItem?.content || []" :key="idx">
          <div class="option-name">
            <span class="option-index">{{ idx + 1 }}</span>
            <span class="option-text">{{ option.value }}</span>
          </div>
          <div class="option-date">
            <el-date-picker v-model="option.validateDateTo" type="datetime" placeholder="点击选择不可选时间"
              :disabled-date="disabledDate" value-format="yyyy-MM-dd HH:mm:ss" style="width: 100%"
              default-time="00:00:00" :clearable="false"></el-date-picker>
          </div>
        </div>
      </div>
      <div class="option-time-set-footer">
        <el-button type="primary" @click="confirmOptionTimeSet">保存</el-button>
      </div>
    </el-dialog>

    <!-- 地图 -->
    <el-dialog width="600px" :visible.sync="addressDialog" :destroy-on-close="true" top :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="请选择地址" @close="addressDialog = false" />
      </template>
      <iframe id="mapPage2" width="100%" height="100%" style="width: 550px; height: 500px" frameborder="0"
        src="https://apis.map.qq.com/tools/locpicker?search=1&type=1&key=NBJBZ-IMQLX-TPL4O-7KADZ-F6HMT-V3BPM&referer=myapp"></iframe>
      <span slot="footer">
        <el-button @click="addressDialog = false">取 消</el-button>
        <el-button type="primary" @click="submitMap">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog width="600px" :visible.sync="musicDialog" :destroy-on-close="true" center :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="音乐" @close="musicDialog = false" />
      </template>
      <audio controls :src="musicLink" type="audio/mp3"></audio>
    </el-dialog>
    <el-dialog title="背景音乐" :visible.sync="bgMusicDialog" width="420px" center :destroy-on-close="true"
      @close="pauseBgMusic">
      <div class="bg-music-list" v-loading="bgMusicLoading">
        <div class="bg-music-item">
          <span class="bg-music-name">无音乐</span>
          <div class="bg-music-ops">
            <el-button size="mini" class="bg-use-btn" :class="{ used: activityDetail.backgroundMusicUrl === '' }"
              @click="useBgMusic(null)">{{
                activityDetail.backgroundMusicUrl === "" ? "使用中" : "使用"
              }}</el-button>
          </div>
        </div>
        <div class="bg-music-item" v-for="item in bgMusicList" :key="item.id">
          <span class="bg-music-name">{{ item.name }}</span>
          <div class="bg-music-ops">
            <span class="bg-preview" :class="{ playing: bgMusicPlayingId === item.id }" @click="toggleBgMusic(item)">
              <img class="bg-audio-icon" :src="bgMusicPlayingId === item.id
                ? bgMusicPauseIcon
                : bgMusicPlayIcon
                " alt="" />
              {{ bgMusicPlayingId === item.id ? "暂停" : "试听" }}
            </span>
            <el-button size="mini" class="bg-use-btn" :class="{ used: activityDetail.backgroundMusicUrl === item.url }"
              @click="useBgMusic(item)">{{
                activityDetail.backgroundMusicUrl === item.url
                  ? "使用中"
                  : "使用"
              }}</el-button>
          </div>
        </div>
      </div>
    </el-dialog>

    <!--        批量添加选项-->

    <el-dialog :visible.sync="batchOptionShow" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="批量添加选项" @close="batchOptionShow = false" />
      </template>
      <el-input type="textarea" :rows="8" placeholder="添加选项，一行一个。" maxlength="500" v-model="lineCopywriting"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchOptionShow = false">取 消</el-button>
        <el-button type="primary" @click="addLineBreak">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 签退：自定义在场时长输入弹窗 -->
    <el-dialog :visible.sync="attendanceDurationDialogVisible" width="400px" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="请输入在场时长（分钟）" @close="cancelAttendanceDurationDialog" />
      </template>
      <el-input v-model="attendanceDurationInput" placeholder="请输入在场时长（分钟）" maxlength="10"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelAttendanceDurationDialog">取 消</el-button>
        <el-button type="primary" @click="confirmAttendanceDurationDialog">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 模块内容未填写提示弹窗 -->
    <el-dialog :visible.sync="incompleteContentDialog" width="400px" center :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="提示" @close="incompleteContentDialog = false" />
      </template>
      <div style="text-align: center">
        <p style="font-size: 14px; color: #333">
          您添加的模块中有未添加的内容，是否发布？
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="incompleteContentDialog = false" style="width: 120px">我再看看</el-button>
        <el-button type="primary" @click="confirmPublish" style="width: 120px">立即发布</el-button>
      </span>
    </el-dialog>

    <!--名单类型-->
    <el-dialog :visible.sync="nameAddOptionsShow" width="30%" class="no-padding-top" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="名单类型选择" @close="nameAddOptionsShow = false" />
      </template>
      <div>
        <el-radio-group v-model="nameOrGroup">
          <el-radio :label="0">不启用</el-radio>
          <el-radio :label="1">添加人员名单</el-radio>
          <el-radio :label="2">添加分组 + 人员名单</el-radio>
        </el-radio-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="nameAddOptionsShow = false">取 消</el-button>
        <el-button type="primary" @click="nameAddChange">确 定</el-button>
      </span>
    </el-dialog>

    <!--分组弹框-->
    <el-drawer :visible.sync="subsetShow" :direction="direction" size="450px" :withHeader="false"
      :before-close="subsetDrawerClose">
      <div class="drawerOutBox fzNameDrawer">
        <div class="drawer-nav-top">
          <div></div>
          <span>设置分组</span>
          <!-- <i class="el-icon-close" @click="subsetDrawerClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="subsetDrawerClose" />
        </div>
        <div class="underline"></div>
        <div>
          <div class="flex-depart-center subset-item" v-for="(item, index) in subsetCenterValueArr" :key="index">
            <div class="flex-depart-left-center sub-left">
              <img :src="subtractFzImgSrc" @click="subtractFzItem(index)" />
              <div class="flex-depart-left-center">
                <div class="cl-name">
                  {{
                    item.listGroupName
                      ? item.listGroupName
                      : ` 分组${index + 1}`
                  }}
                </div>
              </div>
            </div>
            <!--                        <img class="sub-edit" :src="editImgSrc" @click="editFzItem(index,item)">-->
            <div @click="editFzItem(index, item)" v-if="item.clockInList == ''">
              <span class="szfz">设置名单</span>
              <i class="el-icon-arrow-right" style="color: #1877ff"></i>
            </div>
            <div @click="editFzItem(index, item)" v-else>
              <span class="clockNum">{{ item.clockInListNum }}个</span>,<span class="szfz">查看/修改</span>
              <i class="el-icon-arrow-right" style="color: #1877ff"></i>
            </div>
          </div>
          <div class="flex-depart-center subset-item add-sub">
            <div class="flex-depart-left-center sub-left" @click="addFzItem">
              <img :src="addFzImgSrc" />
              <div>添加分组</div>
            </div>
          </div>
        </div>

        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="popupSaveFzFn(0)">取消</el-button>
          <el-button type="primary" @click="popupSaveFzFn(1)">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--编辑分组-->
    <el-drawer :visible.sync="handleSubShow" :direction="direction" size="450px" :withHeader="false"
      :before-close="handleSubDrawerClose">
      <div class="drawerOutBox fzNameDrawer">
        <div class="drawer-nav-top">
          <div></div>
          <span>设置分组名单</span>
          <!-- <i class="el-icon-close" @click="handleSubDrawerClose"></i> -->
          <img src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png" class="close-btn"
            @click="handleSubDrawerClose" />
        </div>
        <div class="underline"></div>

        <div class="setFz-main">
          <div class="ssfz flex-depart-center">
            <!-- <span>所属分组</span> -->
            <div style="width: 100%">
              <el-input v-model="fzTitle" placeholder="请输入分组名称"></el-input>
            </div>
          </div>
          <div style="color: #a5a4a4; font-size: 12px; margin: 10px 0">
            注：每个名单可用逗号，换行隔开，最大可添加 2000 个名单
          </div>
          <div style="position: relative">
            <el-input type="textarea" :rows="15" placeholder="请输入姓名名单" maxlength="-1" @input="handlerBlurFz($event)"
              v-model="fzValue"></el-input>

            <div class="clockNameNumberSwitchDiv">
              <div class="flex-depart-center" style="flex-wrap: wrap">
                <el-switch v-model="clockNameNumberSwitch" @change="clockNameNumberSwitchChange($event)"
                  active-color="#1877FF" inactive-color="rgb(230, 230, 230)" active-value="1"
                  inactive-value="2"></el-switch>
                <div style="margin-left: 6px">添加编号/学号</div>
                <el-checkbox v-model="nameSortSwitch" @change="nameSortSwitchChangeFn"
                  style="margin-left: 16px">按拼音排序</el-checkbox>
              </div>

              <div>
                合计：<span class="total-count">{{ people_num2 }}</span>人
              </div>
            </div>
          </div>

          <div class="import-box flex-depart-center">
            <div class="flex-depart-center">
              <div class="blueTxt" @click="importVisible = true">
                从Excel导入
              </div>
              <div class="empty flex-depart-center" @click="emptyFn">
                <i class="el-icon-delete"></i>
                清空内容
              </div>
            </div>
            <div class="flex-depart-center" @click="
              fzPreviewShow = true;
            openNamelistFun();
            " style="cursor: pointer; color: #1877ff">
              <img src="http://jisuzhizuo.oss-cn-huhehaote.aliyuncs.com/12jielong/lsyJL/yucunmingdan.svg"
                style="margin-right: 5px" />
              预存名单
            </div>
          </div>
        </div>

        <div v-if="fzPreviewShow && onlyGroupArr.length > 0">
          <div class="preview-title">预览（仅展示四排）</div>
          <div class="jl-box" :style="{ paddingBottom: '0' }" style="
              margin-bottom: 0 !important;
              margin-top: 0;
              background-color: transparent !important;
            ">
            <div class="jlName" style="padding: 0 !important">
              <div class="listName newSpanWidth">
                <div class="spanDiv" v-for="(item, index) in sortedOnlyGroupArr.slice(0, 24)" :key="index" :style="{
                  lineHeight:
                    activityDetail.clockNameNumberSwitch == 1 ? '' : '48px',
                }">
                  <span v-if="activityDetail.clockNameNumberSwitch == 1">{{
                    index + 1
                  }}</span>
                  {{ item.length > 4 ? item.substring(0, 4) + "..." : item }}
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="flex-depart-center-end b-marT-10 drawBottomBtn">
          <el-button @click="addOrEditFz(0)">取消</el-button>
          <el-button type="primary" @click="addOrEditFz(1)">确定</el-button>
        </div>
      </div>
    </el-drawer>

    <!--弹框-补卡次数-->
    <el-dialog :visible.sync="disbandBox" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="请输入补卡次数" @close="disbandBox = false" />
      </template>
      <el-input type="text" placeholder="请输入补卡次数" maxlength="500" v-model="clockSupplyCenterText"
        @input="handleClockSupplyCenterTextInput"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="disbandBox = false">取 消</el-button>
        <el-button type="primary" @click="confirmModal">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog :visible.sync="isDelSignInfoPop" width="30%" :show-close="false" :before-close="handleClose">
      <template slot="title">
        <CustomDialogHeader title="提示" @close="isDelSignInfoPop = false" />
      </template>
      <span>表单项内容已修改，仅此项对应的报名信息将不展示，其余报名信息保持不变，确认执行此操作？</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="isDelSignInfoPop = false">取消</el-button>
        <el-button type="primary" @click="confirmChangeForm">确认</el-button>
      </span>
    </el-dialog>

    <!--      图片剪裁-->
    <el-dialog :visible.sync="dialogVisibleCro" width="600px" append-to-body @close="closeCropper" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="图片剪裁" @close="closeCropper" />
      </template>
      <div class="cropper-content">
        <div class="cropper" style="text-align: center">
          <vueCropper ref="cropper" :img="option.img" :outputSize="option.size" :outputType="option.outputType"
            :info="true" :full="option.full" :canMove="option.canMove" :canMoveBox="option.canMoveBox"
            :original="option.original" :autoCrop="option.autoCrop" :fixed="option.fixed"
            :fixedNumber="option.fixedNumber" :centerBox="option.centerBox" :infoTrue="option.infoTrue"
            :fixedBox="option.fixedBox"></vueCropper>
        </div>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="closeCropper">取 消</el-button>
        <el-button type="primary" @click="finish">确认</el-button>
      </div>
    </el-dialog>
    <!--  演示  -->
    <!-- <el-dialog
      :title="contentList.title"
      :visible.sync="demonVisible"
      width="450px"
      :show-close="false"
    >
      <template slot="title">
        <CustomDialogHeader title="演示" @close="demonVisible = false" />
      </template>
      <div style="max-height: 700px; overflow-y: auto">
        <img class="usePopImg" :src="contentList.imgurl" alt="" />
      </div>
    </el-dialog> -->

    <el-dialog :title="contentList.title" :visible.sync="demonVisible" width="465px" :show-close="false"
      custom-class="dialogClass" class="demo-dialog">
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">{{ contentList.title }}</span>
        <img class="custom-close" src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="demonVisible = false" alt="关闭" title="关闭" />
      </span>
      <div style="max-height: 450px; overflow-y: auto; padding-top: 0">
        <img class="usePopImg" :src="contentList.imgurl" alt="" />
      </div>
    </el-dialog>

    <!-- 封面设置 Drawer -->
    <el-drawer title="封面设置" :visible.sync="coverSettingDrawer" direction="rtl" size="400px"
      :before-close="closeCoverSetting" :destroy-on-close="false">
      <div class="cover-setting-container" style="padding: 0 20px">
        <!-- 系统封面区域 -->
        <div class="cover-section" style="margin-bottom: 0">
          <div class="cover-preview" v-if="customCoverDialog.isVideo == 2">
            <div class="section-header">
              <h4>选择系统封面</h4>
              <el-switch v-model="customCoverDialog.isCoverEnabled" :active-value="1" :inactive-value="2"
                @change="toggleCoverEnabled">
              </el-switch>
            </div>
            <div v-if="customCoverDialog.isCoverEnabled === 1" class="cover-placeholder">
              <img v-if="
                customCoverDialog.isVideo === 2 &&
                customCoverDialog.activityModeUrl
              " :src="customCoverDialog.activityModeUrl" alt="封面图" style="width: 100%; object-fit: cover" />
              <!-- <div class="placeholder-text">封面图</div> -->
            </div>
            <div v-if="
              customCoverDialog.isCoverEnabled === 1 &&
              customCoverDialog.isVideo == 2
            " class="cover-btn-center">
              <el-button type="primary" @click="selectSystemCover" style="margin-top: 10px">
                更换封面
              </el-button>
            </div>
          </div>
        </div>

        <div v-if="customCoverDialog.isVideo === 1" class="video-container">
          <video controls width="340" height="240">
            <source :src="customCoverDialog.playUrl" type="video/mp4" />
            Sorry, your browser doesn't support embedded videos.
          </video>
          <div class="delete-btn" @click="deleteVideo">
            <i class="el-icon-close"></i>
          </div>
        </div>
        <!-- 自定义封面区域 -->
        <div class="cover-section">
          <div class="cover-tips" v-if="customCoverDialog.isVideo == 2">
            *尺寸比例: 宽5:高4,建议宽度1500px,高度1200px。
          </div>
          <div class="custom-covers" v-if="customCoverDialog.isVideo == 2">
            <!-- {{customCoverDialog.subCoverImages.length}} -->
            <div v-for="(image, index) in customCoverDialog.subCoverImages" :key="index" class="custom-cover-item"
              @click="selectCustomCover(image)">
              <img :src="image" alt="" class="cover-thumbnail" />
              <div class="delete-btn" @click.stop="deleteCoverImage(index)">
                <i class="el-icon-close"></i>
              </div>
              <div class="select-overlay" v-if="customCoverDialog.activityModeUrl === image">
                <i class="el-icon-check"></i>
              </div>
            </div>
          </div>
          <div class="upload-tips" v-if="customCoverDialog.isVideo == 2">
            *最多可上传{{ customCoverDialog.maxCoverImages }}张自定义封面图片
          </div>
          <div class="upload-tips" v-if="customCoverDialog.isVideo == 1">
            该封面已包含视频，不可再上传图片轮播。如需修改为图片轮播，请删除视频。
          </div>
          <div class="upload-buttons" v-if="customCoverDialog.isVideo == 2">
            <el-button type="primary" icon="el-icon-plus" :disabled="customCoverDialog.subCoverImages.length >=
              customCoverDialog.maxCoverImages
              ">
              <input type="file" accept="image/*" multiple @change="handleCoverImageUpload" :disabled="customCoverDialog.subCoverImages.length >=
                customCoverDialog.maxCoverImages
                " style="
                  position: absolute;
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                " />
              上传自定义图片
            </el-button>

            <el-button type="primary" icon="el-icon-video-camera">
              <input type="file" accept=".mp4" @change="handleCoverVideoUpload" style="
                  position: absolute;
                  opacity: 0;
                  width: 100%;
                  height: 100%;
                  cursor: pointer;
                " />
              上传自定义视频
            </el-button>
          </div>
        </div>
        <!-- 保存按钮 -->
        <div style="height: 90px; position: absolute; bottom: 0; left: 0; right: 0">
          <div class="save-section">
            <el-button type="primary" @click="saveCoverSetting" style="width: 100%">
              保存
            </el-button>
          </div>
        </div>
      </div>
    </el-drawer>
    <el-dialog :visible.sync="catchBatchSetNumShowBox" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="批量添加选项" @close="catchBatchSetNumShowBox = false" />
      </template>
      <el-input type="number" placeholder="请输入数量" maxlength="10" v-model="batch_set_num"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="catchBatchSetNumShowBox = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchSetNum">确 定</el-button>
      </span>
    </el-dialog>

    <!-- 批量添加预约项 -->
    <el-dialog :visible.sync="batchAppointmentVisible" width="30%" :show-close="false">
      <template slot="title">
        <CustomDialogHeader title="批量添加预约项" @close="batchAppointmentVisible = false" />
      </template>
      <el-input type="textarea" :rows="6" maxlength="500" placeholder="添加预约项，一行一个。"
        v-model="batchAppointmentText"></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="batchAppointmentVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirmBatchAppointment">确 定</el-button>
      </span>
    </el-dialog>
    <!-- 预约时间设置弹层 -->
    <AppointmentTimeDialog :visible.sync="appointmentTimeVisible" :option-data="currentAppointmentOption"
      @save="handleAppointmentTimeSave" />

    <!-- 文件签字 -->
    <siginFile ref="siginFileRef" @closeHandler="closeHandler" @saveHandler="saveHandler"></siginFile>

    <!-- 设置逻辑弹层 -->
    <SetLogicDialog :visible.sync="setLogicDialogVisible" :field-data="currentEditFieldData"
      :field-index="currentLogicFieldIndex" :list-index="currentLogicListIndex" :all-sign-fields="allSignFieldsData"
      @save="handleSetLogicSave" />

    <!-- 身份认证小程序码 -->
    <el-dialog :visible.sync="authCodeDialogVisible" width="400px" :show-close="false" center
      custom-class="dialogClass">
      <span slot="title" class="dialog-title">
        <span class="dialog-title-text">身份认证</span>
        <img class="custom-close" src="https://ossfytp.mustke.com/image/newStyleImages/pop-guanbi22.png"
          @click="authCodeDialogVisible = false" alt="关闭" title="关闭" />
      </span>
      <div style="text-align: center; padding: 20px">
        <el-image :src="authCodeUrl" style="width: 200px; height: 200px"></el-image>
        <p style="margin-top: 15px; font-size: 14px; color: #666">
          请使用微信扫码完成身份认证
        </p>
      </div>
    </el-dialog>

    <!-- 参与数据同步至投票管家弹窗 -->
    <el-dialog custom-class="dialogClass" :visible.sync="voteSyncDialogVisible" width="455px" center
      :show-close="false">
      <template slot="title">
        <CustomDialogHeader :title="'参与数据同步至投票管家'" @close="voteSyncDialogVisible = false" />
      </template>
      <div style="
          text-align: center;

          padding-top: 0px;
          padding-bottom: 30px;
        ">
        <div>
          <el-image :src="voteSyncCodeUrl" class="code-image"></el-image>
        </div>
        <div>请扫码去小程序操作</div>
      </div>
    </el-dialog>

    <!-- 返利模式说明弹窗 -->
    <el-dialog :visible.sync="rebateModeDialogVisible" width="400px" :show-close="false" center
      custom-class="rebate-mode-dialog">
      <template slot="title">
        <CustomDialogHeader :title="'返利模式说明'" @close="rebateModeDialogVisible = false" />
      </template>
      <div>
        <div style="font-size: 16px; line-height: 1.8">
          <p style="margin-bottom: 15px">
            <span style="color: #1877ff; font-weight: bold">分享返利</span>
            <span style="color: #666">
              ，不购买分享后有人购买即可获得返利
            </span>
          </p>
          <p style="margin-bottom: 20px">
            <span style="color: #1877ff; font-weight: bold">参与返利</span>
            <span style="color: #666"> ，必须购买后分享才可获得返利 </span>
          </p>
        </div>
        <div style="text-align: center; margin-top: 20px">
          <el-button type="primary" round style="
              width: 200px;
              background-color: #1877ff;
              border-color: #1877ff;
            " @click="rebateModeDialogVisible = false">我知道了</el-button>
        </div>
      </div>
    </el-dialog>
    <NoticeConfigDialog :visible.sync="noticeDialogVisible" :config="noticeConfig" @save="handleNoticeConfigSave" />
    <PayImagePicker :visible="payPickerVisible" :currentImage="fmActivityChargeItemVOS[payPickerIndex]?.showImg || ''"
      @confirm="handlePayImageConfirm" @customUpload="handlePayImageCustomUpload" @close="payPickerVisible = false" />
  </Layout>
</template>
<style lang="scss" scoped>
// 统一开关样式：开启 #1877ff，关闭浅灰底+白圆点，保证关闭状态也能看出是开关
::v-deep .el-switch {
  transform: scale(1.25);
}

::v-deep .el-switch.is-checked .el-switch__core {
  background-color: #1877ff !important;
  border-color: #1877ff !important;
}

::v-deep .el-switch:not(.is-checked) .el-switch__core {
  background-color: #dcdfe6 !important;
  border-color: #dcdfe6 !important;
}

.option-time-set-dialog {
  padding: 10px;
}

.dialogClass {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}

//.demo-dialog {
//  ::v-deep .el-dialog--center .el-dialog__body {
//    max-height: 500px;
//    overflow: auto;
//  }
//}
.dialog-title {
  position: relative;
  display: block;
  width: 100%;
  text-align: center;
  border-bottom: 1px solid #f8f8f8;
}

.dialog-title-text {
  font-weight: bold;
  display: inline-block;
  font-size: 20px;
  color: black;
}

.custom-close {
  width: 22px;
  height: 22px;
  cursor: pointer;
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
}

/* 自定义对话框头部样式 */
.custom-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 10px 0;

  .title-text {
    font-size: 16px;
    font-weight: 600;
    color: #303133;
    position: relative;
  }

  .title-underline {
    position: absolute;
    bottom: -5px;
    left: -20px;
    right: -20px;
    height: 1px;
    background: #e7e7e7;
    border-radius: 1px;
  }
}

.select-count {
  color: var(--el-text-color-primary);
  text-align: center;
  max-height: 200px;
  overflow-y: auto;

  .select-count-item {
    user-select: none;
    padding: 5px;
    padding-left: 0;
    color: #999;

    &:hover {
      color: #409eff;
      opacity: 0.8;
      cursor: pointer;
      background-color: #f5f5f5;
    }
  }

  .active {
    color: #409eff;
    cursor: pointer;
    background-color: #f5f5f5;
  }

  &::-webkit-scrollbar {
    width: 8px;
    /* 垂直滚动条宽度 */
    height: 8px;
    /* 水平滚动条高度 */
  }

  /* 滚动条轨道（背景） */
  &::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
  }

  /* 滚动条滑块 */
  &::-webkit-scrollbar-thumb {
    background: #888;
    border-radius: 4px;
  }

  /* 鼠标悬停时滑块效果 */
  &::-webkit-scrollbar-thumb:hover {
    background: #555;
  }
}

/* 选项行：名称 + 数量 同行显示 */
.opt-row {
  display: flex;
  gap: 8px;
  align-items: center;
}

.opt-row .opt-name {
  flex: 1 1 auto;
}

.opt-row .opt-num {
  flex: 0 0 100px;
}

/* 选项截止时间样式 */
.opt-deadline-row {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.deadline-link {
  font-size: 12px;
  color: #1877ff;
  cursor: pointer;
}

.deadline-link:hover {
  text-decoration: underline;
}

.hidden-date-picker {
  width: 0;
  height: 0;
  opacity: 0;
  position: absolute;
  pointer-events: none;
}

/* 时间选择行：右侧蓝色状态文字 + 箭头，点击展开勾选框+时间框 */
.timeSelectRow {
  cursor: pointer;
}

/* 展开时去掉标题行底边线，改由展开区收口，标题与控件视觉上是一个整体 */
.timeSelectRow.tsRowOpen {
  border-bottom: none;
}

.timeSelectValue {
  display: flex;
  align-items: center;
}

.tsValue {
  font-size: 14px;
  color: #1877ff;
}

.tsArrow {
  display: inline-block;
  font-size: 14px;
  color: #c0c4cc;
  margin-left: 6px;
  transition: transform 0.2s ease;
}

.tsArrowOpen {
  transform: rotate(90deg);
}

.tsExpandRow {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 10px 15px 12px 15px;
  background-color: white;
  border-bottom: 1px solid #f2f2f2;
}

/* Bootstrap 给 label 加的 margin-bottom 会让复选框相对时间框偏高，置零以居中对齐 */
.tsExpandRow .el-checkbox {
  margin-bottom: 0;
}

.tsExpandPicker {
  margin-left: 10px;
}

.deadline-text {
  font-size: 12px;
  color: #666;
}

.clear-deadline-btn {
  color: #f56c6c;
  font-size: 12px;
  padding: 0;
}

.clear-deadline-btn:hover {
  color: #f78989;
}

/* 多选/单选选项：按比例分配宽度 */
.selectBox-item {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selectBox-item .opt-name-input {
  width: 70% !important;
}

.selectBox-item .opt-num-input {
  width: 30% !important;
}

.selectBox-item .selectBox-item-index {
  width: 40px;
}

/* 预约项：序号/输入框/删除图标同一行垂直居中并占满整行宽度，“设置预约时间”另起一行与输入框左对齐 */
.selectBox-item.appointment-item {
  display: flex;
  flex-direction: column;
  align-items: stretch;
}

.selectBox-item.appointment-item .appointment-line {
  display: flex;
  align-items: center;
  gap: 8px;
}

.selectBox-item.appointment-item .appointment-line .opt-name-input {
  flex: 1;
  width: auto !important;
}

.selectBox-item.appointment-item .appointment-time-row {
  margin-left: 48px;
  margin-top: 6px;
}

.selectBox-item.appointment-item .opt-time-link {
  text-align: left;
}

.w-50 {
  width: 50px;
  margin-left: auto;
}

.b-marT-10 {
  margin-top: 10px;
}

.b-marT-20 {
  margin-top: 20px;
}

/* flex布局 */
.flex-depart-left {
  display: flex;
  align-items: center;
}

.flex-depart-center {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.flex-depart-center-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

.flex-depart-center-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.flex-depart-top {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
}

.flex-depart-left-warp {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.flex-depart-center-top {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.flex-depart-left-center {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

/*大图排序*/
.flex-depart-column-top-left {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
}

.add-tools {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 16px;
  color: #1877ff;
  margin-left: 8px;
  cursor: pointer;

  .add-tools-item {
    display: flex;
    align-items: center;
  }

  .add-tools-item-text {
    margin-left: 5px;
  }
}

.name-flex {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;

  .el-dropdown-link {
    cursor: pointer;
    color: #409eff;
  }

  .flex-left {
    display: flex;
    align-items: center;
  }

  .flex-right {
    display: flex;
    align-items: center;
  }

  .flex-dropdown {
    margin-left: 10px;
  }
}

.yanshiBtn {
  width: 60px;
  height: 15px;
}

.clockNameNumberSwitchDiv {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 10px;
}

.name-row-num {
  position: relative;
}

.nr-pos-abs {
  position: absolute;
  right: 20px;
  top: 0;
  width: 200px;
}

.outBox {
  width: 680px;
  margin: 0 auto;
  background-color: #fbfbfb;
}

.bigTitle {
  width: 100%;
  height: 50px;
  line-height: 50px;
  text-align: center;
  color: #367ce0;
  /*font-weight: bold;*/
  background-color: #fbfbfb;
}

.block-title {
  font-size: 16px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
}

.blockBox {
  padding: 15px;
  background-color: white;
  margin-bottom: 10px;
  position: relative;
}

.cannot-edit {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 99;
  height: 100%;
  width: 100%;
}

.handle-box {
  display: inline-block;
}

.handle-box .h-item {
  margin-right: 30px;
  cursor: pointer;
  display: inline-block;
  float: left;
  margin-top: 8px;
}

.handle-box .h-item img {
  width: 20px;
  height: 20px;
  margin-right: 1px;
}

.handle-box .h-item span {
  font-size: 14px;
  color: #767d98;
  cursor: pointer;

  &:hover {
    color: #1877ff;
    /* 鼠标悬浮时的字体颜色 */
  }
}

.rangeTimes {
  margin-bottom: 10px;
}

.addBtnStyle {
  width: 200px;
  height: 40px;
  background: #ffffff;
  border: 1px dashed #4a73f7;
  border-radius: 23px;
  font-size: 14px;
  color: #1877ff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  font-weight: bold;

  i {
    margin-right: 10px;
  }
}

.f-block {
  background: #fafafa;
  border-radius: 2px;
  box-sizing: border-box;
  /*padding: 10px;*/
  margin-top: 10px;
  overflow: hidden;
}

.f-block:last-child {
  /*margin-bottom: 0;*/
}

.tl-item .f-ipt {
  width: 490px;
}

.f-handle img {
  width: 20px;
  height: 20px;
  margin-left: 5px;
  cursor: pointer;
}

.checkedState .el-checkbox {
  margin-bottom: 0;
}

.ch-copy {
  margin-left: 50px;
  font-size: 13px;
  color: #409eff;
  align-items: center;
  cursor: pointer;

  i {
    /*width: 17px;*/
    /*height: 17px;*/
    margin-right: 4px;
  }
}

.selectBox-item {
  padding-left: 20px;
}

.selectBox-item .el-input {
  width: 500px;
  margin-right: 10px;
}

.selectBox-item i {
  font-size: 18px;
}

.addOptStyle {
  color: #1877ff;
  cursor: pointer;
  text-align: center;
}

.settingBox {
  padding: 10px 15px;
  background-color: white;
  position: relative;
  border-bottom: 1px solid #f2f2f2;
}

.sTitle {
  font-size: 14px;
  font-weight: Bold;
  text-align: left;
  color: #191919;
  display: inline-flex;
  align-items: center;

  label {
    font-size: 12px;
    color: grey;
    font-weight: normal;
  }

  b {
    width: 4px;
    height: 14px;
    background: #1877ff;
    border-radius: 2px;
    margin-right: 5px;
  }
}

.s-right {
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
}

.fs16 {
  font-size: 16px;
}

.settingBox .el-date-editor .el-range-separator {
  width: 15%;
}

::v-deep .el-range-separator {
  width: 12%;
}

.setText {
  color: #1877ff;
  cursor: pointer;
  text-decoration: underline;
}

.bg-music-list {
  padding: 0 4px;
}

.bg-music-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 6px;
  border-bottom: 1px solid #f2f2f2;
}

.bg-music-name {
  flex: 1;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding-right: 8px;
  font-size: 14px;
  color: #333;
}

.bg-music-ops {
  display: flex;
  align-items: center;
  flex-shrink: 0;

  .bg-preview {
    display: inline-flex;
    align-items: center;
    line-height: 1;
    cursor: pointer;
    font-size: 14px;
    color: #1877ff;
    margin-right: 12px;
    user-select: none;
    padding: 2px 8px;
    border: 1px solid #1877ff;
    border-radius: 4px;

    .bg-audio-icon {
      display: block;
      width: 18px;
      height: 18px;
      margin-right: 4px;
    }

    &.playing {
      color: #ff4d4f;
      border-color: #ff4d4f;
    }
  }

  ::v-deep .bg-use-btn {
    width: 64px;
    padding: 7px 0;
    color: #fff;
    background-color: #1877ff;
    border-color: #1877ff;

    &.used {
      background-color: #52c41a;
      border-color: #52c41a;
    }

    &:hover,
    &:focus {
      color: #fff;
      background-color: #1877ff;
      border-color: #1877ff;
    }

    &.used:hover,
    &.used:focus {
      background-color: #52c41a;
      border-color: #52c41a;
    }
  }
}

.unLine {
  text-decoration: none !important;
}

.settingBox .el-radio {
  margin-bottom: 0;
}

.set-out-box .b-marT-10 {
  margin-top: 0;
}

.block-for-box {
  -webkit-appearance: none;
  background-color: #fcfcfc;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  width: 100%;
  padding: 10px;
  margin-top: 10px;
}

.big-img img {
  max-width: 600px;
  height: auto;
}

.b-handle img {
  width: 20px;
  height: 20px;
  margin: 5px;
  cursor: pointer;
}

.addSmallBtn {
  width: 100%;
  height: 45px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #f7f7f7;
  color: #1877ff;
  border-radius: 4px;
  position: relative;
  cursor: pointer;
}

.updateFileBtn {
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  opacity: 0;
  cursor: pointer;
}

.el-dropdown-menu__item {
  position: relative;
}

.rangeTimes i {
  margin-left: 5px;
  font-size: 25px;
  cursor: pointer;
  color: #f56c6c;
}

.add-rangeTimes {
  color: #1877ff;
  cursor: pointer;
}

.map {
  width: 100%;
  height: 300px;
}

.deadline {
  width: 80px;
  margin-left: 5px;
}

.sw80 .el-select {
  width: 80px !important;
}

.smallImgbox {
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  margin: 5px;
  position: relative;
}

.handle2 {
  width: 150px;
  height: 150px;
  position: absolute;
  left: 0;
  top: 0;
  background: rgba(0, 0, 0, 0.5);
  display: none;

  img {
    width: 20px;
    height: auto;
    cursor: pointer;
    margin-top: 70px;
    margin-left: 33px;
  }
}

.seeBigImgHover:hover {
  .handle2 {
    display: block;
  }
}

.imgBg {
  width: 150px;
  height: 150px;
  /*background: url("https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg") no-repeat center;*/
  background-size: cover;
  border-radius: 5px;
}

.upl-smallImg {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 150px;
  background-color: #f7f7f7;
  color: #1877ff;
  cursor: pointer;
  margin: 5px;
  position: relative;
  border-radius: 5px;

  i {
    font-size: 26px;
  }
}

.upl-smallImg2 {
  width: 100%;
  height: 200px;
  margin: 0;
  box-sizing: border-box;
  border: 1px dashed #1877ff;
}

.filesStyle {
  height: 45px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 15px;

  .tubiao {
    margin-right: 2px;
  }

  .del {
    margin-left: 10px;
    position: relative;
    top: 1px;
    cursor: pointer;
  }

  img {
    width: 20px;
    height: 20px;
    margin-right: 5px;
  }
}

.previewImgBox {
  width: 100%;
  height: 100%;
  z-index: 99999;
  background-color: rgba(0, 0, 0, 0.5);
  position: fixed;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;

  .inner-p-img {
    height: 600px;
    width: auto;
  }

  .closePImg {
    font-size: 40px;
    cursor: pointer;
    position: fixed;
    top: 40px;
    right: 40px;
    color: white;
  }
}

.drawerOutBox {
  padding: 0 20px;
  height: 100%;
  position: relative;
  background: #f8f8f8;
}

.drawBottomBtn {
  width: 100%;
  height: 70px;
  position: absolute;
  left: 0;
  bottom: 0;
  box-sizing: border-box;
  padding-right: 20px;
}

.af-title {
  font-weight: bold;
  margin-top: 10px;
}

.ty-b-item {
  position: relative;
  width: 195px;
  height: 80px;
  border: 1px solid #b2c4fb;
  background-color: #f4f7fe;
  border-radius: 5px;
  box-sizing: border-box;
  padding-top: 18px;
  padding-left: 10px;
  cursor: pointer;
}

.ty-b-item div {
  font-weight: bold;
  color: #1877ff;
  margin-bottom: 10px;
}

.addFBtn {
  color: #1877ff;
  font-size: 22px;
  position: absolute;
  right: 10px;
  top: 18px;
}

.cy-box {
  display: flex;
  display: -webkit-flex;
  justify-content: space-between;
  flex-direction: row;
  flex-wrap: wrap;
}

.cy-item {
  width: 128px;
  height: 45px;
  box-sizing: border-box;
  padding: 0 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: #f4f7fe;
  border-radius: 5px;
  margin-bottom: 5px;
  cursor: pointer;

  .addFBtn2 {
    color: #1877ff;
    font-size: 22px;
  }
}

.seniorStyle {
  background-color: #ecf4ff !important;
  cursor: pointer;
}

.cus-dates {
  margin-bottom: 0 !important;
  margin-left: 5px;
}

.nl-title {
  font-weight: bold;
  margin-top: 10px;

  span {
    font-size: 12px;
    font-weight: normal;
    color: grey;
  }
}

.daoru {
  color: #1877ff;
  cursor: pointer;
  position: relative;
  text-decoration: underline;
}

.qingkong {
  cursor: pointer;
  color: red;
}

.ycn {
  width: 100%;
  padding: 10px;
  border-radius: 4px;
  box-sizing: border-box;
  background-color: #fbfbfb;
  border: 1px solid #d4d4d4;

  .n-name {
    width: 50%;
    word-break: break-word;
  }

  .n-handle {
    span {
      color: #1877ff;
      margin-left: 10px;
      cursor: pointer;
    }
  }
}

.duiHao {
  text-align: center;
  margin-top: 10px;

  img {
    height: 80px;
    width: 80px;
  }
}

.updateFileBtn-out {
  position: relative;
}

.copy-image-out {
  position: relative;
}

.del-copy-img {
  width: 30px;
  height: 30px;
  cursor: pointer;
  position: absolute;
  top: 10px;
  right: 10px;
}

.copy-image {
  width: 100%;
  height: auto;
}

.posi-bottom-btn-box {
  position: fixed;
  left: 130px;
  right: 0;
  bottom: 0px; // 修改为 0，让按钮固定在视口底部
  height: 74px;
  z-index: 999;
  transition: bottom 0.2s ease; // 添加过渡效果，让按钮移动更平滑
  //background: #fff;
}

.saveDatabox {
  width: 300px;
  height: 45px;
  background: #1877ff;
  border-radius: 25px;
  font-size: 16px;
  font-weight: Bold;
  color: #ffffff;
  cursor: pointer;
  border: 2px solid #1877ff;
}

.yl {
  width: 160px;
  height: 45px;
  background: #fff;
  border-radius: 25px;
  font-size: 16px;
  font-weight: Bold;
  color: #1877ff;
  border: 1px solid #1877ff;
  cursor: pointer;
  margin-right: 10px;
}

.s-name-item {
  width: 105px;
  height: 45px;
  background: #f2f2f2;
  border-radius: 4px;
  display: inline-block;
  text-align: center;
  line-height: 45px;
  margin-right: 10px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
}

.set-out-box {
  position: relative;
  height: auto;
}

.centerTitle input {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;
  color: #333333;
  display: inline-block;
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px;
  /*transition: border-color .2s cubic-bezier(.645,.045,.355,1);*/
  width: 100%;
}

.centerTitle input:focus {
  border-color: #409eff;
}

.centerTitle input::-webkit-input-placeholder {
  /* placeholder颜色 */
  color: #c4c4cc;
  /* placeholder字体大小 */
  font-size: 14px;
}

.centerTitle {}

.addnameBtns button {
  width: 45%;
}

.el-divider--horizontal {
  display: block;
  height: 1px;
  width: 100%;
  margin: 5px 0;
}

.hoverColor1:hover {
  background-color: #ecf4ff;
}

.hoverColor1:hover .del {
  color: red;
}

.drawer-nav-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 60px;

  span {
    font-size: 18px;
    color: black;
    font-weight: bold;
  }

  i {
    cursor: pointer;
    font-size: 18px;
  }
}

.underline {
  width: 100%;
  height: 0.5px;
  background: #e7e7e7;
}

.close-btn {
  width: 20px;
  height: 20px;
  cursor: pointer;
}

.danwei {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 4px;
  border: 1px solid #dcdfe6;
  box-sizing: border-box;

  /*display: inline-block;*/
  height: 40px;
  line-height: 40px;
  outline: 0;
  padding: 0 15px 0 0;
  width: 440px;
  overflow: hidden;

  input {
    color: #606266;
    width: 420px;
    height: 38px;
    border: 0;
    outline: none;
    box-sizing: border-box;
    padding-left: 10px;
    /*background-color: red;*/
  }
}

.set-out-box .settingBox:hover {
  background-color: #ecf4ff;
}

.blockBox {}

.settingBox {}

.danwei:hover {
  border: 1px solid #409eff !important;
}

.el-input {}

.bf-item {}

.bf-item {}

.zsy {}

.nozsy {}

.gl-btnStyle {
  width: 100%;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #1877ff;
  background-color: rgba(247, 247, 247, 1);
  cursor: pointer;
}

.gljl-block {
  height: 45px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 4px;
  box-sizing: border-box;
  padding: 0 15px;
}

.gljl-block:hover {
  background-color: #ecf4ff;
}

.gljl-block .del:hover {
  color: red;
}

.cell-box {
  margin-left: 10px;
}

.cell-name {
  margin-bottom: 5px;
  font-weight: bold;
}

.cell-addTime {
  font-size: 12px;
}

.bg-gray {
  background-color: #f5f5f5;
}

.pad-10 {
  padding: 10px;
}

.call-out {
  height: calc(100% - 190px);
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  /* 增加 iOS 滚动支持 */
  padding-bottom: 20px;
  /* 增加底部填充,确保有足够空间触发滚动 */
}

.flex-depart-leftStart {
  display: flex;
  justify-content: flex-start;
}

.inner-main-box {
  width: 97%;
  display: flex;
  flex-direction: column;
  box-sizing: border-box;
  padding: 10px 10px;
}

.add-signfile {
  align-items: center;
  font-size: 14px;
  color: #1877ff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  position: relative;
  margin-top: 10px;
}

.signfile-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: rgba(187, 217, 255, 0.35);
  height: 40px;
  border-radius: 5px;
  padding: 0 10px;
  margin-top: 10px;
  border: 1px solid #abceff;

  .fileName {
    flex: 1;
  }

  .file-action {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;

    &-item {
      cursor: pointer;
      color: #377bff;
      margin-left: 16px;
      font-size: 13px;
    }
  }
}

.left-ttype {
  width: 5%;
  background: #c2dbff;
  font-size: 14px;
  color: #466aa9;
  writing-mode: vertical-rl;
  display: flex;
  justify-content: center;
  align-items: center;
  letter-spacing: 2px;
  border-top-left-radius: 2px;
  border-bottom-left-radius: 2px;
}

.propertySet-box {
  .bx-item {
    width: 49%;
    background-color: white;
    height: 60px;
    box-sizing: border-box;
    padding: 0 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .bx-item .el-checkbox {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-flow: row-reverse;
    margin-bottom: 0;
  }

  .flex-depart-top2 {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .x {
    color: red;
  }

  .title-block {
    background-color: white;
    padding: 10px;
    border-top: 0.5px solid #e5e5e5;
  }

  .tb-left {
    color: #555555;
    font-size: 15px;
    display: flex;
    align-items: center;
  }

  .zz {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 65px;
    border-bottom: 1px solid #eee;
    padding-left: 10px;
    padding-right: 10px;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .zz-picker {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    width: 214px;
    height: 44px;
    background: #f4f4f4;
    border-radius: 5px;

    image {
      width: 20px;
      height: 20px;
    }
  }

  .no-repeat {
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    padding-left: 10px;
    padding-right: 10px;
    height: 80px;
  }

  .wb-setting-block {
    background-color: white;
    margin-top: 10px;
  }

  .no-title {
    font-size: 14px;
    font-weight: bold;
    text-align: left;
    color: #555555;
  }

  .no-tips {
    font-size: 13px;
    text-align: left;
    color: #7c838e;
  }

  .bx-block {
    margin-top: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .tips-block {
    margin-top: 10px;
    background-color: white;
    padding-bottom: 10px;
  }

  .tip-title {
    padding: 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: white;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .tip-t-area {
    margin-top: 10px;
  }

  .up-img-fun {
    margin-top: 7px;
    width: 100px;
    height: 100px;
    background: #f4f4f4;
    border-radius: 5px;
  }

  .footerBtn {
    height: 63px;
    width: 100%;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    position: fixed;
    left: 0;
    bottom: 0;
    z-index: 9999;
    padding-left: 10px;
    padding-right: 10px;
    padding-bottom: calc(-18.5px + env(safe-area-inset-bottom));

    .btn {
      width: 340px;
      height: 40px;
      background-color: #1877ff;
      border-radius: 25px;
      text-align: center;
      line-height: 40px;
      color: white;
      font-size: 16px;
    }
  }

  .files-num {
    background-color: white;
    padding: 15px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-sizing: border-box;
    margin-top: 10px;

    text {
      color: #555555;
      font-size: 15px;
    }
  }

  .radio-block {
    width: 94%;
    margin: 10px auto;
    background-color: white;
    border-radius: 4px;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .rb-item {
    padding-top: 12.5px;
    padding-bottom: 12.5px;
    display: flex;
    justify-content: space-between;
    border-bottom: 0.5px solid #e5e5e5;
  }

  // 截止时间行样式
  .rb-item-time {
    border-bottom: 0.5px solid #e5e5e5;

    .rb-left-time {
      padding-left: 34px;

      .time-label {
        font-size: 13px;
        color: #1877ff;
      }
    }
  }

  .rb-left {
    width: 75%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    view {
      width: 14px;
      height: 14px;
      background: #e2e2e2;
      border: 0.5px solid #cbcbcb;
      border-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #8f8f8f;
      font-size: 12px;
    }

    input {
      width: 88%;
      margin-left: 10px;
    }
  }

  .rb-right {
    width: 25%;
    display: flex;
    justify-content: space-between;
    align-items: center;

    img {
      width: 24px;
      height: 24px;
    }
  }

  // .radio-add {
  //   margin: 0 auto;
  //   padding: 0 10px;
  //   box-sizing: border-box;
  //   display: flex;
  //   justify-content: space-between;
  //   align-items: center;

  //   span {
  //     color: #477aff;
  //     font-size: 14px;
  //     cursor: pointer;
  //   }
  // }
  .radio-add {
    width: calc(100% - 20px);
    margin: 10px auto;
    padding: 0;
    box-sizing: border-box;
    display: flex;
    background-color: white;
    border: 1px solid #477aff;
    border-radius: 6px;
    overflow: hidden;

    span {
      color: #477aff;
      font-size: 14px;
      padding: 10px;
      background-color: white;
      flex: 1;
      text-align: center;
      position: relative;
      border: none;

      &:not(:last-child)::after {
        content: "";
        position: absolute;
        right: 0;
        top: 0;
        width: 1px;
        height: 100%;
        background-color: #477aff;
      }
    }
  }

  .area-block {
    margin-top: 10px;
    background-color: white;
    box-sizing: border-box;
    padding: 0 10px;
  }

  .tt-list {
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 44px;
    border-bottom: 1px solid #e7e7e7;
    font-size: 14px;
    width: 96%;
    margin: 0 auto;

    img {
      width: 16px;
      height: 16px;
      flex-shrink: 0;
    }
  }

  .tt-title {
    font-size: 14px;
    font-weight: bold;
    color: #555555;
    line-height: 45px;
    border-bottom: 1px solid #e7e7e7;
  }

  .position-block {
    margin-top: 5px;
    background-color: white;
    box-sizing: border-box;
    padding: 7.5px 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .position-title {
    display: flex;
    color: #555555;
    font-size: 7.5px;
    align-items: center;

    img {
      width: 7.5px;
      height: 7.5px;
      flex-shrink: 0;
      margin-left: 5px;
    }
  }

  .popComm {
    background-color: white;
    border-radius: 5px;
    width: 160px;
    padding-bottom: 7.5px;
  }

  .close-xsxq {
    position: absolute;
    right: 5px;
    top: 7.5px;

    img {
      height: 10px;
      width: 10px;
    }
  }

  .tishi-title {
    line-height: 25px;
    border-bottom: 0.5px solid #eee;
    font-weight: 600;
    font-size: 8px;
    text-align: center;
    color: #333;
  }

  .center-content {
    width: 92%;
    margin: 5px auto;

    textarea {
      width: 100%;
      height: 125px;
      background: #f4f4f4;
      border: 0.5px solid #dcdde0;
      border-radius: 2px;
      box-sizing: border-box;
      padding: 5px;
    }
  }

  .popComm .btn1 {
    width: 105px;
    height: 20px;
    background: #4a73f8;
    border-radius: 11.25px;
    color: white;
    text-align: center;
    line-height: 20px;
    margin: 0 auto;
  }

  .reject-con {
    width: 160px;
    background: #ffffff;
    border-radius: 4px;
    overflow: hidden;
    position: relative;

    .studybtn {
      height: 23.25px;
      border: 0.25px solid #e4e4e4;
      border-radius: 0px 0px 4px 4px;
      line-height: 23.25px;
      text-align: center;
      font-size: 7.5px;
      color: #4a73f8;
    }

    .top-title {
      height: 22.5px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 0.5px solid #e7e7e7;

      text {
        font-size: 9px;
        font-weight: bold;
        color: #2b2f36;
      }

      .re-close {
        position: absolute;
        right: 5px;
        top: 7.25px;
      }
    }
  }

  .invite-txt1 {
    height: 42.5px;
    display: flex;
    justify-content: center;
    align-items: center;

    view {
      font-size: 7px;
      text-align: center;
      color: #555555;
    }

    input {
      width: 140px;
      height: 22px;
      background: #f4f4f4;
      border: 0.5px solid #dcdde0;
      border-radius: 2px;
      box-sizing: border-box;
      padding-left: 5px;
      line-height: 22px;
    }
  }

  .copyTA-Style {
    padding: 4px;
    color: grey;
    font-size: 7.5px;
  }

  .copyTA-Style-nodata {
    padding: 4px;
    color: #adadad;
    font-size: 7.5px;
  }
}

.sxsz {
  font-size: 13px;
  color: #1877ff;
  cursor: pointer;
}

.drawerOutBox-nopadding {
  padding: 0;
}

.gray-bg {
  background-color: #f5f5f5;
}

.drawerOutBox-nopadding .drawer-nav-top {
  background-color: white;
}

.padding-0-20 {
  padding: 0 10px;
}

.up-img-fun1 {
  width: 50px;
  height: auto;
  margin-top: 3.5px;
}

.up-box1 {
  margin-top: 3.5px;
  width: 50px;
  height: 50px;
  background: #f4f4f4;
  border-radius: 2.5px;
  overflow: hidden;
  position: relative;
}

/*    分组名单*/
.subsetBox {
  box-sizing: border-box;
  padding: 15px 10px;
  padding-bottom: 0;
}

.bd-popTitle {
  color: black;
  text-align: center;
}

.subset-item {
  padding: 15px 0px;
  border-bottom: 1px solid #eee;
  width: 94%;
  margin: 0 auto;
}

.sub-left img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
  cursor: pointer;
}

.sub-left .cl-name {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  width: 220px;
}

.sub-edit {
  width: 17.5px;
  height: 17.5px;
  cursor: pointer;
}

.add-sub {
  color: #1877ff;
  border-bottom: 0;
  cursor: pointer;
}

.gzh-dialog-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  color: #1f2233;

  .el-icon-close {
    font-size: 16px;
    cursor: pointer;
    color: #626974;
  }
}

.gzh-dialog-content {
  text-align: center;
  padding: 10px 0 20px;

  p {
    margin: 12px 0 18px;
    color: #626974;
    font-size: 14px;
  }
}

.gzh-dialog-qrcode {
  width: 220px;
  height: 220px;
  object-fit: contain;
  margin: 0 auto;
  display: block;
}

.gzh-download-btn {
  width: 200px;
  margin: 0 auto;
  display: inline-block;
}

.preview-title {
  font-size: 14px;
  color: #626974;
  margin-top: 15px;
  margin-bottom: 10px;
  text-align: center;
}

.setFz-main {
  margin-top: 15px;
}

.ssfz {
  border-radius: 4px;
  margin-bottom: 10px;
  box-sizing: border-box;
}

.import-box {
  font-size: 14px;
  margin-top: 12px;

  img {
    height: 15px;
    width: 15px;
  }
}

.blueTxt {
  color: #1877ff;
  cursor: pointer;
}

.import-box .empty {
  margin-left: 10px;
  cursor: pointer;
}

.yl16 {
  text-align: center;
  font-size: 12px;
  color: grey;
  margin-top: 15px;
  margin-bottom: 10px;
}

.fz-select-box {
  border-radius: 4px;
  border: 1px solid #dadbde !important;
  margin: 0px auto 10px;
  box-sizing: border-box;
  padding: 10px;
  background-color: white;
  width: 96%;
}

.jlName {
  margin: 0 auto 0 auto;
  border-radius: 5px;
  // background-color: #fff;

  .listName {
    display: flex;
    display: -webkit-flex;
    // 名单块左对齐排布（靠 margin 留间隙），不做两端对齐，避免最后一行被拉开
    justify-content: flex-start;
    flex-direction: row;
    flex-wrap: wrap;
    margin-top: 10px;

    .spanDiv {
      height: 50px;
      width: 10%;
      margin: 4px;
      background-color: #f2f2f2;
      border-radius: 4px;
      text-align: center;
      font-size: 12px;
      color: #626974;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
    }

    .spanDivEmpty {
      height: 0px;
      width: 10%;
      margin: 4px;
    }
  }

  .tips {
    font-size: 14px;
    text-align: center;
    color: #333;
    padding: 0 15px;
  }
}

// 预览名单改为 5 列网格，列宽随容器自适应，避免右侧留出大块空白
.jl-box .jlName .listName.newSpanWidth {
  display: grid;
  grid-template-columns: repeat(5, 1fr);
}

.newSpanWidth .spanDiv {
  width: auto !important;
}

.newSpanWidth .spanDivEmpty {
  height: 0px;
  width: auto !important;
  margin: 4px;
}

// 设置分组名单抽屉：内容超过一屏时容器随内容撑高，底部按钮跟在内容之后，
// 避免 absolute 定位的按钮在小屏滚动时盖住预览名单
.fzNameDrawer {
  height: auto;
  min-height: 100%;
  padding-bottom: 80px;
}

.emptySpan {
  height: 0px;
  flex: 0 0 23%;
  margin-bottom: 6px;
  background-color: #f2f2f2;
  border-radius: 4px;
  margin-right: 2.5%;
  text-align: center;
  font-size: 12px;
  color: #626974;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.mar-bot-check-0 .el-checkbox {
  margin-bottom: 0;
}

.cannotEditStyle {
  padding-top: 10px;
  padding-bottom: 10px;
  color: #ff0000;
  font-size: 15px;
}

::v-deep .el-input__inner {
  color: #333;
}

::v-deep .el-textarea__inner {
  color: #333;
  padding: 15px;
}

.jl-box {
  background-color: #ebeef2;
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-bottom: 10px;
  margin-top: 16px;

  .jl-title {
    height: 57px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 17px;
    font-weight: bold;
    width: 94%;
    margin: 0 auto;
    color: #323b5a;
  }

  .jlName {
    /*width: 690rpx;*/
    margin: 0 auto 0 auto;
    border-radius: 5px;
    // background-color: #fff;
    padding: 12px 8px 12px 8px;

    .listName {
      display: flex;
      flex-wrap: wrap;
      margin-top: 10px;
      padding: 10px 0;

      .span {
        height: 47px;
        flex: 0 0 23%;
        margin-bottom: 6px;
        background-color: #f2f2f2;
        border-radius: 4px;
        margin-right: calc(10% / 4);
        text-align: center;
        // line-height: 95rpx;
        font-size: 12px;
        color: #626974;
        display: flex;
        align-items: center;
        justify-content: center;
        flex-direction: column;
      }

      .span:nth-child(4n) {
        margin-right: 0;
      }
    }

    .tips {
      font-size: 14px;
      text-align: center;
      color: #333;
      padding: 0 15px;
    }
  }
}

.kf {
  height: 250px;
  width: 96px;
  /*background-color: red;*/
  position: fixed;
  right: 0px;
  bottom: 100px;
  z-index: 99;
}

.kf-tx {
  width: 93px;
  height: auto;
  position: absolute;
  right: 0;
  top: 75px;
  cursor: pointer;
}

.kf-qr {
  width: 200px;
  height: auto;
  position: absolute;
  top: 0;
  right: 0;
}

.kf-close {
  width: 25px;
  height: 25px;
  position: absolute;
  right: 20px;
  top: 16px;
  cursor: pointer;
}

.szfz {
  color: #1877ff;
  font-size: 14px;
  cursor: pointer;
}

.clockNum {
  font-size: 14px;
  cursor: pointer;
}

.bjmd {
  text-align: center;
  margin-top: 15px;

  span {
    color: #1877ff;
    cursor: pointer;
  }
}

.bjmdBtn {
  padding: 6px 10px;
  color: #1877ff;
  /*border: 1px solid #1877FF;*/
  border-radius: 4px;
  /*position: absolute;*/
  /*right: 10px;*/
  /*top: 15px;*/
  cursor: pointer;
}

// 图片裁剪样式
.cropper-content {
  .cropper {
    width: auto;
    height: 300px;
  }
}

.fm-block {
  font-size: 16px;
  //margin-bottom: 10px;
}

.fm-select span {
  color: #191919;
  font-weight: bold;
}

.fm-select img {
  width: 60px;
  height: 15px;
}

.fm-b-right {
  width: 160px;
  height: 30px;
  background-color: red;
}

.fm-b-right .ms {
  display: flex;
  flex: 1;
  height: 100%;
  justify-content: center;
  align-items: center;
  background-color: #f9f9f9;
  color: #2b2f36;
  cursor: pointer;
  font-size: 13px;
}

.ms-active {
  background-color: #1877ff !important;
  color: white !important;
}

.fm-picture {
  width: 250px;
  height: 160px;
  background: rgba(74, 115, 248, 0.08);
  border: 0.5px solid rgba(74, 115, 248, 0.4);
  border-radius: 2.5px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.fm-picture span {
  color: #4a73f8;
}

.fm-picture label {
  font-size: 13px;
}

.fm-flex {
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;
  padding-left: 104px;
  box-sizing: border-box;
}

.fm-flex img {
  width: 250px;
  height: auto;
}

.fm-btns div {
  display: flex;
  width: 140px;
  height: 35px;
  text-align: center;
  margin-left: 20px;
  justify-content: center;
  align-items: center;
  border-radius: 2px;
  cursor: pointer;
}

.fm-btns span {
  margin-left: 35px;
}

.fm-btns .el-button {
  margin-left: 20px;
}

.fm-btns .el-dropdown {
  margin-left: 10px;
}

.xt-btn {
  background-color: white;
  color: #1877ff;
  border: 1px dashed #1877ff;
}

.zdy-btn {
  background-color: white;
  color: #1877ff;
  border: 1px dashed #1877ff;
}

.edit-share {
  display: flex;
  justify-content: flex-end;
  align-items: center;

  .sm-1 {
    height: 80px;
    width: 100px;
  }

  span {
    margin-left: 10px;
    color: #1877ff !important;
    cursor: pointer;
    position: relative;
  }
}

.usePopImg {
  width: 100%;
  height: auto;
}

.yanshiBtn {
  cursor: pointer;
}

.model-title1 {
  margin-bottom: 5px;
  margin-top: 15px;
}

.new-block-style1 {
  font-size: 14px;
  text-align: left;
  color: #191919;
  padding-left: 29px;
  font-weight: 500;
}

.new-block-style2 {
  text-align: left;
  color: #191919;
  padding-left: 29px;
  font-weight: 500;
}

/* 封面设置样式 */
.cover-setting-container {
  height: 100%;

  .cover-section {
    margin-bottom: 100px;

    .section-header {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h4 {
        margin: 0;
        font-size: 16px;
        font-weight: 500;
      }
    }

    .cover-preview {
      border: 2px dashed #d9d9d9;
      padding: 20px;

      .cover-placeholder {
        width: 100%;
        //height: 358px;

        border-radius: 8px;
        display: flex;
        align-items: center;
        justify-content: center;
        background-color: #fafafa;
        margin-top: 15px;
        margin-bottom: 10px;

        .placeholder-text {
          color: #999;
          font-size: 14px;
        }
      }

      .cover-btn-center {
        display: flex;
        justify-content: center;
      }
    }

    .cover-tips {
      font-size: 12px;
      color: #343a40;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .custom-covers {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 15px;

      .custom-cover-item {
        position: relative;
        width: 175px;
        height: calc(175px / 1.5);
        border-radius: 4px;
        overflow: hidden;
        cursor: pointer;
        transition: transform 0.2s ease;

        &:hover {
          transform: scale(1.05);
        }

        .cover-thumbnail {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }

        .delete-btn {
          position: absolute;
          top: 5px;
          right: 5px;
          width: 20px;
          height: 20px;
          background-color: rgba(255, 0, 0, 0.8);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: white;
          font-size: 12px;
        }

        .select-overlay {
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(24, 119, 255, 0.3);
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-size: 20px;
        }
      }
    }

    .upload-tips {
      font-size: 12px;
      color: #343a40;
      margin-top: 10px;
      margin-bottom: 10px;
    }

    .upload-buttons {
      display: flex;
      gap: 10px;

      .el-button {
        position: relative;
        overflow: hidden;
      }
    }
  }

  .save-section {
    position: absolute;
    bottom: 0;
    left: 20px;
    right: 20px;
    background-color: white;
    padding: 15px 0;
    border-top: 1px solid #e8e8e8;
  }

  .video-container {
    position: relative;
    display: inline-block;

    .delete-btn {
      position: absolute;
      top: 34px;
      right: 10px;
      width: 20px;
      height: 20px;
      background-color: rgba(255, 0, 0, 0.8);
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      color: white;
      font-size: 12px;
    }
  }
}

.fm-flex .fm-pics-block {
  width: 400px;
  height: 300px;
  margin-top: 10px;
}

.pic-out-box {
  width: 400px;
  height: 300px;
  text-align: center;
}

.settingBox .el-select {
  width: 440px;
}

.settingBox .el-input {
  width: 440px !important;
}

.mar-top10 {
  margin-top: 10px !important;
}

body .el-dialog__body {
  border-top: 1px solid #f2f2f2 !important;
}

.name-title-left {
  display: flex;
  flex-direction: column;

  .name-title-main {
    display: flex;
    align-items: center;
  }
}

.name-title-left span {
  color: #191919;
  font-weight: bold;
  font-size: 16px;
}

.name-title-sub {
  font-size: 12px;
  color: #949eaf;
  margin-top: 2px;
}

// 预设名单工具行：每排数量 + 展示全部分组 下拉并排，右侧固定灰字提示
.packet-tools {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 0;
  font-size: 13px;
  color: #626974;

  .el-dropdown-link {
    cursor: pointer;
    color: #1877ff;
  }

  .packet-left {
    display: flex;
    align-items: center;
  }

  .packet-count {
    margin-right: 8px;
  }

  .packet-dropdown {
    margin-right: 5px;
    color: #1877ff;
  }

  .packet-dropdown--group {
    margin-left: 30px;
  }
}

// 分组标签栏：横向滚动标签（全部/分组名），选中态蓝底白字，「添加分组」固定最右
.group-tab-bar {
  display: flex;
  align-items: center;

  .group-tab-scroll {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow-x: auto;

    &::-webkit-scrollbar {
      display: none;
    }

    .group-tab-list {
      display: inline-flex;
      align-items: center;

      .group-tab-item {
        display: inline-flex;
        align-items: center;
        justify-content: center;
        box-sizing: border-box;
        height: 32px;
        padding: 0 10px;
        margin-right: 8px;
        font-size: 14px;
        font-weight: bold;
        color: #626974;
        background-color: #fff;
        border: 1px solid #dadbde;
        border-radius: 4px;
        cursor: pointer;

        &:last-child {
          margin-right: 0;
        }
      }

      // 选中态：实心按钮（蓝底白字）
      .group-tab-item--active {
        color: #fff;
        background-color: #1877ff;
        border-color: #1877ff;
      }

      // 人数：小字号半角括号紧贴名称
      .group-tab-count {
        margin-left: 1px;
        font-size: 14px;
      }
    }
  }

  // 「添加分组」：蓝色文字固定在最右侧，不随标签滚动
  .group-tab-add {
    flex-shrink: 0;
    margin-left: 8px;
    font-size: 14px;
    color: #1877ff;
    cursor: pointer;
  }
}

// 名单操作：编辑本组名单居中展示；选中分组时「删除本组」以纯文字固定在右侧
.group-action-bar {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  // 上间隙 = 宫格块底部 margin 4px + 此处 6px = 10px，与卡片底部 padding 10px 对称
  margin-top: 6px;

  .group-action {
    display: flex;
    align-items: center;
    justify-content: center;
    box-sizing: border-box;
    height: 32px;
    // 行高等于内容高（32 - 上下边框各 1px），文字垂直居中不受继承行高影响
    line-height: 30px;
    padding: 0 20px;
    margin: 0 5px;
    font-size: 14px;
    border-radius: 4px;
    cursor: pointer;
  }

  .group-action-edit {
    color: #1877ff;
    border: 1px dashed #1877ff;
    background-color: #ebf3ff;
  }

  .group-action-del {
    position: absolute;
    right: 0;
    font-size: 14px;
    color: #fa3534;
    cursor: pointer;
  }
}

.map-btn {
  width: 440px;
  text-align: left;
}

.no-padding-top {
  ::v-deep .el-dialog__header {
    padding: 5px 20px 10px;
  }
}

.logic-rule-desc {
  font-size: 12px;
  color: #333;
  margin-top: 10px;
  padding-left: 52px;
  line-height: 1.4;
}

// 设置选项不可选时间弹窗样式
.option-time-set-box {
  max-height: 400px;
  overflow-y: auto;

  .option-time-header {
    display: flex;
    justify-content: space-between;
    padding: 5px 10px;
    border-bottom: 1px solid #e8e8e8;
    margin-bottom: 5px;

    .header-title {
      font-size: 14px;
      color: #666;
      font-weight: 500;

      &:first-child {
        flex: 1;
      }

      &:last-child {
        width: 40%;
        text-align: center;
      }
    }
  }

  .option-item {
    display: flex;
    align-items: center;
    padding: 5px 10px;
    border-bottom: 1px solid #f0f0f0;

    &:last-child {
      border-bottom: none;
    }

    .option-name {
      width: 60%;
      display: flex;
      align-items: center;

      .option-index {
        display: inline-block;
        width: 20px;
        height: 20px;
        border-radius: 50%;
        background: #f0f0f0;
        text-align: center;
        line-height: 20px;
        font-size: 11px;
        color: #666;
        margin-right: 8px;
      }

      .option-text {
        font-size: 13px;
        color: #333;
      }
    }

    .option-date {
      width: 40%;

      ::v-deep .el-input__inner {
        padding: 3px 8px;
        height: 28px;
        font-size: 12px;
      }

      ::v-deep .el-input__prefix {
        display: none;
      }
    }
  }
}

// 设置选项不可选时间入口样式
.option-time-set-entry {
  margin-top: 15px;
  padding: 14px 15px;
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;

  span {
    font-size: 14px;
    color: #323b5a;
    font-weight: 500;
  }

  i {
    color: #909399;
    font-size: 16px;
  }
}

// 设置选项不可选时间弹窗底部样式
.option-time-set-footer {
  display: flex;
  justify-content: center;
  padding: 10px 0 20px;

  .el-button {
    width: 80%;
  }
}

// ==================== 在线收款模块样式 ====================
.online-payment-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  .online-payment-title {
    display: flex;
    align-items: center;
    font-size: 16px;
    font-weight: 600;
    color: #333;

    .el-icon-question {
      margin-left: 6px;
      color: #909399;
      cursor: pointer;
    }
  }

  .payment-select-wrap {
    position: relative;

    .payment-select-icon {
      position: absolute;
      left: 10px;
      top: 50%;
      transform: translateY(-50%);
      width: 16px;
      height: 16px;
      z-index: 2;
      pointer-events: none;
    }

    ::v-deep .el-input__inner {
      padding-left: 32px;
    }
  }
}

.payment-option-icon {
  width: 14px;
  height: 14px;
  margin-right: 6px;
  vertical-align: -2px;
}

.payment-section-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  font-weight: 600;
  color: #333;
  margin: 15px 0 10px;

  .add-payment-text-btn {
    font-size: 14px;
    font-weight: normal;
    color: #1877ff;

    i {
      margin-right: 3px;
    }

    &:disabled {
      color: #c0c4cc;
      cursor: not-allowed;
    }
  }
}

.payment-tip {
  font-size: 12px;
  color: #909399;
  margin-top: 10px;
  margin-bottom: 15px;
  line-height: 1.5;
}

.payment-item-box {
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  padding: 20px 15px;
  margin-bottom: 15px;
  background: #fff;

  .payment-item-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    font-weight: 600;
    color: #333;
    margin-bottom: 15px;
    padding-bottom: 10px;
    border-bottom: 1px solid #f0f0f0;

    .delete-payment-text {
      font-size: 13px;
      font-weight: normal;
      color: #f56c6c;
      cursor: pointer;

      i {
        margin-right: 3px;
      }

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .payment-item-content {
    .payment-row {
      display: flex;
      align-items: center;
      padding: 15px 0;
      border-bottom: 1px solid #f5f5f5;

      &:last-child {
        border-bottom: none;
      }

      &.payment-row-double {
        display: flex;
        flex-direction: row;

        .payment-double-item {
          display: flex;
          align-items: center;
          flex: 1;

          .payment-label {
            min-width: 120px;
          }
        }
      }

      .payment-label {
        font-size: 14px;
        color: #606266;
        min-width: 140px;

        .required {
          color: #f56c6c;
          margin-right: 2px;
        }
      }

      .payment-input-full {
        width: 350px;
        margin-left: auto;
      }

      .payment-input-small {
        width: 350px;
        margin-left: auto;
      }

      .payment-upload-right {
        display: flex;
        align-items: center;
        margin-left: auto;
        gap: 10px;

        .payment-upload-btn-small {
          width: 50px;
          height: 50px;
          border: 1px dashed #d9d9d9;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          color: #8c939d;
          font-size: 18px;
          transition: all 0.3s;

          &:hover {
            border-color: #1877ff;
            color: #1877ff;
          }
        }

        .payment-image-preview-small {
          position: relative;
          width: 50px;
          height: 50px;
          border-radius: 4px;
          //overflow: hidden;

          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 4px;
          }

          .payment-image-delete-btn {
            position: absolute;
            top: -6px;
            right: -6px;
            width: 18px;
            height: 18px;
            border-radius: 50%;
            background: #f56c6c;
            color: #fff;
            font-size: 12px;
            line-height: 18px;
            text-align: center;
            cursor: pointer;
            z-index: 1;
          }
        }

        .change-btn {
          color: #1877ff;
          cursor: pointer;
          font-size: 14px;
          margin-left: 5px;

          &:hover {
            text-decoration: underline;
          }
        }
      }
    }
  }

  .add-payment-btn-wrap {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    padding-top: 20px;
    border-top: 1px solid #f0f0f0;

    .add-payment-btn {
      background-color: #1877ff;
      border-color: #1877ff;
      color: #fff;

      &:disabled {
        background-color: #a0cfff;
        border-color: #a0cfff;
      }
    }
  }
}

.code-image {
  width: 250px;
  height: 250px;
}

.rebate-mode-dialog {
  border-radius: 9px;
  background: #f8f8f8;
  overflow: hidden;
}

.rebate-mode-dialog .dialog-title-text {
  text-align: center;
  display: block;
}
</style>
